export const MPUMALANGA_COORDS = {
  type: "MultiPolygon",
  coordinates: [
    [
      [28.24428, -26.88478],
      [28.24705, -26.8860101],
      [28.24755, -26.8862601],
      [28.24791, -26.8864701],
      [28.2484199, -26.88676],
      [28.24882, -26.8870401],
      [28.24919, -26.8872701],
      [28.24964, -26.8876101],
      [28.25011, -26.8879501],
      [28.25046, -26.8882901],
      [28.25089, -26.8886501],
      [28.25117, -26.8889201],
      [28.25146, -26.8892101],
      [28.2515999, -26.88946],
      [28.2516, -26.8897801],
      [28.25155, -26.8902101],
      [28.25148, -26.8904401],
      [28.25137, -26.8910201],
      [28.25128, -26.8916201],
      [28.25122, -26.8919001],
      [28.25125, -26.8921801],
      [28.2513899, -26.8926],
      [28.25171, -26.8930301],
      [28.25228, -26.8937001],
      [28.25289, -26.8943201],
      [28.25337, -26.8948101],
      [28.25413, -26.8955501],
      [28.25494, -26.8961601],
      [28.25542, -26.8966001],
      [28.25584, -26.8970401],
      [28.2563, -26.8974801],
      [28.25716, -26.8982101],
      [28.2578, -26.8988001],
      [28.25832, -26.8992201],
      [28.25864, -26.8995101],
      [28.25902, -26.8998301],
      [28.25934, -26.9001501],
      [28.26002, -26.9007001],
      [28.26042, -26.9010801],
      [28.26086, -26.9015601],
      [28.26102, -26.9017001],
      [28.26123, -26.9018501],
      [28.2613699, -26.902],
      [28.26162, -26.9023901],
      [28.26181, -26.9026901],
      [28.26194, -26.9030601],
      [28.26204, -26.9033801],
      [28.2621499, -26.90373],
      [28.26219, -26.9040701],
      [28.26218, -26.9048301],
      [28.26209, -26.9053601],
      [28.2620199, -26.90593],
      [28.26187, -26.9064301],
      [28.26138, -26.9075401],
      [28.26117, -26.9079701],
      [28.26112, -26.9082101],
      [28.2609999, -26.9086],
      [28.26093, -26.9092401],
      [28.2609, -26.9106301],
      [28.26084, -26.9111101],
      [28.26086, -26.9114401],
      [28.26093, -26.9118401],
      [28.26105, -26.9123601],
      [28.2611199, -26.91257],
      [28.26128, -26.9128101],
      [28.26184, -26.9140201],
      [28.26205, -26.9143101],
      [28.2622799, -26.9146],
      [28.26257, -26.9147701],
      [28.2629199, -26.91491],
      [28.26331, -26.9149901],
      [28.26365, -26.9150201],
      [28.26406, -26.9150501],
      [28.26489, -26.9150001],
      [28.2653799, -26.91491],
      [28.26593, -26.9147101],
      [28.26632, -26.9145601],
      [28.26701, -26.9143001],
      [28.268, -26.9138001],
      [28.2682399, -26.9137],
      [28.26874, -26.9132801],
      [28.26912, -26.9128801],
      [28.26965, -26.9123801],
      [28.27008, -26.9120401],
      [28.2705, -26.9116901],
      [28.27091, -26.9114701],
      [28.27132, -26.9111301],
      [28.27171, -26.9107201],
      [28.27238, -26.9101901],
      [28.27416, -26.9088601],
      [28.2764899, -26.90705],
      [28.27686, -26.9068601],
      [28.27746, -26.9064801],
      [28.27793, -26.9062301],
      [28.27856, -26.9059101],
      [28.27889, -26.9057701],
      [28.27929, -26.9056801],
      [28.27967, -26.9055901],
      [28.2800399, -26.90555],
      [28.28046, -26.9056601],
      [28.28097, -26.9058001],
      [28.28122, -26.9059101],
      [28.2814999, -26.90607],
      [28.2817, -26.9062801],
      [28.28191, -26.9065901],
      [28.28216, -26.9071001],
      [28.28228, -26.9074801],
      [28.2823199, -26.9078],
      [28.28229, -26.9084101],
      [28.28217, -26.9092301],
      [28.28168, -26.9110701],
      [28.28157, -26.9115601],
      [28.28149, -26.9120101],
      [28.28139, -26.9125401],
      [28.28135, -26.9131001],
      [28.28129, -26.9141901],
      [28.2812999, -26.9145],
      [28.28136, -26.9147701],
      [28.28153, -26.9152301],
      [28.28199, -26.9161501],
      [28.28281, -26.9175001],
      [28.28329, -26.9183001],
      [28.28381, -26.9190801],
      [28.28406, -26.9195501],
      [28.28436, -26.9200901],
      [28.28454, -26.9203901],
      [28.28472, -26.9207101],
      [28.28514, -26.9215301],
      [28.28567, -26.9223901],
      [28.28599, -26.9229601],
      [28.28652, -26.9239601],
      [28.28724, -26.9254101],
      [28.28734, -26.9255301],
      [28.28752, -26.9257401],
      [28.28764, -26.9259001],
      [28.28781, -26.9262901],
      [28.28815, -26.9270601],
      [28.28844, -26.9277501],
      [28.28862, -26.9280901],
      [28.28884, -26.9284301],
      [28.2891599, -26.92898],
      [28.28956, -26.9295201],
      [28.29036, -26.9305101],
      [28.29086, -26.9309201],
      [28.29143, -26.9314801],
      [28.29198, -26.9320301],
      [28.29236, -26.9324301],
      [28.29291, -26.9329201],
      [28.29327, -26.9332701],
      [28.29369, -26.9337501],
      [28.29408, -26.9340401],
      [28.29596, -26.9358601],
      [28.29786, -26.9377001],
      [28.29829, -26.9382101],
      [28.299, -26.9388301],
      [28.29933, -26.9391901],
      [28.2998399, -26.93968],
      [28.30043, -26.9401601],
      [28.30076, -26.9403901],
      [28.30123, -26.9406701],
      [28.3016899, -26.9409],
      [28.30222, -26.9410001],
      [28.30251, -26.9410101],
      [28.30288, -26.9410701],
      [28.30351, -26.9411501],
      [28.30384, -26.9411701],
      [28.30446, -26.9411301],
      [28.3048299, -26.94108],
      [28.3051, -26.9409801],
      [28.30547, -26.9408401],
      [28.30603, -26.9406301],
      [28.30691, -26.9401401],
      [28.30775, -26.9395901],
      [28.30792, -26.9395001],
      [28.3082399, -26.93929],
      [28.30866, -26.9389101],
      [28.30891, -26.9385601],
      [28.30949, -26.9378301],
      [28.31043, -26.9365801],
      [28.31081, -26.9362301],
      [28.31111, -26.9359001],
      [28.3113099, -26.93562],
      [28.31151, -26.9351901],
      [28.31168, -26.9347701],
      [28.31185, -26.9338001],
      [28.31187, -26.9331301],
      [28.31195, -26.9326201],
      [28.31201, -26.9318001],
      [28.31208, -26.9311101],
      [28.31222, -26.9304301],
      [28.31231, -26.9299401],
      [28.31231, -26.9296901],
      [28.31224, -26.9294601],
      [28.31229, -26.9288601],
      [28.3124899, -26.92786],
      [28.3129, -26.9268901],
      [28.31302, -26.9266401],
      [28.31328, -26.9261601],
      [28.3136, -26.9256201],
      [28.3137999, -26.92536],
      [28.31402, -26.9251701],
      [28.3143, -26.9249201],
      [28.3146, -26.9247401],
      [28.31503, -26.9245501],
      [28.31559, -26.9242101],
      [28.3161099, -26.92395],
      [28.31657, -26.9238401],
      [28.31711, -26.9237701],
      [28.31737, -26.9237001],
      [28.31797, -26.9234801],
      [28.31853, -26.9232301],
      [28.31912, -26.9230701],
      [28.31968, -26.9229501],
      [28.32029, -26.9228201],
      [28.32075, -26.9227501],
      [28.32142, -26.9226601],
      [28.3219099, -26.92257],
      [28.32277, -26.9225901],
      [28.32335, -26.9226301],
      [28.32419, -26.9226601],
      [28.3253, -26.9226101],
      [28.32564, -26.9225801],
      [28.32585, -26.9225301],
      [28.32621, -26.9225301],
      [28.3265399, -26.92254],
      [28.32678, -26.9226401],
      [28.32711, -26.9227901],
      [28.32879, -26.9234401],
      [28.32934, -26.9235901],
      [28.3298799, -26.92376],
      [28.33013, -26.9239401],
      [28.3304, -26.9242001],
      [28.33073, -26.9245901],
      [28.33107, -26.9250401],
      [28.3311899, -26.92527],
      [28.33122, -26.9254801],
      [28.33126, -26.9259001],
      [28.33114, -26.9266801],
      [28.33101, -26.9270601],
      [28.3308899, -26.9274],
      [28.33064, -26.9278601],
      [28.33048, -26.9281401],
      [28.3302499, -26.92843],
      [28.32986, -26.9287901],
      [28.32941, -26.9291601],
      [28.32812, -26.9298601],
      [28.32567, -26.9312601],
      [28.32498, -26.9316101],
      [28.32461, -26.9318101],
      [28.32432, -26.9320501],
      [28.3231, -26.9328501],
      [28.3227599, -26.93306],
      [28.32261, -26.9332201],
      [28.32205, -26.9337901],
      [28.32116, -26.9346001],
      [28.32084, -26.9349301],
      [28.32067, -26.9352601],
      [28.32046, -26.9354601],
      [28.32022, -26.9356401],
      [28.32007, -26.9357901],
      [28.31988, -26.9361401],
      [28.3196899, -26.93652],
      [28.31966, -26.9366701],
      [28.31966, -26.9368901],
      [28.31971, -26.9371401],
      [28.31979, -26.9373701],
      [28.31989, -26.9378601],
      [28.31985, -26.9383201],
      [28.31982, -26.9387501],
      [28.31982, -26.9389701],
      [28.3198599, -26.93956],
      [28.31998, -26.9400701],
      [28.32016, -26.9405001],
      [28.3204, -26.9411001],
      [28.32046, -26.9414601],
      [28.32063, -26.9419201],
      [28.32077, -26.9421901],
      [28.32106, -26.9428301],
      [28.32166, -26.9441801],
      [28.32191, -26.9447901],
      [28.32217, -26.9453001],
      [28.32258, -26.9460601],
      [28.3231, -26.9472801],
      [28.32333, -26.9477901],
      [28.3236, -26.9482501],
      [28.3239199, -26.94867],
      [28.32421, -26.9488401],
      [28.32453, -26.9489601],
      [28.3248199, -26.94903],
      [28.32524, -26.9490601],
      [28.32568, -26.9489901],
      [28.3266199, -26.94877],
      [28.32755, -26.9483501],
      [28.32805, -26.9481001],
      [28.3284, -26.9479101],
      [28.32952, -26.9472301],
      [28.33015, -26.9468101],
      [28.33101, -26.9462401],
      [28.33184, -26.9456601],
      [28.33247, -26.9451701],
      [28.33276, -26.9449101],
      [28.33333, -26.9446101],
      [28.3335, -26.9445301],
      [28.33376, -26.9443001],
      [28.3342699, -26.94401],
      [28.33458, -26.9437401],
      [28.33525, -26.9430501],
      [28.33577, -26.9427001],
      [28.33641, -26.9422701],
      [28.33684, -26.9419201],
      [28.33778, -26.9412701],
      [28.33822, -26.9408901],
      [28.33894, -26.9403501],
      [28.33941, -26.9401001],
      [28.33991, -26.9397801],
      [28.34158, -26.9384501],
      [28.34189, -26.9382801],
      [28.34217, -26.9381101],
      [28.34256, -26.9377101],
      [28.34538, -26.9355701],
      [28.34654, -26.9347001],
      [28.34709, -26.9343301],
      [28.3475999, -26.93396],
      [28.34779, -26.9338501],
      [28.34809, -26.9336801],
      [28.34857, -26.9334301],
      [28.349, -26.9332401],
      [28.34964, -26.9328901],
      [28.35032, -26.9325601],
      [28.35067, -26.9323801],
      [28.35128, -26.9321401],
      [28.35199, -26.9318801],
      [28.35258, -26.9316801],
      [28.3528899, -26.9316],
      [28.35354, -26.9314901],
      [28.35428, -26.9313801],
      [28.355, -26.9313101],
      [28.35634, -26.9313001],
      [28.35657, -26.9312401],
      [28.35671, -26.9312301],
      [28.3570899, -26.93113],
      [28.35763, -26.9311501],
      [28.35826, -26.9312301],
      [28.35906, -26.9313601],
      [28.36028, -26.9315701],
      [28.36117, -26.9316701],
      [28.3621, -26.9318101],
      [28.36262, -26.9319701],
      [28.3639199, -26.93226],
      [28.36475, -26.9325801],
      [28.36536, -26.9328001],
      [28.36707, -26.9335501],
      [28.36786, -26.9338301],
      [28.36841, -26.9341201],
      [28.3688699, -26.93432],
      [28.36917, -26.9344101],
      [28.36953, -26.9344801],
      [28.36998, -26.9345601],
      [28.37069, -26.9346201],
      [28.37155, -26.9346901],
      [28.37215, -26.9347301],
      [28.3726099, -26.93474],
      [28.37304, -26.9346801],
      [28.37365, -26.9345501],
      [28.37425, -26.9343801],
      [28.37502, -26.9340801],
      [28.37573, -26.9338201],
      [28.37641, -26.9335801],
      [28.37718, -26.9332901],
      [28.37813, -26.9329301],
      [28.37877, -26.9328101],
      [28.38009, -26.9324701],
      [28.38079, -26.9323301],
      [28.3813, -26.9322201],
      [28.38183, -26.9320001],
      [28.38237, -26.9318401],
      [28.38273, -26.9316601],
      [28.3834499, -26.93143],
      [28.38445, -26.9312201],
      [28.38493, -26.9311701],
      [28.38568, -26.9310601],
      [28.38584, -26.9310001],
      [28.38636, -26.9309501],
      [28.38707, -26.9308601],
      [28.38837, -26.9307201],
      [28.3889699, -26.9307],
      [28.38976, -26.9308401],
      [28.3903, -26.9309301],
      [28.39114, -26.9311301],
      [28.3921499, -26.93142],
      [28.39278, -26.9316701],
      [28.39355, -26.9320401],
      [28.39469, -26.9326601],
      [28.39521, -26.9329401],
      [28.39595, -26.9333901],
      [28.39683, -26.9339301],
      [28.39876, -26.9351701],
      [28.39922, -26.9354601],
      [28.39956, -26.9356901],
      [28.3999199, -26.93601],
      [28.40014, -26.9363301],
      [28.40042, -26.9368001],
      [28.40096, -26.9379401],
      [28.4011999, -26.93851],
      [28.40135, -26.9389501],
      [28.40141, -26.9396201],
      [28.40151, -26.9406701],
      [28.40142, -26.9413601],
      [28.40142, -26.9420201],
      [28.40131, -26.9436801],
      [28.40129, -26.9441401],
      [28.4012799, -26.94462],
      [28.40111, -26.9451501],
      [28.40092, -26.9459301],
      [28.40058, -26.9469101],
      [28.40043, -26.9471901],
      [28.40031, -26.9474101],
      [28.40013, -26.9476601],
      [28.40001, -26.9479401],
      [28.39992, -26.9484101],
      [28.39987, -26.9488701],
      [28.3998699, -26.94917],
      [28.40008, -26.9503001],
      [28.4003499, -26.95087],
      [28.40091, -26.9513301],
      [28.40139, -26.9517401],
      [28.40267, -26.9527101],
      [28.40311, -26.9530201],
      [28.40331, -26.9532101],
      [28.40353, -26.9534501],
      [28.40381, -26.9536701],
      [28.40415, -26.9540201],
      [28.40447, -26.9543901],
      [28.4050099, -26.95511],
      [28.40567, -26.9563401],
      [28.40599, -26.9570301],
      [28.40674, -26.9583901],
      [28.40706, -26.9590601],
      [28.40731, -26.9594501],
      [28.4074, -26.9597301],
      [28.40756, -26.9599401],
      [28.40777, -26.9608101],
      [28.4079, -26.9614701],
      [28.4082, -26.9621901],
      [28.4084299, -26.96272],
      [28.40864, -26.9630501],
      [28.4091, -26.9638301],
      [28.4097, -26.9646201],
      [28.41022, -26.9656601],
      [28.41058, -26.9662301],
      [28.41134, -26.9672801],
      [28.41165, -26.9677101],
      [28.41189, -26.9679901],
      [28.41221, -26.9684401],
      [28.41255, -26.9687901],
      [28.4129, -26.9692801],
      [28.41344, -26.9702201],
      [28.41366, -26.9708901],
      [28.41388, -26.9713201],
      [28.4141, -26.9716201],
      [28.41441, -26.9722101],
      [28.4148999, -26.97296],
      [28.41531, -26.9733701],
      [28.41548, -26.9734901],
      [28.41582, -26.9736701],
      [28.41622, -26.9739001],
      [28.41652, -26.9740801],
      [28.41706, -26.9745001],
      [28.418, -26.9754001],
      [28.41838, -26.9758401],
      [28.41888, -26.9763501],
      [28.41988, -26.9773401],
      [28.42017, -26.9775601],
      [28.4203799, -26.97772],
      [28.4207, -26.9780801],
      [28.42115, -26.9787101],
      [28.4213, -26.9788901],
      [28.4216, -26.9794001],
      [28.42222, -26.9804401],
      [28.42269, -26.9811701],
      [28.42293, -26.9817301],
      [28.42313, -26.9819601],
      [28.42339, -26.9824501],
      [28.42364, -26.9829701],
      [28.42396, -26.9833601],
      [28.42407, -26.9835401],
      [28.42425, -26.9840001],
      [28.42476, -26.9847701],
      [28.42531, -26.9854401],
      [28.42594, -26.9862701],
      [28.42628, -26.9868001],
      [28.42647, -26.9871201],
      [28.4267, -26.9874201],
      [28.4268599, -26.98757],
      [28.42704, -26.9876301],
      [28.42747, -26.9878601],
      [28.42795, -26.9880701],
      [28.42847, -26.9883801],
      [28.4288399, -26.9887],
      [28.42891, -26.9888101],
      [28.4290499, -26.98917],
      [28.42901, -26.9896101],
      [28.42892, -26.9898101],
      [28.4286899, -26.99035],
      [28.42775, -26.9917501],
      [28.42749, -26.9921201],
      [28.42729, -26.9923301],
      [28.42697, -26.9928401],
      [28.4266, -26.9933401],
      [28.4261099, -26.99401],
      [28.42554, -26.9945201],
      [28.42499, -26.9949301],
      [28.4247, -26.9951201],
      [28.42448, -26.9952801],
      [28.42401, -26.9956801],
      [28.42337, -26.9964301],
      [28.42297, -26.9967801],
      [28.42271, -26.9969001],
      [28.42227, -26.9972301],
      [28.42145, -26.9978701],
      [28.4209, -26.9982301],
      [28.42039, -26.9985801],
      [28.41974, -26.9990301],
      [28.41931, -26.9994001],
      [28.41893, -26.9997601],
      [28.41851, -27.0001301],
      [28.41821, -27.0005401],
      [28.41814, -27.0006301],
      [28.41777, -27.0009901],
      [28.4171, -27.0015901],
      [28.41621, -27.0025001],
      [28.41601, -27.0026601],
      [28.41554, -27.0031601],
      [28.4147599, -27.00409],
      [28.41405, -27.0052201],
      [28.41369, -27.0058501],
      [28.4134599, -27.00624],
      [28.41337, -27.0066001],
      [28.41332, -27.0068601],
      [28.4133, -27.0069501],
      [28.4133, -27.0073101],
      [28.4133499, -27.00753],
      [28.4138, -27.0085001],
      [28.41436, -27.0096701],
      [28.4148199, -27.0104],
      [28.4154899, -27.0111801],
      [28.4160599, -27.0116701],
      [28.4167499, -27.0121301],
      [28.4176099, -27.01263],
      [28.41849, -27.0129801],
      [28.4189899, -27.01306],
      [28.41926, -27.0130301],
      [28.4197099, -27.0128801],
      [28.4201699, -27.01264],
      [28.4209899, -27.01213],
      [28.42174, -27.0112501],
      [28.4222599, -27.01069],
      [28.42272, -27.0103301],
      [28.42344, -27.0098401],
      [28.42446, -27.0093201],
      [28.4253099, -27.0089101],
      [28.4263099, -27.00833],
      [28.42794, -27.0077801],
      [28.42898, -27.0074501],
      [28.4300299, -27.007],
      [28.43106, -27.0062801],
      [28.43171, -27.0056701],
      [28.4325299, -27.00487],
      [28.4337, -27.0034401],
      [28.43457, -27.0024701],
      [28.43515, -27.0016301],
      [28.43536, -27.00134],
      [28.43551, -27.0009701],
      [28.43561, -27.00069],
      [28.43576, -27.0004801],
      [28.43602, -27.0001501],
      [28.43624, -26.9999201],
      [28.43651, -26.9994901],
      [28.43661, -26.99924],
      [28.437, -26.9986401],
      [28.43732, -26.9982001],
      [28.4375899, -26.9978201],
      [28.43782, -26.9976001],
      [28.43801, -26.9973201],
      [28.43833, -26.997],
      [28.43871, -26.9964701],
      [28.43889, -26.9962301],
      [28.43911, -26.9959401],
      [28.43939, -26.9956401],
      [28.43962, -26.9953401],
      [28.44027, -26.9946601],
      [28.44092, -26.9940101],
      [28.44122, -26.9937301],
      [28.44138, -26.9934301],
      [28.44151, -26.9930901],
      [28.44169, -26.9927301],
      [28.4418899, -26.99238],
      [28.44245, -26.9917901],
      [28.44284, -26.9914001],
      [28.44314, -26.9910601],
      [28.44347, -26.9907101],
      [28.44374, -26.9904101],
      [28.444, -26.9900601],
      [28.44443, -26.9895201],
      [28.44524, -26.9883801],
      [28.44573, -26.9878001],
      [28.44749, -26.9854501],
      [28.44761, -26.9852901],
      [28.44796, -26.9849001],
      [28.44839, -26.9844401],
      [28.44999, -26.9829001],
      [28.4501, -26.9828101],
      [28.4502, -26.9827201],
      [28.45041, -26.9825801],
      [28.4506, -26.9823901],
      [28.45087, -26.9820101],
      [28.45102, -26.9818301],
      [28.45127, -26.9814801],
      [28.4513499, -26.98133],
      [28.45142, -26.9811301],
      [28.45149, -26.9808601],
      [28.45156, -26.9805701],
      [28.45161, -26.9804001],
      [28.45163, -26.9802401],
      [28.45168, -26.9800401],
      [28.45174, -26.9797401],
      [28.4517299, -26.9795],
      [28.45163, -26.9791401],
      [28.4514899, -26.97886],
      [28.45117, -26.9785501],
      [28.45017, -26.9775701],
      [28.4499, -26.9773801],
      [28.44956, -26.9771801],
      [28.44915, -26.9768601],
      [28.4468, -26.9749101],
      [28.44651, -26.9746301],
      [28.4462, -26.9742501],
      [28.44578, -26.9738501],
      [28.44547, -26.9734701],
      [28.44491, -26.9729401],
      [28.4443, -26.9724201],
      [28.44398, -26.9720901],
      [28.44343, -26.9716001],
      [28.44298, -26.9712201],
      [28.44263, -26.9708901],
      [28.44235, -26.9706801],
      [28.44175, -26.9702901],
      [28.44137, -26.9700301],
      [28.44101, -26.9698401],
      [28.44068, -26.9696401],
      [28.4403799, -26.96946],
      [28.43994, -26.9690801],
      [28.43963, -26.9688501],
      [28.4394, -26.9687001],
      [28.43892, -26.9683401],
      [28.43852, -26.9681001],
      [28.43817, -26.9679101],
      [28.43781, -26.9677301],
      [28.43747, -26.9675201],
      [28.43718, -26.9673801],
      [28.43701, -26.9672501],
      [28.43666, -26.9670301],
      [28.4364699, -26.96689],
      [28.43635, -26.9667301],
      [28.43615, -26.9665001],
      [28.43604, -26.9662701],
      [28.4358999, -26.96595],
      [28.43591, -26.9657001],
      [28.43598, -26.9654401],
      [28.4362, -26.9650701],
      [28.4366399, -26.96455],
      [28.43685, -26.9644001],
      [28.43714, -26.9641201],
      [28.43752, -26.9638301],
      [28.43818, -26.9634001],
      [28.4385, -26.9631801],
      [28.43898, -26.9628301],
      [28.43952, -26.9624801],
      [28.44002, -26.9622401],
      [28.44063, -26.9619301],
      [28.44119, -26.9617501],
      [28.44162, -26.9615701],
      [28.4421, -26.9612001],
      [28.44271, -26.9607901],
      [28.44307, -26.9605401],
      [28.4433599, -26.96036],
      [28.44376, -26.9602601],
      [28.4442599, -26.96027],
      [28.44499, -26.9604501],
      [28.4454, -26.9605801],
      [28.4460999, -26.96092],
      [28.4464, -26.9612301],
      [28.44689, -26.9617401],
      [28.44724, -26.9620801],
      [28.44762, -26.9624601],
      [28.44805, -26.9627501],
      [28.4484399, -26.96293],
      [28.44888, -26.9630801],
      [28.44955, -26.9632601],
      [28.45009, -26.9633601],
      [28.45054, -26.9634301],
      [28.4510099, -26.96357],
      [28.4514, -26.9637701],
      [28.45204, -26.9641901],
      [28.45272, -26.9645901],
      [28.45328, -26.9650101],
      [28.45388, -26.9655401],
      [28.45452, -26.9662301],
      [28.455245, -26.967005],
      [28.45563, -26.9674401],
      [28.4559799, -26.96766],
      [28.45636, -26.9677201],
      [28.4567, -26.9678501],
      [28.4570899, -26.96804],
      [28.45737, -26.9683501],
      [28.45761, -26.9685101],
      [28.45823, -26.9692201],
      [28.45866, -26.9696101],
      [28.45913, -26.9700901],
      [28.45966, -26.9707101],
      [28.4601, -26.9712301],
      [28.46057, -26.9717101],
      [28.46113, -26.9721201],
      [28.4613099, -26.97229],
      [28.4615, -26.9725801],
      [28.46161, -26.9728701],
      [28.4616899, -26.97329],
      [28.46168, -26.9738301],
      [28.46165, -26.9747501],
      [28.46159, -26.9752601],
      [28.46156, -26.9757801],
      [28.46157, -26.9760501],
      [28.46154, -26.9765601],
      [28.46154, -26.9769401],
      [28.4616, -26.9774201],
      [28.4616999, -26.97772],
      [28.46189, -26.9781201],
      [28.46201, -26.9783101],
      [28.46228, -26.9785701],
      [28.46258, -26.9789201],
      [28.46283, -26.9792001],
      [28.46301, -26.9794601],
      [28.46324, -26.9798601],
      [28.46341, -26.9802301],
      [28.46358, -26.9805901],
      [28.46382, -26.9813801],
      [28.46398, -26.9818601],
      [28.46414, -26.9821501],
      [28.46433, -26.9825701],
      [28.4645299, -26.98286],
      [28.46467, -26.9829601],
      [28.4648899, -26.98307],
      [28.46514, -26.9831201],
      [28.46536, -26.9831501],
      [28.46564, -26.9831801],
      [28.46596, -26.9831801],
      [28.4665099, -26.98309],
      [28.46722, -26.9828601],
      [28.46755, -26.9827601],
      [28.46791, -26.9825701],
      [28.46832, -26.9823301],
      [28.46869, -26.9822101],
      [28.46922, -26.9820201],
      [28.47044, -26.9815701],
      [28.47074, -26.9813801],
      [28.47098, -26.9812601],
      [28.47142, -26.9809601],
      [28.4717, -26.9807501],
      [28.47192, -26.9805801],
      [28.4720999, -26.98044],
      [28.47228, -26.9802301],
      [28.47242, -26.9800001],
      [28.4725, -26.9797301],
      [28.4725399, -26.97951],
      [28.47247, -26.9792301],
      [28.47233, -26.9790001],
      [28.47213, -26.9785501],
      [28.47138, -26.9769101],
      [28.47101, -26.9763401],
      [28.47072, -26.9758401],
      [28.47048, -26.9754401],
      [28.4703199, -26.97519],
      [28.47022, -26.9748701],
      [28.47015, -26.9745901],
      [28.4701, -26.9743001],
      [28.4701, -26.9739401],
      [28.47009, -26.9733401],
      [28.47014, -26.9730201],
      [28.4701599, -26.9728],
      [28.47033, -26.9722501],
      [28.47063, -26.9714201],
      [28.47086, -26.9710501],
      [28.471, -26.9708301],
      [28.47111, -26.9704101],
      [28.47122, -26.9701301],
      [28.47145, -26.9696801],
      [28.4718899, -26.96894],
      [28.47244, -26.9681701],
      [28.47277, -26.9677901],
      [28.47324, -26.9672901],
      [28.47336, -26.9671401],
      [28.47345, -26.9669201],
      [28.4737, -26.9665001],
      [28.47449, -26.9654101],
      [28.47492, -26.9648401],
      [28.4751, -26.9645001],
      [28.47533, -26.9641401],
      [28.47562, -26.9636901],
      [28.4758399, -26.96328],
      [28.476, -26.9626701],
      [28.47601, -26.9624001],
      [28.47605, -26.9621501],
      [28.47608, -26.9618301],
      [28.4760899, -26.96154],
      [28.47598, -26.9611101],
      [28.47593, -26.9607501],
      [28.47583, -26.9604801],
      [28.4756499, -26.96018],
      [28.47548, -26.9600501],
      [28.47533, -26.9598901],
      [28.47498, -26.9596601],
      [28.47465, -26.9594701],
      [28.4741699, -26.95926],
      [28.47388, -26.9591801],
      [28.47341, -26.9590701],
      [28.47283, -26.9589801],
      [28.47231, -26.9588701],
      [28.47195, -26.9587601],
      [28.47171, -26.9586601],
      [28.47145, -26.9585501],
      [28.4711999, -26.95843],
      [28.47096, -26.9581901],
      [28.4707299, -26.95799],
      [28.47055, -26.9576901],
      [28.47047, -26.9574901],
      [28.47034, -26.9571901],
      [28.4703, -26.9570001],
      [28.4702799, -26.95669],
      [28.47031, -26.9564801],
      [28.47048, -26.9560301],
      [28.47073, -26.9556201],
      [28.47114, -26.9550701],
      [28.4714099, -26.95468],
      [28.4716, -26.9545201],
      [28.47202, -26.9541701],
      [28.47257, -26.9537301],
      [28.47295, -26.9534301],
      [28.47311, -26.9531701],
      [28.47343, -26.9528601],
      [28.4737, -26.9525401],
      [28.47387, -26.9523301],
      [28.47425, -26.9519201],
      [28.4746, -26.9515101],
      [28.47482, -26.9512901],
      [28.47498, -26.9510801],
      [28.47517, -26.9507801],
      [28.4754299, -26.95051],
      [28.47571, -26.9503401],
      [28.47595, -26.9502101],
      [28.4760899, -26.95016],
      [28.47652, -26.9501401],
      [28.47727, -26.9501401],
      [28.4776499, -26.95019],
      [28.47787, -26.9502901],
      [28.47823, -26.9506401],
      [28.47852, -26.9508901],
      [28.4788099, -26.95121],
      [28.47909, -26.9517101],
      [28.47932, -26.9523601],
      [28.47951, -26.9528301],
      [28.47969, -26.9532501],
      [28.4801199, -26.9542501],
      [28.4802999, -26.9547301],
      [28.4804499, -26.9551601],
      [28.4806899, -26.9556901],
      [28.4811999, -26.9568501],
      [28.48197, -26.958685],
      [28.4821899, -26.95932],
      [28.4823599, -26.9601901],
      [28.4825199, -26.9607301],
      [28.4825999, -26.9612401],
      [28.4826999, -26.9617801],
      [28.4828499, -26.9633601],
      [28.4828599, -26.9637401],
      [28.4829099, -26.9640601],
      [28.4830499, -26.9646301],
      [28.4832999, -26.9657601],
      [28.4834299, -26.9663101],
      [28.4834899, -26.9666601],
      [28.4836099, -26.96711],
      [28.4838599, -26.9676101],
      [28.4840799, -26.9681701],
      [28.4843899, -26.9686301],
      [28.4845499, -26.9689901],
      [28.4847299, -26.9694201],
      [28.4851399, -26.9699701],
      [28.4854799, -26.9705501],
      [28.4858499, -26.97111],
      [28.4861699, -26.9714301],
      [28.4865399, -26.9717501],
      [28.4869899, -26.9722001],
      [28.4873099, -26.9724001],
      [28.4875299, -26.9725601],
      [28.4878499, -26.9728401],
      [28.4882199, -26.9731101],
      [28.4885599, -26.97335],
      [28.4890999, -26.9736701],
      [28.4894499, -26.9738601],
      [28.4899799, -26.9742101],
      [28.4905199, -26.9744701],
      [28.4910499, -26.9747301],
      [28.4913099, -26.9749201],
      [28.4924299, -26.9755601],
      [28.49274, -26.9756901],
      [28.4932399, -26.9759201],
      [28.4936699, -26.97606],
      [28.49418, -26.9761701],
      [28.4948799, -26.9762601],
      [28.49548, -26.9763701],
      [28.4960199, -26.9764901],
      [28.4967999, -26.9767301],
      [28.4975899, -26.9769801],
      [28.4981899, -26.9771901],
      [28.4989099, -26.9774301],
      [28.4993399, -26.9776001],
      [28.4996199, -26.97772],
      [28.4997299, -26.9777201],
      [28.4998999, -26.9776701],
      [28.5000199, -26.9776301],
      [28.5001999, -26.9776701],
      [28.5004499, -26.97776],
      [28.50069, -26.9779201],
      [28.50097, -26.9782401],
      [28.5013299, -26.9785401],
      [28.5017, -26.9789201],
      [28.50215, -26.9792901],
      [28.50279, -26.9797701],
      [28.5032099, -26.9801101],
      [28.50344, -26.9804001],
      [28.50365, -26.9806201],
      [28.50418, -26.9811201],
      [28.50457, -26.9814301],
      [28.50478, -26.9816401],
      [28.5051499, -26.9821101],
      [28.5054299, -26.9825201],
      [28.5057499, -26.9829501],
      [28.50607, -26.9833301],
      [28.5062099, -26.9834601],
      [28.50653, -26.9836901],
      [28.5068799, -26.9839901],
      [28.5073099, -26.9843301],
      [28.50765, -26.9846201],
      [28.5078799, -26.9848801],
      [28.5081299, -26.9850801],
      [28.5085, -26.9853501],
      [28.5087799, -26.9855401],
      [28.50895, -26.9856601],
      [28.5091, -26.9857601],
      [28.5092399, -26.9859],
      [28.5093599, -26.9861301],
      [28.5096099, -26.9866101],
      [28.5096599, -26.9868401],
      [28.5097099, -26.9870901],
      [28.5098899, -26.9875901],
      [28.5100199, -26.9880301],
      [28.5101399, -26.9884201],
      [28.5103899, -26.9890301],
      [28.5104499, -26.9893201],
      [28.5105699, -26.9897201],
      [28.5107999, -26.99005],
      [28.5108699, -26.9902701],
      [28.5109199, -26.9904901],
      [28.5109799, -26.9910201],
      [28.5109899, -26.9914901],
      [28.5109299, -26.9922501],
      [28.5109199, -26.9925601],
      [28.5108799, -26.99277],
      [28.5107099, -26.9931201],
      [28.5103899, -26.9936801],
      [28.5093799, -26.9950501],
      [28.5087499, -26.9958401],
      [28.5084299, -26.9963701],
      [28.5075699, -26.9976301],
      [28.5073099, -26.9981001],
      [28.5069499, -26.9985801],
      [28.5064699, -26.9992401],
      [28.5060199, -26.9999001],
      [28.5057399, -27.00033],
      [28.5056599, -27.0003601],
      [28.5055299, -27.0004201],
      [28.5054099, -27.0004601],
      [28.5052999, -27.0004901],
      [28.5051599, -27.0005601],
      [28.5050199, -27.00067],
      [28.5048899, -27.0009301],
      [28.5046399, -27.0014901],
      [28.5042999, -27.0021501],
      [28.5041199, -27.0025301],
      [28.5040399, -27.0027701],
      [28.50383, -27.0033701],
      [28.50364, -27.0038701],
      [28.50339, -27.0043801],
      [28.50326, -27.0047001],
      [28.50309, -27.0050401],
      [28.50304, -27.0052301],
      [28.5029799, -27.00552],
      [28.50298, -27.0057201],
      [28.50302, -27.0061101],
      [28.50305, -27.0064101],
      [28.50312, -27.0069001],
      [28.50323, -27.0072301],
      [28.5033, -27.0074801],
      [28.5034, -27.0077301],
      [28.5035799, -27.00803],
      [28.50384, -27.0082101],
      [28.50413, -27.0083501],
      [28.50456, -27.0085101],
      [28.5052, -27.0087001],
      [28.50606, -27.0089601],
      [28.50766, -27.0094301],
      [28.50785, -27.0094501],
      [28.5081, -27.0095101],
      [28.50828, -27.0094901],
      [28.50851, -27.0095101],
      [28.5087799, -27.00962],
      [28.50895, -27.0098301],
      [28.50935, -27.0101801],
      [28.51013, -27.0108301],
      [28.51055, -27.0112701],
      [28.51101, -27.0116501],
      [28.51123, -27.0118301],
      [28.5114499, -27.01197],
      [28.512, -27.0122201],
      [28.51222, -27.0123001],
      [28.51264, -27.0124801],
      [28.51293, -27.0126201],
      [28.51323, -27.0127601],
      [28.51362, -27.0128701],
      [28.51395, -27.0129601],
      [28.51452, -27.0130101],
      [28.51477, -27.0130101],
      [28.51511, -27.0131201],
      [28.51572, -27.0133001],
      [28.51643, -27.0135101],
      [28.51676, -27.0135901],
      [28.51719, -27.0137001],
      [28.51753, -27.0138501],
      [28.5178499, -27.01397],
      [28.51829, -27.0142201],
      [28.51865, -27.0144701],
      [28.51885, -27.0146001],
      [28.51925, -27.0148101],
      [28.51961, -27.0150001],
      [28.5201, -27.0152501],
      [28.52046, -27.0154501],
      [28.52085, -27.0156701],
      [28.52126, -27.0159301],
      [28.52149, -27.0160601],
      [28.52179, -27.0162401],
      [28.52194, -27.0163101],
      [28.52213, -27.0164301],
      [28.52236, -27.0165501],
      [28.52256, -27.0166601],
      [28.52289, -27.0168101],
      [28.52317, -27.0168901],
      [28.5233799, -27.01694],
      [28.5240599, -27.0169401],
      [28.5244299, -27.0168901],
      [28.5246999, -27.0168801],
      [28.5250899, -27.0169101],
      [28.5254599, -27.0170001],
      [28.5257299, -27.0170701],
      [28.5261499, -27.01719],
      [28.5263399, -27.0173101],
      [28.52666, -27.0175101],
      [28.5270099, -27.0177001],
      [28.5272799, -27.0178301],
      [28.5276199, -27.0180201],
      [28.52784, -27.0182001],
      [28.52812, -27.0183901],
      [28.5282899, -27.01851],
      [28.52842, -27.0187001],
      [28.52866, -27.0189901],
      [28.52884, -27.0192301],
      [28.52903, -27.0195801],
      [28.52917, -27.0199201],
      [28.52933, -27.0203301],
      [28.5294, -27.0205101],
      [28.52951, -27.0207101],
      [28.52966, -27.0210201],
      [28.52978, -27.0212401],
      [28.52988, -27.0215101],
      [28.52995, -27.0217101],
      [28.53002, -27.0219601],
      [28.53009, -27.0222401],
      [28.5301499, -27.02251],
      [28.53015, -27.0236701],
      [28.5301, -27.0240801],
      [28.53011, -27.0243401],
      [28.53012, -27.0248301],
      [28.53016, -27.0252001],
      [28.53016, -27.0257201],
      [28.53019, -27.0259001],
      [28.53022, -27.0261301],
      [28.5303199, -27.02647],
      [28.53057, -27.0268001],
      [28.53082, -27.0271001],
      [28.53097, -27.0272401],
      [28.53118, -27.0274301],
      [28.53145, -27.0276801],
      [28.5317, -27.0278601],
      [28.5321, -27.0281701],
      [28.53243, -27.0284901],
      [28.53279, -27.0287401],
      [28.53333, -27.0290901],
      [28.53377, -27.0293501],
      [28.53397, -27.0295601],
      [28.53423, -27.0297401],
      [28.5344, -27.0299401],
      [28.53491, -27.0304001],
      [28.53507, -27.0306601],
      [28.53521, -27.0308701],
      [28.53555, -27.0312701],
      [28.53579, -27.0314801],
      [28.53624, -27.0319101],
      [28.53653, -27.0321901],
      [28.53683, -27.0324101],
      [28.53712, -27.0326601],
      [28.53739, -27.0328501],
      [28.53785, -27.0331701],
      [28.53819, -27.0334501],
      [28.5384899, -27.03366],
      [28.53888, -27.0337801],
      [28.53922, -27.0338901],
      [28.53955, -27.0339501],
      [28.53989, -27.0339801],
      [28.54024, -27.0339401],
      [28.54054, -27.0339201],
      [28.5409299, -27.03388],
      [28.54143, -27.0340301],
      [28.54181, -27.0341201],
      [28.5421299, -27.03425],
      [28.54234, -27.0343701],
      [28.54256, -27.0345001],
      [28.54286, -27.0347201],
      [28.54334, -27.0351701],
      [28.54371, -27.0355401],
      [28.54412, -27.0359801],
      [28.54446, -27.0363501],
      [28.54502, -27.0369201],
      [28.54554, -27.0375501],
      [28.54616, -27.0381701],
      [28.54654, -27.0385001],
      [28.54685, -27.0387401],
      [28.54706, -27.0389201],
      [28.54729, -27.0391201],
      [28.54751, -27.0393001],
      [28.54784, -27.0395601],
      [28.54817, -27.0398001],
      [28.5486, -27.0401401],
      [28.5490699, -27.04058],
      [28.54932, -27.0409001],
      [28.54955, -27.0412801],
      [28.54969, -27.0416001],
      [28.54981, -27.0420001],
      [28.5499199, -27.04229],
      [28.54996, -27.0426501],
      [28.55004, -27.0430301],
      [28.55004, -27.0434401],
      [28.5500099, -27.04392],
      [28.54987, -27.0445001],
      [28.54974, -27.0450101],
      [28.54957, -27.0455201],
      [28.54934, -27.0460201],
      [28.54909, -27.0464201],
      [28.5488, -27.0469001],
      [28.54865, -27.0471101],
      [28.54855, -27.0473301],
      [28.5483, -27.0479601],
      [28.54814, -27.0483701],
      [28.54779, -27.0490201],
      [28.54754, -27.0495001],
      [28.54733, -27.0499401],
      [28.54706, -27.0504901],
      [28.54682, -27.0509801],
      [28.54666, -27.0513801],
      [28.54643, -27.0518001],
      [28.54631, -27.0519501],
      [28.5461, -27.0523801],
      [28.5457499, -27.05294],
      [28.54552, -27.0531701],
      [28.54527, -27.0534501],
      [28.5450899, -27.05361],
      [28.54483, -27.0536701],
      [28.54466, -27.0536601],
      [28.54434, -27.0537201],
      [28.5438, -27.0538201],
      [28.54348, -27.0538901],
      [28.54304, -27.0539501],
      [28.5427, -27.0540201],
      [28.54229, -27.0541101],
      [28.54152, -27.0543101],
      [28.54088, -27.0544901],
      [28.54061, -27.0545601],
      [28.54008, -27.0547401],
      [28.53969, -27.0548801],
      [28.53911, -27.0550001],
      [28.53864, -27.0550701],
      [28.53831, -27.0551101],
      [28.53792, -27.0552101],
      [28.53769, -27.0552601],
      [28.5374, -27.0553201],
      [28.53712, -27.0553701],
      [28.53685, -27.0555001],
      [28.5366199, -27.05568],
      [28.53637, -27.0560401],
      [28.53574, -27.0571301],
      [28.53496, -27.0585101],
      [28.53356, -27.0614601],
      [28.53339, -27.0619101],
      [28.53315, -27.0624601],
      [28.53298, -27.0628501],
      [28.5328899, -27.06301],
      [28.53286, -27.0632501],
      [28.532731, -27.063758],
      [28.53265, -27.0643901],
      [28.53264, -27.0649001],
      [28.53271, -27.0653901],
      [28.5328099, -27.06578],
      [28.53297, -27.0661101],
      [28.53314, -27.0663501],
      [28.5334499, -27.06672],
      [28.53375, -27.0668601],
      [28.534, -27.0669001],
      [28.53439, -27.0669601],
      [28.5347399, -27.06695],
      [28.53521, -27.0668701],
      [28.53687, -27.0665501],
      [28.53737, -27.0664901],
      [28.5380399, -27.06634],
      [28.53835, -27.0662301],
      [28.53958, -27.0655901],
      [28.54007, -27.0653701],
      [28.54067, -27.0651601],
      [28.54129, -27.0648401],
      [28.54199, -27.0645801],
      [28.54237, -27.0644101],
      [28.54292, -27.0642201],
      [28.5434199, -27.06402],
      [28.54403, -27.0638801],
      [28.54457, -27.0638301],
      [28.5451, -27.0637201],
      [28.54574, -27.0636501],
      [28.54632, -27.0635501],
      [28.54674, -27.0635101],
      [28.547, -27.0634401],
      [28.54754, -27.0633601],
      [28.54812, -27.0633401],
      [28.5484999, -27.06327],
      [28.54891, -27.0631301],
      [28.54939, -27.0629101],
      [28.54987, -27.0627201],
      [28.55026, -27.0625601],
      [28.55053, -27.0624501],
      [28.55097, -27.0623201],
      [28.55153, -27.0622001],
      [28.5521, -27.0620401],
      [28.5526399, -27.06188],
      [28.55334, -27.0615301],
      [28.55352, -27.0614001],
      [28.55374, -27.0612701],
      [28.55395, -27.0610901],
      [28.5542, -27.0608801],
      [28.5546399, -27.06043],
      [28.55488, -27.0600901],
      [28.55504, -27.0598101],
      [28.55524, -27.0593801],
      [28.55541, -27.0589601],
      [28.55557, -27.0586201],
      [28.55569, -27.0583601],
      [28.55586, -27.0579901],
      [28.55615, -27.0575601],
      [28.55643, -27.0572001],
      [28.55668, -27.0568901],
      [28.5571599, -27.05631],
      [28.55733, -27.0562401],
      [28.55754, -27.0562001],
      [28.55782, -27.0561101],
      [28.5581, -27.0559501],
      [28.55844, -27.0557001],
      [28.55861, -27.0555001],
      [28.55885, -27.0553201],
      [28.5591, -27.0551401],
      [28.5593899, -27.05495],
      [28.55963, -27.0546801],
      [28.5598899, -27.05423],
      [28.55999, -27.0537501],
      [28.56019, -27.0531101],
      [28.56027, -27.0526101],
      [28.56051, -27.0511501],
      [28.56053, -27.0503601],
      [28.56058, -27.0499701],
      [28.56062, -27.0494201],
      [28.5607942, -27.0488331],
      [28.56068, -27.0485301],
      [28.5607299, -27.0479],
      [28.5607, -27.0474901],
      [28.56064, -27.0469101],
      [28.56059, -27.0466501],
      [28.56052, -27.0461501],
      [28.56032, -27.0454601],
      [28.5602, -27.0449001],
      [28.56005, -27.0445001],
      [28.55988, -27.0441401],
      [28.55978, -27.0438301],
      [28.55971, -27.0435301],
      [28.55953, -27.0430301],
      [28.55944, -27.0425301],
      [28.5593, -27.0419801],
      [28.5592099, -27.04149],
      [28.55921, -27.0411301],
      [28.55923, -27.0409101],
      [28.5592999, -27.04066],
      [28.55954, -27.0403501],
      [28.5600299, -27.03993],
      [28.56083, -27.0393901],
      [28.56185, -27.0387601],
      [28.56261, -27.0384201],
      [28.56297, -27.0383001],
      [28.56339, -27.0380601],
      [28.5639, -27.0378101],
      [28.56425, -27.0375901],
      [28.56451, -27.0373101],
      [28.56487, -27.0370501],
      [28.56538, -27.0366901],
      [28.56603, -27.0363201],
      [28.56644, -27.0361101],
      [28.56699, -27.0357701],
      [28.56756, -27.0354901],
      [28.56787, -27.0353201],
      [28.56826, -27.0351401],
      [28.56869, -27.0350001],
      [28.5689499, -27.03495],
      [28.56942, -27.0349701],
      [28.56981, -27.0350001],
      [28.57032, -27.0351801],
      [28.5708099, -27.03542],
      [28.57114, -27.0356601],
      [28.57203, -27.0363901],
      [28.57239, -27.0367301],
      [28.57406, -27.0381401],
      [28.57436, -27.0383301],
      [28.57471, -27.0385501],
      [28.5749499, -27.0387],
      [28.57521, -27.0388201],
      [28.57544, -27.0389201],
      [28.57572, -27.0390101],
      [28.57591, -27.0390601],
      [28.57623, -27.0391701],
      [28.57689, -27.0392701],
      [28.5773399, -27.03931],
      [28.57761, -27.0393001],
      [28.57819, -27.0392801],
      [28.57888, -27.0391801],
      [28.5799299, -27.039],
      [28.58057, -27.0387801],
      [28.58105, -27.0386101],
      [28.5815, -27.0384301],
      [28.58275, -27.0380201],
      [28.58327, -27.0378401],
      [28.5836, -27.0376501],
      [28.58394, -27.0374901],
      [28.58423, -27.0373101],
      [28.5846699, -27.03693],
      [28.58507, -27.0364301],
      [28.58547, -27.0358601],
      [28.58567, -27.0354201],
      [28.58629, -27.0344901],
      [28.58655, -27.0339701],
      [28.58726, -27.03267],
      [28.58857, -27.03034],
      [28.58928, -27.02915],
      [28.58947, -27.02886],
      [28.58972, -27.0283501],
      [28.59005, -27.0278301],
      [28.59113, -27.0260301],
      [28.5913699, -27.02567],
      [28.59181, -27.02516],
      [28.59218, -27.02475],
      [28.59246, -27.02447],
      [28.59284, -27.02414],
      [28.5932499, -27.02385],
      [28.59372, -27.02357],
      [28.59422, -27.02325],
      [28.5945, -27.02309],
      [28.5948199, -27.02296],
      [28.59523, -27.0229001],
      [28.59551, -27.02288],
      [28.59603, -27.0228101],
      [28.59653, -27.02268],
      [28.59735, -27.0226],
      [28.59842, -27.02256],
      [28.59928, -27.02252],
      [28.59962, -27.0224701],
      [28.60005, -27.0223801],
      [28.6004, -27.0223101],
      [28.6008, -27.0222001],
      [28.60134, -27.02209],
      [28.60195, -27.02199],
      [28.60287, -27.02184],
      [28.60318, -27.0217001],
      [28.6034199, -27.02162],
      [28.60357, -27.0215101],
      [28.60382, -27.02131],
      [28.60399, -27.02116],
      [28.6041899, -27.02106],
      [28.60447, -27.0209901],
      [28.60481, -27.02095],
      [28.60516, -27.0210201],
      [28.60545, -27.0210901],
      [28.6058899, -27.0211401],
      [28.6062899, -27.0211601],
      [28.6070199, -27.0211301],
      [28.607378, -27.021096],
      [28.6076499, -27.0210701],
      [28.6080199, -27.0210201],
      [28.6083299, -27.02099],
      [28.60864, -27.02083],
      [28.6088899, -27.0207],
      [28.60903, -27.0205201],
      [28.6090935, -27.0203832],
      [28.60916, -27.0202401],
      [28.60929, -27.0197001],
      [28.60937, -27.0191201],
      [28.6094499, -27.0188],
      [28.60942, -27.0183001],
      [28.60936, -27.0177901],
      [28.6093, -27.0170401],
      [28.60916, -27.0163501],
      [28.60906, -27.0159301],
      [28.60892, -27.0153801],
      [28.60848, -27.0138801],
      [28.60832, -27.0134901],
      [28.60824, -27.0131801],
      [28.60809, -27.0123701],
      [28.6079299, -27.01148],
      [28.60787, -27.0107501],
      [28.60786, -27.0102701],
      [28.60787, -27.0099301],
      [28.60785, -27.0094601],
      [28.6078, -27.0090401],
      [28.60782, -27.0087901],
      [28.6078599, -27.00858],
      [28.6079599, -27.0084301],
      [28.6081399, -27.0083201],
      [28.6082899, -27.00822],
      [28.6085399, -27.0081701],
      [28.60883, -27.0081101],
      [28.6094899, -27.00804],
      [28.6101499, -27.0080401],
      [28.6107099, -27.0081101],
      [28.61143, -27.0081801],
      [28.61233, -27.0082601],
      [28.61307, -27.0083301],
      [28.61356, -27.00837],
      [28.61409, -27.0085401],
      [28.6145, -27.0086501],
      [28.61494, -27.0087201],
      [28.61548, -27.0088201],
      [28.61598, -27.0089001],
      [28.61654, -27.0089301],
      [28.61714, -27.0089301],
      [28.61769, -27.0090401],
      [28.61814, -27.0091101],
      [28.61861, -27.0091801],
      [28.61889, -27.0092301],
      [28.6194, -27.0093101],
      [28.61981, -27.0093601],
      [28.62016, -27.0094301],
      [28.6206899, -27.00956],
      [28.62112, -27.0097101],
      [28.62141, -27.0098501],
      [28.6216699, -27.0099801],
      [28.6218599, -27.0100601],
      [28.62209, -27.0101201],
      [28.6223699, -27.0101801],
      [28.6226699, -27.0102101],
      [28.6230599, -27.0102001],
      [28.6233999, -27.0102501],
      [28.6236599, -27.0103001],
      [28.6239599, -27.0103701],
      [28.6245299, -27.0105301],
      [28.6249599, -27.0105901],
      [28.6255299, -27.01074],
      [28.625731, -27.010832],
      [28.6258999, -27.0109101],
      [28.6264299, -27.0111201],
      [28.6270099, -27.0114601],
      [28.6276799, -27.0118401],
      [28.62795, -27.01199],
      [28.6281999, -27.01213],
      [28.6283399, -27.0122401],
      [28.6284899, -27.0123601],
      [28.6286799, -27.01247],
      [28.62893, -27.0125401],
      [28.6292399, -27.0126001],
      [28.6295699, -27.0126101],
      [28.62997, -27.0127201],
      [28.6302399, -27.01284],
      [28.6306599, -27.0131001],
      [28.63124, -27.01354],
      [28.63154, -27.0137201],
      [28.63204, -27.01413],
      [28.63292, -27.0148],
      [28.63353, -27.01525],
      [28.63379, -27.01553],
      [28.63445, -27.01607],
      [28.63526, -27.016627],
      [28.63605, -27.01717],
      [28.63659, -27.01763],
      [28.63699, -27.01796],
      [28.63728, -27.01825],
      [28.63777, -27.01864],
      [28.63818, -27.01898],
      [28.63873, -27.01936],
      [28.63916, -27.01972],
      [28.6393599, -27.01987],
      [28.63971, -27.02002],
      [28.64013, -27.02021],
      [28.64099, -27.02062],
      [28.64145, -27.02081],
      [28.64185, -27.02093],
      [28.6423199, -27.02105],
      [28.64278, -27.02103],
      [28.6432599, -27.02093],
      [28.6435, -27.02084],
      [28.64369, -27.02076],
      [28.64403, -27.02061],
      [28.64427, -27.02046],
      [28.6444299, -27.02031],
      [28.64461, -27.02005],
      [28.64481, -27.01972],
      [28.64502, -27.01949],
      [28.6455, -27.01898],
      [28.64645, -27.0178],
      [28.64681, -27.01737],
      [28.64698, -27.01713],
      [28.64712, -27.01691],
      [28.6473299, -27.01662],
      [28.64747, -27.01623],
      [28.64768, -27.0156],
      [28.64785, -27.01519],
      [28.64796, -27.01479],
      [28.64809, -27.01438],
      [28.64826, -27.01384],
      [28.64835, -27.01338],
      [28.64843, -27.01291],
      [28.64849, -27.01248],
      [28.64875, -27.01131],
      [28.64884, -27.01108],
      [28.6489499, -27.01087],
      [28.64913, -27.01067],
      [28.64935, -27.01049],
      [28.64963, -27.01033],
      [28.65004, -27.01023],
      [28.6507, -27.0099],
      [28.65109, -27.00964],
      [28.6513199, -27.00943],
      [28.65152, -27.00899],
      [28.6517, -27.00866],
      [28.6518, -27.00842],
      [28.652, -27.00782],
      [28.65251, -27.00658],
      [28.65319, -27.00477],
      [28.65399, -27.00253],
      [28.65421, -27.0018],
      [28.65438, -27.0013],
      [28.65448, -27.0009],
      [28.65455, -27.00065],
      [28.65463, -27.00053],
      [28.65483, -27.00021],
      [28.65515, -26.99983],
      [28.65535, -26.99945],
      [28.65548, -26.99924],
      [28.65568, -26.99877],
      [28.6557899, -26.99861],
      [28.65583, -26.99839],
      [28.65588, -26.99813],
      [28.6558899, -26.99788],
      [28.65584, -26.99763],
      [28.65576, -26.9973501],
      [28.65564, -26.99713],
      [28.6555199, -26.99693],
      [28.65521, -26.99657],
      [28.65483, -26.9962],
      [28.65413, -26.9957501],
      [28.65348, -26.9952601],
      [28.65313, -26.99504],
      [28.6524999, -26.99463],
      [28.65188, -26.9944],
      [28.65133, -26.99418],
      [28.65082, -26.99396],
      [28.65034, -26.99375],
      [28.64993, -26.99356],
      [28.64928, -26.99325],
      [28.64894, -26.9931101],
      [28.64868, -26.9930301],
      [28.64808, -26.9928701],
      [28.64725, -26.9927301],
      [28.64633, -26.9925501],
      [28.6458199, -26.99237],
      [28.64527, -26.9922801],
      [28.64502, -26.9922801],
      [28.64426, -26.9922101],
      [28.64291, -26.9920401],
      [28.64233, -26.9920001],
      [28.64169, -26.9919301],
      [28.64079, -26.9918601],
      [28.63922, -26.9917501],
      [28.63871, -26.9917101],
      [28.63828, -26.9916601],
      [28.63796, -26.9916],
      [28.63746, -26.99155],
      [28.63717, -26.99152],
      [28.63671, -26.99143],
      [28.63624, -26.99131],
      [28.63574, -26.99123],
      [28.63546, -26.99115],
      [28.63506, -26.99108],
      [28.6347, -26.9909701],
      [28.6344199, -26.99086],
      [28.63399, -26.9908501],
      [28.63367, -26.9908601],
      [28.633, -26.9909301],
      [28.6325299, -26.99103],
      [28.63218, -26.9911501],
      [28.63159, -26.9914101],
      [28.6312, -26.99156],
      [28.63072, -26.99177],
      [28.6304499, -26.9919101],
      [28.63027, -26.99202],
      [28.6288299, -26.9926501],
      [28.6285399, -26.99277],
      [28.6282299, -26.99278],
      [28.6275999, -26.9929901],
      [28.6255199, -26.9939201],
      [28.6250699, -26.9941101],
      [28.6242499, -26.9945101],
      [28.6239099, -26.9947501],
      [28.6232899, -26.9950701],
      [28.62232, -26.9956601],
      [28.62183, -26.9959301],
      [28.62126, -26.9962801],
      [28.6208799, -26.99653],
      [28.62062, -26.99675],
      [28.62025, -26.99707],
      [28.61978, -26.99766],
      [28.61919, -26.99825],
      [28.61904, -26.99849],
      [28.61889, -26.99871],
      [28.61872, -26.99902],
      [28.6185299, -26.9992601],
      [28.6182399, -26.9995601],
      [28.6180299, -26.9998201],
      [28.6178399, -26.9999601],
      [28.6175499, -27.00011],
      [28.6172399, -27.0001701],
      [28.6169199, -27.0001401],
      [28.6164199, -27.00008],
      [28.61598, -26.9998801],
      [28.6155899, -26.99974],
      [28.61528, -26.9995101],
      [28.61471, -26.9989901],
      [28.61451, -26.9987601],
      [28.6141999, -26.9984401],
      [28.61381, -26.9980401],
      [28.61321, -26.9974501],
      [28.61264, -26.99689],
      [28.61224, -26.99648],
      [28.61189, -26.99611],
      [28.61146, -26.9957],
      [28.61083, -26.9951],
      [28.61044, -26.9946],
      [28.61005, -26.99412],
      [28.60986, -26.99394],
      [28.6097099, -26.99379],
      [28.6094899, -26.9936801],
      [28.6090099, -26.9935001],
      [28.6088499, -26.99347],
      [28.6085099, -26.9934801],
      [28.6081199, -26.9935301],
      [28.6076699, -26.9936901],
      [28.6073499, -26.9938201],
      [28.60673, -26.9941601],
      [28.60639, -26.9943101],
      [28.6061699, -26.99438],
      [28.60585, -26.9943801],
      [28.60563, -26.9943101],
      [28.6053899, -26.99421],
      [28.60528, -26.9940501],
      [28.60514, -26.9939101],
      [28.6050599, -26.99374],
      [28.6050499, -26.9934901],
      [28.6050399, -26.9932101],
      [28.6050999, -26.9929301],
      [28.6052199, -26.99256],
      [28.6055799, -26.9918101],
      [28.6063499, -26.99065],
      [28.6065999, -26.9904001],
      [28.6069599, -26.9900101],
      [28.6071599, -26.9896801],
      [28.6076399, -26.9892601],
      [28.6087099, -26.9883601],
      [28.6089399, -26.9881301],
      [28.6093899, -26.9877601],
      [28.6097699, -26.9873401],
      [28.6101599, -26.98695],
      [28.6104299, -26.9865301],
      [28.6106899, -26.9861301],
      [28.6112499, -26.9852701],
      [28.6125299, -26.9833501],
      [28.6136999, -26.9815701],
      [28.6141499, -26.9808101],
      [28.6144699, -26.9802401],
      [28.6147599, -26.9797001],
      [28.6152299, -26.9788501],
      [28.6154999, -26.9784401],
      [28.6157999, -26.9779201],
      [28.6161199, -26.9773801],
      [28.6163899, -26.9769501],
      [28.6167399, -26.9765501],
      [28.6170799, -26.9761301],
      [28.6173499, -26.9757401],
      [28.6176799, -26.9753101],
      [28.6180899, -26.9747201],
      [28.6182799, -26.9745301],
      [28.6184299, -26.9742801],
      [28.61857, -26.9740301],
      [28.6189299, -26.9733701],
      [28.61946, -26.9725301],
      [28.61986, -26.9719201],
      [28.6204699, -26.9706801],
      [28.6206799, -26.9701501],
      [28.6209099, -26.9696101],
      [28.6210499, -26.9694001],
      [28.6212199, -26.96909],
      [28.6214499, -26.9688401],
      [28.6217699, -26.9685301],
      [28.6223799, -26.9681001],
      [28.6231299, -26.9677301],
      [28.6234499, -26.96752],
      [28.6243399, -26.9672101],
      [28.62489, -26.9669801],
      [28.6258099, -26.9666501],
      [28.62631, -26.9664501],
      [28.62692, -26.9662001],
      [28.6273799, -26.9660101],
      [28.6282099, -26.9655601],
      [28.6288899, -26.9651901],
      [28.6294699, -26.9648501],
      [28.6297999, -26.9646601],
      [28.6304299, -26.9643901],
      [28.6321099, -26.9634601],
      [28.6327999, -26.9630601],
      [28.6330799, -26.9629401],
      [28.6333099, -26.9628601],
      [28.6335799, -26.96272],
      [28.6338799, -26.9625101],
      [28.6342899, -26.9622301],
      [28.6345399, -26.9620101],
      [28.6347899, -26.96175],
      [28.6350799, -26.9612601],
      [28.6352899, -26.9607301],
      [28.6354399, -26.9602901],
      [28.6355799, -26.9598501],
      [28.6356899, -26.95945],
      [28.6358099, -26.9588801],
      [28.6358699, -26.9582001],
      [28.6357899, -26.9578001],
      [28.6357599, -26.9573201],
      [28.635771, -26.957105],
      [28.6357799, -26.9569101],
      [28.63584, -26.9564801],
      [28.6359199, -26.95619],
      [28.6361399, -26.9558401],
      [28.6363099, -26.9555701],
      [28.6364999, -26.9553501],
      [28.6368599, -26.95505],
      [28.6372499, -26.9549601],
      [28.6377999, -26.9549201],
      [28.6382599, -26.9548801],
      [28.6389599, -26.9548801],
      [28.63951, -26.9548101],
      [28.6398999, -26.9547801],
      [28.6402599, -26.9546801],
      [28.6404999, -26.9545501],
      [28.6409799, -26.9544401],
      [28.6413499, -26.9544301],
      [28.6419499, -26.9543701],
      [28.6424399, -26.9543601],
      [28.64298, -26.9542701],
      [28.6433799, -26.9542201],
      [28.6436899, -26.9541201],
      [28.6440099, -26.95402],
      [28.6442999, -26.9537501],
      [28.6444899, -26.9534401],
      [28.64471, -26.9531401],
      [28.6448899, -26.9529201],
      [28.6449144, -26.9529032],
      [28.6450499, -26.95281],
      [28.6453199, -26.9527301],
      [28.64552, -26.9527001],
      [28.6458199, -26.95268],
      [28.64632, -26.9527701],
      [28.6466499, -26.9529201],
      [28.6469199, -26.95304],
      [28.6472899, -26.9533901],
      [28.6475399, -26.9536801],
      [28.64831, -26.9545401],
      [28.64916, -26.9554801],
      [28.64946, -26.9558201],
      [28.65142, -26.9579301],
      [28.65184, -26.9583201],
      [28.65225, -26.9586101],
      [28.6528199, -26.9590701],
      [28.6535499, -26.9595701],
      [28.6539799, -26.9598901],
      [28.6544599, -26.96019],
      [28.65491, -26.9603901],
      [28.65535, -26.9605601],
      [28.6557, -26.9606401],
      [28.65621, -26.9607101],
      [28.6567799, -26.96079],
      [28.6576399, -26.9607401],
      [28.6580299, -26.9607301],
      [28.6586199, -26.9606501],
      [28.6591899, -26.9605501],
      [28.65964, -26.9604601],
      [28.66018, -26.9603801],
      [28.6606199, -26.96042],
      [28.6610999, -26.9606501],
      [28.6614399, -26.9607901],
      [28.6619199, -26.9610601],
      [28.6624199, -26.9613201],
      [28.6629199, -26.9616201],
      [28.6640699, -26.96239],
      [28.6647399, -26.9629401],
      [28.6659899, -26.9639901],
      [28.6663099, -26.9643201],
      [28.6665299, -26.9645501],
      [28.6668499, -26.9648301],
      [28.6671699, -26.9650301],
      [28.6676, -26.9652201],
      [28.66817, -26.9654901],
      [28.66881, -26.9659001],
      [28.6694899, -26.9664001],
      [28.6701999, -26.9669001],
      [28.6711099, -26.9674801],
      [28.67233, -26.96828],
      [28.6727099, -26.9685301],
      [28.67449, -26.96976],
      [28.67531, -26.97039],
      [28.67573, -26.97072],
      [28.6761499, -26.9710201],
      [28.6771399, -26.9718301],
      [28.6780399, -26.9724901],
      [28.67887, -26.97303],
      [28.6796899, -26.9736101],
      [28.6803599, -26.974],
      [28.6809299, -26.9742801],
      [28.6813899, -26.9744801],
      [28.6817999, -26.9746301],
      [28.6823999, -26.9749101],
      [28.6828999, -26.9750501],
      [28.6833799, -26.9751801],
      [28.6838999, -26.9752901],
      [28.68433, -26.9753401],
      [28.6849699, -26.9754801],
      [28.6855499, -26.9756001],
      [28.6862599, -26.9757],
      [28.6867499, -26.9757301],
      [28.6875199, -26.9757601],
      [28.6890999, -26.9758701],
      [28.6897499, -26.9759101],
      [28.6903599, -26.9759101],
      [28.6910099, -26.9758701],
      [28.6927499, -26.9757301],
      [28.6935799, -26.9756201],
      [28.6946799, -26.9756601],
      [28.6962299, -26.9756901],
      [28.6967699, -26.9757001],
      [28.6975199, -26.9758001],
      [28.6980099, -26.9758201],
      [28.6986999, -26.97584],
      [28.6990999, -26.9758001],
      [28.6994599, -26.9757501],
      [28.6999799, -26.9756501],
      [28.7009099, -26.9752501],
      [28.7013899, -26.97496],
      [28.7019499, -26.9744901],
      [28.7031099, -26.9734301],
      [28.7035799, -26.9729301],
      [28.7039499, -26.9724701],
      [28.7045799, -26.9717401],
      [28.7049099, -26.97124],
      [28.7050299, -26.9709501],
      [28.7051199, -26.9706801],
      [28.7051499, -26.9704201],
      [28.7053099, -26.9700301],
      [28.7055799, -26.9695101],
      [28.7058299, -26.9691001],
      [28.7060099, -26.96886],
      [28.7062199, -26.9687101],
      [28.7065599, -26.9685401],
      [28.7069099, -26.9684401],
      [28.7073199, -26.96836],
      [28.7078599, -26.9684001],
      [28.7083199, -26.9685101],
      [28.7088099, -26.9685801],
      [28.70945, -26.9687001],
      [28.70985, -26.9688001],
      [28.71041, -26.9689801],
      [28.7109099, -26.96919],
      [28.71141, -26.9695101],
      [28.71166, -26.9697201],
      [28.7122799, -26.9702001],
      [28.7126599, -26.9705101],
      [28.71305, -26.9708001],
      [28.71346, -26.9712001],
      [28.7138099, -26.97161],
      [28.714, -26.9720001],
      [28.71417, -26.9724701],
      [28.71421, -26.9728001],
      [28.71422, -26.9731701],
      [28.71424, -26.9737101],
      [28.7143, -26.9743001],
      [28.71442, -26.9753701],
      [28.71449, -26.9762501],
      [28.71454, -26.9764801],
      [28.7146899, -26.97713],
      [28.71491, -26.9776901],
      [28.71502, -26.9779101],
      [28.71519, -26.9782601],
      [28.71537, -26.9785201],
      [28.7157499, -26.9791],
      [28.71618, -26.9795101],
      [28.71668, -26.9799201],
      [28.71722, -26.9802401],
      [28.71751, -26.9804201],
      [28.71857, -26.9811401],
      [28.71912, -26.9814001],
      [28.71966, -26.9817001],
      [28.72023, -26.9820601],
      [28.7208, -26.9824901],
      [28.72108, -26.9826901],
      [28.72138, -26.9828401],
      [28.7216499, -26.98296],
      [28.72224, -26.9831001],
      [28.72284, -26.9831801],
      [28.7231099, -26.98324],
      [28.7235199, -26.9834301],
      [28.7237899, -26.9835801],
      [28.7241099, -26.9837401],
      [28.7244399, -26.9839401],
      [28.7248699, -26.9842101],
      [28.7253699, -26.9846],
      [28.7258999, -26.9851801],
      [28.7261399, -26.9854601],
      [28.7264399, -26.98584],
      [28.7267199, -26.9862801],
      [28.7269699, -26.9866501],
      [28.7272599, -26.9872501],
      [28.7275399, -26.9878201],
      [28.7277999, -26.9882001],
      [28.7279499, -26.9884901],
      [28.7284999, -26.9894901],
      [28.7287199, -26.9898401],
      [28.7288399, -26.9901201],
      [28.7290499, -26.9904801],
      [28.7291499, -26.9907501],
      [28.7292899, -26.9911201],
      [28.7295499, -26.9919301],
      [28.7297999, -26.9925601],
      [28.7298899, -26.9927901],
      [28.7299999, -26.9930601],
      [28.7301899, -26.9934801],
      [28.7304099, -26.9940101],
      [28.7306399, -26.9945401],
      [28.7307699, -26.9947501],
      [28.7310399, -26.9952401],
      [28.7311199, -26.99548],
      [28.7313699, -26.9957301],
      [28.7316599, -26.9961301],
      [28.7317999, -26.9963001],
      [28.7320199, -26.9966601],
      [28.7324799, -26.9973501],
      [28.7330899, -26.9982301],
      [28.7333599, -26.9984801],
      [28.73376, -26.9988001],
      [28.7340799, -26.9991201],
      [28.7342199, -26.9993701],
      [28.7345299, -26.9997001],
      [28.73489, -27.0001301],
      [28.7351199, -27.0005501],
      [28.7352599, -27.00074],
      [28.73552, -27.00092],
      [28.73581, -27.00114],
      [28.7361, -27.00139],
      [28.73649, -27.0017001],
      [28.7368499, -27.00193],
      [28.73726, -27.0020801],
      [28.73761, -27.0021401],
      [28.73807, -27.0022101],
      [28.73839, -27.0022501],
      [28.73873, -27.0022701],
      [28.7391099, -27.0023801],
      [28.7395599, -27.0024901],
      [28.7402399, -27.0026001],
      [28.7407099, -27.0026401],
      [28.7411099, -27.0026801],
      [28.7414299, -27.00275],
      [28.7417599, -27.0029001],
      [28.7421099, -27.0031501],
      [28.7424699, -27.00337],
      [28.7427499, -27.0034101],
      [28.7430899, -27.0034101],
      [28.7436899, -27.0033901],
      [28.7441799, -27.0032401],
      [28.7445499, -27.0031001],
      [28.7449899, -27.0030701],
      [28.7451999, -27.00301],
      [28.74588, -27.0026301],
      [28.74724, -27.0017601],
      [28.7477, -27.0014001],
      [28.74817, -27.0011501],
      [28.74852, -27.0009201],
      [28.74881, -27.0006701],
      [28.7491199, -27.0004401],
      [28.7494899, -27.0002301],
      [28.74987, -27.0000501],
      [28.7502, -26.9999001],
      [28.75059, -26.9997001],
      [28.75095, -26.9993301],
      [28.75114, -26.9991301],
      [28.75145, -26.9988301],
      [28.75177, -26.9986001],
      [28.75202, -26.9984001],
      [28.7524199, -26.99816],
      [28.75297, -26.9979201],
      [28.75347, -26.9977901],
      [28.75388, -26.9976601],
      [28.75424, -26.9975701],
      [28.7546699, -26.99748],
      [28.75524, -26.9974301],
      [28.7556899, -26.9974701],
      [28.7562899, -26.9976],
      [28.7568299, -26.9978101],
      [28.7574099, -26.9980601],
      [28.7580999, -26.9983701],
      [28.7590099, -26.9988301],
      [28.7595799, -26.9991201],
      [28.7599399, -26.9993601],
      [28.7604599, -26.9996901],
      [28.76099, -27.0000201],
      [28.76144, -27.0003701],
      [28.76197, -27.0008301],
      [28.7626999, -27.00134],
      [28.76292, -27.0014501],
      [28.76322, -27.0016301],
      [28.76346, -27.0017401],
      [28.76387, -27.0019001],
      [28.7643, -27.0020001],
      [28.765279, -27.002238],
      [28.76585, -27.0024001],
      [28.76644, -27.0026001],
      [28.76673, -27.0026901],
      [28.767, -27.0027601],
      [28.76728, -27.0028501],
      [28.76761, -27.0030001],
      [28.7678199, -27.0030901],
      [28.76814, -27.0031301],
      [28.7684799, -27.0031601],
      [28.7687399, -27.00315],
      [28.76899, -27.0030701],
      [28.76927, -27.0029601],
      [28.76957, -27.0028301],
      [28.76985, -27.0028001],
      [28.7702299, -27.00283],
      [28.77068, -27.0029901],
      [28.77112, -27.0032001],
      [28.77157, -27.0034901],
      [28.77207, -27.0037601],
      [28.77246, -27.0039501],
      [28.77282, -27.0042001],
      [28.77319, -27.0045301],
      [28.77356, -27.0049101],
      [28.77378, -27.0050601],
      [28.77413, -27.0052501],
      [28.7744299, -27.00545],
      [28.77473, -27.0057501],
      [28.7752, -27.0062501],
      [28.77538, -27.0065101],
      [28.77554, -27.0067101],
      [28.7758399, -27.0072301],
      [28.7760299, -27.0075801],
      [28.7761699, -27.0078201],
      [28.7763099, -27.0080501],
      [28.7765299, -27.0083401],
      [28.7766799, -27.00857],
      [28.7767399, -27.0087201],
      [28.7768199, -27.0090501],
      [28.7768199, -27.00937],
      [28.77674, -27.0097701],
      [28.77651, -27.0104901],
      [28.77647, -27.0107801],
      [28.77646, -27.0110401],
      [28.77621, -27.0118601],
      [28.77571, -27.0129601],
      [28.77545, -27.0135101],
      [28.7752299, -27.0140401],
      [28.7749399, -27.0146401],
      [28.7741199, -27.0159701],
      [28.7739699, -27.0162501],
      [28.7738299, -27.0166401],
      [28.7736599, -27.0171101],
      [28.7735699, -27.0173701],
      [28.7735299, -27.01757],
      [28.7735299, -27.0178601],
      [28.7735699, -27.0182101],
      [28.7736199, -27.0185101],
      [28.7736899, -27.0187301],
      [28.7738299, -27.01896],
      [28.7739799, -27.0190901],
      [28.7741799, -27.01926],
      [28.7743699, -27.0193401],
      [28.77476, -27.0195201],
      [28.77543, -27.0197201],
      [28.77619, -27.0198801],
      [28.77686, -27.0199901],
      [28.77707, -27.0200001],
      [28.77752, -27.0200601],
      [28.77831, -27.0201801],
      [28.7787099, -27.02027],
      [28.7790499, -27.0203901],
      [28.77948, -27.0206201],
      [28.77983, -27.0208201],
      [28.78015, -27.0210301],
      [28.7804699, -27.0212701],
      [28.7807799, -27.02143],
      [28.7812899, -27.0216301],
      [28.7828799, -27.0222001],
      [28.78357, -27.0225101],
      [28.78404, -27.0226601],
      [28.78472, -27.0229301],
      [28.78635, -27.0235901],
      [28.78711, -27.0238101],
      [28.78776, -27.0239101],
      [28.78855, -27.0241301],
      [28.78973, -27.0245001],
      [28.7909599, -27.0248901],
      [28.7914299, -27.02502],
      [28.7917499, -27.0251601],
      [28.7922199, -27.0253801],
      [28.7926199, -27.0256301],
      [28.7929999, -27.0258401],
      [28.7934299, -27.0261301],
      [28.7939099, -27.0264101],
      [28.79424, -27.0266701],
      [28.79448, -27.0269501],
      [28.7945699, -27.02709],
      [28.79462, -27.0273501],
      [28.79465, -27.0276401],
      [28.79457, -27.0280401],
      [28.79457, -27.0283601],
      [28.7946, -27.0285801],
      [28.7946999, -27.02875],
      [28.79502, -27.0289301],
      [28.7953299, -27.02899],
      [28.79572, -27.0289701],
      [28.79601, -27.0289201],
      [28.7962399, -27.02883],
      [28.79645, -27.0285801],
      [28.79659, -27.0283601],
      [28.7971399, -27.0274601],
      [28.7978099, -27.0263601],
      [28.7979399, -27.0259701],
      [28.7980799, -27.0257101],
      [28.7983899, -27.0250101],
      [28.7986799, -27.0242901],
      [28.7988699, -27.0238501],
      [28.7989699, -27.0234601],
      [28.7991999, -27.0229001],
      [28.7994499, -27.0223101],
      [28.7998099, -27.0214601],
      [28.8000499, -27.0208701],
      [28.8002399, -27.0205801],
      [28.8003499, -27.0202801],
      [28.8006099, -27.0198201],
      [28.8007499, -27.0194801],
      [28.8010799, -27.0188401],
      [28.8012299, -27.0185501],
      [28.8014599, -27.0182301],
      [28.8017499, -27.0177001],
      [28.8019599, -27.0172],
      [28.8020099, -27.0168901],
      [28.8020899, -27.0165201],
      [28.8021499, -27.0160601],
      [28.8021499, -27.01561],
      [28.8020099, -27.0152301],
      [28.8018799, -27.0149201],
      [28.8014599, -27.0145301],
      [28.8012899, -27.0144301],
      [28.8011599, -27.0142801],
      [28.8010499, -27.0141],
      [28.801, -27.0139301],
      [28.8009399, -27.01361],
      [28.80097, -27.0134001],
      [28.80112, -27.0130001],
      [28.8013299, -27.01255],
      [28.8015, -27.0123101],
      [28.80178, -27.0119901],
      [28.8021999, -27.01167],
      [28.80253, -27.0115201],
      [28.80284, -27.0114101],
      [28.8030899, -27.01135],
      [28.80357, -27.0113501],
      [28.80419, -27.0113801],
      [28.8048899, -27.01153],
      [28.80507, -27.0116601],
      [28.80532, -27.0118701],
      [28.80556, -27.0121501],
      [28.8059899, -27.01255],
      [28.80626, -27.0129201],
      [28.80661, -27.0133701],
      [28.80686, -27.0139301],
      [28.80698, -27.0141201],
      [28.80721, -27.0144301],
      [28.80742, -27.0146601],
      [28.80767, -27.0150501],
      [28.80804, -27.0157001],
      [28.80889, -27.0173101],
      [28.809, -27.0175801],
      [28.80915, -27.0178701],
      [28.80932, -27.0183001],
      [28.80964, -27.0189801],
      [28.8097699, -27.01928],
      [28.80982, -27.0195601],
      [28.80993, -27.0201201],
      [28.80994, -27.0207201],
      [28.81, -27.0209601],
      [28.81008, -27.0211501],
      [28.81016, -27.0214001],
      [28.81023, -27.0217401],
      [28.8103, -27.0220901],
      [28.8104, -27.0226501],
      [28.81043, -27.0230901],
      [28.81045, -27.0238101],
      [28.81051, -27.0243401],
      [28.81055, -27.0246601],
      [28.81058, -27.0251001],
      [28.81055, -27.0256301],
      [28.81055, -27.0259501],
      [28.81063, -27.0263501],
      [28.81063, -27.0266601],
      [28.81066, -27.0271701],
      [28.81073, -27.0275701],
      [28.81086, -27.0282401],
      [28.8109, -27.0285401],
      [28.8109, -27.0288301],
      [28.81096, -27.0294601],
      [28.81113, -27.0301001],
      [28.81122, -27.0307401],
      [28.81137, -27.0317801],
      [28.81157, -27.0326001],
      [28.81163, -27.0329501],
      [28.81168, -27.0333601],
      [28.8117099, -27.03407],
      [28.81149, -27.0354501],
      [28.8114299, -27.0358901],
      [28.8113499, -27.0362601],
      [28.8113499, -27.0366],
      [28.8112399, -27.0368201],
      [28.8110599, -27.0369601],
      [28.8109099, -27.03713],
      [28.8108499, -27.0372701],
      [28.8107699, -27.0375801],
      [28.8107799, -27.0378801],
      [28.8108099, -27.0383401],
      [28.8108599, -27.03861],
      [28.8109699, -27.0388901],
      [28.8112199, -27.0395801],
      [28.8115699, -27.0402701],
      [28.8119999, -27.0409001],
      [28.8124799, -27.0414301],
      [28.8126799, -27.04164],
      [28.8128399, -27.0417201],
      [28.8130399, -27.0419601],
      [28.8135699, -27.0423701],
      [28.8140099, -27.04257],
      [28.8142699, -27.0426001],
      [28.8147599, -27.0425601],
      [28.8152699, -27.0425201],
      [28.8155499, -27.0425301],
      [28.8158699, -27.04245],
      [28.8161999, -27.0422901],
      [28.8166299, -27.0420201],
      [28.8173299, -27.0415401],
      [28.8176699, -27.0413301],
      [28.8186299, -27.0406901],
      [28.8189099, -27.0405501],
      [28.8197899, -27.0400701],
      [28.8217299, -27.0388601],
      [28.8224599, -27.0384901],
      [28.8231899, -27.0381901],
      [28.8238899, -27.0378901],
      [28.8243399, -27.0376501],
      [28.8245799, -27.0374601],
      [28.8248899, -27.0372901],
      [28.8252099, -27.0371101],
      [28.8254599, -27.03704],
      [28.8258899, -27.0370101],
      [28.8262999, -27.03705],
      [28.8266299, -27.0371501],
      [28.8269199, -27.0372701],
      [28.8273999, -27.0376301],
      [28.8279399, -27.0379001],
      [28.8283399, -27.0380901],
      [28.8288599, -27.0384301],
      [28.8294499, -27.0388201],
      [28.8298199, -27.0391101],
      [28.8302199, -27.0393901],
      [28.8305899, -27.0396301],
      [28.8313799, -27.0401001],
      [28.8318799, -27.0403801],
      [28.8322799, -27.04066],
      [28.8328099, -27.0409001],
      [28.8343899, -27.0416601],
      [28.8346499, -27.0417501],
      [28.8350499, -27.04184],
      [28.8354899, -27.0418901],
      [28.8359299, -27.0419301],
      [28.8365099, -27.0419301],
      [28.8368299, -27.0419101],
      [28.8372399, -27.0419501],
      [28.8377399, -27.0419001],
      [28.8382099, -27.0418301],
      [28.8389599, -27.04162],
      [28.8395999, -27.0413401],
      [28.8403999, -27.0410401],
      [28.8410099, -27.0407801],
      [28.8415299, -27.0405201],
      [28.8423999, -27.0400101],
      [28.8429699, -27.0396301],
      [28.8433599, -27.0393201],
      [28.8436199, -27.03912],
      [28.8440099, -27.0386901],
      [28.8442099, -27.0384301],
      [28.8444199, -27.0381501],
      [28.8446499, -27.0379601],
      [28.8452999, -27.0371401],
      [28.8455499, -27.0368701],
      [28.8459099, -27.0363701],
      [28.8464099, -27.0359101],
      [28.8476399, -27.0345801],
      [28.8480499, -27.0341001],
      [28.8486299, -27.0333401],
      [28.8489999, -27.0328501],
      [28.8501499, -27.0315001],
      [28.8502999, -27.0313001],
      [28.8505299, -27.03093],
      [28.8506999, -27.0304001],
      [28.8509899, -27.0296501],
      [28.8510999, -27.0294101],
      [28.8512799, -27.0290401],
      [28.8513699, -27.0287501],
      [28.8514599, -27.0284101],
      [28.8515699, -27.0281601],
      [28.8516699, -27.02796],
      [28.8518999, -27.0276501],
      [28.8521999, -27.0273501],
      [28.8526699, -27.02704],
      [28.8530499, -27.0269001],
      [28.8533599, -27.0268301],
      [28.8536899, -27.0267101],
      [28.8539599, -27.0265301],
      [28.8542899, -27.0263501],
      [28.8546499, -27.0262101],
      [28.8553299, -27.0259901],
      [28.8555899, -27.0259001],
      [28.8557999, -27.02574],
      [28.8560199, -27.0254201],
      [28.8561999, -27.0252101],
      [28.8565599, -27.0249801],
      [28.8567999, -27.02485],
      [28.8571399, -27.0248101],
      [28.8574599, -27.0248101],
      [28.8578699, -27.02492],
      [28.8582799, -27.0252201],
      [28.8588399, -27.0257101],
      [28.8592799, -27.0262301],
      [28.8596399, -27.0266701],
      [28.8598899, -27.0270801],
      [28.8601799, -27.0274001],
      [28.8604399, -27.0276401],
      [28.8606699, -27.0278501],
      [28.86101, -27.0282],
      [28.8616, -27.02868],
      [28.8620199, -27.029],
      [28.8625, -27.02923],
      [28.86293, -27.0294401],
      [28.86327, -27.0296601],
      [28.86364, -27.02992],
      [28.86407, -27.03024],
      [28.86454, -27.03052],
      [28.86492, -27.03069],
      [28.8655599, -27.03098],
      [28.86596, -27.03105],
      [28.86646, -27.03113],
      [28.8669, -27.03123],
      [28.8680299, -27.03154],
      [28.86838, -27.03156],
      [28.86869, -27.0315001],
      [28.86884, -27.0314001],
      [28.86907, -27.03136],
      [28.8692899, -27.03136],
      [28.8695399, -27.0314301],
      [28.8698799, -27.0316],
      [28.86995, -27.0316801],
      [28.87073, -27.0332601],
      [28.87095, -27.0336001],
      [28.87114, -27.034],
      [28.8713, -27.0346001],
      [28.8716, -27.0351601],
      [28.87192, -27.03594],
      [28.87209, -27.0362601],
      [28.87224, -27.03673],
      [28.87243, -27.0370201],
      [28.87263, -27.03726],
      [28.8728799, -27.03765],
      [28.87302, -27.03794],
      [28.8732, -27.0384201],
      [28.87327, -27.03859],
      [28.87344, -27.03928],
      [28.87362, -27.03987],
      [28.87387, -27.04065],
      [28.8741, -27.0414701],
      [28.87428, -27.0420401],
      [28.8744, -27.0425401],
      [28.87457, -27.0431501],
      [28.87489, -27.04388],
      [28.87509, -27.0441501],
      [28.8753299, -27.04488],
      [28.87555, -27.04523],
      [28.87575, -27.0455701],
      [28.87592, -27.0458901],
      [28.87622, -27.0464001],
      [28.87658, -27.04693],
      [28.8768, -27.04724],
      [28.87709, -27.04764],
      [28.8773, -27.04793],
      [28.8774699, -27.04822],
      [28.8777, -27.0488],
      [28.87797, -27.0493],
      [28.87815, -27.04978],
      [28.87834, -27.05031],
      [28.87847, -27.05076],
      [28.8786, -27.05119],
      [28.87867, -27.0515],
      [28.87873, -27.0516301],
      [28.8788499, -27.0518201],
      [28.8789799, -27.0522801],
      [28.8792199, -27.0535101],
      [28.8793699, -27.0540101],
      [28.8794171, -27.0541452],
      [28.8795999, -27.05467],
      [28.8797499, -27.0549901],
      [28.8798899, -27.0552301],
      [28.8800199, -27.0554001],
      [28.8802599, -27.0556801],
      [28.8804799, -27.0559],
      [28.8809099, -27.0561701],
      [28.8811999, -27.0563701],
      [28.8820499, -27.0566901],
      [28.8826699, -27.0569201],
      [28.8832999, -27.0570601],
      [28.8838199, -27.0572601],
      [28.8841899, -27.0573901],
      [28.8845699, -27.05749],
      [28.8851099, -27.0574901],
      [28.8853899, -27.0575301],
      [28.8858599, -27.0575701],
      [28.8861399, -27.05762],
      [28.8864299, -27.0577601],
      [28.8871499, -27.0583701],
      [28.8873499, -27.0584901],
      [28.8875999, -27.0587001],
      [28.8877199, -27.0588401],
      [28.8878199, -27.0589301],
      [28.8880399, -27.0590701],
      [28.8882599, -27.0592],
      [28.8885999, -27.0592701],
      [28.8888999, -27.0592801],
      [28.889249, -27.05927],
      [28.88945, -27.0592001],
      [28.88976, -27.0591001],
      [28.89013, -27.0589501],
      [28.89067, -27.0585901],
      [28.89132, -27.0581401],
      [28.8918799, -27.05774],
      [28.8931799, -27.0564001],
      [28.89336, -27.0561901],
      [28.89356, -27.0559201],
      [28.89369, -27.0558101],
      [28.8940599, -27.0554901],
      [28.89421, -27.0553501],
      [28.8943899, -27.0551701],
      [28.8945899, -27.0550601],
      [28.8947, -27.0550101],
      [28.89484, -27.0548501],
      [28.8950299, -27.0546601],
      [28.8954299, -27.0544101],
      [28.8962699, -27.05395],
      [28.89662, -27.0535701],
      [28.8968, -27.0534201],
      [28.8971, -27.0530401],
      [28.89793, -27.0517901],
      [28.89825, -27.0511501],
      [28.89854, -27.0507301],
      [28.89925, -27.0498701],
      [28.89958, -27.0493801],
      [28.89983, -27.0490201],
      [28.89995, -27.0488401],
      [28.90007, -27.0487201],
      [28.9001999, -27.0485601],
      [28.9003799, -27.04834],
      [28.9004499, -27.0480601],
      [28.9003899, -27.04761],
      [28.9000099, -27.0467701],
      [28.8998499, -27.0464201],
      [28.8995899, -27.0460401],
      [28.8991199, -27.04541],
      [28.8986899, -27.0450101],
      [28.8983399, -27.0447901],
      [28.8979299, -27.0445201],
      [28.8976499, -27.0443801],
      [28.8972499, -27.0442201],
      [28.8968899, -27.044],
      [28.8965299, -27.0435301],
      [28.8963899, -27.0432601],
      [28.8962999, -27.0429801],
      [28.8962099, -27.04267],
      [28.8961799, -27.0418501],
      [28.8962199, -27.0414001],
      [28.8963199, -27.0408201],
      [28.8965699, -27.03972],
      [28.8967499, -27.0392201],
      [28.89704, -27.0387001],
      [28.89715, -27.0384001],
      [28.89727, -27.0380601],
      [28.8975199, -27.0375001],
      [28.89791, -27.0368101],
      [28.89803, -27.0365101],
      [28.8982199, -27.0361301],
      [28.89868, -27.0355101],
      [28.8988399, -27.0353301],
      [28.8990099, -27.0351401],
      [28.8991099, -27.0348601],
      [28.8991399, -27.03466],
      [28.8991099, -27.0343901],
      [28.8990099, -27.0338101],
      [28.8989799, -27.0336201],
      [28.8988699, -27.0333701],
      [28.8987899, -27.0331901],
      [28.8987599, -27.0330301],
      [28.8987599, -27.0327401],
      [28.8988017, -27.0325057],
      [28.8988899, -27.03201],
      [28.8988799, -27.0317901],
      [28.8988199, -27.0314701],
      [28.89854, -27.030735],
      [28.8983699, -27.0302701],
      [28.8982499, -27.03],
      [28.8980299, -27.0296201],
      [28.8978099, -27.0293001],
      [28.8973399, -27.0286201],
      [28.8970999, -27.0283301],
      [28.8968599, -27.0281],
      [28.89655, -27.0279001],
      [28.8962199, -27.0276701],
      [28.8957199, -27.0274301],
      [28.8953999, -27.0272401],
      [28.8950199, -27.0270801],
      [28.8947199, -27.0268901],
      [28.8943099, -27.0267301],
      [28.8938599, -27.0265401],
      [28.89349, -27.0264201],
      [28.8930899, -27.02629],
      [28.89277, -27.0262401],
      [28.89251, -27.0262301],
      [28.89177, -27.0261401],
      [28.89097, -27.0261501],
      [28.8897099, -27.0261501],
      [28.8892199, -27.02617],
      [28.88887, -27.0261101],
      [28.88843, -27.0260501],
      [28.88819, -27.0259501],
      [28.88778, -27.0258401],
      [28.88742, -27.0257401],
      [28.88687, -27.0256701],
      [28.88635, -27.0255701],
      [28.8860599, -27.0254501],
      [28.8858399, -27.0253201],
      [28.8855599, -27.02517],
      [28.8854599, -27.0250001],
      [28.88535, -27.0248201],
      [28.8852999, -27.02441],
      [28.88541, -27.0240301],
      [28.88556, -27.0237101],
      [28.8857799, -27.02338],
      [28.88622, -27.0229101],
      [28.88682, -27.0224101],
      [28.8872399, -27.0220401],
      [28.8875599, -27.0216601],
      [28.8881199, -27.0209501],
      [28.8884899, -27.0205601],
      [28.88884, -27.0201401],
      [28.8890299, -27.01984],
      [28.88916, -27.0194401],
      [28.8895, -27.0188301],
      [28.88986, -27.0182901],
      [28.89016, -27.0178601],
      [28.89028, -27.0176801],
      [28.89061, -27.0171401],
      [28.89088, -27.0167501],
      [28.89117, -27.0164101],
      [28.8914999, -27.01608],
      [28.89174, -27.0159401],
      [28.8919099, -27.01577],
      [28.892, -27.0156001],
      [28.89207, -27.0153801],
      [28.89211, -27.0151301],
      [28.8921799, -27.01476],
      [28.89238, -27.0144801],
      [28.89262, -27.0142001],
      [28.89279, -27.0139801],
      [28.89296, -27.0138201],
      [28.89326, -27.0135601],
      [28.8935599, -27.0134],
      [28.89387, -27.0133501],
      [28.89418, -27.0133201],
      [28.8945199, -27.01337],
      [28.89486, -27.0136601],
      [28.8951099, -27.0139001],
      [28.8952999, -27.0140301],
      [28.89587, -27.0146401],
      [28.89625, -27.0149401],
      [28.89659, -27.0151101],
      [28.89702, -27.0154701],
      [28.89741, -27.01579],
      [28.89769, -27.01599],
      [28.89916, -27.01691],
      [28.89989, -27.01735],
      [28.9005, -27.01764],
      [28.90098, -27.01795],
      [28.9013, -27.01818],
      [28.90275, -27.01907],
      [28.90329, -27.01934],
      [28.90387, -27.01968],
      [28.9041599, -27.01983],
      [28.9046, -27.01997],
      [28.90523, -27.02007],
      [28.9058, -27.02013],
      [28.90669, -27.02009],
      [28.90708, -27.02011],
      [28.9075399, -27.02014],
      [28.90794, -27.02009],
      [28.90845, -27.01999],
      [28.90879, -27.01988],
      [28.9091899, -27.01972],
      [28.90965, -27.01938],
      [28.91005, -27.01913],
      [28.9103, -27.01899],
      [28.91102, -27.01856],
      [28.9111, -27.0185401],
      [28.91137, -27.0184801],
      [28.91179, -27.0183801],
      [28.91211, -27.0182701],
      [28.9124199, -27.01817],
      [28.91275, -27.0179501],
      [28.91318, -27.0176001],
      [28.91338, -27.0173901],
      [28.91351, -27.0172301],
      [28.91378, -27.0168601],
      [28.91406, -27.0165701],
      [28.9145, -27.0160401],
      [28.91475, -27.0157901],
      [28.91515, -27.0155301],
      [28.91534, -27.0153901],
      [28.9156, -27.0151801],
      [28.91579, -27.0149301],
      [28.91615, -27.0143501],
      [28.9166199, -27.01372],
      [28.91703, -27.0132901],
      [28.9174, -27.0130001],
      [28.91787, -27.0125701],
      [28.91809, -27.0124101],
      [28.91845, -27.0122701],
      [28.91867, -27.0121301],
      [28.91888, -27.0119701],
      [28.91911, -27.0118101],
      [28.91936, -27.0116001],
      [28.91966, -27.0113701],
      [28.91994, -27.0112101],
      [28.9203899, -27.01108],
      [28.92089, -27.0111001],
      [28.9214, -27.0111701],
      [28.92211, -27.0112701],
      [28.92322, -27.0114701],
      [28.9237499, -27.01155],
      [28.92463, -27.0118401],
      [28.92521, -27.0120901],
      [28.92581, -27.0124201],
      [28.92679, -27.0130101],
      [28.9269799, -27.01316],
      [28.92717, -27.0133601],
      [28.92764, -27.0139101],
      [28.92813, -27.0143801],
      [28.92845, -27.0145901],
      [28.9288499, -27.01475],
      [28.92929, -27.0148501],
      [28.92959, -27.0149101],
      [28.92998, -27.0149301],
      [28.93055, -27.0149501],
      [28.93086, -27.0149901],
      [28.93161, -27.0150601],
      [28.93215, -27.0151301],
      [28.93268, -27.0151801],
      [28.93319, -27.0152501],
      [28.93379, -27.0152801],
      [28.93413, -27.0153101],
      [28.93457, -27.0153601],
      [28.93534, -27.0153601],
      [28.93598, -27.0152801],
      [28.93657, -27.0152501],
      [28.93795, -27.0153201],
      [28.93829, -27.0153001],
      [28.93889, -27.0153601],
      [28.93968, -27.0154301],
      [28.94033, -27.0154401],
      [28.94079, -27.0154801],
      [28.9411799, -27.01548],
      [28.94144, -27.0153601],
      [28.94176, -27.0152501],
      [28.94261, -27.0150101],
      [28.9435, -27.0147301],
      [28.94406, -27.0146001],
      [28.94442, -27.0145101],
      [28.9447599, -27.01434],
      [28.94498, -27.0141101],
      [28.9452099, -27.01392],
      [28.94563, -27.0137301],
      [28.94641, -27.0134901],
      [28.94717, -27.0132601],
      [28.94769, -27.0130701],
      [28.94826, -27.0129701],
      [28.94865, -27.0128501],
      [28.94952, -27.0125501],
      [28.95018, -27.0123801],
      [28.95099, -27.0121601],
      [28.95145, -27.0120501],
      [28.9517399, -27.01194],
      [28.95214, -27.0118801],
      [28.95268, -27.0118101],
      [28.95324, -27.0117801],
      [28.95371, -27.0118001],
      [28.9540999, -27.01181],
      [28.95435, -27.0117401],
      [28.95458, -27.0116301],
      [28.9547699, -27.01146],
      [28.95509, -27.0108901],
      [28.95547, -27.0099601],
      [28.95581, -27.0092301],
      [28.95599, -27.0089301],
      [28.95607, -27.0087201],
      [28.95622, -27.0082901],
      [28.95632, -27.0079601],
      [28.9566, -27.0073901],
      [28.9568, -27.0070101],
      [28.95696, -27.0067201],
      [28.9572499, -27.00608],
      [28.95777, -27.0054701],
      [28.95812, -27.0050901],
      [28.95852, -27.0045801],
      [28.95929, -27.0035801],
      [28.95965, -27.0030901],
      [28.96006, -27.0026001],
      [28.96024, -27.0022401],
      [28.96033, -27.0019301],
      [28.96058, -27.0015001],
      [28.96097, -27.0008201],
      [28.9610199, -27.00063],
      [28.96099, -27.0004601],
      [28.96099, -27.0003701],
      [28.96102, -27.0000701],
      [28.96117, -26.9997101],
      [28.9612099, -26.99944],
      [28.96149, -26.9989001],
      [28.9617199, -26.99861],
      [28.96225, -26.9982301],
      [28.96271, -26.9978801],
      [28.96336, -26.9973701],
      [28.96401, -26.9968101],
      [28.96429, -26.9965801],
      [28.9649, -26.9961101],
      [28.96539, -26.9956101],
      [28.9660799, -26.99488],
      [28.96619, -26.9946901],
      [28.96628, -26.9944201],
      [28.96635, -26.9942401],
      [28.96643, -26.9941001],
      [28.96653, -26.9937901],
      [28.96655, -26.9934301],
      [28.96648, -26.9929201],
      [28.9665099, -26.99249],
      [28.9666, -26.9922701],
      [28.96686, -26.9919201],
      [28.9671699, -26.99161],
      [28.9675299, -26.99146],
      [28.96782, -26.9914701],
      [28.96842, -26.9915001],
      [28.96892, -26.9915601],
      [28.96953, -26.9916101],
      [28.97018, -26.9917501],
      [28.97083, -26.9918301],
      [28.9713299, -26.99189],
      [28.97201, -26.9920901],
      [28.97235, -26.9922101],
      [28.97299, -26.9924101],
      [28.97372, -26.9927101],
      [28.97415, -26.9929401],
      [28.9744699, -26.99312],
      [28.97483, -26.9934901],
      [28.97531, -26.9939801],
      [28.97555, -26.9942101],
      [28.97594, -26.9945701],
      [28.97654, -26.9951301],
      [28.9769799, -26.9955],
      [28.9775, -26.9958001],
      [28.97814, -26.9961001],
      [28.97904, -26.9965101],
      [28.97964, -26.9967501],
      [28.98005, -26.9968901],
      [28.98047, -26.9971401],
      [28.98085, -26.9973301],
      [28.98143, -26.9976101],
      [28.98178, -26.9978301],
      [28.98217, -26.9979801],
      [28.98272, -26.9982301],
      [28.98328, -26.9984801],
      [28.98381, -26.9987601],
      [28.98447, -26.9990101],
      [28.98492, -26.9991401],
      [28.98545, -26.9993201],
      [28.98591, -26.9994301],
      [28.9870499, -26.99971],
      [28.98748, -26.9998901],
      [28.98799, -27.0001301],
      [28.98844, -27.0003601],
      [28.98869, -27.0004801],
      [28.98881, -27.0005501],
      [28.98902, -27.0006501],
      [28.98919, -27.0007501],
      [28.98958, -27.0009701],
      [28.9899, -27.0012501],
      [28.99027, -27.0015701],
      [28.99058, -27.0017101],
      [28.99101, -27.0019001],
      [28.99155, -27.0022101],
      [28.99248, -27.0026501],
      [28.99269, -27.0027701],
      [28.99307, -27.0029601],
      [28.99349, -27.0032001],
      [28.99378, -27.0032701],
      [28.9943799, -27.00349],
      [28.99483, -27.0036201],
      [28.99524, -27.0037201],
      [28.99563, -27.0038401],
      [28.99613, -27.0039801],
      [28.99702, -27.0041601],
      [28.99751, -27.0042501],
      [28.99772, -27.0042801],
      [28.99835, -27.0043501],
      [28.99868, -27.0043701],
      [28.99899, -27.0044201],
      [28.99946, -27.0045101],
      [28.99961, -27.0045301],
      [28.99979, -27.0045701],
      [28.99999, -27.0046401],
      [29.00035, -27.0048701],
      [29.00072, -27.0049501],
      [29.00111, -27.0050101],
      [29.00147, -27.0050401],
      [29.00246, -27.0052101],
      [29.00284, -27.0052601],
      [29.00334, -27.0054101],
      [29.003714, -27.005491],
      [29.00394, -27.0055401],
      [29.00458, -27.0057001],
      [29.00523, -27.0057601],
      [29.0061, -27.0058801],
      [29.00646, -27.0058801],
      [29.00674, -27.0059201],
      [29.00727, -27.0060201],
      [29.00756, -27.0060801],
      [29.00781, -27.0061101],
      [29.00828, -27.0061001],
      [29.00867, -27.0061501],
      [29.00914, -27.0062301],
      [29.0097299, -27.00641],
      [29.0101, -27.0066001],
      [29.01057, -27.0069101],
      [29.01155, -27.0076001],
      [29.01192, -27.0079601],
      [29.01235, -27.0082301],
      [29.01274, -27.0085301],
      [29.01336, -27.0089501],
      [29.01407, -27.0093901],
      [29.01446, -27.0095601],
      [29.01473, -27.0097301],
      [29.01513, -27.0099501],
      [29.0151418, -27.0099569],
      [29.01564, -27.0102501],
      [29.01607, -27.0104701],
      [29.0165299, -27.0108],
      [29.01727, -27.0114901],
      [29.01773, -27.0120201],
      [29.0182, -27.0124601],
      [29.01872, -27.0127901],
      [29.01922, -27.0131201],
      [29.01987, -27.0135701],
      [29.02039, -27.0138401],
      [29.02085, -27.0141101],
      [29.02126, -27.0143501],
      [29.02167, -27.0145701],
      [29.02228, -27.0150001],
      [29.0226799, -27.01528],
      [29.02307, -27.0154201],
      [29.02343, -27.0155101],
      [29.02393, -27.0156301],
      [29.0246, -27.0158301],
      [29.02521, -27.0159501],
      [29.02588, -27.0160801],
      [29.02635, -27.0161801],
      [29.02665, -27.0162501],
      [29.0270199, -27.01643],
      [29.02729, -27.0167501],
      [29.0275, -27.0170601],
      [29.02783, -27.0175201],
      [29.02793, -27.0177601],
      [29.0280799, -27.01817],
      [29.02808, -27.0184501],
      [29.028, -27.0187401],
      [29.0279099, -27.01924],
      [29.02769, -27.0195501],
      [29.02743, -27.0198601],
      [29.02681, -27.0205601],
      [29.02649, -27.0209101],
      [29.0262699, -27.02124],
      [29.02618, -27.0216301],
      [29.02615, -27.0219101],
      [29.02618, -27.0220901],
      [29.0263199, -27.02241],
      [29.02681, -27.0230001],
      [29.02709, -27.0232201],
      [29.02759, -27.0236401],
      [29.02799, -27.0240001],
      [29.02844, -27.0244201],
      [29.02941, -27.0252601],
      [29.03, -27.0258801],
      [29.0301499, -27.02607],
      [29.03026, -27.0263001],
      [29.03029, -27.0265701],
      [29.03025, -27.0269101],
      [29.0302, -27.0270501],
      [29.03015, -27.0273701],
      [29.03015, -27.0277701],
      [29.0302, -27.0281101],
      [29.0303199, -27.02848],
      [29.0305, -27.0286401],
      [29.03069, -27.0287801],
      [29.03098, -27.0289201],
      [29.0312399, -27.02896],
      [29.03151, -27.0289101],
      [29.03192, -27.0287801],
      [29.03228, -27.0286201],
      [29.03287, -27.0284201],
      [29.03344, -27.0282801],
      [29.03398, -27.0280601],
      [29.03453, -27.0277601],
      [29.0349299, -27.02753],
      [29.03524, -27.0272901],
      [29.03557, -27.0269301],
      [29.03603, -27.0264301],
      [29.03646, -27.0259401],
      [29.03676, -27.0256301],
      [29.03697, -27.0254001],
      [29.03724, -27.0252201],
      [29.03752, -27.0249401],
      [29.0377199, -27.02466],
      [29.03788, -27.0241901],
      [29.03822, -27.0235601],
      [29.03844, -27.0232101],
      [29.03859, -27.0228901],
      [29.0387699, -27.02249],
      [29.03884, -27.0221301],
      [29.03878, -27.0217501],
      [29.03875, -27.0215001],
      [29.0391, -27.0202401],
      [29.03934, -27.0197801],
      [29.0395199, -27.01903],
      [29.03962, -27.0183001],
      [29.03965, -27.0180401],
      [29.03968, -27.0174801],
      [29.03978, -27.0163701],
      [29.03976, -27.0157701],
      [29.03977, -27.0153101],
      [29.03965, -27.0145701],
      [29.03963, -27.0140401],
      [29.03962, -27.0134501],
      [29.0395899, -27.01278],
      [29.03951, -27.0125201],
      [29.03939, -27.0122901],
      [29.03925, -27.0119601],
      [29.03915, -27.0114301],
      [29.03895, -27.0104901],
      [29.03886, -27.0100501],
      [29.03868, -27.0095401],
      [29.0385599, -27.00904],
      [29.03849, -27.0084801],
      [29.03846, -27.0079801],
      [29.0385, -27.0072301],
      [29.03849, -27.0069701],
      [29.03834, -27.0067101],
      [29.0382699, -27.00645],
      [29.03831, -27.0060701],
      [29.03838, -27.0055101],
      [29.0384399, -27.00534],
      [29.03863, -27.0050901],
      [29.03884, -27.0048201],
      [29.03925, -27.0045301],
      [29.0396499, -27.00432],
      [29.04023, -27.0041401],
      [29.04072, -27.0040401],
      [29.04147, -27.0039601],
      [29.0421799, -27.00383],
      [29.04301, -27.0038401],
      [29.04346, -27.0038401],
      [29.04392, -27.0038901],
      [29.0444599, -27.00395],
      [29.04492, -27.0040901],
      [29.04536, -27.0042701],
      [29.04545, -27.0043301],
      [29.04565, -27.0044201],
      [29.04595, -27.0045001],
      [29.04645, -27.0045701],
      [29.04688, -27.0046701],
      [29.0473, -27.0047601],
      [29.04769, -27.0048501],
      [29.04794, -27.0049001],
      [29.04851, -27.0051301],
      [29.04912, -27.0052501],
      [29.04977, -27.0054701],
      [29.0504499, -27.00571],
      [29.05107, -27.0060201],
      [29.05148, -27.0062301],
      [29.05179, -27.0065101],
      [29.05236, -27.0069901],
      [29.05264, -27.0072301],
      [29.0529499, -27.00743],
      [29.05319, -27.0075301],
      [29.05346, -27.0076301],
      [29.05396, -27.0076601],
      [29.05433, -27.0076801],
      [29.05486, -27.0077701],
      [29.05527, -27.0078601],
      [29.0555499, -27.00795],
      [29.05592, -27.0081601],
      [29.05631, -27.0084201],
      [29.05666, -27.0087101],
      [29.05691, -27.0089601],
      [29.0572299, -27.0093],
      [29.05762, -27.0099901],
      [29.05774, -27.0101701],
      [29.05809, -27.0108601],
      [29.05837, -27.0113501],
      [29.05851, -27.0116701],
      [29.05869, -27.0120601],
      [29.0589, -27.0129201],
      [29.05921, -27.0140001],
      [29.05945, -27.0146901],
      [29.0595999, -27.01514],
      [29.05971, -27.0158501],
      [29.05978, -27.0163601],
      [29.05979, -27.0168901],
      [29.05977, -27.0172701],
      [29.05971, -27.0174601],
      [29.05967, -27.0176801],
      [29.0596599, -27.01796],
      [29.05947, -27.0184201],
      [29.05932, -27.0186101],
      [29.05918, -27.0189501],
      [29.05899, -27.0192101],
      [29.05875, -27.0195701],
      [29.05863, -27.0200501],
      [29.05856, -27.0203601],
      [29.05828, -27.0208901],
      [29.05821, -27.0213001],
      [29.0578, -27.0222801],
      [29.05727, -27.0237201],
      [29.05689, -27.0245901],
      [29.0566, -27.0252001],
      [29.05637, -27.0257801],
      [29.0562099, -27.02616],
      [29.05606, -27.0264001],
      [29.05542, -27.0270801],
      [29.05505, -27.0275801],
      [29.05464, -27.0282001],
      [29.05436, -27.0288001],
      [29.05411, -27.0293401],
      [29.05398, -27.0295401],
      [29.0538, -27.0297201],
      [29.0536099, -27.02993],
      [29.05346, -27.0304001],
      [29.0533799, -27.03107],
      [29.05334, -27.0315201],
      [29.05327, -27.0317301],
      [29.0532, -27.0322301],
      [29.0531499, -27.0325],
      [29.0532, -27.0329401],
      [29.05326, -27.0335101],
      [29.05332, -27.0336901],
      [29.0535399, -27.03413],
      [29.0538, -27.0344901],
      [29.05421, -27.0349901],
      [29.05461, -27.0353501],
      [29.0549999, -27.0357],
      [29.05544, -27.0360201],
      [29.05603, -27.0363801],
      [29.05661, -27.0367601],
      [29.05697, -27.0369801],
      [29.05722, -27.0371701],
      [29.05769, -27.0375701],
      [29.05881, -27.0384801],
      [29.05931, -27.0388301],
      [29.05995, -27.0392601],
      [29.06037, -27.0394601],
      [29.06069, -27.0396801],
      [29.06109, -27.0399101],
      [29.06166, -27.0401601],
      [29.06222, -27.0405201],
      [29.0629, -27.0408401],
      [29.06334, -27.0411401],
      [29.0638999, -27.04163],
      [29.06432, -27.0421201],
      [29.06463, -27.0425101],
      [29.0648599, -27.04283],
      [29.06495, -27.0430701],
      [29.065, -27.0432901],
      [29.06509, -27.0435701],
      [29.06509, -27.0437101],
      [29.0650699, -27.04382],
      [29.06498, -27.0440101],
      [29.06465, -27.0443601],
      [29.0645099, -27.04453],
      [29.06426, -27.0446901],
      [29.06383, -27.0448601],
      [29.06338, -27.0449901],
      [29.06305, -27.0450201],
      [29.06261, -27.0450801],
      [29.06244, -27.0451401],
      [29.0622099, -27.04522],
      [29.06189, -27.0454701],
      [29.0617, -27.0456801],
      [29.06154, -27.0459801],
      [29.0614499, -27.04626],
      [29.06145, -27.0469601],
      [29.06153, -27.0475801],
      [29.06161, -27.0479601],
      [29.0616399, -27.04833],
      [29.06168, -27.0484701],
      [29.06183, -27.0488701],
      [29.06216, -27.0494801],
      [29.0626599, -27.0503],
      [29.06302, -27.0507201],
      [29.06333, -27.0511601],
      [29.06351, -27.0514001],
      [29.06372, -27.0515601],
      [29.0642299, -27.05201],
      [29.06483, -27.0523401],
      [29.06533, -27.0526201],
      [29.06577, -27.0528401],
      [29.0661, -27.0530301],
      [29.06683, -27.0535801],
      [29.06709, -27.0538801],
      [29.0674, -27.0542301],
      [29.06787, -27.0546601],
      [29.0683099, -27.05501],
      [29.06865, -27.0552001],
      [29.06891, -27.0553701],
      [29.06952, -27.0555801],
      [29.06996, -27.0557901],
      [29.07022, -27.0559401],
      [29.0705599, -27.05604],
      [29.0708, -27.0560201],
      [29.07129, -27.0560701],
      [29.0715399, -27.05611],
      [29.07177, -27.0561901],
      [29.07195, -27.0563101],
      [29.0720599, -27.05645],
      [29.072088, -27.056581],
      [29.07211, -27.0567901],
      [29.0721099, -27.05698],
      [29.072, -27.0572201],
      [29.07169, -27.0577101],
      [29.07146, -27.0581201],
      [29.0712, -27.0585701],
      [29.07109, -27.0587901],
      [29.07093, -27.0591401],
      [29.0708299, -27.05937],
      [29.07081, -27.0595601],
      [29.07082, -27.0600601],
      [29.0710799, -27.06071],
      [29.07143, -27.0611301],
      [29.07171, -27.0614201],
      [29.07197, -27.0616301],
      [29.0724899, -27.06204],
      [29.07288, -27.0622301],
      [29.07323, -27.0623401],
      [29.07357, -27.0624401],
      [29.0739599, -27.06273],
      [29.07413, -27.0629601],
      [29.0742299, -27.06318],
      [29.07425, -27.0634701],
      [29.07422, -27.0638601],
      [29.07415, -27.0642201],
      [29.0740599, -27.0645],
      [29.07379, -27.0647301],
      [29.0735399, -27.06491],
      [29.07329, -27.0650001],
      [29.07308, -27.0650101],
      [29.0727999, -27.06492],
      [29.07256, -27.0645601],
      [29.07247, -27.0643201],
      [29.07222, -27.0640001],
      [29.0719099, -27.0637],
      [29.07169, -27.0636501],
      [29.07144, -27.0636301],
      [29.0710199, -27.06375],
      [29.0708, -27.0639701],
      [29.0706299, -27.06425],
      [29.0706499, -27.06474],
      [29.07083, -27.0650001],
      [29.0710199, -27.06514],
      [29.07124, -27.0651801],
      [29.0715699, -27.0653],
      [29.07182, -27.0655001],
      [29.0719499, -27.06575],
      [29.07196, -27.0659401],
      [29.0718999, -27.06618],
      [29.07154, -27.0666401],
      [29.07098, -27.0671101],
      [29.07065, -27.0673901],
      [29.07039, -27.0675601],
      [29.0700699, -27.06776],
      [29.0698, -27.0677901],
      [29.06937, -27.0678201],
      [29.069, -27.0678101],
      [29.06861, -27.0677001],
      [29.0684299, -27.06763],
      [29.06823, -27.0674301],
      [29.06812, -27.0672101],
      [29.0679599, -27.06693],
      [29.06789, -27.0666401],
      [29.06783, -27.0662201],
      [29.06776, -27.0656401],
      [29.06759, -27.0650801],
      [29.0673899, -27.06474],
      [29.06698, -27.0645101],
      [29.0667099, -27.06449],
      [29.06634, -27.0646101],
      [29.06594, -27.0647801],
      [29.06544, -27.0650801],
      [29.0652199, -27.0653],
      [29.06475, -27.0660101],
      [29.06424, -27.0668901],
      [29.06386, -27.0673201],
      [29.06369, -27.0675101],
      [29.06349, -27.0677901],
      [29.06327, -27.0683101],
      [29.06294, -27.0690001],
      [29.06277, -27.0693601],
      [29.06253, -27.0698301],
      [29.06218, -27.0702201],
      [29.06182, -27.0706801],
      [29.06125, -27.0714301],
      [29.0610299, -27.07175],
      [29.06095, -27.0720401],
      [29.0608899, -27.07239],
      [29.06096, -27.0727601],
      [29.06104, -27.0731001],
      [29.06114, -27.0733201],
      [29.06139, -27.0737901],
      [29.06194, -27.0746101],
      [29.06207, -27.0748801],
      [29.0621199, -27.07505],
      [29.06213, -27.0755401],
      [29.06202, -27.0758601],
      [29.06175, -27.0762601],
      [29.06151, -27.0769301],
      [29.06128, -27.0776401],
      [29.06111, -27.0780801],
      [29.06087, -27.0785301],
      [29.0605899, -27.07898],
      [29.06027, -27.0792801],
      [29.0600199, -27.07939],
      [29.05966, -27.0794201],
      [29.05923, -27.0794201],
      [29.05884, -27.0793101],
      [29.05859, -27.0792401],
      [29.05804, -27.0791401],
      [29.05762, -27.0790401],
      [29.05719, -27.0788401],
      [29.05681, -27.0787001],
      [29.05638, -27.0786201],
      [29.0559999, -27.07862],
      [29.05575, -27.0787301],
      [29.0556, -27.0789101],
      [29.0554199, -27.07923],
      [29.05542, -27.0794801],
      [29.05543, -27.0800601],
      [29.0556, -27.0808401],
      [29.05574, -27.0813401],
      [29.0559899, -27.08192],
      [29.0562599, -27.08224],
      [29.05661, -27.0824001],
      [29.05726, -27.0826801],
      [29.05763, -27.0828801],
      [29.05798, -27.0830301],
      [29.05876, -27.0832001],
      [29.05947, -27.0834301],
      [29.0597599, -27.08356],
      [29.06009, -27.0838201],
      [29.06046, -27.0841401],
      [29.06074, -27.0845001],
      [29.06128, -27.0850101],
      [29.06161, -27.0851801],
      [29.0619199, -27.08527],
      [29.06231, -27.0853001],
      [29.06259, -27.0853001],
      [29.0629599, -27.08522],
      [29.06313, -27.0851101],
      [29.06339, -27.0848601],
      [29.06352, -27.0845301],
      [29.06373, -27.0842301],
      [29.06406, -27.0839301],
      [29.0644099, -27.08373],
      [29.06467, -27.0836701],
      [29.0651199, -27.08378],
      [29.06553, -27.0840401],
      [29.06594, -27.0843601],
      [29.06633, -27.0847701],
      [29.06666, -27.0850601],
      [29.06699, -27.0853101],
      [29.0673299, -27.0855],
      [29.06773, -27.0856101],
      [29.06849, -27.0857901],
      [29.06902, -27.0858901],
      [29.06948, -27.0859101],
      [29.0700599, -27.08586],
      [29.07049, -27.0857501],
      [29.0708099, -27.08558],
      [29.0712399, -27.08551],
      [29.07144, -27.0855501],
      [29.07162, -27.0856001],
      [29.0718299, -27.08573],
      [29.07191, -27.0858701],
      [29.07196, -27.0860101],
      [29.07205, -27.0864501],
      [29.0721, -27.0868001],
      [29.07208, -27.0871501],
      [29.07204, -27.0875501],
      [29.07199, -27.0879401],
      [29.0719999, -27.08805],
      [29.07211, -27.0882601],
      [29.07228, -27.0886501],
      [29.0725, -27.0889701],
      [29.07285, -27.0895301],
      [29.0737199, -27.09082],
      [29.07409, -27.0912001],
      [29.07438, -27.0915701],
      [29.07468, -27.0918501],
      [29.0748799, -27.09193],
      [29.07513, -27.0918501],
      [29.0753, -27.0917701],
      [29.07544, -27.0915301],
      [29.0757, -27.0912501],
      [29.0758799, -27.09114],
      [29.07626, -27.0911301],
      [29.0764799, -27.09114],
      [29.07691, -27.0915001],
      [29.07727, -27.0919401],
      [29.07773, -27.0925801],
      [29.0779399, -27.09304],
      [29.07799, -27.0936001],
      [29.07785, -27.0940301],
      [29.0778, -27.0943901],
      [29.07782, -27.0947401],
      [29.07783, -27.0950401],
      [29.0778499, -27.09521],
      [29.0781, -27.0958901],
      [29.07843, -27.0965101],
      [29.07856, -27.0966501],
      [29.07873, -27.0968301],
      [29.0789, -27.0970801],
      [29.07912, -27.0974801],
      [29.07944, -27.0984801],
      [29.07952, -27.0986201],
      [29.07964, -27.0988101],
      [29.07974, -27.0990601],
      [29.07985, -27.0994401],
      [29.07996, -27.0997301],
      [29.08005, -27.0999801],
      [29.08021, -27.1001701],
      [29.0804099, -27.10041],
      [29.08054, -27.1005001],
      [29.08073, -27.1005601],
      [29.08102, -27.1006901],
      [29.08137, -27.1009201],
      [29.0817099, -27.10123],
      [29.08203, -27.1016601],
      [29.0822399, -27.10199],
      [29.08234, -27.1023401],
      [29.0825, -27.1029401],
      [29.08265, -27.1035301],
      [29.08268, -27.1038501],
      [29.08275, -27.1041701],
      [29.08291, -27.1046701],
      [29.08315, -27.1051701],
      [29.08329, -27.1054301],
      [29.0834199, -27.1056],
      [29.08372, -27.1058101],
      [29.08417, -27.1059601],
      [29.08463, -27.1059901],
      [29.08503, -27.1060201],
      [29.08524, -27.1060601],
      [29.0857499, -27.10613],
      [29.08604, -27.1062401],
      [29.0862899, -27.10644],
      [29.08643, -27.1066801],
      [29.08647, -27.1071301],
      [29.0864399, -27.1073],
      [29.0863, -27.1076701],
      [29.08604, -27.1081701],
      [29.08583, -27.1087401],
      [29.08572, -27.1090201],
      [29.0856599, -27.10922],
      [29.08564, -27.1094501],
      [29.08566, -27.1099001],
      [29.08573, -27.1102601],
      [29.0858099, -27.11046],
      [29.08604, -27.1107601],
      [29.08639, -27.1111601],
      [29.087, -27.1116601],
      [29.08725, -27.1119001],
      [29.0874299, -27.11201],
      [29.08773, -27.1120901],
      [29.08812, -27.1122001],
      [29.08823, -27.1122601],
      [29.0884, -27.1123301],
      [29.0884899, -27.1124],
      [29.0886, -27.1125601],
      [29.08865, -27.1128001],
      [29.0886499, -27.113],
      [29.08857, -27.1132001],
      [29.0883, -27.1134101],
      [29.08707, -27.1141501],
      [29.08672, -27.1143601],
      [29.08654, -27.1145101],
      [29.0862599, -27.11476],
      [29.08612, -27.1149701],
      [29.08601, -27.1152601],
      [29.08601, -27.1154601],
      [29.0860599, -27.11576],
      [29.08623, -27.1160101],
      [29.08639, -27.1161501],
      [29.0866599, -27.11639],
      [29.08687, -27.1165101],
      [29.08717, -27.1166601],
      [29.08762, -27.1168401],
      [29.08801, -27.1169801],
      [29.08814, -27.1170501],
      [29.0881999, -27.1171],
      [29.08826, -27.1172001],
      [29.08832, -27.1173701],
      [29.08832, -27.1175301],
      [29.08833, -27.1177701],
      [29.08836, -27.1179801],
      [29.0884299, -27.11821],
      [29.08858, -27.1183701],
      [29.0888099, -27.11855],
      [29.0891, -27.1186201],
      [29.08935, -27.1186301],
      [29.08997, -27.1186101],
      [29.0906, -27.1185901],
      [29.09122, -27.1185901],
      [29.0914899, -27.11854],
      [29.09167, -27.1184301],
      [29.0919, -27.1182301],
      [29.0921, -27.1181201],
      [29.0923999, -27.11804],
      [29.0926, -27.1180801],
      [29.0927399, -27.11816],
      [29.09284, -27.1183301],
      [29.0928799, -27.1185],
      [29.09274, -27.1188201],
      [29.09249, -27.1190401],
      [29.09215, -27.1193601],
      [29.09183, -27.1195401],
      [29.0915499, -27.11993],
      [29.09144, -27.1202601],
      [29.0913999, -27.12056],
      [29.0915, -27.1208601],
      [29.09173, -27.1211401],
      [29.09199, -27.1213201],
      [29.09212, -27.1214401],
      [29.09229, -27.1216401],
      [29.09247, -27.1218901],
      [29.0927199, -27.12213],
      [29.09297, -27.1222601],
      [29.09325, -27.1223201],
      [29.09365, -27.1223201],
      [29.0940399, -27.12225],
      [29.09423, -27.1221101],
      [29.09443, -27.1219501],
      [29.09461, -27.1218101],
      [29.0948, -27.1216701],
      [29.09512, -27.1215701],
      [29.0953199, -27.12157],
      [29.09557, -27.1216901],
      [29.09622, -27.1221301],
      [29.09664, -27.1224501],
      [29.0970299, -27.12273],
      [29.09718, -27.1229801],
      [29.09732, -27.1232301],
      [29.09757, -27.1237901],
      [29.09799, -27.1248701],
      [29.09838, -27.1255901],
      [29.09865, -27.1261201],
      [29.09899, -27.1265601],
      [29.0992399, -27.12688],
      [29.09952, -27.1271501],
      [29.10007, -27.1275801],
      [29.10077, -27.1280101],
      [29.10117, -27.1282701],
      [29.10155, -27.1285301],
      [29.10224, -27.1289701],
      [29.10286, -27.1293801],
      [29.10351, -27.1298301],
      [29.10376, -27.1300601],
      [29.1040099, -27.13034],
      [29.10417, -27.1306001],
      [29.10452, -27.1311401],
      [29.10495, -27.1318901],
      [29.10517, -27.1323901],
      [29.1053599, -27.13288],
      [29.10541, -27.1331401],
      [29.10542, -27.1333501],
      [29.1054099, -27.13376],
      [29.10532, -27.1339901],
      [29.10513, -27.1342101],
      [29.1049399, -27.13439],
      [29.10468, -27.1344701],
      [29.1043199, -27.13449],
      [29.104, -27.1343501],
      [29.10384, -27.1341601],
      [29.1036599, -27.13405],
      [29.10319, -27.1339801],
      [29.10262, -27.1339501],
      [29.1022799, -27.13396],
      [29.10202, -27.1340801],
      [29.10183, -27.1342401],
      [29.1014399, -27.13474],
      [29.10125, -27.1353301],
      [29.10115, -27.1360601],
      [29.1012, -27.1365001],
      [29.10127, -27.1369201],
      [29.1013499, -27.13724],
      [29.10177, -27.1375901],
      [29.10225, -27.1379101],
      [29.10265, -27.1381801],
      [29.10325, -27.1387801],
      [29.10461, -27.1400501],
      [29.10496, -27.1403401],
      [29.10523, -27.1405501],
      [29.10564, -27.1407301],
      [29.10616, -27.1409901],
      [29.10677, -27.1413701],
      [29.10714, -27.1416301],
      [29.1074499, -27.14189],
      [29.10784, -27.1424201],
      [29.10812, -27.1428801],
      [29.10839, -27.1433301],
      [29.10909, -27.1445901],
      [29.10958, -27.1453401],
      [29.1098, -27.1457001],
      [29.11007, -27.1463401],
      [29.11027, -27.1469901],
      [29.11038, -27.1473401],
      [29.11063, -27.1477101],
      [29.1108699, -27.14797],
      [29.11129, -27.1482501],
      [29.11166, -27.1484801],
      [29.11228, -27.1487701],
      [29.11247, -27.1488701],
      [29.11281, -27.1490301],
      [29.11312, -27.1491801],
      [29.11323, -27.1492801],
      [29.1134499, -27.14956],
      [29.11347, -27.1497601],
      [29.1133999, -27.14995],
      [29.11319, -27.1502301],
      [29.11262, -27.1509201],
      [29.11249, -27.1511701],
      [29.1123, -27.1515201],
      [29.1121599, -27.15185],
      [29.1121, -27.1521601],
      [29.1121, -27.1528301],
      [29.11212, -27.1529501],
      [29.11222, -27.1531701],
      [29.11245, -27.1536801],
      [29.11251, -27.1540301],
      [29.11254, -27.1544001],
      [29.11259, -27.1547201],
      [29.11262, -27.1552301],
      [29.11263, -27.1555901],
      [29.11269, -27.1559701],
      [29.1127699, -27.15625],
      [29.11319, -27.1569701],
      [29.11357, -27.1576301],
      [29.11381, -27.1581501],
      [29.11406, -27.1587201],
      [29.1141099, -27.15891],
      [29.11414, -27.1594301],
      [29.1141299, -27.1600801],
      [29.11408, -27.1607501],
      [29.11397, -27.1613801],
      [29.11384, -27.1619401],
      [29.1138, -27.1621801],
      [29.1137, -27.1625201],
      [29.11368, -27.1628301],
      [29.1136599, -27.16324],
      [29.11375, -27.1637301],
      [29.11394, -27.1641301],
      [29.11414, -27.1643801],
      [29.1143, -27.1646901],
      [29.1144, -27.1649201],
      [29.1145799, -27.16541],
      [29.11465, -27.1659301],
      [29.11467, -27.1667401],
      [29.11471, -27.1675101],
      [29.11468, -27.1678401],
      [29.1146799, -27.1685601],
      [29.1146999, -27.16885],
      [29.1148099, -27.1690701],
      [29.1149399, -27.1693101],
      [29.1150499, -27.1695701],
      [29.1151299, -27.1698001],
      [29.1153699, -27.1700901],
      [29.11555, -27.1703001],
      [29.11587, -27.1707001],
      [29.1160299, -27.1709101],
      [29.1161499, -27.1712301],
      [29.11632, -27.1715101],
      [29.1165399, -27.1718201],
      [29.1165799, -27.1720001],
      [29.1167599, -27.1722301],
      [29.1169399, -27.1723901],
      [29.1171399, -27.17253],
      [29.1174099, -27.1725801],
      [29.1176899, -27.1726001],
      [29.1179999, -27.1726301],
      [29.1182299, -27.1726301],
      [29.1185899, -27.1726201],
      [29.1188699, -27.1726001],
      [29.1191699, -27.17254],
      [29.1195899, -27.1723801],
      [29.1201599, -27.1721001],
      [29.1206099, -27.1718501],
      [29.1210099, -27.17157],
      [29.1212599, -27.1713201],
      [29.1215099, -27.1709901],
      [29.1217599, -27.1705201],
      [29.1218999, -27.1702401],
      [29.1221599, -27.1698601],
      [29.1223699, -27.1695801],
      [29.1225399, -27.1693301],
      [29.1227499, -27.1689701],
      [29.1228599, -27.1687601],
      [29.1231299, -27.1683901],
      [29.1234599, -27.1679501],
      [29.1236799, -27.16771],
      [29.1240599, -27.1674001],
      [29.1244199, -27.1672301],
      [29.1246999, -27.16715],
      [29.1252399, -27.1670701],
      [29.1257699, -27.1670001],
      [29.1262699, -27.1670101],
      [29.1264999, -27.1671],
      [29.1265899, -27.1672301],
      [29.1266299, -27.1674501],
      [29.1265199, -27.1678401],
      [29.1265199, -27.1682],
      [29.1265899, -27.1684901],
      [29.1266699, -27.1687501],
      [29.1269099, -27.169],
      [29.1271799, -27.1690501],
      [29.1274999, -27.16907],
      [29.1279399, -27.1689901],
      [29.1284399, -27.1688201],
      [29.1288899, -27.1686801],
      [29.1292199, -27.1685201],
      [29.1295699, -27.16836],
      [29.1297899, -27.1681401],
      [29.1299999, -27.1678601],
      [29.1302299, -27.1673601],
      [29.1303599, -27.1669301],
      [29.1304199, -27.16665],
      [29.1303799, -27.1662001],
      [29.1301699, -27.1655701],
      [29.1298299, -27.1644401],
      [29.1295999, -27.1637201],
      [29.1295299, -27.1633401],
      [29.1295299, -27.1631101],
      [29.1295799, -27.16282],
      [29.1296999, -27.1626801],
      [29.1298999, -27.1625901],
      [29.1300499, -27.16254],
      [29.1302999, -27.1625401],
      [29.1306999, -27.1626501],
      [29.1309399, -27.1627101],
      [29.1312099, -27.16269],
      [29.1314299, -27.1625601],
      [29.1315699, -27.1624401],
      [29.1316799, -27.16226],
      [29.1317299, -27.1619001],
      [29.1317399, -27.1616701],
      [29.1317599, -27.1611901],
      [29.1317999, -27.1606701],
      [29.1318899, -27.16034],
      [29.1320999, -27.1601701],
      [29.1323199, -27.1601201],
      [29.1326299, -27.16012],
      [29.1328399, -27.16024],
      [29.1328899, -27.1603701],
      [29.1329599, -27.1608101],
      [29.1329899, -27.1613001],
      [29.1329999, -27.1615301],
      [29.1330699, -27.1619701],
      [29.1331299, -27.16228],
      [29.1332499, -27.1624601],
      [29.1334199, -27.16256],
      [29.1336399, -27.1626001],
      [29.1338799, -27.16259],
      [29.1340599, -27.1624901],
      [29.1344199, -27.1623001],
      [29.1347699, -27.1621],
      [29.1351199, -27.1620401],
      [29.1355199, -27.1620401],
      [29.1359699, -27.16202],
      [29.1362199, -27.1619201],
      [29.1364999, -27.1617701],
      [29.1368599, -27.1615301],
      [29.1371599, -27.1612501],
      [29.1373999, -27.1610001],
      [29.1376499, -27.16065],
      [29.1378299, -27.1600901],
      [29.1379099, -27.1597701],
      [29.1379699, -27.1592001],
      [29.1379999, -27.1588401],
      [29.1379499, -27.15841],
      [29.1376999, -27.1577901],
      [29.1374699, -27.1571601],
      [29.1372699, -27.1567001],
      [29.1369399, -27.1562601],
      [29.1365299, -27.1554201],
      [29.1363799, -27.15506],
      [29.1363199, -27.1546101],
      [29.1363699, -27.15422],
      [29.1365699, -27.1539501],
      [29.1370099, -27.1536801],
      [29.1372399, -27.1534501],
      [29.1374199, -27.15322],
      [29.1374999, -27.1529701],
      [29.1375399, -27.1526001],
      [29.1376599, -27.15241],
      [29.1379599, -27.1522401],
      [29.1382099, -27.1521501],
      [29.1385199, -27.15208],
      [29.1390899, -27.1521801],
      [29.1394599, -27.15233],
      [29.1401499, -27.1528301],
      [29.1406099, -27.1530801],
      [29.1411299, -27.1534401],
      [29.1413899, -27.1537001],
      [29.1416699, -27.15381],
      [29.1419899, -27.1538201],
      [29.1422899, -27.15378],
      [29.1424999, -27.1536801],
      [29.1427099, -27.1535201],
      [29.1428999, -27.1533501],
      [29.1430799, -27.1531301],
      [29.1432799, -27.15289],
      [29.1434799, -27.1528101],
      [29.1437099, -27.1526901],
      [29.1439299, -27.15264],
      [29.1443999, -27.1527101],
      [29.1449399, -27.1528201],
      [29.1453999, -27.1528501],
      [29.1458199, -27.15282],
      [29.1460499, -27.1527501],
      [29.1462699, -27.1526401],
      [29.1464399, -27.1525101],
      [29.1465599, -27.1523701],
      [29.1466799, -27.1522],
      [29.1467399, -27.1520001],
      [29.1467799, -27.1515801],
      [29.1467599, -27.1507501],
      [29.1467299, -27.1503301],
      [29.1467599, -27.1500101],
      [29.1467999, -27.1495701],
      [29.1468699, -27.1494],
      [29.1471599, -27.1491801],
      [29.1473699, -27.14908],
      [29.1477499, -27.1491201],
      [29.1481199, -27.14919],
      [29.1485899, -27.1494401],
      [29.1489799, -27.1497101],
      [29.1492999, -27.15002],
      [29.1493899, -27.1502201],
      [29.1494999, -27.1505501],
      [29.1496299, -27.1509101],
      [29.1497899, -27.1511801],
      [29.1500099, -27.1515],
      [29.1504099, -27.1518101],
      [29.1507599, -27.15194],
      [29.1510199, -27.1519001],
      [29.1512199, -27.1517701],
      [29.1512999, -27.15169],
      [29.1513999, -27.1514701],
      [29.1513599, -27.1512401],
      [29.1513999, -27.15095],
      [29.1515799, -27.1506501],
      [29.1517599, -27.1503301],
      [29.1520199, -27.1500601],
      [29.1521499, -27.1499001],
      [29.1522599, -27.1496501],
      [29.1522699, -27.14939],
      [29.1521799, -27.1490501],
      [29.1520599, -27.1487001],
      [29.1520499, -27.1482601],
      [29.1520499, -27.1477101],
      [29.1521299, -27.1472],
      [29.1523099, -27.1467201],
      [29.1524799, -27.1463101],
      [29.1526499, -27.1460001],
      [29.1529799, -27.14566],
      [29.1533299, -27.1455001],
      [29.1542999, -27.1452201],
      [29.1551199, -27.14501],
      [29.1556799, -27.1449401],
      [29.1561499, -27.1449301],
      [29.1565399, -27.14498],
      [29.1568799, -27.1451001],
      [29.1571199, -27.14525],
      [29.1572799, -27.1454401],
      [29.1575399, -27.1458701],
      [29.1577599, -27.1461601],
      [29.1580599, -27.14627],
      [29.1583599, -27.1462301],
      [29.1587899, -27.14607],
      [29.1590499, -27.1458701],
      [29.1591599, -27.1457501],
      [29.1593799, -27.14549],
      [29.1594599, -27.1453201],
      [29.1595199, -27.1451201],
      [29.1595499, -27.1448901],
      [29.1595399, -27.14457],
      [29.1593799, -27.1442301],
      [29.1591299, -27.1438701],
      [29.1590499, -27.14366],
      [29.1590499, -27.1434001],
      [29.1592099, -27.14318],
      [29.1594499, -27.1431101],
      [29.1597899, -27.14309],
      [29.1600999, -27.1432301],
      [29.1605299, -27.1433701],
      [29.1609599, -27.1434401],
      [29.1614199, -27.14343],
      [29.1618099, -27.1433601],
      [29.1628299, -27.1431501],
      [29.1634299, -27.1430401],
      [29.1638199, -27.1429401],
      [29.1641799, -27.1428001],
      [29.1644999, -27.1426801],
      [29.1648499, -27.1424701],
      [29.1651799, -27.1422501],
      [29.1655199, -27.14211],
      [29.1658199, -27.1420901],
      [29.1660799, -27.14216],
      [29.1664299, -27.1424701],
      [29.1666599, -27.1426301],
      [29.1669199, -27.14271],
      [29.1672299, -27.14265],
      [29.1674099, -27.1425001],
      [29.1676899, -27.1422201],
      [29.1678599, -27.1419101],
      [29.1680299, -27.1416501],
      [29.1681599, -27.14154],
      [29.1685499, -27.14141],
      [29.1688699, -27.1414001],
      [29.1694999, -27.1414101],
      [29.1700699, -27.1414301],
      [29.1706499, -27.1415501],
      [29.1709299, -27.14162],
      [29.1711999, -27.1417901],
      [29.1715799, -27.1419801],
      [29.1718999, -27.1421901],
      [29.1722399, -27.1424001],
      [29.1725399, -27.1426701],
      [29.1728899, -27.1430301],
      [29.1731399, -27.1432101],
      [29.1735199, -27.1434101],
      [29.1739199, -27.1436201],
      [29.1742299, -27.1438101],
      [29.1744899, -27.14406],
      [29.1746699, -27.1443701],
      [29.1749999, -27.1450401],
      [29.1751599, -27.1453601],
      [29.1754299, -27.14574],
      [29.1756599, -27.1459401],
      [29.1760199, -27.1461301],
      [29.1764099, -27.1462701],
      [29.1769499, -27.1464201],
      [29.1772299, -27.14651],
      [29.1777999, -27.1465501],
      [29.1782299, -27.14654],
      [29.1785299, -27.1464801],
      [29.1788399, -27.1463701],
      [29.1790299, -27.14624],
      [29.1791599, -27.1459801],
      [29.1792299, -27.1455401],
      [29.1792399, -27.1450701],
      [29.1792199, -27.14476],
      [29.1793399, -27.1444801],
      [29.1795499, -27.14423],
      [29.1798199, -27.1441201],
      [29.1801199, -27.14416],
      [29.1803899, -27.1443201],
      [29.1806099, -27.1445301],
      [29.1810099, -27.1446301],
      [29.1812299, -27.1446401],
      [29.1816199, -27.1447301],
      [29.1818899, -27.14482],
      [29.1821399, -27.1451001],
      [29.1824999, -27.14534],
      [29.1827099, -27.1453901],
      [29.1830499, -27.14543],
      [29.1835799, -27.1453501],
      [29.1843199, -27.1451401],
      [29.1846899, -27.1450001],
      [29.1851199, -27.1448501],
      [29.1855899, -27.1446401],
      [29.1860599, -27.1444901],
      [29.1866599, -27.1444001],
      [29.1871299, -27.1442801],
      [29.1875599, -27.1441501],
      [29.1881599, -27.1438601],
      [29.1885799, -27.1436501],
      [29.1889199, -27.1435001],
      [29.1892599, -27.1434101],
      [29.1896499, -27.1433701],
      [29.1899899, -27.1433401],
      [29.1902099, -27.14325],
      [29.1903899, -27.1430601],
      [29.1904299, -27.1429101],
      [29.1904899, -27.14265],
      [29.1903699, -27.1423601],
      [29.1900199, -27.1419701],
      [29.1898199, -27.1417201],
      [29.1897099, -27.1415001],
      [29.1896499, -27.14123],
      [29.1896799, -27.1409401],
      [29.1898999, -27.14062],
      [29.1901099, -27.1405201],
      [29.1905599, -27.14036],
      [29.1909999, -27.1404101],
      [29.1914199, -27.1405401],
      [29.1918099, -27.1405901],
      [29.1920199, -27.1405801],
      [29.1922699, -27.14055],
      [29.1924499, -27.1404101],
      [29.1925599, -27.1403],
      [29.1926399, -27.1401201],
      [29.1927199, -27.1397801],
      [29.1927199, -27.13959],
      [29.1925099, -27.1391001],
      [29.1921899, -27.1386001],
      [29.1919399, -27.1379901],
      [29.1918799, -27.13763],
      [29.1919299, -27.1373901],
      [29.1920599, -27.1372],
      [29.1923099, -27.1370901],
      [29.1926999, -27.1370501],
      [29.1929099, -27.13707],
      [29.1932599, -27.1372101],
      [29.1934499, -27.1373401],
      [29.1936199, -27.13753],
      [29.1937599, -27.1378401],
      [29.1939899, -27.1383901],
      [29.1941799, -27.1388201],
      [29.1944099, -27.1392601],
      [29.1946599, -27.1397401],
      [29.1948099, -27.14002],
      [29.1950399, -27.1402101],
      [29.1953999, -27.1404201],
      [29.1956599, -27.14053],
      [29.1960799, -27.1406401],
      [29.1967999, -27.1406701],
      [29.1974299, -27.1406001],
      [29.1976699, -27.1405901],
      [29.1979199, -27.14062],
      [29.1982899, -27.1408301],
      [29.1987399, -27.1411801],
      [29.1991799, -27.1416001],
      [29.1994599, -27.1418601],
      [29.1997099, -27.1420601],
      [29.1999599, -27.1424201],
      [29.2002499, -27.14267],
      [29.2006199, -27.1428001],
      [29.2012999, -27.1428201],
      [29.2018099, -27.1428501],
      [29.2022499, -27.14304],
      [29.2025599, -27.1434101],
      [29.2028999, -27.1439301],
      [29.2032099, -27.1444001],
      [29.2035399, -27.14469],
      [29.2039699, -27.1448701],
      [29.2042399, -27.14487],
      [29.2044999, -27.1447501],
      [29.2047299, -27.1446601],
      [29.2049899, -27.1444501],
      [29.2054199, -27.1442201],
      [29.2056999, -27.1440601],
      [29.2060199, -27.1438501],
      [29.2062299, -27.14367],
      [29.2064099, -27.1434601],
      [29.2065399, -27.1432801],
      [29.2066499, -27.1430901],
      [29.2068399, -27.1428401],
      [29.2070399, -27.1426701],
      [29.2072299, -27.14252],
      [29.2075899, -27.1424201],
      [29.2081499, -27.1423801],
      [29.2085399, -27.1424201],
      [29.2088899, -27.1423501],
      [29.2093099, -27.1423001],
      [29.2097099, -27.14238],
      [29.2099899, -27.1425901],
      [29.2101799, -27.1429],
      [29.2103099, -27.1433801],
      [29.2104299, -27.1438101],
      [29.2105699, -27.14404],
      [29.2108899, -27.1443101],
      [29.2116199, -27.1446401],
      [29.2121899, -27.1449501],
      [29.2126599, -27.1452],
      [29.2129299, -27.1456001],
      [29.2130799, -27.1459501],
      [29.2134699, -27.1466001],
      [29.2137599, -27.14694],
      [29.2141199, -27.1471801],
      [29.2146099, -27.1474201],
      [29.2151799, -27.14758],
      [29.2157599, -27.1476301],
      [29.2165699, -27.1475601],
      [29.2170799, -27.1473801],
      [29.2178299, -27.1472401],
      [29.2182799, -27.1471601],
      [29.2186599, -27.1471001],
      [29.2190199, -27.14695],
      [29.2192099, -27.1468101],
      [29.2193499, -27.1466701],
      [29.2195299, -27.1463801],
      [29.2196999, -27.1461701],
      [29.2199599, -27.1460301],
      [29.2204099, -27.14583],
      [29.2209199, -27.1457801],
      [29.2213999, -27.1458501],
      [29.2219599, -27.14578],
      [29.2222999, -27.1456001],
      [29.2225899, -27.1453401],
      [29.2227699, -27.1451401],
      [29.2228999, -27.14494],
      [29.2231799, -27.1447601],
      [29.223537, -27.144661],
      [29.2238699, -27.1447001],
      [29.2244199, -27.1451301],
      [29.2252599, -27.1456901],
      [29.2257799, -27.1459401],
      [29.2267799, -27.1465101],
      [29.2272499, -27.1467201],
      [29.2276399, -27.1469401],
      [29.2277899, -27.14708],
      [29.2278899, -27.1473001],
      [29.2278399, -27.14755],
      [29.2276799, -27.1478001],
      [29.2273499, -27.1482301],
      [29.2271199, -27.1485001],
      [29.2270199, -27.14869],
      [29.2270199, -27.1493001],
      [29.2271199, -27.1499001],
      [29.2272399, -27.15019],
      [29.2275099, -27.1504501],
      [29.2277199, -27.15062],
      [29.2281099, -27.1507201],
      [29.2283599, -27.1506901],
      [29.2286799, -27.1507201],
      [29.2289999, -27.1508],
      [29.2291599, -27.1510101],
      [29.2292099, -27.1513001],
      [29.2291799, -27.15182],
      [29.2290999, -27.1520801],
      [29.2289599, -27.1522901],
      [29.2286599, -27.1526601],
      [29.2284999, -27.1529501],
      [29.2283699, -27.1531301],
      [29.2281899, -27.1535101],
      [29.2280099, -27.15377],
      [29.2277599, -27.1539201],
      [29.2275699, -27.1540601],
      [29.2272399, -27.1543101],
      [29.2270399, -27.15453],
      [29.2269799, -27.1548601],
      [29.2269799, -27.1553501],
      [29.2270199, -27.1557501],
      [29.2271399, -27.15592],
      [29.2274799, -27.1559801],
      [29.2277799, -27.1559801],
      [29.2280599, -27.1560301],
      [29.2283499, -27.15622],
      [29.2285299, -27.1565901],
      [29.2285899, -27.1568001],
      [29.2285799, -27.15716],
      [29.2284799, -27.1573801],
      [29.2282999, -27.1576401],
      [29.2281499, -27.1577401],
      [29.2278299, -27.1579801],
      [29.2276799, -27.1581],
      [29.2276499, -27.1584001],
      [29.2277299, -27.1587001],
      [29.2278699, -27.15896],
      [29.2281599, -27.1590901],
      [29.2284599, -27.1590901],
      [29.2288899, -27.15904],
      [29.2290299, -27.1591401],
      [29.2290799, -27.1593301],
      [29.2290699, -27.15961],
      [29.2289499, -27.1598001],
      [29.2287399, -27.16002],
      [29.2285699, -27.1600801],
      [29.2283899, -27.1601101],
      [29.2282499, -27.16018],
      [29.2280699, -27.1604001],
      [29.2280099, -27.1606501],
      [29.2280099, -27.1609],
      [29.2281099, -27.1610801],
      [29.2282499, -27.16123],
      [29.2285599, -27.1613401],
      [29.2288699, -27.1613701],
      [29.2291899, -27.1613701],
      [29.2293899, -27.16131],
      [29.2295699, -27.1611701],
      [29.2296499, -27.16106],
      [29.2296699, -27.1607501],
      [29.2296399, -27.1604],
      [29.2297399, -27.1601801],
      [29.2298999, -27.16006],
      [29.2302499, -27.16004],
      [29.2305099, -27.1601801],
      [29.2307099, -27.16037],
      [29.2307699, -27.1607701],
      [29.2307099, -27.1620501],
      [29.2306199, -27.1633001],
      [29.2303599, -27.1647601],
      [29.2303099, -27.1652201],
      [29.2302099, -27.1656601],
      [29.2300899, -27.1659501],
      [29.2299899, -27.16626],
      [29.2297999, -27.16648],
      [29.2297399, -27.1667301],
      [29.2297499, -27.1669901],
      [29.2298099, -27.16723],
      [29.2299899, -27.1674],
      [29.2303099, -27.1674901],
      [29.2306099, -27.1675101],
      [29.2310099, -27.1675701],
      [29.2313399, -27.1677301],
      [29.2317399, -27.16794],
      [29.2318899, -27.1681701],
      [29.2320399, -27.1684601],
      [29.2321699, -27.1687401],
      [29.2324599, -27.1691501],
      [29.2327899, -27.1695801],
      [29.2332399, -27.1700701],
      [29.2336399, -27.1703901],
      [29.2341999, -27.1708801],
      [29.2343999, -27.1710501],
      [29.2346899, -27.17134],
      [29.2350399, -27.1718501],
      [29.2353399, -27.1725001],
      [29.2355099, -27.17309],
      [29.2355499, -27.1740901],
      [29.2356899, -27.1747301],
      [29.2358499, -27.1751401],
      [29.2360399, -27.1759501],
      [29.2363099, -27.1768001],
      [29.2364599, -27.1774101],
      [29.2364899, -27.1775901],
      [29.2364499, -27.17787],
      [29.2362799, -27.1781401],
      [29.2359699, -27.1785401],
      [29.2357099, -27.1787101],
      [29.2354199, -27.17903],
      [29.2353499, -27.1793701],
      [29.2351999, -27.1797801],
      [29.2350399, -27.1804601],
      [29.2349099, -27.1809801],
      [29.2347199, -27.1813501],
      [29.2345299, -27.1818101],
      [29.2344299, -27.18218],
      [29.2344699, -27.1825701],
      [29.2345399, -27.1827801],
      [29.2347199, -27.1831601],
      [29.2348399, -27.18332],
      [29.2351299, -27.1835101],
      [29.2353799, -27.18361],
      [29.2357599, -27.1836401],
      [29.2360699, -27.1836301],
      [29.2367399, -27.1834401],
      [29.2375499, -27.1832201],
      [29.2386199, -27.1828801],
      [29.2392399, -27.1826801],
      [29.2398099, -27.1824901],
      [29.2403199, -27.1823701],
      [29.2407799, -27.1823001],
      [29.2412499, -27.18226],
      [29.2415199, -27.1823101],
      [29.2422099, -27.18253],
      [29.2429199, -27.1830101],
      [29.2432999, -27.1832401],
      [29.2436599, -27.1835101],
      [29.2438899, -27.18376],
      [29.2440399, -27.1841101],
      [29.2440299, -27.1843701],
      [29.2439199, -27.18476],
      [29.2437399, -27.1849201],
      [29.2433599, -27.18525],
      [29.2431399, -27.1853101],
      [29.2427499, -27.18529],
      [29.2423499, -27.1851201],
      [29.2419999, -27.1849101],
      [29.2417399, -27.1847601],
      [29.2414199, -27.1846101],
      [29.2409199, -27.18454],
      [29.2406299, -27.1845801],
      [29.2401099, -27.18474],
      [29.2398799, -27.1849901],
      [29.2397199, -27.1852701],
      [29.2396099, -27.1856101],
      [29.2395499, -27.18596],
      [29.2396099, -27.1863101],
      [29.2397599, -27.1866401],
      [29.2400099, -27.18717],
      [29.2405099, -27.1877601],
      [29.2410199, -27.1880801],
      [29.2414199, -27.18834],
      [29.2417099, -27.1883901],
      [29.2419099, -27.1884201],
      [29.2421599, -27.18834],
      [29.2422399, -27.1881901],
      [29.2423499, -27.1879701],
      [29.2424099, -27.1877701],
      [29.2424099, -27.1874401],
      [29.2423399, -27.1871901],
      [29.2423399, -27.1867001],
      [29.2424099, -27.18644],
      [29.2425999, -27.18613],
      [29.2429199, -27.1859801],
      [29.2431599, -27.1859201],
      [29.2434899, -27.18587],
      [29.2439399, -27.1859501],
      [29.2442899, -27.1861901],
      [29.2444499, -27.18636],
      [29.2446399, -27.1867401],
      [29.2447899, -27.1871501],
      [29.2451299, -27.18765],
      [29.2453499, -27.1878101],
      [29.2456699, -27.1879401],
      [29.2460799, -27.1880801],
      [29.2463499, -27.1882601],
      [29.2465299, -27.18847],
      [29.2466099, -27.1888901],
      [29.2465999, -27.18925],
      [29.2464799, -27.1895901],
      [29.2459099, -27.1903401],
      [29.2455999, -27.1905401],
      [29.2453799, -27.19075],
      [29.2453099, -27.1909401],
      [29.2453499, -27.19115],
      [29.2455999, -27.1914601],
      [29.2459299, -27.1917201],
      [29.2462899, -27.19197],
      [29.2467399, -27.1921701],
      [29.2469299, -27.1922201],
      [29.2471799, -27.1922301],
      [29.2474499, -27.19222],
      [29.2476999, -27.1921301],
      [29.2479399, -27.1920001],
      [29.2485899, -27.1915401],
      [29.2494899, -27.1909601],
      [29.2497899, -27.1906001],
      [29.2501699, -27.1901601],
      [29.2504399, -27.1899401],
      [29.2506099, -27.1898301],
      [29.2508999, -27.1897],
      [29.2512299, -27.1896501],
      [29.2514799, -27.1897101],
      [29.2519399, -27.1897401],
      [29.2524799, -27.1896401],
      [29.2536799, -27.1895901],
      [29.2540899, -27.18968],
      [29.2543199, -27.1898201],
      [29.2545199, -27.1900301],
      [29.2546299, -27.19031],
      [29.2545799, -27.1905301],
      [29.2544999, -27.1907601],
      [29.2543199, -27.1910001],
      [29.2540699, -27.1912501],
      [29.2536899, -27.1915701],
      [29.2534199, -27.19185],
      [29.2533499, -27.1920801],
      [29.2532299, -27.1925],
      [29.2532599, -27.1930401],
      [29.2533799, -27.1936101],
      [29.2535099, -27.19397],
      [29.2536599, -27.1942301],
      [29.2539099, -27.1945201],
      [29.2542299, -27.19477],
      [29.2545899, -27.1948501],
      [29.2548799, -27.1949101],
      [29.2553599, -27.19495],
      [29.2557699, -27.1949001],
      [29.2559799, -27.19479],
      [29.2562699, -27.19461],
      [29.2565199, -27.1943001],
      [29.2567299, -27.1938401],
      [29.2568699, -27.1935201],
      [29.2569799, -27.1929501],
      [29.2571399, -27.1923801],
      [29.2572999, -27.1922101],
      [29.2574199, -27.1920401],
      [29.2574499, -27.19184],
      [29.2571799, -27.1912601],
      [29.2568199, -27.1906601],
      [29.2566199, -27.1904001],
      [29.2565499, -27.1901301],
      [29.2565599, -27.18988],
      [29.2567899, -27.1896301],
      [29.2570299, -27.1894901],
      [29.2574399, -27.1894101],
      [29.2577799, -27.18928],
      [29.2580299, -27.1890501],
      [29.2580899, -27.18888],
      [29.2580899, -27.1884401],
      [29.2579899, -27.1880001],
      [29.2577399, -27.1876101],
      [29.2575899, -27.1873201],
      [29.2575599, -27.18704],
      [29.2576999, -27.1867401],
      [29.2580799, -27.1865001],
      [29.2583799, -27.1863201],
      [29.2585899, -27.18613],
      [29.2586599, -27.1859501],
      [29.2586199, -27.18538],
      [29.2584399, -27.1849301],
      [29.2582699, -27.1846801],
      [29.2582699, -27.18433],
      [29.2584099, -27.1840701],
      [29.2585899, -27.1838601],
      [29.2589499, -27.18361],
      [29.2590299, -27.1834401],
      [29.2590799, -27.1831801],
      [29.2590799, -27.1824801],
      [29.2591199, -27.18212],
      [29.2593599, -27.1818401],
      [29.2596299, -27.18165],
      [29.2599699, -27.1815101],
      [29.2601899, -27.1814101],
      [29.2604399, -27.1813401],
      [29.2608099, -27.18134],
      [29.2611199, -27.1814401],
      [29.2615999, -27.1816901],
      [29.2622599, -27.1822601],
      [29.2626999, -27.1826901],
      [29.2629199, -27.18297],
      [29.2629999, -27.1831801],
      [29.2629999, -27.1833701],
      [29.2629499, -27.18355],
      [29.2627399, -27.18363],
      [29.2625599, -27.1836201],
      [29.2622299, -27.1835101],
      [29.2618699, -27.1832901],
      [29.2613699, -27.1830901],
      [29.2609599, -27.18304],
      [29.2606299, -27.1831001],
      [29.2604799, -27.18319],
      [29.2602999, -27.1834401],
      [29.2602099, -27.18367],
      [29.2602199, -27.1838101],
      [29.2602799, -27.1841001],
      [29.2604699, -27.18435],
      [29.2608199, -27.1845501],
      [29.2613599, -27.1848201],
      [29.2616999, -27.1850101],
      [29.2620299, -27.18527],
      [29.2622299, -27.1855701],
      [29.2623499, -27.1858901],
      [29.2623899, -27.1861901],
      [29.2625399, -27.18661],
      [29.2627499, -27.1869401],
      [29.2629599, -27.1871801],
      [29.2632499, -27.18738],
      [29.2636399, -27.1874401],
      [29.2639199, -27.1874801],
      [29.2642399, -27.18748],
      [29.2646099, -27.1873901],
      [29.2648299, -27.1872801],
      [29.2654599, -27.1870001],
      [29.2657799, -27.18675],
      [29.2659899, -27.1863601],
      [29.2661099, -27.1860601],
      [29.2662099, -27.1856501],
      [29.2662799, -27.1851701],
      [29.2663099, -27.1848201],
      [29.2664699, -27.18432],
      [29.2667999, -27.18404],
      [29.2670199, -27.1839901],
      [29.2674199, -27.18397],
      [29.2676499, -27.1841001],
      [29.2679699, -27.1844701],
      [29.2681899, -27.18486],
      [29.2681999, -27.1851401],
      [29.2681199, -27.18546],
      [29.2678899, -27.1857501],
      [29.2676899, -27.1858301],
      [29.2672599, -27.1860401],
      [29.2670799, -27.18615],
      [29.2668699, -27.1864401],
      [29.2667599, -27.1866501],
      [29.2666099, -27.1871901],
      [29.2664499, -27.1876301],
      [29.2662199, -27.1879701],
      [29.2660599, -27.18828],
      [29.2660199, -27.1887001],
      [29.2660499, -27.1891501],
      [29.2660499, -27.18934],
      [29.2659099, -27.1898801],
      [29.2656499, -27.1903401],
      [29.2655099, -27.1906801],
      [29.2654399, -27.1909301],
      [29.2654499, -27.1912101],
      [29.2654899, -27.19143],
      [29.2656799, -27.19159],
      [29.2660199, -27.1916001],
      [29.2663199, -27.1915201],
      [29.2665799, -27.19141],
      [29.2668399, -27.1911301],
      [29.2674199, -27.1905901],
      [29.2678399, -27.1901401],
      [29.2682099, -27.1898001],
      [29.2684699, -27.1895801],
      [29.2687099, -27.1893001],
      [29.2689399, -27.1890601],
      [29.2692199, -27.18895],
      [29.2694599, -27.1889401],
      [29.2696899, -27.1889601],
      [29.2699999, -27.18901],
      [29.2701599, -27.1891501],
      [29.2702499, -27.18934],
      [29.2702299, -27.1897001],
      [29.2702199, -27.1899401],
      [29.2700699, -27.1903201],
      [29.2699299, -27.1906401],
      [29.2697499, -27.1910701],
      [29.2696299, -27.1913801],
      [29.2695199, -27.1916001],
      [29.2694099, -27.192],
      [29.2693799, -27.1922501],
      [29.2693699, -27.1925801],
      [29.2693699, -27.1929401],
      [29.2694499, -27.19323],
      [29.2696899, -27.1934201],
      [29.2700399, -27.1936001],
      [29.2704199, -27.1938301],
      [29.2706499, -27.1940701],
      [29.2707799, -27.19424],
      [29.2708699, -27.1946001],
      [29.2708599, -27.1952301],
      [29.2707799, -27.19579],
      [29.2706699, -27.1960901],
      [29.2705499, -27.1963501],
      [29.2703499, -27.19664],
      [29.2701699, -27.1967101],
      [29.2699299, -27.19672],
      [29.2696799, -27.1966501],
      [29.2693799, -27.1964201],
      [29.2691299, -27.1962901],
      [29.2688399, -27.1960701],
      [29.2684499, -27.19601],
      [29.2682599, -27.1961001],
      [29.2681399, -27.19627],
      [29.2681099, -27.1966201],
      [29.2680299, -27.1969301],
      [29.2679599, -27.1971601],
      [29.2679299, -27.1974001],
      [29.2679099, -27.19754],
      [29.2679999, -27.1979401],
      [29.2682099, -27.1983],
      [29.2685099, -27.1983301],
      [29.2687799, -27.1982201],
      [29.2690699, -27.1981101],
      [29.2696199, -27.1978601],
      [29.2703299, -27.19764],
      [29.2707099, -27.1974001],
      [29.2710399, -27.1971801],
      [29.2712499, -27.1969601],
      [29.2715299, -27.1966501],
      [29.2717799, -27.1964001],
      [29.2719399, -27.19621],
      [29.2720199, -27.1960301],
      [29.2721599, -27.1953601],
      [29.2721999, -27.1949201],
      [29.2721999, -27.1942401],
      [29.2720699, -27.19375],
      [29.2718199, -27.1933501],
      [29.2715899, -27.1931],
      [29.2714899, -27.1926501],
      [29.2715499, -27.1921501],
      [29.2716199, -27.19194],
      [29.2719299, -27.19163],
      [29.2721899, -27.1916201],
      [29.2726199, -27.1917101],
      [29.2727499, -27.1917801],
      [29.2730099, -27.1918401],
      [29.2732899, -27.1918501],
      [29.2736099, -27.19192],
      [29.2739399, -27.1921301],
      [29.2743999, -27.1924401],
      [29.2746799, -27.19272],
      [29.2747299, -27.19302],
      [29.2746399, -27.1931401],
      [29.2744199, -27.1933001],
      [29.2739199, -27.1935201],
      [29.2734699, -27.1938001],
      [29.2732399, -27.1940401],
      [29.2730699, -27.19424],
      [29.2729299, -27.1945901],
      [29.2728199, -27.1948901],
      [29.2728099, -27.19521],
      [29.2729299, -27.1954501],
      [29.2731799, -27.19564],
      [29.2734499, -27.1956101],
      [29.2736899, -27.1954301],
      [29.2739399, -27.1953001],
      [29.2743999, -27.1949701],
      [29.2747299, -27.1947901],
      [29.2752099, -27.1946],
      [29.2760699, -27.1944401],
      [29.2766799, -27.1943301],
      [29.2770899, -27.19434],
      [29.2773999, -27.1944501],
      [29.2777499, -27.1945901],
      [29.2782299, -27.1946501],
      [29.2792099, -27.1946301],
      [29.2799899, -27.1945801],
      [29.2803999, -27.1945901],
      [29.2807599, -27.1946401],
      [29.2810199, -27.1946701],
      [29.2812899, -27.1947201],
      [29.2815899, -27.19479],
      [29.2819799, -27.1950101],
      [29.2821999, -27.19522],
      [29.2823599, -27.1956001],
      [29.2823599, -27.19596],
      [29.2821399, -27.1964001],
      [29.2817199, -27.1969001],
      [29.2815699, -27.1971601],
      [29.2813199, -27.1975301],
      [29.2811199, -27.1979301],
      [29.2809499, -27.1981901],
      [29.2808099, -27.19853],
      [29.2807399, -27.19891],
      [29.2808199, -27.1991301],
      [29.2810099, -27.1994101],
      [29.2813199, -27.19959],
      [29.2815799, -27.1996301],
      [29.2818899, -27.19959],
      [29.2822499, -27.1993701],
      [29.2826399, -27.19905],
      [29.2827999, -27.1987201],
      [29.2830399, -27.1981501],
      [29.2832099, -27.1977001],
      [29.2834099, -27.1972901],
      [29.2835399, -27.1969801],
      [29.2835399, -27.1966801],
      [29.2835699, -27.1963601],
      [29.2836799, -27.19615],
      [29.2840799, -27.1958701],
      [29.2844299, -27.1955801],
      [29.2847299, -27.1954101],
      [29.2849499, -27.1953001],
      [29.2849999, -27.1952],
      [29.2849999, -27.1949701],
      [29.2849199, -27.1947],
      [29.2848199, -27.1945901],
      [29.2844599, -27.1944101],
      [29.2842399, -27.1942701],
      [29.2838499, -27.1941301],
      [29.2835699, -27.1940501],
      [29.2831999, -27.1939801],
      [29.2828799, -27.1939501],
      [29.2824999, -27.1937901],
      [29.2823199, -27.1937201],
      [29.2820299, -27.19352],
      [29.2819199, -27.1933301],
      [29.2817799, -27.1930101],
      [29.2817099, -27.1927101],
      [29.2817199, -27.19242],
      [29.2818499, -27.19214],
      [29.2820299, -27.1920601],
      [29.2823499, -27.19208],
      [29.2824999, -27.1922101],
      [29.2825299, -27.1924601],
      [29.2825799, -27.19264],
      [29.2826899, -27.1927901],
      [29.2829899, -27.1931001],
      [29.2832199, -27.1933501],
      [29.2834599, -27.1935101],
      [29.2836499, -27.19364],
      [29.2838999, -27.1936401],
      [29.2839899, -27.1935901],
      [29.2841099, -27.1935],
      [29.2841299, -27.1932701],
      [29.2839799, -27.1930001],
      [29.2838399, -27.1927701],
      [29.2837299, -27.1925301],
      [29.2836099, -27.19227],
      [29.2836099, -27.1919201],
      [29.2836799, -27.1917001],
      [29.2837799, -27.1915301],
      [29.2838599, -27.1913201],
      [29.2839699, -27.1910201],
      [29.2840799, -27.1907101],
      [29.2841699, -27.1906001],
      [29.2844199, -27.19028],
      [29.2846499, -27.1901601],
      [29.2848899, -27.19003],
      [29.2852299, -27.1900301],
      [29.2857099, -27.1901401],
      [29.2863899, -27.1903201],
      [29.2866399, -27.19043],
      [29.2868599, -27.1906201],
      [29.2870699, -27.19083],
      [29.2871199, -27.1909801],
      [29.2871099, -27.1911301],
      [29.2869299, -27.19137],
      [29.2867099, -27.1914401],
      [29.2863399, -27.1914301],
      [29.2858799, -27.1913701],
      [29.2854599, -27.1914],
      [29.2851399, -27.1915101],
      [29.2848899, -27.1916601],
      [29.2847899, -27.19183],
      [29.2847899, -27.1920801],
      [29.2848199, -27.1923101],
      [29.2848999, -27.19247],
      [29.2851399, -27.1925101],
      [29.2853699, -27.1924701],
      [29.2857299, -27.1923701],
      [29.2861499, -27.1923301],
      [29.2864299, -27.1923301],
      [29.2868899, -27.19235],
      [29.2871499, -27.1924401],
      [29.2876299, -27.19271],
      [29.2882799, -27.1934701],
      [29.2883999, -27.19373],
      [29.2884399, -27.1940401],
      [29.2884699, -27.1945201],
      [29.2884299, -27.1950301],
      [29.2884599, -27.1955701],
      [29.2884699, -27.1959201],
      [29.2885199, -27.1962301],
      [29.2886599, -27.19653],
      [29.2890699, -27.1968401],
      [29.2893499, -27.1970301],
      [29.2896999, -27.1972101],
      [29.2899799, -27.1974301],
      [29.2904099, -27.1976601],
      [29.2906899, -27.19792],
      [29.2908599, -27.1984201],
      [29.2910399, -27.1987801],
      [29.2913399, -27.1992201],
      [29.2916499, -27.1996001],
      [29.2922299, -27.20013],
      [29.2927399, -27.2004201],
      [29.2931099, -27.2006801],
      [29.2935099, -27.2008701],
      [29.2937999, -27.20097],
      [29.2940399, -27.2009801],
      [29.2942899, -27.2009901],
      [29.2946099, -27.2009301],
      [29.2948999, -27.2009001],
      [29.2950599, -27.2008501],
      [29.2953799, -27.20082],
      [29.2956299, -27.2009301],
      [29.2957499, -27.20104],
      [29.2957699, -27.2013501],
      [29.2956299, -27.2016401],
      [29.2955099, -27.2018401],
      [29.2953899, -27.2022501],
      [29.2953399, -27.2025],
      [29.2953599, -27.2028101],
      [29.2954399, -27.20314],
      [29.2955899, -27.2033101],
      [29.2958699, -27.20341],
      [29.2962699, -27.2033601],
      [29.2967199, -27.2033601],
      [29.2971299, -27.2034701],
      [29.2974699, -27.20363],
      [29.2977999, -27.2039101],
      [29.2979599, -27.2041101],
      [29.2980399, -27.2042601],
      [29.2980599, -27.20451],
      [29.2979099, -27.2047701],
      [29.2976099, -27.2050501],
      [29.2972399, -27.20544],
      [29.2972099, -27.2055201],
      [29.2971799, -27.2058301],
      [29.2972799, -27.20614],
      [29.2975299, -27.2063301],
      [29.2977899, -27.2066301],
      [29.2981599, -27.2071701],
      [29.2983099, -27.2073801],
      [29.2984099, -27.2075501],
      [29.2985599, -27.20783],
      [29.2986199, -27.2081801],
      [29.2986199, -27.2084701],
      [29.2987199, -27.2088901],
      [29.2988099, -27.20919],
      [29.2989299, -27.2093101],
      [29.2990899, -27.2094],
      [29.2993299, -27.2094301],
      [29.2996299, -27.2093501],
      [29.3001299, -27.2092001],
      [29.3003899, -27.2091401],
      [29.3005199, -27.20914],
      [29.3006099, -27.2091801],
      [29.3007899, -27.2092201],
      [29.3011999, -27.2094301],
      [29.3014799, -27.2095701],
      [29.3017499, -27.2096801],
      [29.3018599, -27.20974],
      [29.3018599, -27.20989],
      [29.3017499, -27.2100401],
      [29.3014699, -27.2102701],
      [29.3010599, -27.2106201],
      [29.3005999, -27.2109401],
      [29.3004199, -27.21117],
      [29.3003799, -27.2114001],
      [29.3003899, -27.2115901],
      [29.3005399, -27.21194],
      [29.3006899, -27.2120901],
      [29.3010699, -27.2123901],
      [29.3013699, -27.2127001],
      [29.3020399, -27.2131301],
      [29.3027899, -27.2136301],
      [29.3031599, -27.2138601],
      [29.3035899, -27.2141801],
      [29.3039899, -27.2145201],
      [29.3042399, -27.2148201],
      [29.3044099, -27.2149201],
      [29.3045999, -27.2151],
      [29.3048099, -27.2151701],
      [29.3050499, -27.21514],
      [29.3052699, -27.2149801],
      [29.3054599, -27.2147801],
      [29.3057099, -27.21467],
      [29.3058499, -27.2146801],
      [29.3061299, -27.2147701],
      [29.3063299, -27.2149101],
      [29.3069699, -27.2152701],
      [29.3074499, -27.2155201],
      [29.3079699, -27.2157101],
      [29.3083099, -27.2159501],
      [29.3086199, -27.21612],
      [29.3089699, -27.2162001],
      [29.3091899, -27.2161801],
      [29.3093299, -27.21609],
      [29.3094099, -27.2158401],
      [29.3095399, -27.2154501],
      [29.3096199, -27.2152701],
      [29.3097299, -27.2149501],
      [29.3098999, -27.21479],
      [29.3103599, -27.2147201],
      [29.3107399, -27.2147101],
      [29.3111399, -27.2146601],
      [29.3115399, -27.2145801],
      [29.3117699, -27.21447],
      [29.3118799, -27.2142901],
      [29.3119499, -27.2141501],
      [29.3119799, -27.2139201],
      [29.3119199, -27.21361],
      [29.3117299, -27.2133301],
      [29.3114199, -27.2129901],
      [29.3110599, -27.2126001],
      [29.3107399, -27.2122601],
      [29.3106899, -27.212],
      [29.3107799, -27.2116901],
      [29.3109899, -27.21142],
      [29.3112399, -27.2112601],
      [29.3115099, -27.2111501],
      [29.311616, -27.211135],
      [29.3116499, -27.21113],
      [29.3120299, -27.2112701],
      [29.3122399, -27.2113801],
      [29.3125799, -27.2114501],
      [29.3128199, -27.21145],
      [29.3129899, -27.21138],
      [29.3130799, -27.2112601],
      [29.3131199, -27.2110101],
      [29.3132199, -27.21066],
      [29.3134899, -27.2103401],
      [29.3137099, -27.2101301],
      [29.3140199, -27.2098101],
      [29.3142899, -27.20966],
      [29.3148299, -27.2095901],
      [29.3152499, -27.2096001],
      [29.3156199, -27.2096301],
      [29.3161199, -27.20968],
      [29.3165199, -27.2098501],
      [29.3168699, -27.21],
      [29.3172099, -27.2101801],
      [29.3175099, -27.2103201],
      [29.3177499, -27.21044],
      [29.3179099, -27.2104701],
      [29.3181599, -27.2104601],
      [29.3185599, -27.2103501],
      [29.3188499, -27.21021],
      [29.3191699, -27.2099301],
      [29.3194499, -27.2096801],
      [29.3196799, -27.2095601],
      [29.3199699, -27.20941],
      [29.3203899, -27.2093301],
      [29.3209999, -27.2091501],
      [29.3216199, -27.2090601],
      [29.3223999, -27.2090101],
      [29.3230499, -27.2089501],
      [29.3236899, -27.2088701],
      [29.3242099, -27.2088201],
      [29.3245799, -27.2087401],
      [29.3248299, -27.2086601],
      [29.3252099, -27.2085601],
      [29.3255299, -27.2084901],
      [29.3259199, -27.2083],
      [29.3261699, -27.2080601],
      [29.3263499, -27.2078401],
      [29.3264999, -27.2076401],
      [29.3266699, -27.2074501],
      [29.3268099, -27.2072101],
      [29.3268999, -27.2069901],
      [29.3269599, -27.2067401],
      [29.3270399, -27.2065001],
      [29.3272099, -27.20627],
      [29.3275599, -27.2061101],
      [29.3280999, -27.2060701],
      [29.3284599, -27.2059901],
      [29.3287199, -27.20583],
      [29.3288799, -27.2055701],
      [29.3290199, -27.2053701],
      [29.3290899, -27.2051501],
      [29.3291499, -27.2049301],
      [29.3293199, -27.2046101],
      [29.3294399, -27.2042901],
      [29.3295099, -27.2039801],
      [29.3296399, -27.20373],
      [29.3298999, -27.20362],
      [29.3301599, -27.2036601],
      [29.3305399, -27.20385],
      [29.3307299, -27.2040601],
      [29.3310099, -27.2045001],
      [29.3310999, -27.20474],
      [29.3311099, -27.2049401],
      [29.3310999, -27.2051701],
      [29.3310399, -27.2053501],
      [29.3308999, -27.2056701],
      [29.3307599, -27.20581],
      [29.3306899, -27.2061201],
      [29.3306399, -27.2065101],
      [29.3306399, -27.2070201],
      [29.3306599, -27.2075001],
      [29.3307399, -27.2078301],
      [29.3308399, -27.20801],
      [29.3310499, -27.2081201],
      [29.3313599, -27.2081601],
      [29.3315399, -27.20816],
      [29.3317999, -27.2080301],
      [29.3320499, -27.2078601],
      [29.3323999, -27.2076901],
      [29.3327299, -27.2075701],
      [29.3330699, -27.2074401],
      [29.3333699, -27.2073301],
      [29.3338199, -27.2071701],
      [29.3341799, -27.2070901],
      [29.3344299, -27.20705],
      [29.3346299, -27.2070901],
      [29.3348999, -27.20721],
      [29.3350699, -27.2073601],
      [29.3351499, -27.2074701],
      [29.3352799, -27.20768],
      [29.3351799, -27.2078901],
      [29.3349999, -27.2081501],
      [29.3348899, -27.2083601],
      [29.3348299, -27.2086201],
      [29.3347699, -27.2087801],
      [29.3346299, -27.20889],
      [29.3343599, -27.2088901],
      [29.3340199, -27.2088301],
      [29.3336799, -27.2086301],
      [29.3334999, -27.2085801],
      [29.3331699, -27.20841],
      [29.3328099, -27.2084501],
      [29.3325699, -27.20855],
      [29.3323699, -27.2088101],
      [29.3323599, -27.2092201],
      [29.3323899, -27.20938],
      [29.3324799, -27.2094501],
      [29.3327099, -27.20958],
      [29.3328199, -27.2098201],
      [29.3328299, -27.20996],
      [29.3327799, -27.2100601],
      [29.3326099, -27.21019],
      [29.3323299, -27.2102301],
      [29.3320499, -27.2101801],
      [29.3318299, -27.2101401],
      [29.3314699, -27.2101001],
      [29.3312699, -27.21015],
      [29.3311799, -27.2103401],
      [29.3311799, -27.21056],
      [29.3312599, -27.2107101],
      [29.3314099, -27.2109001],
      [29.3316299, -27.2111901],
      [29.3317799, -27.2114501],
      [29.3318499, -27.21173],
      [29.3317799, -27.2118501],
      [29.3316299, -27.2119701],
      [29.3313999, -27.2120901],
      [29.3312199, -27.2122601],
      [29.3311399, -27.2123801],
      [29.3310599, -27.21257],
      [29.3310599, -27.2127901],
      [29.3311299, -27.2130401],
      [29.3312899, -27.21324],
      [29.3315599, -27.2133801],
      [29.3318599, -27.2134601],
      [29.3322499, -27.2135501],
      [29.3326299, -27.2135501],
      [29.3331299, -27.2136101],
      [29.3335199, -27.21363],
      [29.3337099, -27.2136901],
      [29.3340199, -27.2138201],
      [29.3341299, -27.21393],
      [29.3341399, -27.2141001],
      [29.3341399, -27.2142901],
      [29.3340599, -27.21443],
      [29.3339199, -27.2145101],
      [29.3335899, -27.2146601],
      [29.3329099, -27.2148601],
      [29.3326599, -27.21495],
      [29.3324499, -27.2151501],
      [29.3323199, -27.2155101],
      [29.3321599, -27.2158701],
      [29.3319899, -27.2162301],
      [29.3317299, -27.2164601],
      [29.3316399, -27.21659],
      [29.3315199, -27.2173601],
      [29.3314799, -27.2179601],
      [29.3314999, -27.2182401],
      [29.3316499, -27.2186],
      [29.3318899, -27.2188501],
      [29.3321899, -27.2190301],
      [29.3326199, -27.21915],
      [29.3329199, -27.2191001],
      [29.3330699, -27.21899],
      [29.3331399, -27.2187801],
      [29.3331099, -27.2184401],
      [29.3329599, -27.2181001],
      [29.3327899, -27.21768],
      [29.3327899, -27.2173001],
      [29.3328999, -27.21703],
      [29.3331099, -27.2169201],
      [29.3333999, -27.21685],
      [29.3338199, -27.2169401],
      [29.3342799, -27.2171401],
      [29.3345299, -27.2172401],
      [29.3349599, -27.2173101],
      [29.3352999, -27.2173101],
      [29.3354599, -27.21729],
      [29.3355899, -27.2171701],
      [29.3356499, -27.21705],
      [29.3356399, -27.2168501],
      [29.3354099, -27.2165201],
      [29.3352399, -27.2162301],
      [29.3350899, -27.2160301],
      [29.3349899, -27.2157101],
      [29.3349099, -27.21507],
      [29.3350099, -27.2147801],
      [29.3351799, -27.21451],
      [29.3355099, -27.2143901],
      [29.3359299, -27.21446],
      [29.3360799, -27.2146001],
      [29.3362599, -27.21486],
      [29.3363999, -27.2152101],
      [29.3365299, -27.2157901],
      [29.3366599, -27.2161201],
      [29.3367399, -27.2163901],
      [29.3369599, -27.2169801],
      [29.3371299, -27.2178401],
      [29.3371199, -27.2181101],
      [29.3370999, -27.21832],
      [29.3369599, -27.2185501],
      [29.3367799, -27.2187701],
      [29.3366199, -27.2190701],
      [29.3363699, -27.2193701],
      [29.3360999, -27.21974],
      [29.3360299, -27.2198701],
      [29.3359399, -27.2201701],
      [29.3358899, -27.2205701],
      [29.3357599, -27.2211201],
      [29.3356899, -27.2214101],
      [29.3355899, -27.2216801],
      [29.3355599, -27.22186],
      [29.3356099, -27.2220801],
      [29.3357799, -27.22229],
      [29.3360299, -27.2223701],
      [29.3363099, -27.2224701],
      [29.3366799, -27.2225501],
      [29.3368999, -27.2225801],
      [29.3371299, -27.22264],
      [29.3373099, -27.2227901],
      [29.3374199, -27.2228901],
      [29.3375299, -27.2230701],
      [29.3376599, -27.22333],
      [29.3377199, -27.2236201],
      [29.3377499, -27.2239401],
      [29.3376999, -27.2241501],
      [29.3375999, -27.22444],
      [29.3374399, -27.2245701],
      [29.3370699, -27.2246801],
      [29.3368299, -27.22469],
      [29.3364999, -27.2245901],
      [29.3361899, -27.2243601],
      [29.3359999, -27.2241101],
      [29.3358899, -27.22395],
      [29.3357799, -27.2237101],
      [29.3357099, -27.2235201],
      [29.3355999, -27.2231801],
      [29.3354999, -27.2229301],
      [29.3352999, -27.22268],
      [29.3350799, -27.2226001],
      [29.3348299, -27.22262],
      [29.3345799, -27.2227901],
      [29.3344299, -27.2230401],
      [29.3342799, -27.2233201],
      [29.3340299, -27.2235701],
      [29.3336899, -27.2238001],
      [29.3335299, -27.2239401],
      [29.3334399, -27.2241101],
      [29.3333999, -27.2243],
      [29.3335299, -27.2246401],
      [29.3336899, -27.22487],
      [29.3341199, -27.2251801],
      [29.3345499, -27.2253601],
      [29.3352499, -27.2256701],
      [29.3357199, -27.2258701],
      [29.3359099, -27.2260301],
      [29.3360799, -27.22622],
      [29.3362099, -27.2265201],
      [29.3362099, -27.22671],
      [29.3360399, -27.227],
      [29.3359299, -27.2270801],
      [29.3354299, -27.2272201],
      [29.3345799, -27.2274101],
      [29.3342499, -27.2275501],
      [29.3339699, -27.22769],
      [29.3337499, -27.2278901],
      [29.3334999, -27.2282101],
      [29.3333699, -27.2284501],
      [29.3327099, -27.2293301],
      [29.3325599, -27.2296201],
      [29.3322099, -27.2301601],
      [29.3321399, -27.2303101],
      [29.3321399, -27.23047],
      [29.3322999, -27.2307601],
      [29.3325399, -27.2310301],
      [29.3327599, -27.23126],
      [29.3330699, -27.2313901],
      [29.3333799, -27.2315001],
      [29.3338399, -27.2316401],
      [29.3341999, -27.2317201],
      [29.3346399, -27.2317501],
      [29.3350899, -27.2317601],
      [29.3355599, -27.2318301],
      [29.3359599, -27.23189],
      [29.3361499, -27.2319901],
      [29.3362699, -27.2321],
      [29.3363099, -27.2322201],
      [29.3362899, -27.2326001],
      [29.3362199, -27.2328801],
      [29.3360799, -27.2330301],
      [29.3360099, -27.23322],
      [29.3360899, -27.2335801],
      [29.3361699, -27.23377],
      [29.3362999, -27.2339201],
      [29.3366199, -27.2341801],
      [29.3369799, -27.2343401],
      [29.3371899, -27.23448],
      [29.3374199, -27.2345501],
      [29.3377399, -27.2345601],
      [29.3379499, -27.2346701],
      [29.3381599, -27.23481],
      [29.3382399, -27.2349801],
      [29.3382199, -27.2351],
      [29.3380699, -27.2353101],
      [29.3378699, -27.23545],
      [29.3375699, -27.2354901],
      [29.3372299, -27.2354301],
      [29.3367899, -27.2352201],
      [29.3363999, -27.23508],
      [29.3362199, -27.2351201],
      [29.3358699, -27.2354101],
      [29.3356499, -27.2356601],
      [29.3353399, -27.2358101],
      [29.3351699, -27.2358901],
      [29.3348799, -27.2360301],
      [29.3346999, -27.2361201],
      [29.3345599, -27.2362401],
      [29.3344099, -27.23642],
      [29.3343799, -27.2366201],
      [29.3344299, -27.2370301],
      [29.3345799, -27.2375201],
      [29.3348999, -27.2381901],
      [29.3350399, -27.2384801],
      [29.3352499, -27.23895],
      [29.3352899, -27.2391901],
      [29.3352999, -27.2394801],
      [29.3352399, -27.2398],
      [29.3350499, -27.2400501],
      [29.3347199, -27.2402501],
      [29.3345199, -27.2403601],
      [29.3342899, -27.2405601],
      [29.3340599, -27.2408301],
      [29.3336499, -27.2412601],
      [29.3332799, -27.2416201],
      [29.3330199, -27.2418601],
      [29.3327999, -27.24206],
      [29.3325599, -27.2424501],
      [29.3324199, -27.24282],
      [29.3323699, -27.2432501],
      [29.3323699, -27.2437101],
      [29.3323799, -27.2441801],
      [29.3323599, -27.24443],
      [29.3321499, -27.2446501],
      [29.3318899, -27.2448301],
      [29.3316399, -27.2449701],
      [29.3311099, -27.2451701],
      [29.3302799, -27.2454201],
      [29.3298599, -27.2455801],
      [29.3294199, -27.2457501],
      [29.3289699, -27.2459601],
      [29.3285999, -27.24613],
      [29.3282199, -27.2464701],
      [29.3280599, -27.24664],
      [29.3279699, -27.2470501],
      [29.3280099, -27.2474401],
      [29.3280399, -27.2477101],
      [29.3279899, -27.2479001],
      [29.3279099, -27.24807],
      [29.3276499, -27.2482801],
      [29.3274199, -27.2484101],
      [29.3271599, -27.2486301],
      [29.3270299, -27.2487301],
      [29.3268499, -27.2487901],
      [29.3267599, -27.24887],
      [29.3267099, -27.2490001],
      [29.3266599, -27.2493401],
      [29.3266299, -27.24966],
      [29.3266899, -27.2500001],
      [29.3268499, -27.2503],
      [29.3268399, -27.2504501],
      [29.3267899, -27.2506401],
      [29.3266999, -27.25085],
      [29.3265099, -27.2510501],
      [29.3262999, -27.2512401],
      [29.3260299, -27.2514401],
      [29.3257199, -27.2515701],
      [29.3254599, -27.25172],
      [29.3253699, -27.2518501],
      [29.3253299, -27.2520801],
      [29.3253299, -27.25239],
      [29.3254699, -27.2527101],
      [29.3256199, -27.2528501],
      [29.3257199, -27.2531001],
      [29.3258699, -27.2535601],
      [29.3259999, -27.2538001],
      [29.3260599, -27.2540901],
      [29.3260699, -27.2544101],
      [29.3261099, -27.2547401],
      [29.3262499, -27.25514],
      [29.3265999, -27.2556201],
      [29.3270999, -27.2559901],
      [29.3274399, -27.2562901],
      [29.3278399, -27.2565201],
      [29.3282199, -27.2566701],
      [29.3284199, -27.2568001],
      [29.3285399, -27.25691],
      [29.3286899, -27.2571701],
      [29.3286899, -27.2573701],
      [29.3287099, -27.2577501],
      [29.3286699, -27.2580701],
      [29.3286599, -27.2582601],
      [29.3286599, -27.2585101],
      [29.3286299, -27.25891],
      [29.3283499, -27.2594701],
      [29.3283099, -27.2596701],
      [29.3282999, -27.25995],
      [29.3284699, -27.2602601],
      [29.3286099, -27.2605101],
      [29.3287999, -27.26072],
      [29.3290699, -27.2608501],
      [29.3294099, -27.2609501],
      [29.3297299, -27.2610101],
      [29.3300699, -27.2610801],
      [29.3303599, -27.2611901],
      [29.3306399, -27.2613701],
      [29.3307999, -27.2615],
      [29.3308599, -27.2617301],
      [29.3307899, -27.2620101],
      [29.3307099, -27.2624401],
      [29.3306999, -27.2627001],
      [29.3307299, -27.26294],
      [29.3309199, -27.2632401],
      [29.3311599, -27.26343],
      [29.3314499, -27.2635701],
      [29.3318199, -27.26367],
      [29.3321999, -27.2636701],
      [29.3325899, -27.2635901],
      [29.3329299, -27.26364],
      [29.3331999, -27.2638801],
      [29.3334799, -27.2640901],
      [29.3337999, -27.26425],
      [29.3340499, -27.2642801],
      [29.3343499, -27.2642801],
      [29.3350499, -27.2642701],
      [29.3358199, -27.2641801],
      [29.3361399, -27.26414],
      [29.3366399, -27.2641801],
      [29.3369999, -27.2642201],
      [29.3374199, -27.2643401],
      [29.3378899, -27.2645001],
      [29.3382199, -27.26455],
      [29.3383399, -27.2645101],
      [29.3386399, -27.2642501],
      [29.3391699, -27.2636501],
      [29.3394999, -27.2632001],
      [29.3398099, -27.2627001],
      [29.3402299, -27.2620001],
      [29.3405499, -27.2614401],
      [29.3407399, -27.26106],
      [29.3407699, -27.2606901],
      [29.3408099, -27.2603701],
      [29.3407999, -27.2601201],
      [29.3407099, -27.2596601],
      [29.3406699, -27.2594501],
      [29.3404899, -27.2588101],
      [29.3401699, -27.2573801],
      [29.3400499, -27.2568601],
      [29.3398899, -27.2564301],
      [29.3397799, -27.2560601],
      [29.3397599, -27.2558301],
      [29.3396999, -27.2550801],
      [29.3397199, -27.2544301],
      [29.3396099, -27.2539501],
      [29.3395699, -27.2533601],
      [29.3395799, -27.25273],
      [29.3396899, -27.2520401],
      [29.3398499, -27.2516001],
      [29.3401399, -27.2510901],
      [29.3402899, -27.2507801],
      [29.3404899, -27.2505001],
      [29.3406299, -27.25023],
      [29.3410599, -27.2497601],
      [29.3416299, -27.2492701],
      [29.3419599, -27.2489401],
      [29.3422099, -27.2487601],
      [29.3425099, -27.2486001],
      [29.3427099, -27.24847],
      [29.3429499, -27.2484001],
      [29.3432699, -27.2483701],
      [29.3437399, -27.2483801],
      [29.3444399, -27.2484101],
      [29.3449199, -27.2484101],
      [29.3454599, -27.2484601],
      [29.3462099, -27.2486001],
      [29.3468099, -27.24873],
      [29.3470799, -27.2488801],
      [29.3472799, -27.2490001],
      [29.3474399, -27.2490801],
      [29.3477599, -27.2492201],
      [29.3481699, -27.24932],
      [29.3486699, -27.2492901],
      [29.3489699, -27.2492501],
      [29.3493499, -27.2491601],
      [29.3498199, -27.2490601],
      [29.3506399, -27.2488501],
      [29.3509599, -27.2487301],
      [29.3512999, -27.2486901],
      [29.3515099, -27.2486601],
      [29.3517399, -27.24871],
      [29.3519399, -27.2489201],
      [29.3522999, -27.2494401],
      [29.3525199, -27.24964],
      [29.3528299, -27.2497501],
      [29.3531699, -27.2498101],
      [29.3533699, -27.24979],
      [29.3535499, -27.2496101],
      [29.3536999, -27.2493701],
      [29.3538799, -27.24904],
      [29.3541499, -27.2488101],
      [29.3546299, -27.24865],
      [29.3551999, -27.2487101],
      [29.3557399, -27.2488301],
      [29.3559799, -27.2488801],
      [29.3562899, -27.2489201],
      [29.3566599, -27.2489501],
      [29.3570099, -27.2489401],
      [29.3575799, -27.2489201],
      [29.3582899, -27.2489201],
      [29.3586599, -27.2488801],
      [29.3589299, -27.24881],
      [29.3591099, -27.2486901],
      [29.3594099, -27.2483401],
      [29.3598199, -27.2479101],
      [29.3601999, -27.2476001],
      [29.3605299, -27.2473101],
      [29.3608699, -27.2471301],
      [29.3612299, -27.24702],
      [29.3618699, -27.2470201],
      [29.3624799, -27.24712],
      [29.3629799, -27.2473701],
      [29.3633299, -27.2475201],
      [29.3636799, -27.2477401],
      [29.3644599, -27.2484101],
      [29.3651399, -27.2489201],
      [29.3655999, -27.2492801],
      [29.3660299, -27.2495901],
      [29.3663899, -27.2498801],
      [29.3668399, -27.2502701],
      [29.3671699, -27.2506401],
      [29.3673999, -27.2508201],
      [29.3677099, -27.2510201],
      [29.3681499, -27.25127],
      [29.3686299, -27.2514101],
      [29.3693499, -27.2514901],
      [29.3697699, -27.25149],
      [29.3701999, -27.2514101],
      [29.3705599, -27.2513301],
      [29.3711999, -27.2510801],
      [29.3714199, -27.2509701],
      [29.3718399, -27.2508301],
      [29.3720599, -27.25079],
      [29.3722799, -27.2505901],
      [29.3724599, -27.2503501],
      [29.3726199, -27.25026],
      [29.3728699, -27.25025],
      [29.3730499, -27.2503301],
      [29.3733299, -27.2505201],
      [29.3734299, -27.2506501],
      [29.3735799, -27.2507901],
      [29.3737499, -27.2509],
      [29.3740999, -27.2509701],
      [29.3744699, -27.2510101],
      [29.3751299, -27.25099],
      [29.3754199, -27.2508601],
      [29.3755999, -27.2507801],
      [29.3757899, -27.2506901],
      [29.3760299, -27.2505101],
      [29.3761899, -27.2503501],
      [29.3763299, -27.2501501],
      [29.3767199, -27.2497501],
      [29.3770399, -27.2495101],
      [29.3774699, -27.2490201],
      [29.3778699, -27.24865],
      [29.3784299, -27.2482801],
      [29.3789999, -27.2479801],
      [29.3795599, -27.2477701],
      [29.3800399, -27.2476201],
      [29.3803899, -27.24746],
      [29.3807099, -27.2473901],
      [29.3811199, -27.2473501],
      [29.3817499, -27.24737],
      [29.3821899, -27.2475601],
      [29.3825799, -27.2478401],
      [29.3827999, -27.2480301],
      [29.3829799, -27.2482901],
      [29.3832299, -27.2486201],
      [29.3834799, -27.2488301],
      [29.3837499, -27.24897],
      [29.3839399, -27.2490101],
      [29.3842499, -27.2490401],
      [29.3845099, -27.249],
      [29.3846899, -27.2488901],
      [29.3849999, -27.24868],
      [29.3857999, -27.2474301],
      [29.3859699, -27.2472801],
      [29.3861399, -27.2472],
      [29.3863899, -27.2471801],
      [29.3866699, -27.2471901],
      [29.3869599, -27.24725],
      [29.3872999, -27.2471801],
      [29.3875199, -27.2470701],
      [29.3877399, -27.2469501],
      [29.3878299, -27.24688],
      [29.3878299, -27.2467701],
      [29.3876999, -27.2466401],
      [29.3876299, -27.2463901],
      [29.3876599, -27.24616],
      [29.3878799, -27.24596],
      [29.3881399, -27.2459501],
      [29.3883799, -27.24597],
      [29.3887999, -27.2462101],
      [29.3890499, -27.24646],
      [29.3890999, -27.2466001],
      [29.3891199, -27.2468501],
      [29.3891099, -27.2472101],
      [29.3890399, -27.24746],
      [29.3889299, -27.2475801],
      [29.3886599, -27.2477501],
      [29.3884499, -27.24787],
      [29.3881499, -27.2479601],
      [29.3876999, -27.2480101],
      [29.3873299, -27.2480701],
      [29.3871099, -27.2481401],
      [29.3867899, -27.24827],
      [29.3866499, -27.2484001],
      [29.3864799, -27.2486401],
      [29.3863399, -27.2489501],
      [29.3862899, -27.24926],
      [29.3863399, -27.2495701],
      [29.3864199, -27.2497801],
      [29.3865999, -27.24994],
      [29.3870499, -27.2499201],
      [29.3874599, -27.2498901],
      [29.3877399, -27.2498501],
      [29.3882699, -27.2497301],
      [29.3888199, -27.2495201],
      [29.3891999, -27.24934],
      [29.3893699, -27.2492001],
      [29.3897799, -27.2489001],
      [29.3899599, -27.2487101],
      [29.3900499, -27.24857],
      [29.3901099, -27.2482501],
      [29.3901599, -27.2478901],
      [29.3902099, -27.24766],
      [29.3901499, -27.2473101],
      [29.3900099, -27.2469101],
      [29.3897199, -27.2462501],
      [29.3894699, -27.2458601],
      [29.3892299, -27.24556],
      [29.3888299, -27.2453101],
      [29.3882999, -27.2450001],
      [29.3876499, -27.2445201],
      [29.3873699, -27.2443401],
      [29.3871099, -27.2441801],
      [29.3869299, -27.24402],
      [29.3868699, -27.2438001],
      [29.3868799, -27.24357],
      [29.3870499, -27.2434501],
      [29.3871599, -27.24342],
      [29.3873799, -27.2434601],
      [29.3875499, -27.2435801],
      [29.3876999, -27.2436501],
      [29.3879399, -27.2437301],
      [29.3881299, -27.2437101],
      [29.3884999, -27.24371],
      [29.3888099, -27.2436101],
      [29.3890699, -27.2434201],
      [29.3893999, -27.2432501],
      [29.3897599, -27.2430601],
      [29.3901699, -27.2429001],
      [29.3904799, -27.24279],
      [29.3908699, -27.2427301],
      [29.3912999, -27.2426901],
      [29.3917399, -27.24274],
      [29.3922199, -27.2428701],
      [29.3925299, -27.2430101],
      [29.3927699, -27.2431001],
      [29.3931199, -27.2431201],
      [29.3934099, -27.24312],
      [29.3937599, -27.2430001],
      [29.3940699, -27.2428201],
      [29.3944999, -27.2426501],
      [29.3947299, -27.2425601],
      [29.3951199, -27.2425001],
      [29.3953599, -27.24245],
      [29.3961099, -27.2424901],
      [29.3967899, -27.2426301],
      [29.3972199, -27.2427001],
      [29.3975799, -27.24285],
      [29.3978899, -27.2428601],
      [29.3981499, -27.2428301],
      [29.3985399, -27.2427401],
      [29.3987599, -27.24269],
      [29.3994299, -27.2427401],
      [29.3999999, -27.2428501],
      [29.4002099, -27.24293],
      [29.4002999, -27.2430401],
      [29.4002999, -27.24327],
      [29.4002199, -27.2434601],
      [29.4001099, -27.2436401],
      [29.3998899, -27.2438201],
      [29.3997499, -27.24434],
      [29.3998499, -27.2445201],
      [29.3999099, -27.2447001],
      [29.4000299, -27.2448601],
      [29.4001399, -27.2451101],
      [29.4001699, -27.2456301],
      [29.4003299, -27.2461201],
      [29.4005899, -27.2467001],
      [29.4008399, -27.2470601],
      [29.4009899, -27.2475001],
      [29.4010499, -27.2478501],
      [29.4011399, -27.2485601],
      [29.4012099, -27.2487801],
      [29.4013199, -27.2492001],
      [29.4014599, -27.24956],
      [29.4016799, -27.2498501],
      [29.4019399, -27.2500301],
      [29.4022199, -27.2502701],
      [29.4023399, -27.2504101],
      [29.4024299, -27.2504501],
      [29.4026599, -27.25055],
      [29.4027799, -27.2507301],
      [29.4029599, -27.2510201],
      [29.4032999, -27.2514501],
      [29.4035199, -27.2517001],
      [29.4037599, -27.2519101],
      [29.4040999, -27.2522001],
      [29.4043199, -27.2523],
      [29.4047099, -27.2523501],
      [29.4049199, -27.2524101],
      [29.4053899, -27.2523401],
      [29.4056899, -27.2523001],
      [29.4059699, -27.25226],
      [29.4062899, -27.2521501],
      [29.4067799, -27.2519501],
      [29.4070299, -27.2518001],
      [29.4073499, -27.2516301],
      [29.4076799, -27.2515101],
      [29.4080099, -27.2514401],
      [29.4083599, -27.25145],
      [29.4086099, -27.2515501],
      [29.4087999, -27.2516901],
      [29.4090599, -27.2518501],
      [29.4093099, -27.2521001],
      [29.4095099, -27.25227],
      [29.4098199, -27.2523501],
      [29.4100599, -27.2524201],
      [29.4102999, -27.2523801],
      [29.4105499, -27.2523601],
      [29.4106899, -27.25234],
      [29.4107699, -27.2522001],
      [29.4109899, -27.2519001],
      [29.4113199, -27.2515201],
      [29.4115699, -27.25126],
      [29.4119099, -27.2510801],
      [29.4121199, -27.25102],
      [29.4127599, -27.2512001],
      [29.4129699, -27.2512701],
      [29.4131699, -27.2513001],
      [29.4134199, -27.2513],
      [29.4138399, -27.2512101],
      [29.4141699, -27.2510501],
      [29.4144199, -27.2508801],
      [29.4146599, -27.2506901],
      [29.4147999, -27.25052],
      [29.4149199, -27.2504701],
      [29.4150999, -27.25048],
      [29.4151999, -27.2506301],
      [29.4155099, -27.2509101],
      [29.4159399, -27.2513901],
      [29.4163499, -27.2518401],
      [29.4168299, -27.2522701],
      [29.4171499, -27.2525901],
      [29.4171799, -27.2527701],
      [29.4173299, -27.2530201],
      [29.4174199, -27.25312],
      [29.4177099, -27.2532001],
      [29.4179799, -27.25323],
      [29.4182299, -27.2534001],
      [29.4184299, -27.2536201],
      [29.4186699, -27.2539701],
      [29.4187799, -27.2543001],
      [29.4188599, -27.2545201],
      [29.4188699, -27.2545601],
      [29.4189799, -27.2547701],
      [29.4194099, -27.25539],
      [29.4195599, -27.2554401],
      [29.4197799, -27.2554601],
      [29.4200299, -27.25546],
      [29.4201399, -27.2553601],
      [29.4201699, -27.25518],
      [29.4200499, -27.2549101],
      [29.4200499, -27.25448],
      [29.4201199, -27.2542301],
      [29.4202999, -27.25387],
      [29.4205999, -27.2537701],
      [29.4208399, -27.2538401],
      [29.4212799, -27.2537601],
      [29.4215699, -27.2538101],
      [29.4217499, -27.25386],
      [29.4222099, -27.2542701],
      [29.4224299, -27.2545401],
      [29.4225299, -27.25472],
      [29.4225299, -27.2549101],
      [29.4224999, -27.25516],
      [29.4223799, -27.2552901],
      [29.4220299, -27.2555401],
      [29.4215999, -27.2559001],
      [29.4214799, -27.2560301],
      [29.4213099, -27.25613],
      [29.4212499, -27.2562901],
      [29.4212699, -27.2564701],
      [29.4213199, -27.25661],
      [29.4215899, -27.2567901],
      [29.4218199, -27.2569001],
      [29.4221199, -27.2569101],
      [29.4226499, -27.2571501],
      [29.4229999, -27.2574701],
      [29.4233199, -27.25756],
      [29.4235099, -27.2575301],
      [29.4236399, -27.25743],
      [29.4237899, -27.2571301],
      [29.4238599, -27.2569301],
      [29.4238899, -27.2567201],
      [29.4239299, -27.25657],
      [29.4240399, -27.2564601],
      [29.4242299, -27.2564201],
      [29.4244199, -27.25632],
      [29.4249699, -27.2563101],
      [29.4255799, -27.2564401],
      [29.4260699, -27.2564901],
      [29.4263199, -27.25649],
      [29.4264299, -27.2564101],
      [29.4265399, -27.25628],
      [29.4265399, -27.2560501],
      [29.4264299, -27.25585],
      [29.4260799, -27.2555901],
      [29.4257899, -27.2554801],
      [29.4252899, -27.2553701],
      [29.4248299, -27.2551401],
      [29.4246499, -27.25499],
      [29.4246399, -27.25485],
      [29.4247699, -27.2547501],
      [29.4251099, -27.2547101],
      [29.4253999, -27.2546001],
      [29.4258299, -27.2542101],
      [29.4260499, -27.25405],
      [29.4263399, -27.2539201],
      [29.4267099, -27.2538001],
      [29.4276199, -27.25374],
      [29.4280399, -27.2538101],
      [29.4281799, -27.25387],
      [29.4283499, -27.2540201],
      [29.4285799, -27.2542701],
      [29.4287999, -27.2546701],
      [29.4293099, -27.2554701],
      [29.4294899, -27.2557101],
      [29.4295899, -27.25596],
      [29.4295999, -27.2562401],
      [29.4297499, -27.25684],
      [29.4299799, -27.2573501],
      [29.4304699, -27.2583101],
      [29.4309899, -27.25887],
      [29.4311999, -27.2589401],
      [29.4313799, -27.2590901],
      [29.4315699, -27.25919],
      [29.4316999, -27.2593901],
      [29.4317699, -27.2596701],
      [29.4318099, -27.26001],
      [29.4317499, -27.2603901],
      [29.4315799, -27.2608901],
      [29.4315399, -27.26121],
      [29.4316299, -27.2616501],
      [29.4317399, -27.26188],
      [29.4320399, -27.2622001],
      [29.4323499, -27.2624],
      [29.4327299, -27.2625201],
      [29.4330299, -27.2625701],
      [29.4332999, -27.2625201],
      [29.4334799, -27.26245],
      [29.4336599, -27.2623101],
      [29.4337999, -27.26208],
      [29.4338499, -27.26154],
      [29.4339799, -27.2614201],
      [29.4341599, -27.2613501],
      [29.4343499, -27.26133],
      [29.4345799, -27.2613801],
      [29.4348299, -27.2615501],
      [29.4350399, -27.2618],
      [29.4350799, -27.2619301],
      [29.4350599, -27.2622101],
      [29.4350799, -27.2623501],
      [29.4351999, -27.2627],
      [29.4354099, -27.26284],
      [29.4356899, -27.2628401],
      [29.4359399, -27.2627701],
      [29.4360999, -27.26269],
      [29.4362399, -27.2624901],
      [29.4362499, -27.26237],
      [29.4361399, -27.2621301],
      [29.4357299, -27.2616901],
      [29.4355799, -27.2613801],
      [29.4354999, -27.26106],
      [29.4355799, -27.26087],
      [29.4357999, -27.2608001],
      [29.4362799, -27.26089],
      [29.4364299, -27.2610101],
      [29.4367999, -27.2613701],
      [29.4370599, -27.2618701],
      [29.4377199, -27.2629901],
      [29.4382799, -27.2638301],
      [29.4385699, -27.2641501],
      [29.4389399, -27.2645101],
      [29.4390199, -27.26469],
      [29.4389699, -27.2648401],
      [29.4388299, -27.2649701],
      [29.4386499, -27.2650901],
      [29.4385799, -27.26518],
      [29.4385899, -27.2660501],
      [29.4387199, -27.26626],
      [29.4389699, -27.2663801],
      [29.4393799, -27.2664],
      [29.4394599, -27.26657],
      [29.4392299, -27.26696],
      [29.4392299, -27.2671501],
      [29.4393299, -27.2675001],
      [29.4394599, -27.26765],
      [29.4398799, -27.2676401],
      [29.4401799, -27.2675701],
      [29.4405399, -27.2674601],
      [29.4409699, -27.2673101],
      [29.4412299, -27.2672001],
      [29.4415499, -27.2670601],
      [29.4418699, -27.2668901],
      [29.4423599, -27.2667001],
      [29.4425999, -27.26663],
      [29.4429999, -27.2666901],
      [29.4434299, -27.26693],
      [29.4437599, -27.2673501],
      [29.4440999, -27.2678501],
      [29.4443899, -27.2683401],
      [29.4444899, -27.2686701],
      [29.4446399, -27.2689801],
      [29.4447599, -27.26914],
      [29.4450999, -27.2693301],
      [29.4454899, -27.26959],
      [29.4456199, -27.2697301],
      [29.4458499, -27.2701901],
      [29.4458499, -27.2705301],
      [29.4459199, -27.2708501],
      [29.4459799, -27.27134],
      [29.4464199, -27.27191],
      [29.4475499, -27.27243],
      [29.4479299, -27.2727],
      [29.4481099, -27.27298],
      [29.4481899, -27.27334],
      [29.4481599, -27.27368],
      [29.4480599, -27.27402],
      [29.4479599, -27.27419],
      [29.4479699, -27.27474],
      [29.4482099, -27.2752301],
      [29.4483299, -27.27538],
      [29.4485799, -27.2754901],
      [29.4487199, -27.27548],
      [29.4489599, -27.2753601],
      [29.4492099, -27.2751801],
      [29.4494599, -27.2749301],
      [29.4495999, -27.2747201],
      [29.4499199, -27.2745501],
      [29.4501699, -27.2745],
      [29.4506799, -27.27481],
      [29.4507499, -27.2749801],
      [29.4508199, -27.2753101],
      [29.4509099, -27.2760201],
      [29.4508499, -27.27628],
      [29.4506999, -27.2764401],
      [29.4504899, -27.2765501],
      [29.4502799, -27.27672],
      [29.4501799, -27.2769301],
      [29.4501599, -27.2772601],
      [29.4501799, -27.27748],
      [29.4503099, -27.2776901],
      [29.4505299, -27.2780001],
      [29.4506399, -27.27813],
      [29.4510599, -27.2782001],
      [29.4513199, -27.2781201],
      [29.4514599, -27.27805],
      [29.4515199, -27.2778801],
      [29.4516299, -27.2777201],
      [29.4516999, -27.2774401],
      [29.4516599, -27.2771301],
      [29.4516599, -27.2764801],
      [29.4517499, -27.27634],
      [29.4519199, -27.2763001],
      [29.4522299, -27.27631],
      [29.4525299, -27.2764201],
      [29.4531999, -27.2767601],
      [29.4533399, -27.27695],
      [29.4533299, -27.27713],
      [29.4532799, -27.2773601],
      [29.4532799, -27.27756],
      [29.4533799, -27.2777601],
      [29.4537099, -27.2780001],
      [29.4542399, -27.2784201],
      [29.4545099, -27.27861],
      [29.4547599, -27.2789201],
      [29.4548699, -27.2791101],
      [29.4550599, -27.27937],
      [29.4551499, -27.2796101],
      [29.4551899, -27.2798501],
      [29.4551799, -27.28035],
      [29.4550699, -27.2805601],
      [29.4548999, -27.2807501],
      [29.4547299, -27.2809801],
      [29.4544399, -27.2811001],
      [29.4543299, -27.2812001],
      [29.4542099, -27.28142],
      [29.4542599, -27.2815701],
      [29.4544099, -27.2817301],
      [29.4545699, -27.2820701],
      [29.4546399, -27.28233],
      [29.4547899, -27.2826201],
      [29.4550299, -27.28282],
      [29.4552199, -27.2828101],
      [29.4553999, -27.28268],
      [29.4554899, -27.2823901],
      [29.4554899, -27.28224],
      [29.4556599, -27.2820801],
      [29.4558999, -27.282],
      [29.4560599, -27.28181],
      [29.4562199, -27.28154],
      [29.4563999, -27.28145],
      [29.4565899, -27.2815],
      [29.4567399, -27.28173],
      [29.4568299, -27.28182],
      [29.4568599, -27.28223],
      [29.4570599, -27.28294],
      [29.4570199, -27.2832701],
      [29.4569099, -27.28353],
      [29.4567399, -27.2836501],
      [29.4565799, -27.2836601],
      [29.4564699, -27.2837101],
      [29.4563699, -27.28383],
      [29.4563699, -27.2840301],
      [29.4564899, -27.28421],
      [29.4566799, -27.2843001],
      [29.4570399, -27.28437],
      [29.4574899, -27.2843401],
      [29.4580999, -27.28416],
      [29.4587999, -27.2841901],
      [29.4593999, -27.2842401],
      [29.4600099, -27.2843201],
      [29.4602899, -27.28438],
      [29.4603999, -27.2844601],
      [29.4604299, -27.28456],
      [29.4603899, -27.2846301],
      [29.4601499, -27.2846201],
      [29.4599599, -27.28463],
      [29.4597799, -27.2847401],
      [29.4594399, -27.2849901],
      [29.4588699, -27.28532],
      [29.4587999, -27.2856401],
      [29.4587999, -27.286],
      [29.4590899, -27.2863201],
      [29.4597199, -27.2866001],
      [29.4602899, -27.28681],
      [29.4606499, -27.2867701],
      [29.4610599, -27.28669],
      [29.4611599, -27.2865801],
      [29.4611199, -27.28633],
      [29.4609399, -27.2861201],
      [29.4607199, -27.2860101],
      [29.4605399, -27.28583],
      [29.4605199, -27.2855801],
      [29.4606299, -27.28538],
      [29.4608699, -27.2852601],
      [29.4609799, -27.28525],
      [29.4611599, -27.28539],
      [29.4614399, -27.2853901],
      [29.4617299, -27.28534],
      [29.4618399, -27.28546],
      [29.4618499, -27.2856301],
      [29.4617899, -27.2858501],
      [29.4617599, -27.2860601],
      [29.4616499, -27.2862801],
      [29.4616399, -27.28667],
      [29.4616799, -27.2867801],
      [29.4617899, -27.2869],
      [29.4619899, -27.2870001],
      [29.4623899, -27.2870601],
      [29.4626299, -27.2870701],
      [29.4629499, -27.28714],
      [29.4632399, -27.2872801],
      [29.4636699, -27.28772],
      [29.4637799, -27.2879601],
      [29.4638299, -27.28838],
      [29.4635799, -27.2892301],
      [29.4633999, -27.2897801],
      [29.4633799, -27.29023],
      [29.4635499, -27.2907601],
      [29.4638699, -27.29126],
      [29.4644399, -27.2915901],
      [29.4648199, -27.2918301],
      [29.4651499, -27.2921101],
      [29.4653699, -27.29241],
      [29.4654299, -27.2928301],
      [29.4654499, -27.2934701],
      [29.4655499, -27.2948001],
      [29.4655099, -27.2950001],
      [29.4655099, -27.2952601],
      [29.4654699, -27.2955401],
      [29.4655099, -27.2960901],
      [29.4655799, -27.29651],
      [29.4658399, -27.2971101],
      [29.4660299, -27.2974501],
      [29.4661099, -27.2978301],
      [29.4661399, -27.2981301],
      [29.4662499, -27.2985201],
      [29.4662699, -27.2988501],
      [29.4663399, -27.299],
      [29.4664299, -27.2990401],
      [29.4665199, -27.29899],
      [29.4665299, -27.2988701],
      [29.4666699, -27.2987201],
      [29.4667699, -27.29864],
      [29.4670599, -27.2985801],
      [29.4679899, -27.29857],
      [29.4686599, -27.2987501],
      [29.4690699, -27.2990501],
      [29.4694599, -27.2992401],
      [29.4698099, -27.29944],
      [29.4699299, -27.2996401],
      [29.4699599, -27.2997701],
      [29.4700099, -27.3002601],
      [29.4699999, -27.30051],
      [29.4698399, -27.3007001],
      [29.4696799, -27.30077],
      [29.4693599, -27.3007501],
      [29.4689099, -27.30077],
      [29.4687699, -27.3009401],
      [29.4686799, -27.30109],
      [29.4686799, -27.3012701],
      [29.4687399, -27.3014901],
      [29.4688799, -27.30162],
      [29.4690999, -27.3016201],
      [29.4692599, -27.3015501],
      [29.4694999, -27.3014001],
      [29.4696599, -27.3013601],
      [29.4698799, -27.3012601],
      [29.4702399, -27.30119],
      [29.4706199, -27.3012701],
      [29.4708499, -27.3013701],
      [29.4709399, -27.30151],
      [29.4709899, -27.3018001],
      [29.4709699, -27.3020201],
      [29.4709299, -27.3023201],
      [29.4708399, -27.30251],
      [29.4704099, -27.3027701],
      [29.4701899, -27.3029401],
      [29.4700199, -27.3029901],
      [29.4698399, -27.30307],
      [29.4697499, -27.3033101],
      [29.4697499, -27.30357],
      [29.4697799, -27.30375],
      [29.4699599, -27.3041],
      [29.4699999, -27.30435],
      [29.4699799, -27.30484],
      [29.4701099, -27.30559],
      [29.4701999, -27.30579],
      [29.4703699, -27.30601],
      [29.4705299, -27.30625],
      [29.4709399, -27.30678],
      [29.4712599, -27.30767],
      [29.4713499, -27.30788],
      [29.4716199, -27.30834],
      [29.4718099, -27.30853],
      [29.4719799, -27.30877],
      [29.4721599, -27.30923],
      [29.4722299, -27.30951],
      [29.4722099, -27.30971],
      [29.4721699, -27.30987],
      [29.4720899, -27.31005],
      [29.4720199, -27.31014],
      [29.4719499, -27.31037],
      [29.4719599, -27.31058],
      [29.4720399, -27.31085],
      [29.4720499, -27.31114],
      [29.4720199, -27.31131],
      [29.4719499, -27.31142],
      [29.4717299, -27.31145],
      [29.4715399, -27.31141],
      [29.4713199, -27.31123],
      [29.4709999, -27.31112],
      [29.4705699, -27.31111],
      [29.4701999, -27.31121],
      [29.4698299, -27.31146],
      [29.4696599, -27.31167],
      [29.4695499, -27.31196],
      [29.4695699, -27.31266],
      [29.4694899, -27.31303],
      [29.4693399, -27.31334],
      [29.4690999, -27.31363],
      [29.4687399, -27.31392],
      [29.4685099, -27.31417],
      [29.4682599, -27.31438],
      [29.4678599, -27.31506],
      [29.4676899, -27.3154],
      [29.4676199, -27.31561],
      [29.4676199, -27.3162],
      [29.4676599, -27.3166],
      [29.4678999, -27.31707],
      [29.4681699, -27.31745],
      [29.4683799, -27.31764],
      [29.4687499, -27.31793],
      [29.4690599, -27.31813],
      [29.4694399, -27.3186],
      [29.4697799, -27.31911],
      [29.4699899, -27.31964],
      [29.4702199, -27.32037],
      [29.4703399, -27.32122],
      [29.4702599, -27.3215201],
      [29.4701599, -27.3218301],
      [29.4698699, -27.3224001],
      [29.4696299, -27.32281],
      [29.4692599, -27.32319],
      [29.4690299, -27.32345],
      [29.4689599, -27.32364],
      [29.4689399, -27.324],
      [29.4689899, -27.3242],
      [29.4691299, -27.32445],
      [29.4693799, -27.32481],
      [29.4700699, -27.32547],
      [29.4713899, -27.32652],
      [29.4722299, -27.32715],
      [29.4734199, -27.32808],
      [29.4736399, -27.3282],
      [29.4738499, -27.32842],
      [29.4741599, -27.32866],
      [29.4744499, -27.32883],
      [29.4750299, -27.32902],
      [29.4753099, -27.32916],
      [29.4759099, -27.32952],
      [29.4764599, -27.3298],
      [29.4768299, -27.33005],
      [29.4771299, -27.33033],
      [29.4776199, -27.33061],
      [29.4777999, -27.3308],
      [29.4781499, -27.3310901],
      [29.4785099, -27.3314401],
      [29.4796799, -27.33241],
      [29.4803899, -27.3327301],
      [29.4807399, -27.33282],
      [29.4809199, -27.3328001],
      [29.4821599, -27.3325401],
      [29.4824899, -27.3323601],
      [29.4826299, -27.33223],
      [29.4826999, -27.3320901],
      [29.4827599, -27.3319101],
      [29.4827499, -27.3315801],
      [29.4826199, -27.3312901],
      [29.4825399, -27.3309801],
      [29.4825799, -27.32937],
      [29.4826699, -27.3290201],
      [29.4827899, -27.3287701],
      [29.4829699, -27.3285601],
      [29.4831199, -27.32828],
      [29.4833199, -27.3280801],
      [29.4836799, -27.3278301],
      [29.4840399, -27.32762],
      [29.4846599, -27.3274701],
      [29.4851599, -27.3274401],
      [29.4856699, -27.3273801],
      [29.4859199, -27.3273701],
      [29.4860999, -27.32731],
      [29.4863199, -27.32731],
      [29.48637, -27.32737],
      [29.4863499, -27.3275],
      [29.4862899, -27.32877],
      [29.4861499, -27.32959],
      [29.4861499, -27.32982],
      [29.48619, -27.33008],
      [29.48611, -27.33032],
      [29.48595, -27.33121],
      [29.4857, -27.33239],
      [29.48565, -27.33266],
      [29.48564, -27.33296],
      [29.48551, -27.33351],
      [29.48541, -27.33403],
      [29.48533, -27.33433],
      [29.48524, -27.33458],
      [29.48521, -27.33479],
      [29.48519, -27.33533],
      [29.4850999, -27.33549],
      [29.48491, -27.33564],
      [29.4847299, -27.33575],
      [29.48451, -27.33599],
      [29.48436, -27.33621],
      [29.48419, -27.33653],
      [29.4840699, -27.33696],
      [29.48386, -27.33749],
      [29.4837599, -27.33768],
      [29.48372, -27.33821],
      [29.4837299, -27.33878],
      [29.4838799, -27.33916],
      [29.48402, -27.3396],
      [29.48419, -27.33995],
      [29.4843499, -27.34023],
      [29.4845399, -27.34047],
      [29.48476, -27.34061],
      [29.48515, -27.34072],
      [29.4854299, -27.34078],
      [29.4858799, -27.34078],
      [29.4862699, -27.34076],
      [29.4865199, -27.3407],
      [29.4867699, -27.34062],
      [29.4869, -27.34049],
      [29.4869299, -27.34026],
      [29.48702, -27.33998],
      [29.48704, -27.3397],
      [29.48703, -27.33919],
      [29.4871799, -27.33842],
      [29.48754, -27.33785],
      [29.4877999, -27.33755],
      [29.48822, -27.33737],
      [29.48882, -27.33722],
      [29.48913, -27.33709],
      [29.48949, -27.33697],
      [29.48964, -27.33686],
      [29.4898899, -27.3368],
      [29.4900999, -27.33687],
      [29.49016, -27.33698],
      [29.4901599, -27.33724],
      [29.4900899, -27.33742],
      [29.48997, -27.33875],
      [29.4900999, -27.3391],
      [29.4900399, -27.34104],
      [29.4899999, -27.34138],
      [29.4900199, -27.34204],
      [29.4899899, -27.34238],
      [29.4899299, -27.34279],
      [29.4898999, -27.34361],
      [29.4898999, -27.34432],
      [29.4898699, -27.34467],
      [29.4898199, -27.3449],
      [29.4897199, -27.34514],
      [29.4896199, -27.34544],
      [29.4895, -27.34564],
      [29.4892999, -27.34587],
      [29.4889299, -27.34605],
      [29.48845, -27.34612],
      [29.48744, -27.34635],
      [29.48694, -27.34643],
      [29.4864, -27.34646],
      [29.48611, -27.34643],
      [29.4857699, -27.34646],
      [29.4851599, -27.34669],
      [29.4849599, -27.34684],
      [29.4848499, -27.34703],
      [29.4848499, -27.34762],
      [29.4851699, -27.34832],
      [29.4857399, -27.34889],
      [29.4861699, -27.34907],
      [29.4865299, -27.34915],
      [29.4866799, -27.34922],
      [29.4868899, -27.3494],
      [29.4870899, -27.34984],
      [29.4871299, -27.35017],
      [29.4871299, -27.35063],
      [29.4866899, -27.35124],
      [29.4862599, -27.35176],
      [29.4842999, -27.35433],
      [29.4839999, -27.35481],
      [29.4837399, -27.35543],
      [29.4830099, -27.35693],
      [29.4829199, -27.35723],
      [29.4828299, -27.35768],
      [29.4827199, -27.35798],
      [29.4825399, -27.35825],
      [29.4823899, -27.35862],
      [29.4823199, -27.35893],
      [29.4823799, -27.35943],
      [29.4827699, -27.36004],
      [29.4833199, -27.3605801],
      [29.4839899, -27.3611401],
      [29.4843499, -27.3615101],
      [29.4846699, -27.3617401],
      [29.4850599, -27.3619801],
      [29.4853299, -27.3621901],
      [29.4860199, -27.3626401],
      [29.4862899, -27.36279],
      [29.4865499, -27.3627901],
      [29.48704, -27.3627001],
      [29.4875299, -27.36257],
      [29.4878299, -27.3624401],
      [29.48822, -27.3622301],
      [29.48855, -27.3620201],
      [29.48894, -27.36192],
      [29.48938, -27.36175],
      [29.48975, -27.36155],
      [29.4902899, -27.3612],
      [29.49068, -27.36108],
      [29.49125, -27.36099],
      [29.49327, -27.3611],
      [29.4942999, -27.36101],
      [29.49519, -27.361],
      [29.4959599, -27.36104],
      [29.49625, -27.36094],
      [29.4967499, -27.36066],
      [29.497, -27.36043],
      [29.49719, -27.36012],
      [29.49803, -27.3593],
      [29.4984399, -27.35893],
      [29.49876, -27.35879],
      [29.49969, -27.35864],
      [29.50002, -27.35857],
      [29.50088, -27.35844],
      [29.5022, -27.35813],
      [29.5025599, -27.3581],
      [29.50294, -27.35818],
      [29.5032299, -27.35843],
      [29.5033, -27.35859],
      [29.5033, -27.35903],
      [29.50322, -27.3593],
      [29.50298, -27.35993],
      [29.5028599, -27.36029],
      [29.50287, -27.36073],
      [29.5030299, -27.36137],
      [29.5033, -27.3619],
      [29.50378, -27.36244],
      [29.50399, -27.36262],
      [29.50419, -27.36301],
      [29.50467, -27.36413],
      [29.50477, -27.36433],
      [29.50492, -27.36455],
      [29.5052199, -27.36505],
      [29.5054, -27.36522],
      [29.50569, -27.36538],
      [29.5062, -27.36563],
      [29.5068099, -27.36587],
      [29.5072, -27.36594],
      [29.50784, -27.36609],
      [29.50834, -27.36616],
      [29.50956, -27.36649],
      [29.51034, -27.36657],
      [29.51067, -27.36664],
      [29.51176, -27.36683],
      [29.5119799, -27.367],
      [29.51206, -27.36714],
      [29.51212, -27.3675],
      [29.5124399, -27.36785],
      [29.51245, -27.36794],
      [29.5124299, -27.36812],
      [29.51232, -27.36822],
      [29.51191, -27.36835],
      [29.51162, -27.36839],
      [29.51136, -27.36851],
      [29.51095, -27.36873],
      [29.51069, -27.36885],
      [29.51037, -27.36897],
      [29.50987, -27.36901],
      [29.5096599, -27.36908],
      [29.50948, -27.36922],
      [29.5092, -27.36974],
      [29.5090999, -27.37005],
      [29.50888, -27.3718],
      [29.50877, -27.37239],
      [29.50873, -27.37274],
      [29.50872, -27.3739],
      [29.50868, -27.37437],
      [29.5087, -27.37544],
      [29.5086899, -27.37565],
      [29.50876, -27.3761],
      [29.50884, -27.37638],
      [29.50907, -27.37679],
      [29.5094299, -27.37731],
      [29.5102, -27.37799],
      [29.51054, -27.37833],
      [29.5111, -27.37881],
      [29.5119199, -27.37957],
      [29.5122, -27.37974],
      [29.51267, -27.37999],
      [29.51356, -27.38039],
      [29.51414, -27.38071],
      [29.5146099, -27.38104],
      [29.51512, -27.38157],
      [29.51552, -27.38193],
      [29.5157999, -27.38232],
      [29.5161599, -27.3826201],
      [29.5167299, -27.3830001],
      [29.5183399, -27.3838701],
      [29.5191999, -27.3842601],
      [29.5197699, -27.38438],
      [29.5200199, -27.3843701],
      [29.5203099, -27.3843001],
      [29.5206599, -27.3841901],
      [29.5208999, -27.3840801],
      [29.5212099, -27.3839001],
      [29.5215999, -27.3837401],
      [29.5217999, -27.3836401],
      [29.5220899, -27.38344],
      [29.5221499, -27.3832501],
      [29.5222299, -27.38309],
      [29.5221699, -27.3827801],
      [29.5215799, -27.3816101],
      [29.5213099, -27.38117],
      [29.5203399, -27.3803201],
      [29.5194199, -27.3797901],
      [29.5189199, -27.3796001],
      [29.5186899, -27.3794501],
      [29.5184799, -27.37924],
      [29.5183099, -27.3785001],
      [29.5182799, -27.37804],
      [29.5183499, -27.3778701],
      [29.5185499, -27.3776701],
      [29.5188499, -27.3774701],
      [29.5191899, -27.37731],
      [29.5196199, -27.3772201],
      [29.5200899, -27.3770901],
      [29.5212599, -27.37692],
      [29.5218399, -27.3769201],
      [29.5226599, -27.3769701],
      [29.5239199, -27.37718],
      [29.5246199, -27.3773901],
      [29.5261699, -27.3779401],
      [29.5266399, -27.3780801],
      [29.5271499, -27.37828],
      [29.5272999, -27.3784501],
      [29.5273999, -27.3786701],
      [29.5274799, -27.3789401],
      [29.5275799, -27.3791901],
      [29.5277699, -27.3794501],
      [29.5279699, -27.3797001],
      [29.5287199, -27.3803801],
      [29.5292799, -27.3813701],
      [29.5294999, -27.3816301],
      [29.5298699, -27.3821301],
      [29.5304399, -27.3827701],
      [29.5306699, -27.38322],
      [29.53078, -27.3837601],
      [29.5308599, -27.38432],
      [29.53076, -27.3846301],
      [29.53056, -27.3850101],
      [29.5304799, -27.3853801],
      [29.5302899, -27.3858501],
      [29.5299999, -27.3861601],
      [29.5298099, -27.38641],
      [29.5293799, -27.38651],
      [29.5292099, -27.3864201],
      [29.52863, -27.3862101],
      [29.52828, -27.3858701],
      [29.5279099, -27.3856],
      [29.5271699, -27.3855401],
      [29.5265499, -27.3856201],
      [29.5261399, -27.38576],
      [29.5257099, -27.38626],
      [29.5256799, -27.3864501],
      [29.5256799, -27.3871201],
      [29.5257999, -27.3885201],
      [29.5259599, -27.3896701],
      [29.5260999, -27.3901601],
      [29.5262999, -27.3915201],
      [29.5263899, -27.3920301],
      [29.5264899, -27.3924801],
      [29.5264999, -27.3927801],
      [29.5266499, -27.3932401],
      [29.5268699, -27.39378],
      [29.5271399, -27.3941101],
      [29.5273999, -27.3943],
      [29.5277999, -27.3943701],
      [29.5280699, -27.39436],
      [29.5282599, -27.3942201],
      [29.52846, -27.39394],
      [29.52862, -27.39343],
      [29.5287699, -27.39302],
      [29.52975, -27.39193],
      [29.5306099, -27.39086],
      [29.53135, -27.3903],
      [29.53194, -27.38992],
      [29.53249, -27.3896301],
      [29.53443, -27.38855],
      [29.53506, -27.38827],
      [29.5355, -27.3881501],
      [29.5358999, -27.38797],
      [29.53615, -27.3877701],
      [29.53647, -27.3873801],
      [29.53673, -27.3871501],
      [29.5371199, -27.38698],
      [29.53772, -27.3869701],
      [29.5380699, -27.38703],
      [29.53831, -27.3872201],
      [29.5386099, -27.3880701],
      [29.5388799, -27.38873],
      [29.5392199, -27.3891901],
      [29.5397299, -27.3896001],
      [29.5401299, -27.3900301],
      [29.5404799, -27.3903701],
      [29.5407299, -27.3905201],
      [29.5414199, -27.3912701],
      [29.5415699, -27.39148],
      [29.5416399, -27.3919201],
      [29.5418699, -27.3928901],
      [29.5421199, -27.3934001],
      [29.5425199, -27.3945601],
      [29.5427299, -27.3951001],
      [29.5429199, -27.39535],
      [29.5430499, -27.3956501],
      [29.5431699, -27.3960901],
      [29.5432399, -27.3962901],
      [29.5433199, -27.39668],
      [29.5432899, -27.3970001],
      [29.5431499, -27.3972501],
      [29.5430199, -27.3975601],
      [29.5429799, -27.3978101],
      [29.5429999, -27.39825],
      [29.5432099, -27.3987001],
      [29.5434899, -27.399],
      [29.5439199, -27.3992],
      [29.5445599, -27.3992501],
      [29.5456799, -27.3992001],
      [29.5470099, -27.39898],
      [29.5473599, -27.3988101],
      [29.5477599, -27.3985801],
      [29.5484499, -27.3983901],
      [29.5490899, -27.3980701],
      [29.5496199, -27.3979101],
      [29.5501999, -27.39783],
      [29.5508099, -27.3980201],
      [29.5514499, -27.3983301],
      [29.5517999, -27.3985501],
      [29.5520299, -27.39875],
      [29.5521299, -27.39895],
      [29.5520999, -27.3991601],
      [29.5519799, -27.3993801],
      [29.5517699, -27.39985],
      [29.5508799, -27.4006901],
      [29.5503899, -27.4010701],
      [29.5500299, -27.4014401],
      [29.5496599, -27.40178],
      [29.5494399, -27.4022601],
      [29.5491999, -27.4028401],
      [29.5490699, -27.4035201],
      [29.5489699, -27.4038401],
      [29.5489099, -27.40418],
      [29.5489099, -27.4047301],
      [29.5491399, -27.4059501],
      [29.5491799, -27.4065801],
      [29.5491699, -27.4073401],
      [29.5490899, -27.40884],
      [29.5491499, -27.4091801],
      [29.5492699, -27.4094801],
      [29.5496599, -27.4100901],
      [29.5499399, -27.41084],
      [29.5500399, -27.4109601],
      [29.5508599, -27.4116101],
      [29.5519899, -27.4126001],
      [29.5520999, -27.4128101],
      [29.5521499, -27.41296],
      [29.5521499, -27.4132101],
      [29.5521199, -27.4133801],
      [29.5519299, -27.41378],
      [29.5517599, -27.4139301],
      [29.5512599, -27.41413],
      [29.5510499, -27.4141501],
      [29.5504699, -27.4141801],
      [29.5497599, -27.4141001],
      [29.5492299, -27.4139601],
      [29.5485099, -27.4138501],
      [29.5476499, -27.41394],
      [29.5473699, -27.4141001],
      [29.5471399, -27.4143201],
      [29.5467999, -27.4149001],
      [29.5465599, -27.4152301],
      [29.5463899, -27.4154301],
      [29.5461099, -27.4155701],
      [29.5458899, -27.4157901],
      [29.5454899, -27.4164501],
      [29.5452899, -27.41692],
      [29.5450299, -27.4171001],
      [29.5444599, -27.4173801],
      [29.5442699, -27.4174501],
      [29.5440199, -27.41763],
      [29.5433499, -27.4188301],
      [29.5432299, -27.4191201],
      [29.5431099, -27.4193001],
      [29.5426999, -27.4196901],
      [29.5425799, -27.4198401],
      [29.5425499, -27.4199601],
      [29.5425399, -27.42011],
      [29.5426299, -27.4202401],
      [29.5433599, -27.4207401],
      [29.5436799, -27.4209401],
      [29.5441399, -27.4211401],
      [29.5446099, -27.4213901],
      [29.5451099, -27.4216301],
      [29.5455799, -27.4218301],
      [29.5462199, -27.4221401],
      [29.5465299, -27.4223701],
      [29.5472399, -27.4228301],
      [29.5475499, -27.4229701],
      [29.5480499, -27.4232601],
      [29.5482799, -27.4233501],
      [29.5485999, -27.4235],
      [29.5495299, -27.42368],
      [29.5500099, -27.4241001],
      [29.5500899, -27.42437],
      [29.5500599, -27.4246301],
      [29.5499499, -27.4249801],
      [29.5498099, -27.42526],
      [29.5488899, -27.4264501],
      [29.5481599, -27.4272001],
      [29.5477399, -27.4275901],
      [29.5474699, -27.4277601],
      [29.5473099, -27.4279901],
      [29.5470399, -27.4283201],
      [29.5467499, -27.4287401],
      [29.5463099, -27.42922],
      [29.5462899, -27.4294201],
      [29.5465499, -27.4299],
      [29.5465499, -27.4304201],
      [29.5464499, -27.4309301],
      [29.5464599, -27.43112],
      [29.5466599, -27.43128],
      [29.5468399, -27.4313101],
      [29.5474599, -27.4312801],
      [29.5480899, -27.4312901],
      [29.5484599, -27.4313401],
      [29.5487299, -27.4314301],
      [29.5491599, -27.4315201],
      [29.5500899, -27.4314901],
      [29.5507399, -27.4314901],
      [29.5511599, -27.4315301],
      [29.5515499, -27.4316501],
      [29.5519599, -27.4317401],
      [29.5522499, -27.4317701],
      [29.5527899, -27.4318601],
      [29.5540499, -27.43196],
      [29.5544999, -27.4319101],
      [29.5547299, -27.4318601],
      [29.5550799, -27.4316701],
      [29.5553399, -27.4315601],
      [29.5556799, -27.43136],
      [29.5559399, -27.431],
      [29.5561499, -27.4309601],
      [29.5564799, -27.4310901],
      [29.5567699, -27.4312701],
      [29.5572499, -27.4314401],
      [29.5589199, -27.4319101],
      [29.5595399, -27.4320201],
      [29.5599399, -27.43218],
      [29.5602599, -27.4324801],
      [29.5604699, -27.4328],
      [29.5605899, -27.4332101],
      [29.5607299, -27.4337801],
      [29.5607999, -27.4341901],
      [29.5607499, -27.4364401],
      [29.5607499, -27.4370201],
      [29.5606999, -27.4376101],
      [29.5605199, -27.4383601],
      [29.5605399, -27.4393101],
      [29.5606099, -27.43977],
      [29.5607799, -27.4402501],
      [29.5609399, -27.4405501],
      [29.5612899, -27.4413301],
      [29.5618299, -27.44202],
      [29.5621999, -27.4422901],
      [29.5625799, -27.4425301],
      [29.5629199, -27.4426301],
      [29.5632999, -27.44268],
      [29.5637799, -27.4426501],
      [29.5643299, -27.4425101],
      [29.5647499, -27.4423701],
      [29.5658399, -27.4418401],
      [29.5668599, -27.4414101],
      [29.5671699, -27.4413401],
      [29.5675299, -27.44128],
      [29.5679299, -27.4413501],
      [29.5684099, -27.44157],
      [29.5690699, -27.4421001],
      [29.5698799, -27.4430701],
      [29.5702799, -27.4434701],
      [29.5707999, -27.4440801],
      [29.5711499, -27.44456],
      [29.5714099, -27.4452201],
      [29.5715799, -27.4457701],
      [29.5717299, -27.4465101],
      [29.5718299, -27.4469001],
      [29.5719799, -27.4471501],
      [29.5723299, -27.44762],
      [29.5733299, -27.4486201],
      [29.5746199, -27.4496601],
      [29.5754199, -27.4502801],
      [29.5758699, -27.4505601],
      [29.5765899, -27.4512201],
      [29.5770099, -27.45152],
      [29.5773099, -27.4518801],
      [29.5776299, -27.4523601],
      [29.5778499, -27.45278],
      [29.5778099, -27.4529901],
      [29.5777299, -27.4532201],
      [29.5776299, -27.4533401],
      [29.5774999, -27.4535901],
      [29.5774799, -27.45379],
      [29.5775999, -27.45401],
      [29.5778499, -27.4541101],
      [29.5782199, -27.4541201],
      [29.5786099, -27.4541601],
      [29.5789399, -27.45425],
      [29.5790999, -27.4544501],
      [29.5791599, -27.45477],
      [29.5790699, -27.45501],
      [29.5788399, -27.4552001],
      [29.5783199, -27.4554701],
      [29.5781799, -27.4555],
      [29.5780599, -27.4556601],
      [29.5780599, -27.45581],
      [29.5781599, -27.4559501],
      [29.5786599, -27.45631],
      [29.5786799, -27.45651],
      [29.5785999, -27.4565601],
      [29.5783599, -27.4565601],
      [29.5780699, -27.4564601],
      [29.5775999, -27.4564801],
      [29.5773599, -27.45651],
      [29.5770999, -27.4565801],
      [29.5768799, -27.45669],
      [29.5767399, -27.4569501],
      [29.5767399, -27.45713],
      [29.5769099, -27.4573201],
      [29.5772499, -27.4573701],
      [29.5773999, -27.4574801],
      [29.5779699, -27.45777],
      [29.5780799, -27.4579301],
      [29.5781599, -27.45821],
      [29.5779399, -27.4591701],
      [29.5779699, -27.4594],
      [29.5781099, -27.4595801],
      [29.5783799, -27.45966],
      [29.5786599, -27.4596101],
      [29.5788499, -27.45955],
      [29.5789499, -27.4593601],
      [29.5792199, -27.4586401],
      [29.5793399, -27.45846],
      [29.5797999, -27.4583801],
      [29.5800199, -27.45839],
      [29.5801599, -27.4585301],
      [29.5801499, -27.4587601],
      [29.5801899, -27.4590101],
      [29.5802599, -27.45919],
      [29.5805399, -27.4593201],
      [29.5808299, -27.4594001],
      [29.5810899, -27.4595001],
      [29.5811999, -27.45964],
      [29.5811999, -27.4598101],
      [29.5809699, -27.4603501],
      [29.5809199, -27.4605],
      [29.5809499, -27.4606401],
      [29.5810399, -27.46072],
      [29.5811599, -27.4607101],
      [29.5812999, -27.4605901],
      [29.5815799, -27.46031],
      [29.5819799, -27.4602001],
      [29.5824099, -27.4602501],
      [29.5825699, -27.46033],
      [29.5826699, -27.4605101],
      [29.5827099, -27.4606901],
      [29.5826899, -27.4609001],
      [29.5826299, -27.4610101],
      [29.5826699, -27.4612401],
      [29.5827399, -27.46147],
      [29.5829199, -27.4616501],
      [29.5832999, -27.46178],
      [29.5838399, -27.4617801],
      [29.5842799, -27.4617101],
      [29.5844975, -27.4617129],
      [29.584643, -27.461806],
      [29.5847088, -27.4619501],
      [29.5846947, -27.462084],
      [29.5846206, -27.4622106],
      [29.5845343, -27.4622772],
      [29.5844099, -27.46231],
      [29.5841599, -27.4622394],
      [29.5839399, -27.4621901],
      [29.5838251, -27.4621498],
      [29.5836899, -27.46215],
      [29.5836313, -27.462207],
      [29.5835599, -27.46231],
      [29.583509, -27.4624518],
      [29.5835223, -27.4625969],
      [29.5836176, -27.4627362],
      [29.5839299, -27.4630101],
      [29.5840191, -27.4631249],
      [29.5840665, -27.4632835],
      [29.5841799, -27.4638601],
      [29.5842999, -27.46416],
      [29.5844999, -27.4643601],
      [29.5847299, -27.46441],
      [29.5849299, -27.4643501],
      [29.5850499, -27.4642601],
      [29.5852199, -27.4640801],
      [29.5855199, -27.4639201],
      [29.5858599, -27.46384],
      [29.5863499, -27.4639401],
      [29.5867599, -27.464],
      [29.5868699, -27.4639401],
      [29.5869699, -27.46383],
      [29.5869899, -27.4636001],
      [29.5869499, -27.4633601],
      [29.5870099, -27.46319],
      [29.5873099, -27.4630301],
      [29.5874799, -27.463],
      [29.5878699, -27.4631201],
      [29.5889599, -27.4632501],
      [29.5892599, -27.46341],
      [29.5895099, -27.4637701],
      [29.5895399, -27.46401],
      [29.5893999, -27.4642301],
      [29.5891099, -27.4645201],
      [29.5889399, -27.4647901],
      [29.5888199, -27.46502],
      [29.5888199, -27.4653001],
      [29.5889099, -27.46558],
      [29.5891299, -27.4658801],
      [29.5896599, -27.46634],
      [29.5899699, -27.4664601],
      [29.5904699, -27.4665301],
      [29.5907899, -27.46661],
      [29.5911399, -27.4669201],
      [29.5916099, -27.4672801],
      [29.5921799, -27.4675601],
      [29.5925899, -27.4677401],
      [29.5929199, -27.46786],
      [29.5935199, -27.46785],
      [29.5937699, -27.4677001],
      [29.5939899, -27.4675301],
      [29.5941299, -27.4674601],
      [29.5944099, -27.46742],
      [29.5947199, -27.4675801],
      [29.5950399, -27.4679201],
      [29.5952199, -27.46802],
      [29.5955099, -27.4680901],
      [29.5957899, -27.4681201],
      [29.5960499, -27.46822],
      [29.5961499, -27.4683501],
      [29.5961599, -27.4685601],
      [29.5962199, -27.4689601],
      [29.5962899, -27.4692101],
      [29.5964299, -27.46941],
      [29.5967499, -27.4696201],
      [29.5971099, -27.4697801],
      [29.5979033, -27.4702414],
      [29.5982833, -27.4703015],
      [29.5985833, -27.4703115],
      [29.5988033, -27.4702714],
      [29.5990137, -27.4701915],
      [29.5991389, -27.4700743],
      [29.599162, -27.469952],
      [29.599151, -27.469841],
      [29.5989996, -27.4696359],
      [29.5988819, -27.4694008],
      [29.5988816, -27.4691522],
      [29.5989282, -27.468956],
      [29.5990461, -27.4688323],
      [29.5992059, -27.4687703],
      [29.5994109, -27.4687856],
      [29.5996609, -27.4689329],
      [29.5998969, -27.4691635],
      [29.6002189, -27.4696184],
      [29.6005506, -27.4703697],
      [29.6008561, -27.4706457],
      [29.6009475, -27.4708189],
      [29.6009978, -27.4709538],
      [29.6009379, -27.4710339],
      [29.6007678, -27.4711072],
      [29.6006048, -27.4711935],
      [29.600473, -27.4713064],
      [29.6003179, -27.4716407],
      [29.6001372, -27.471856],
      [29.5998299, -27.4720101],
      [29.5996999, -27.47213],
      [29.5995907, -27.4724452],
      [29.5995372, -27.4726556],
      [29.5995751, -27.4728655],
      [29.5996631, -27.4729679],
      [29.5997739, -27.4730395],
      [29.6001012, -27.4730834],
      [29.6003704, -27.473023],
      [29.6006394, -27.4728962],
      [29.6007834, -27.4727463],
      [29.600827, -27.4725734],
      [29.6007899, -27.4723901],
      [29.6007939, -27.4721599],
      [29.6008599, -27.4719],
      [29.6009199, -27.4718401],
      [29.6010599, -27.4717601],
      [29.6012799, -27.4717501],
      [29.6015899, -27.47178],
      [29.6017599, -27.4719001],
      [29.6019299, -27.4721201],
      [29.6021899, -27.4727301],
      [29.6024399, -27.4732501],
      [29.6027399, -27.4736701],
      [29.6028899, -27.4739501],
      [29.6029499, -27.47413],
      [29.6029099, -27.47427],
      [29.6027199, -27.4743801],
      [29.6021899, -27.4744301],
      [29.6019899, -27.47448],
      [29.6019499, -27.4746101],
      [29.6019899, -27.47474],
      [29.6022499, -27.4750001],
      [29.6025399, -27.4752501],
      [29.6026699, -27.47543],
      [29.6026399, -27.4756001],
      [29.6026499, -27.4757001],
      [29.6025299, -27.47581],
      [29.6023099, -27.4758201],
      [29.6020399, -27.4757601],
      [29.6017099, -27.47581],
      [29.6015899, -27.4759501],
      [29.6015199, -27.4761701],
      [29.6014099, -27.4763101],
      [29.6011399, -27.4764601],
      [29.6010199, -27.4766401],
      [29.6009599, -27.47684],
      [29.6010899, -27.4770601],
      [29.6013499, -27.4773301],
      [29.6018699, -27.4782401],
      [29.6024399, -27.4790101],
      [29.6028299, -27.47941],
      [29.6031499, -27.4796001],
      [29.6037399, -27.4799901],
      [29.6038999, -27.4802],
      [29.6038999, -27.4803501],
      [29.6037599, -27.48058],
      [29.6034299, -27.4808101],
      [29.6031399, -27.48096],
      [29.6028999, -27.4810201],
      [29.6025499, -27.4810401],
      [29.6021699, -27.4810401],
      [29.6019499, -27.4811001],
      [29.6017799, -27.48121],
      [29.6017699, -27.4813501],
      [29.6018299, -27.4816501],
      [29.6019699, -27.4819401],
      [29.6021399, -27.4823601],
      [29.6023899, -27.48278],
      [29.6025399, -27.48279],
      [29.6027099, -27.4826601],
      [29.6028499, -27.4824201],
      [29.6030399, -27.4822801],
      [29.6032099, -27.48227],
      [29.6037199, -27.4829201],
      [29.6037799, -27.48311],
      [29.6036499, -27.4833401],
      [29.6034799, -27.48354],
      [29.6035299, -27.48392],
      [29.6037399, -27.4842101],
      [29.6038999, -27.4844801],
      [29.6041499, -27.4847801],
      [29.6043999, -27.4849201],
      [29.6046799, -27.4851601],
      [29.6048799, -27.48541],
      [29.6048799, -27.4855401],
      [29.6047899, -27.4859701],
      [29.6047899, -27.4862201],
      [29.6046499, -27.4867],
      [29.6044699, -27.4868601],
      [29.6043499, -27.4870201],
      [29.604263, -27.4872263],
      [29.6042309, -27.4873881],
      [29.6042706, -27.4875632],
      [29.6043047, -27.4877769],
      [29.6042589, -27.4879436],
      [29.604224, -27.4880082],
      [29.6037899, -27.48881],
      [29.6037899, -27.4891901],
      [29.6038299, -27.4895401],
      [29.6038999, -27.48977],
      [29.6040399, -27.4897901],
      [29.6042199, -27.48972],
      [29.6043299, -27.4895801],
      [29.6044399, -27.4895],
      [29.6045199, -27.4895501],
      [29.6045399, -27.4897301],
      [29.6046499, -27.4899401],
      [29.6046599, -27.4901],
      [29.6045799, -27.4902301],
      [29.6044399, -27.4903801],
      [29.6044199, -27.4906],
      [29.6047099, -27.4910401],
      [29.6049299, -27.4912501],
      [29.6050499, -27.4914001],
      [29.6051399, -27.49159],
      [29.6051099, -27.4917001],
      [29.6050399, -27.4917801],
      [29.6049999, -27.4918801],
      [29.6050399, -27.4920401],
      [29.6050399, -27.4921801],
      [29.6049599, -27.49242],
      [29.6048599, -27.4924501],
      [29.6044499, -27.4927201],
      [29.6043799, -27.49286],
      [29.6045699, -27.4931301],
      [29.6045799, -27.49325],
      [29.6045199, -27.4933101],
      [29.6042899, -27.4933701],
      [29.6040999, -27.4934701],
      [29.6039399, -27.49366],
      [29.6039399, -27.4939101],
      [29.6039799, -27.4942],
      [29.6041699, -27.4944601],
      [29.6044399, -27.4946801],
      [29.6045899, -27.4948601],
      [29.6047599, -27.49511],
      [29.6047399, -27.4953701],
      [29.6047899, -27.49554],
      [29.6052899, -27.4955601],
      [29.6055099, -27.49549],
      [29.6056199, -27.4953601],
      [29.6057199, -27.49521],
      [29.6058299, -27.4952101],
      [29.6059399, -27.49525],
      [29.6059299, -27.4953601],
      [29.6058899, -27.4954601],
      [29.6058999, -27.49564],
      [29.6060099, -27.4957601],
      [29.6061499, -27.4957601],
      [29.6063299, -27.4958301],
      [29.6065799, -27.49599],
      [29.6066699, -27.4961101],
      [29.6066999, -27.4963801],
      [29.6068399, -27.49659],
      [29.6070599, -27.49667],
      [29.6073099, -27.4966301],
      [29.6074699, -27.4965601],
      [29.6077399, -27.4963801],
      [29.6080599, -27.4962601],
      [29.6084499, -27.4962001],
      [29.6089499, -27.49625],
      [29.6093199, -27.4964401],
      [29.6103199, -27.4972701],
      [29.6108199, -27.4977701],
      [29.6109499, -27.49786],
      [29.6109999, -27.4979601],
      [29.6109999, -27.4980801],
      [29.6113199, -27.4984601],
      [29.6115399, -27.49861],
      [29.6119099, -27.4987401],
      [29.6120899, -27.4987801],
      [29.6122899, -27.49894],
      [29.6124099, -27.4992201],
      [29.6124899, -27.4994901],
      [29.6125099, -27.4996901],
      [29.6127299, -27.50014],
      [29.6131399, -27.5003801],
      [29.6136599, -27.5005001],
      [29.6139399, -27.5006501],
      [29.6144199, -27.5007901],
      [29.6147799, -27.50097],
      [29.6150399, -27.5012301],
      [29.6151399, -27.5014801],
      [29.6152399, -27.5018601],
      [29.6154599, -27.5024001],
      [29.6155699, -27.5028601],
      [29.6157199, -27.50309],
      [29.6159799, -27.5032501],
      [29.6168099, -27.5039801],
      [29.6170899, -27.5041601],
      [29.6172399, -27.5043001],
      [29.6173399, -27.50457],
      [29.6175899, -27.5048301],
      [29.6178799, -27.5050901],
      [29.6182699, -27.5053601],
      [29.6189099, -27.5060201],
      [29.6192199, -27.50615],
      [29.6195199, -27.5061401],
      [29.6197899, -27.5060301],
      [29.6200599, -27.5060101],
      [29.6206299, -27.5060101],
      [29.6211199, -27.5060401],
      [29.6213199, -27.50601],
      [29.6217499, -27.5057601],
      [29.6218499, -27.50574],
      [29.6222499, -27.5057901],
      [29.6223599, -27.50577],
      [29.6225799, -27.5055801],
      [29.6227299, -27.50542],
      [29.6229099, -27.5053501],
      [29.6231199, -27.5053301],
      [29.6234199, -27.50543],
      [29.6237499, -27.5057901],
      [29.6238599, -27.50597],
      [29.6239999, -27.5060401],
      [29.6241799, -27.5060901],
      [29.6242899, -27.5060901],
      [29.6244299, -27.50604],
      [29.6245, -27.50561],
      [29.6245999, -27.5055401],
      [29.62487, -27.50554],
      [29.6251399, -27.5057201],
      [29.62535, -27.50578],
      [29.6255299, -27.5057201],
      [29.6257199, -27.5055601],
      [29.6258599, -27.5052901],
      [29.6260399, -27.5050101],
      [29.6262799, -27.5047601],
      [29.6264199, -27.5046401],
      [29.6271, -27.50379],
      [29.6273999, -27.5035801],
      [29.6277699, -27.5034001],
      [29.6280599, -27.5033301],
      [29.6283499, -27.5032801],
      [29.6285299, -27.5032201],
      [29.6286799, -27.5029401],
      [29.6288199, -27.5027801],
      [29.6291299, -27.5025001],
      [29.6296599, -27.5023101],
      [29.6301299, -27.5023501],
      [29.6305699, -27.5024501],
      [29.6308999, -27.5026001],
      [29.6314599, -27.5031001],
      [29.6321299, -27.5032201],
      [29.6324699, -27.5034001],
      [29.6326999, -27.5034601],
      [29.6329399, -27.5035801],
      [29.6333799, -27.5038501],
      [29.6339999, -27.5041501],
      [29.6342299, -27.5042901],
      [29.6345399, -27.5043601],
      [29.6352699, -27.5043501],
      [29.6357599, -27.5041301],
      [29.6359599, -27.5041301],
      [29.6361899, -27.5042401],
      [29.6363299, -27.5044001],
      [29.6364999, -27.5046501],
      [29.6367799, -27.5047201],
      [29.6372999, -27.5047601],
      [29.6377499, -27.5046701],
      [29.6378799, -27.5045901],
      [29.6380899, -27.5045201],
      [29.6384899, -27.5045301],
      [29.6387599, -27.5046401],
      [29.63905, -27.5047],
      [29.6392599, -27.5047101],
      [29.6395299, -27.5047001],
      [29.6398099, -27.5046001],
      [29.6404799, -27.5044201],
      [29.6408199, -27.5043501],
      [29.6410399, -27.5043501],
      [29.64111, -27.50432],
      [29.64119, -27.50416],
      [29.6413199, -27.5040901],
      [29.64148, -27.50409],
      [29.6418099, -27.5041801],
      [29.6422899, -27.5043601],
      [29.6425199, -27.5044701],
      [29.64289, -27.50446],
      [29.6429799, -27.5043301],
      [29.6431299, -27.5040101],
      [29.64328, -27.50379],
      [29.6434499, -27.5037201],
      [29.6438699, -27.5037101],
      [29.6442399, -27.5036701],
      [29.6447699, -27.5036701],
      [29.6452399, -27.5038001],
      [29.6457799, -27.5038801],
      [29.6461699, -27.5038801],
      [29.64662, -27.50395],
      [29.6470499, -27.5041301],
      [29.64738, -27.50442],
      [29.64762, -27.50441],
      [29.6477599, -27.5041801],
      [29.64789, -27.50411],
      [29.6481799, -27.5041301],
      [29.6485599, -27.5042001],
      [29.6490099, -27.5042301],
      [29.64941, -27.50423],
      [29.6495899, -27.5041601],
      [29.6500199, -27.5038201],
      [29.65038, -27.50346],
      [29.6505099, -27.5032001],
      [29.6505899, -27.5029001],
      [29.6505599, -27.5024001],
      [29.6504699, -27.5017301],
      [29.6504699, -27.5013301],
      [29.6505599, -27.5010301],
      [29.65063, -27.50066],
      [29.6505299, -27.5005401],
      [29.6503799, -27.5002601],
      [29.65038, -27.49999],
      [29.6505299, -27.4997501],
      [29.6507899, -27.4995201],
      [29.6510599, -27.4992401],
      [29.6513199, -27.4988301],
      [29.6516999, -27.4985501],
      [29.6520999, -27.4982001],
      [29.6527299, -27.4979201],
      [29.6532099, -27.4976701],
      [29.6534099, -27.4975201],
      [29.6541399, -27.4968701],
      [29.6547499, -27.4964001],
      [29.6550599, -27.4962401],
      [29.6553899, -27.4962301],
      [29.6557399, -27.4962701],
      [29.6562999, -27.4963601],
      [29.6571299, -27.4963401],
      [29.6578399, -27.4963901],
      [29.6581799, -27.4963901],
      [29.6585299, -27.4963301],
      [29.6587799, -27.4961901],
      [29.6589799, -27.4960101],
      [29.6592799, -27.4958401],
      [29.6596299, -27.4957601],
      [29.6602499, -27.4957501],
      [29.6607999, -27.4957601],
      [29.6610899, -27.4958401],
      [29.6612299, -27.4962001],
      [29.6612299, -27.4964201],
      [29.6612499, -27.4965901],
      [29.6614099, -27.4967001],
      [29.6615499, -27.4966901],
      [29.6616399, -27.4965201],
      [29.6616899, -27.4963301],
      [29.6617999, -27.4961701],
      [29.6620399, -27.4960601],
      [29.6623199, -27.4960601],
      [29.6624599, -27.4961101],
      [29.6629599, -27.4964901],
      [29.6633999, -27.4967301],
      [29.6637999, -27.4968201],
      [29.6641199, -27.4968001],
      [29.6643199, -27.4967001],
      [29.6647599, -27.4965601],
      [29.6655599, -27.4962401],
      [29.6662199, -27.4959401],
      [29.6664999, -27.4958701],
      [29.6668599, -27.4959001],
      [29.6671199, -27.4959801],
      [29.6675699, -27.4960901],
      [29.6680399, -27.4962401],
      [29.6683699, -27.4964001],
      [29.6687299, -27.4965201],
      [29.6691899, -27.4965801],
      [29.6694799, -27.4965101],
      [29.6697999, -27.4963601],
      [29.6700899, -27.4963101],
      [29.6704799, -27.4963601],
      [29.6710199, -27.4965101],
      [29.6715199, -27.4967501],
      [29.6719899, -27.4970701],
      [29.6722699, -27.4972201],
      [29.6726499, -27.4973701],
      [29.6730099, -27.4974401],
      [29.6733399, -27.4975301],
      [29.6737099, -27.4977601],
      [29.6739199, -27.4979601],
      [29.6741299, -27.4980001],
      [29.6743599, -27.4979901],
      [29.6746399, -27.4979001],
      [29.6753399, -27.4977401],
      [29.6760199, -27.4975301],
      [29.6764099, -27.4973301],
      [29.6774599, -27.4969201],
      [29.6780699, -27.4968201],
      [29.6786599, -27.4967701],
      [29.6791399, -27.4967801],
      [29.6794799, -27.4968101],
      [29.6796299, -27.4969301],
      [29.6796799, -27.4971901],
      [29.6797199, -27.4975501],
      [29.6797399, -27.4981301],
      [29.6798799, -27.4987401],
      [29.6799899, -27.4994301],
      [29.6800999, -27.4997101],
      [29.6803099, -27.4998501],
      [29.6806699, -27.5000301],
      [29.6810299, -27.5001301],
      [29.6813999, -27.5001001],
      [29.6820799, -27.4998901],
      [29.6830499, -27.4994401],
      [29.6835399, -27.4992601],
      [29.6837999, -27.4989401],
      [29.6848799, -27.4980701],
      [29.6854699, -27.4979201],
      [29.6858099, -27.4977601],
      [29.6858999, -27.4976101],
      [29.6858299, -27.4973901],
      [29.6858299, -27.4971901],
      [29.6859399, -27.4970601],
      [29.6861499, -27.4968701],
      [29.6863999, -27.4966801],
      [29.6865099, -27.4965601],
      [29.6865199, -27.4963901],
      [29.6864399, -27.4962101],
      [29.6862899, -27.4961701],
      [29.6861899, -27.4960001],
      [29.6861999, -27.4958601],
      [29.6863999, -27.4957501],
      [29.6866599, -27.4955701],
      [29.6868399, -27.4954201],
      [29.6870799, -27.4950401],
      [29.6872199, -27.4947301],
      [29.6874399, -27.4940701],
      [29.6875999, -27.4938601],
      [29.6879799, -27.4936401],
      [29.6883199, -27.4935001],
      [29.6891099, -27.4934901],
      [29.6897399, -27.4933601],
      [29.6907699, -27.4931101],
      [29.6911199, -27.4929501],
      [29.6912999, -27.4928801],
      [29.6914299, -27.4928501],
      [29.6917599, -27.4928201],
      [29.6919699, -27.4928701],
      [29.6922599, -27.4930001],
      [29.6924099, -27.4929901],
      [29.6925399, -27.4928901],
      [29.6926599, -27.4927201],
      [29.6929299, -27.4924301],
      [29.6930799, -27.4923501],
      [29.6935499, -27.4922501],
      [29.6939999, -27.4922901],
      [29.6947499, -27.4925701],
      [29.6950699, -27.4928201],
      [29.6952899, -27.4929101],
      [29.6955699, -27.4929401],
      [29.6959099, -27.4930001],
      [29.6961299, -27.4931401],
      [29.6961399, -27.4937601],
      [29.6963399, -27.4939101],
      [29.6966699, -27.4939801],
      [29.6971599, -27.4939301],
      [29.6976699, -27.4939701],
      [29.6982499, -27.4941801],
      [29.6986499, -27.4945401],
      [29.6988799, -27.4946801],
      [29.6990999, -27.4947001],
      [29.6994099, -27.4944901],
      [29.6997899, -27.4943101],
      [29.7002699, -27.4940401],
      [29.7005799, -27.4940101],
      [29.7008899, -27.4941301],
      [29.7011799, -27.4941001],
      [29.7013194, -27.4940482],
      [29.7015699, -27.4937701],
      [29.7022799, -27.4930501],
      [29.7024399, -27.4927601],
      [29.7029299, -27.4920901],
      [29.7031199, -27.4918401],
      [29.7032999, -27.4916601],
      [29.7034099, -27.4915101],
      [29.7034799, -27.4913201],
      [29.7035199, -27.4911101],
      [29.7036499, -27.4906201],
      [29.7038499, -27.4901501],
      [29.7041199, -27.4897201],
      [29.7042699, -27.4894001],
      [29.7045299, -27.4891501],
      [29.7050899, -27.4888701],
      [29.7057099, -27.4884701],
      [29.7060099, -27.4883401],
      [29.7064199, -27.4880401],
      [29.7065099, -27.4879001],
      [29.7064999, -27.4876801],
      [29.7062799, -27.4874701],
      [29.7055821, -27.4871866],
      [29.7053008, -27.4871076],
      [29.7052445, -27.4869538],
      [29.7053201, -27.4867317],
      [29.7052529, -27.486613],
      [29.7051037, -27.4866623],
      [29.705042, -27.4865747],
      [29.7048699, -27.4858301],
      [29.7049399, -27.4853301],
      [29.7050499, -27.4851001],
      [29.7052299, -27.4846101],
      [29.7055299, -27.4843301],
      [29.7057099, -27.4840401],
      [29.7059999, -27.4834201],
      [29.7061899, -27.4827001],
      [29.7062299, -27.4823501],
      [29.7063099, -27.4820701],
      [29.7063099, -27.4817301],
      [29.7062299, -27.4815901],
      [29.7060099, -27.4814001],
      [29.7056999, -27.4812901],
      [29.7052899, -27.4812001],
      [29.7046499, -27.4812001],
      [29.7042399, -27.4810101],
      [29.7040599, -27.4808801],
      [29.7037699, -27.4807001],
      [29.7035899, -27.4805401],
      [29.7032999, -27.4801501],
      [29.7030599, -27.4798701],
      [29.7027699, -27.4796501],
      [29.7025299, -27.4793801],
      [29.7022299, -27.4791901],
      [29.7019399, -27.4790801],
      [29.7015799, -27.4789901],
      [29.7013899, -27.4788801],
      [29.7011499, -27.4788001],
      [29.7008699, -27.4785501],
      [29.7006299, -27.4783001],
      [29.7001199, -27.4780201],
      [29.6997899, -27.4778801],
      [29.6993899, -27.4778301],
      [29.6992299, -27.4777601],
      [29.6992299, -27.4775501],
      [29.6992799, -27.4773601],
      [29.6993499, -27.4772301],
      [29.6992699, -27.4770001],
      [29.6990399, -27.4768301],
      [29.6986099, -27.4762601],
      [29.6984499, -27.4760701],
      [29.6981999, -27.4759401],
      [29.6980299, -27.4757501],
      [29.6979399, -27.4755801],
      [29.6977299, -27.4754101],
      [29.6976899, -27.4751801],
      [29.6977799, -27.4749401],
      [29.6981099, -27.4747601],
      [29.6982899, -27.4746901],
      [29.6987199, -27.4747301],
      [29.6991799, -27.4747301],
      [29.6992899, -27.47469],
      [29.6993099, -27.4746101],
      [29.6992399, -27.47447],
      [29.6990799, -27.4743301],
      [29.6984199, -27.47382],
      [29.6983699, -27.4736601],
      [29.6982599, -27.4731101],
      [29.6982699, -27.4728601],
      [29.6983599, -27.47256],
      [29.6986099, -27.4723201],
      [29.6988599, -27.4721301],
      [29.6991699, -27.4719701],
      [29.6992399, -27.47186],
      [29.6990499, -27.4715301],
      [29.6990199, -27.47125],
      [29.6991899, -27.4707401],
      [29.6994899, -27.47019],
      [29.7002299, -27.4692701],
      [29.7006199, -27.4688501],
      [29.7014899, -27.4681601],
      [29.7017299, -27.4679201],
      [29.7019299, -27.46768],
      [29.7021099, -27.4672101],
      [29.7022399, -27.4667601],
      [29.7023399, -27.46636],
      [29.7023399, -27.4662401],
      [29.7023899, -27.4658501],
      [29.7023899, -27.4652801],
      [29.7023699, -27.4650101],
      [29.7022699, -27.4647201],
      [29.7023199, -27.4643201],
      [29.7022299, -27.4639101],
      [29.7021199, -27.46365],
      [29.7018399, -27.4632701],
      [29.7014899, -27.4625701],
      [29.7013499, -27.4623401],
      [29.7011199, -27.4619901],
      [29.7007099, -27.4614501],
      [29.7005199, -27.4611401],
      [29.7002799, -27.4606601],
      [29.6999099, -27.4600901],
      [29.6996799, -27.4598001],
      [29.6995099, -27.4595201],
      [29.6993599, -27.45909],
      [29.6993299, -27.4588001],
      [29.6993299, -27.4586201],
      [29.6993799, -27.4583301],
      [29.6996599, -27.4576701],
      [29.6998199, -27.4568301],
      [29.6998199, -27.45652],
      [29.6996699, -27.4560501],
      [29.6995199, -27.4556601],
      [29.6992299, -27.4551601],
      [29.6990899, -27.45473],
      [29.6990699, -27.4542601],
      [29.6991599, -27.45393],
      [29.6994099, -27.4536901],
      [29.6994899, -27.4535501],
      [29.6997299, -27.4533001],
      [29.6998799, -27.4530501],
      [29.7000099, -27.45287],
      [29.7000599, -27.4526101],
      [29.7000099, -27.45237],
      [29.6997099, -27.4519701],
      [29.6992599, -27.4515001],
      [29.6991199, -27.4512501],
      [29.6991399, -27.4507701],
      [29.6992899, -27.45034],
      [29.6997699, -27.4497401],
      [29.7001999, -27.4493401],
      [29.7007299, -27.4488001],
      [29.7010299, -27.4486701],
      [29.7011699, -27.4485801],
      [29.7013399, -27.4483901],
      [29.7014599, -27.4481701],
      [29.7017699, -27.4479701],
      [29.7021599, -27.4476701],
      [29.7036499, -27.4464501],
      [29.7038299, -27.4462101],
      [29.7041799, -27.44555],
      [29.7043899, -27.4453901],
      [29.7045799, -27.44532],
      [29.7048199, -27.4453101],
      [29.7053999, -27.4455001],
      [29.7059999, -27.4454801],
      [29.7062499, -27.4453801],
      [29.7069699, -27.4447501],
      [29.7073199, -27.4446001],
      [29.7074699, -27.4445201],
      [29.7079699, -27.4443201],
      [29.7082699, -27.4441701],
      [29.7084999, -27.4440901],
      [29.7096399, -27.4440201],
      [29.7101999, -27.4440201],
      [29.7105599, -27.4439501],
      [29.7108399, -27.4437801],
      [29.7110699, -27.4435201],
      [29.7113599, -27.4432701],
      [29.7118399, -27.4428901],
      [29.7121599, -27.4427201],
      [29.7124199, -27.4426301],
      [29.7127099, -27.4426301],
      [29.7130199, -27.4425201],
      [29.7132099, -27.4423301],
      [29.7137799, -27.4420601],
      [29.7143699, -27.4418101],
      [29.7151199, -27.4414101],
      [29.7158099, -27.4410801],
      [29.7160999, -27.4409001],
      [29.7166099, -27.4406701],
      [29.7168599, -27.4404701],
      [29.7172199, -27.44033],
      [29.7174799, -27.4398601],
      [29.7174799, -27.43952],
      [29.7170299, -27.4388801],
      [29.7169599, -27.43863],
      [29.7170299, -27.4384201],
      [29.7172199, -27.43829],
      [29.7175799, -27.4383601],
      [29.7179199, -27.4385701],
      [29.7181699, -27.43881],
      [29.7184599, -27.4388801],
      [29.7189199, -27.43888],
      [29.7192699, -27.4386701],
      [29.7196699, -27.43826],
      [29.7199399, -27.4377001],
      [29.7201499, -27.4371801],
      [29.7203699, -27.4364801],
      [29.7204799, -27.4359701],
      [29.7206199, -27.4351201],
      [29.7206699, -27.4344101],
      [29.7209699, -27.4332201],
      [29.7211699, -27.4329],
      [29.7214199, -27.4327701],
      [29.7225999, -27.4323401],
      [29.72274, -27.43234],
      [29.7228499, -27.4324201],
      [29.72322, -27.43284],
      [29.7234399, -27.4328401],
      [29.7236299, -27.4327201],
      [29.7238199, -27.4325201],
      [29.72406, -27.43241],
      [29.7247399, -27.4323001],
      [29.7252099, -27.4322901],
      [29.72538, -27.43223],
      [29.72547, -27.43208],
      [29.7256899, -27.4319801],
      [29.7263599, -27.4319701],
      [29.7266499, -27.4318701],
      [29.7270099, -27.4316601],
      [29.72747, -27.43152],
      [29.7281099, -27.4314401],
      [29.72929, -27.43141],
      [29.7300199, -27.4314701],
      [29.7305199, -27.4315901],
      [29.7308099, -27.4317501],
      [29.73109, -27.43184],
      [29.7312399, -27.4318001],
      [29.7314999, -27.4316801],
      [29.7320199, -27.4311801],
      [29.73227, -27.43098],
      [29.7324999, -27.4309301],
      [29.73324, -27.43096],
      [29.7341499, -27.4312201],
      [29.7346899, -27.4314201],
      [29.7352499, -27.4315901],
      [29.7355699, -27.4317101],
      [29.7358599, -27.4317201],
      [29.7363699, -27.4318401],
      [29.73675, -27.43196],
      [29.7377299, -27.4320901],
      [29.7381799, -27.4320801],
      [29.7387299, -27.4321001],
      [29.7391199, -27.4321901],
      [29.7394499, -27.4322301],
      [29.7398999, -27.4321901],
      [29.7408899, -27.4320401],
      [29.7417099, -27.4320301],
      [29.74241, -27.43209],
      [29.7426899, -27.4321901],
      [29.7430699, -27.4323001],
      [29.7435299, -27.4323401],
      [29.7440299, -27.4324801],
      [29.7446399, -27.4326001],
      [29.74521, -27.43287],
      [29.7456399, -27.4333001],
      [29.7459199, -27.4336501],
      [29.7460699, -27.4338701],
      [29.74619, -27.4341],
      [29.7462599, -27.4344101],
      [29.7463199, -27.4348101],
      [29.74644, -27.43505],
      [29.7465999, -27.4351701],
      [29.7468499, -27.4353101],
      [29.7475199, -27.4355101],
      [29.7480399, -27.4355901],
      [29.7484299, -27.4357801],
      [29.7487299, -27.4358701],
      [29.7490599, -27.4360001],
      [29.7494999, -27.4360601],
      [29.74962, -27.43605],
      [29.7503099, -27.4365701],
      [29.7508099, -27.4368301],
      [29.7511699, -27.4370701],
      [29.7515799, -27.4374201],
      [29.7520299, -27.4377401],
      [29.7524199, -27.4379901],
      [29.7525899, -27.4381401],
      [29.75266, -27.43825],
      [29.7526699, -27.4384201],
      [29.7527099, -27.4386101],
      [29.7527299, -27.4388101],
      [29.75284, -27.43904],
      [29.75718, -27.44111],
      [29.7586799, -27.44257],
      [29.75941, -27.4444201],
      [29.76034, -27.4450501],
      [29.7612061, -27.4456521],
      [29.76139, -27.4457801],
      [29.7616196, -27.4459265],
      [29.76255, -27.4465201],
      [29.7636334, -27.4472643],
      [29.76386, -27.4474201],
      [29.7641207, -27.4475844],
      [29.76516, -27.4482401],
      [29.7668374, -27.4493807],
      [29.76716, -27.4496001],
      [29.7672816, -27.4496816],
      [29.76792, -27.4501101],
      [29.76886, -27.4507401],
      [29.76912, -27.4509101],
      [29.77108, -27.4522201],
      [29.772101, -27.4529007],
      [29.77231, -27.4530401],
      [29.77344, -27.4538101],
      [29.77369, -27.4539001],
      [29.7737999, -27.4539301],
      [29.7745285, -27.45392],
      [29.77525, -27.4539101],
      [29.775646, -27.4539252],
      [29.7760299, -27.4539401],
      [29.77637, -27.4540201],
      [29.7770078, -27.4541794],
      [29.77809, -27.4544501],
      [29.7789157, -27.4546868],
      [29.77938, -27.4548201],
      [29.78095, -27.4552601],
      [29.78243, -27.4556501],
      [29.78393, -27.45615],
      [29.7847176, -27.4564907],
      [29.78675, -27.4573701],
      [29.7881664, -27.458031],
      [29.7887, -27.4582801],
      [29.79051, -27.4590701],
      [29.7906399, -27.4591187],
      [29.7909099, -27.4592201],
      [29.7919399, -27.4584101],
      [29.7936, -27.4581401],
      [29.79505, -27.4579101],
      [29.7962399, -27.4577001],
      [29.79694, -27.4560201],
      [29.79742, -27.4549801],
      [29.79812, -27.4532401],
      [29.79843, -27.4523701],
      [29.79898, -27.4515301],
      [29.7991299, -27.4512201],
      [29.7995681, -27.4511752],
      [29.80001, -27.4511301],
      [29.8001882, -27.4511096],
      [29.80036, -27.4510901],
      [29.8017959, -27.4509063],
      [29.80294, -27.4507601],
      [29.80437, -27.4504901],
      [29.8058099, -27.4503601],
      [29.80632, -27.4496101],
      [29.80664, -27.4493301],
      [29.8076796, -27.4486208],
      [29.80793, -27.4484501],
      [29.80919, -27.4475701],
      [29.81044, -27.4467801],
      [29.8114399, -27.4460701],
      [29.81136, -27.4457701],
      [29.8112807, -27.4456431],
      [29.81126, -27.4456101],
      [29.8106899, -27.4447701],
      [29.81079, -27.4432301],
      [29.81086, -27.4417101],
      [29.81107, -27.4393601],
      [29.81126, -27.4367801],
      [29.8113499, -27.4356501],
      [29.8114822, -27.4355624],
      [29.81212, -27.4351401],
      [29.8132363, -27.434393],
      [29.81348, -27.4342301],
      [29.8136999, -27.4339401],
      [29.81423, -27.4318401],
      [29.8145199, -27.4305801],
      [29.81538, -27.4300301],
      [29.81592, -27.4296801],
      [29.81736, -27.4285701],
      [29.817722, -27.428362],
      [29.8178299, -27.4283001],
      [29.81893, -27.4278701],
      [29.8193526, -27.4277327],
      [29.8201, -27.4274901],
      [29.8204026, -27.4274749],
      [29.8207, -27.4274601],
      [29.8212086, -27.4274309],
      [29.82175, -27.4274001],
      [29.82233, -27.4273501],
      [29.8226499, -27.4273001],
      [29.82256, -27.4254901],
      [29.82239, -27.4230801],
      [29.82235, -27.4223501],
      [29.82219, -27.4198001],
      [29.82209, -27.4182401],
      [29.82193, -27.4161301],
      [29.82181, -27.4133701],
      [29.8216599, -27.4115301],
      [29.82238, -27.4105001],
      [29.82361, -27.4086701],
      [29.82402, -27.4080701],
      [29.8240626, -27.408015],
      [29.82426, -27.4077601],
      [29.8248699, -27.4070001],
      [29.8258746, -27.4066335],
      [29.82635, -27.4064601],
      [29.8272517, -27.4061343],
      [29.82898, -27.4055101],
      [29.83057, -27.4049701],
      [29.83149, -27.4046208],
      [29.83194, -27.4044501],
      [29.83333, -27.4039901],
      [29.8334411, -27.4039344],
      [29.8337499, -27.4037801],
      [29.834, -27.4029601],
      [29.83416, -27.4024401],
      [29.8343263, -27.401922],
      [29.83451, -27.4013501],
      [29.8347968, -27.4005763],
      [29.83504, -27.3999201],
      [29.8353799, -27.3987101],
      [29.83587, -27.3973801],
      [29.8359799, -27.3968801],
      [29.83588, -27.3957501],
      [29.83561, -27.3947001],
      [29.83536, -27.3936201],
      [29.83508, -27.3921301],
      [29.8349812, -27.3916172],
      [29.83492, -27.3913001],
      [29.8349105, -27.3908342],
      [29.8348999, -27.3903201],
      [29.83547, -27.3889801],
      [29.83619, -27.3875701],
      [29.83664, -27.3865401],
      [29.8372, -27.3853801],
      [29.83782, -27.3841301],
      [29.83851, -27.3826401],
      [29.83901, -27.3815901],
      [29.83962, -27.3802701],
      [29.84008, -27.3793001],
      [29.84014, -27.3791101],
      [29.8401899, -27.3789901],
      [29.8411113, -27.3787998],
      [29.84174, -27.3786701],
      [29.8419314, -27.3786433],
      [29.84217, -27.3786101],
      [29.84266, -27.3787301],
      [29.8433153, -27.378693],
      [29.8439, -27.3786601],
      [29.8443174, -27.3786549],
      [29.84472, -27.3786501],
      [29.84571, -27.3786501],
      [29.8463399, -27.3787201],
      [29.8467, -27.3789401],
      [29.8468994, -27.3789349],
      [29.84709, -27.3789301],
      [29.8476041, -27.3791315],
      [29.84783, -27.3792201],
      [29.8481, -27.3794001],
      [29.8485175, -27.3795311],
      [29.84931, -27.3797801],
      [29.84992, -27.3799801],
      [29.85096, -27.3803201],
      [29.85193, -27.3806101],
      [29.85232, -27.3807001],
      [29.85349, -27.3808301],
      [29.8539104, -27.3808349],
      [29.85457, -27.3809401],
      [29.85597, -27.3811701],
      [29.8565573, -27.3812441],
      [29.857, -27.3813001],
      [29.8571617, -27.3813095],
      [29.85734, -27.3813201],
      [29.8578458, -27.3814635],
      [29.85808, -27.3815301],
      [29.85937, -27.3820901],
      [29.85984, -27.3823801],
      [29.860049, -27.3824692],
      [29.86059, -27.3827001],
      [29.8610066, -27.3828411],
      [29.86121, -27.3829101],
      [29.86166, -27.3829401],
      [29.861886, -27.3829852],
      [29.86221, -27.3830501],
      [29.8627873, -27.3831166],
      [29.86325, -27.3831701],
      [29.86391, -27.3834301],
      [29.86464, -27.3838301],
      [29.8647924, -27.3838797],
      [29.8651, -27.3839801],
      [29.8655225, -27.3840872],
      [29.86577, -27.3841501],
      [29.8662099, -27.3841501],
      [29.86708, -27.3837501],
      [29.86788, -27.3831501],
      [29.86817, -27.3829301],
      [29.8685013, -27.3827961],
      [29.86864, -27.3827401],
      [29.86904, -27.3826101],
      [29.8691697, -27.3825668],
      [29.86922, -27.3825501],
      [29.86972, -27.3822701],
      [29.87037, -27.3820901],
      [29.8709599, -27.3819301],
      [29.87144, -27.3818901],
      [29.87196, -27.3818901],
      [29.87249, -27.3819301],
      [29.8725806, -27.3819526],
      [29.87273, -27.3819901],
      [29.872923, -27.3819245],
      [29.8732899, -27.3818001],
      [29.8735, -27.3814301],
      [29.8741099, -27.3810301],
      [29.8745644, -27.3809002],
      [29.87481, -27.3808301],
      [29.8749224, -27.3807844],
      [29.87518, -27.3806801],
      [29.8756178, -27.3806413],
      [29.87597, -27.3806101],
      [29.87654, -27.3804801],
      [29.87705, -27.3802601],
      [29.87743, -27.3799801],
      [29.87784, -27.3797301],
      [29.8780493, -27.3796523],
      [29.87846, -27.3795001],
      [29.87891, -27.3793101],
      [29.8792865, -27.3791217],
      [29.8794099, -27.3790601],
      [29.87975, -27.3787201],
      [29.88001, -27.3784301],
      [29.88027, -27.3781501],
      [29.88071, -27.3778801],
      [29.88108, -27.3774901],
      [29.88185, -27.3769901],
      [29.8825699, -27.3767101],
      [29.88311, -27.3767101],
      [29.883355, -27.3766799],
      [29.88368, -27.3766401],
      [29.8839129, -27.3766123],
      [29.8841, -27.3765901],
      [29.8842569, -27.3765639],
      [29.88446, -27.3765301],
      [29.8847365, -27.3765523],
      [29.8850799, -27.3765801],
      [29.8854378, -27.3767715],
      [29.88579, -27.3769601],
      [29.8861099, -27.3772701],
      [29.88613, -27.3776701],
      [29.88645, -27.3781801],
      [29.88649, -27.3783501],
      [29.88656, -27.3787001],
      [29.88651, -27.3799001],
      [29.88639, -27.3804301],
      [29.88639, -27.3809801],
      [29.88638, -27.3814801],
      [29.8864499, -27.3817501],
      [29.88683, -27.3822201],
      [29.8871085, -27.3822733],
      [29.8873, -27.3823101],
      [29.8877299, -27.3825001],
      [29.88794, -27.3828101],
      [29.88818, -27.3832801],
      [29.88833, -27.3836501],
      [29.8883733, -27.3837222],
      [29.8885699, -27.3840501],
      [29.8888206, -27.3841553],
      [29.88907, -27.3842601],
      [29.88944, -27.3844201],
      [29.8896539, -27.3845599],
      [29.8896999, -27.3845901],
      [29.88997, -27.3850401],
      [29.8901499, -27.3855201],
      [29.8902401, -27.3855712],
      [29.89059, -27.3857701],
      [29.8907687, -27.3858262],
      [29.8909399, -27.3858801],
      [29.891051, -27.385859],
      [29.8910741, -27.3858547],
      [29.89126, -27.3858201],
      [29.8916299, -27.3856401],
      [29.8918436, -27.3856914],
      [29.89217, -27.3857701],
      [29.8924553, -27.3859165],
      [29.89254, -27.3859601],
      [29.8927369, -27.3859857],
      [29.8929999, -27.3860201],
      [29.8933687, -27.385975],
      [29.89382, -27.3859201],
      [29.8940743, -27.3858804],
      [29.89427, -27.3858501],
      [29.8944615, -27.3857922],
      [29.8948, -27.3856901],
      [29.8950894, -27.3856309],
      [29.89529, -27.3855901],
      [29.8955704, -27.3855331],
      [29.89598, -27.3854501],
      [29.8962428, -27.3853558],
      [29.89637, -27.3853101],
      [29.8965081, -27.3852423],
      [29.8969, -27.3850501],
      [29.8972077, -27.3849762],
      [29.8974, -27.3849301],
      [29.8976269, -27.3849353],
      [29.8978299, -27.3849401],
      [29.89825, -27.3852401],
      [29.8984311, -27.3854325],
      [29.89873, -27.3857501],
      [29.8988199, -27.3858101],
      [29.8991372, -27.3854928],
      [29.89914, -27.3854901],
      [29.89918, -27.38544],
      [29.89927, -27.38534],
      [29.90096, -27.38342],
      [29.90104, -27.38336],
      [29.90304, -27.38113],
      [29.90623, -27.37747],
      [29.90715, -27.37634],
      [29.9078644, -27.3755001],
      [29.90789, -27.37547],
      [29.90851, -27.37488],
      [29.90904, -27.37416],
      [29.9094299, -27.3738001],
      [29.9094929, -27.3736145],
      [29.90963, -27.37321],
      [29.9096456, -27.3730127],
      [29.90966, -27.37283],
      [29.90979, -27.37237],
      [29.91044, -27.37073],
      [29.9107491, -27.3699648],
      [29.91189, -27.36714],
      [29.91502, -27.35986],
      [29.9172199, -27.3544101],
      [29.9174382, -27.3544893],
      [29.9174681, -27.3545002],
      [29.91755, -27.35453],
      [29.917594, -27.354542],
      [29.9222407, -27.3558047],
      [29.92502, -27.35656],
      [29.93056, -27.35804],
      [29.93593, -27.35953],
      [29.94205, -27.36117],
      [29.94687, -27.36248],
      [29.95128, -27.36371],
      [29.9555, -27.36486],
      [29.9608, -27.36668],
      [29.97085, -27.37028],
      [29.9735669, -27.3712],
      [29.97652, -27.3722],
      [29.9784699, -27.3729901],
      [29.98027, -27.37472],
      [29.98283, -27.3769801],
      [29.98545, -27.3793601],
      [29.98989, -27.3835301],
      [29.99315, -27.3864801],
      [29.99416, -27.38764],
      [29.9950699, -27.3883701],
      [29.9963654, -27.3888655],
      [29.9969, -27.3890701],
      [29.99802, -27.3896301],
      [30.00037, -27.3906101],
      [30.0011041, -27.3909106],
      [30.00269, -27.3915601],
      [30.0045588, -27.3925143],
      [30.00504, -27.3927601],
      [30.00887, -27.3943401],
      [30.01217, -27.3958401],
      [30.016, -27.3974901],
      [30.0161832, -27.3975649],
      [30.016242, -27.397589],
      [30.0164, -27.3975001],
      [30.01768, -27.3970101],
      [30.0187517, -27.3966137],
      [30.02106, -27.3957601],
      [30.02288, -27.3950801],
      [30.02418, -27.3946101],
      [30.0244699, -27.3945001],
      [30.0251706, -27.3936097],
      [30.02591, -27.3926701],
      [30.0267466, -27.3915988],
      [30.02755, -27.3905701],
      [30.02922, -27.3884401],
      [30.0305999, -27.3867001],
      [30.0306955, -27.3867283],
      [30.03087, -27.3867801],
      [30.0325231, -27.3872524],
      [30.03346, -27.3875201],
      [30.0345597, -27.3878326],
      [30.03638, -27.3883501],
      [30.0395799, -27.3892601],
      [30.04068, -27.3887201],
      [30.0409467, -27.3886273],
      [30.0416, -27.3884001],
      [30.0427181, -27.3880174],
      [30.04385, -27.3876301],
      [30.0463599, -27.3867701],
      [30.04666, -27.3864101],
      [30.04702, -27.3859701],
      [30.04838, -27.3842701],
      [30.0497351, -27.3828573],
      [30.04979, -27.3828001],
      [30.0498862, -27.3826465],
      [30.05026, -27.3820501],
      [30.05223, -27.3796601],
      [30.0534, -27.3787101],
      [30.05568, -27.3768501],
      [30.0558283, -27.3767307],
      [30.05676, -27.3759801],
      [30.05798, -27.3749901],
      [30.05879, -27.3743301],
      [30.05912, -27.3740501],
      [30.05978, -27.3734601],
      [30.060715, -27.37263],
      [30.06165, -27.3718001],
      [30.0625985, -27.3709484],
      [30.06351, -27.3701301],
      [30.06606, -27.3678601],
      [30.0682899, -27.3658701],
      [30.068346, -27.365892],
      [30.069836, -27.3664854],
      [30.07045, -27.3667301],
      [30.0712571, -27.367054],
      [30.07324, -27.3678501],
      [30.07602, -27.3689601],
      [30.0769671, -27.3693349],
      [30.07741, -27.3695101],
      [30.07834, -27.3698801],
      [30.0790299, -27.3701601],
      [30.0803776, -27.3698665],
      [30.08128, -27.3696701],
      [30.08357, -27.3691801],
      [30.084864, -27.3689093],
      [30.0868199, -27.3685001],
      [30.0898, -27.3707101],
      [30.09436, -27.3740901],
      [30.0945814, -27.3742531],
      [30.09569, -27.3750701],
      [30.09767, -27.3765101],
      [30.09965, -27.3779601],
      [30.1013494, -27.3791897],
      [30.10164, -27.3794001],
      [30.10362, -27.3808401],
      [30.1056, -27.3822901],
      [30.1076, -27.3837001],
      [30.10961, -27.3851101],
      [30.11161, -27.3865301],
      [30.11312, -27.3878201],
      [30.11464, -27.3891101],
      [30.11615, -27.3904001],
      [30.11855, -27.3924401],
      [30.12335, -27.3965401],
      [30.12576, -27.3985701],
      [30.12818, -27.4006001],
      [30.12836, -27.4007601],
      [30.13087, -27.4028601],
      [30.14091, -27.4113001],
      [30.143415, -27.413394],
      [30.1435963, -27.4132479],
      [30.14378, -27.4131001],
      [30.14414, -27.4128001],
      [30.1452, -27.4119401],
      [30.14604, -27.4112601],
      [30.14645, -27.4109201],
      [30.14698, -27.4105001],
      [30.1475, -27.4100701],
      [30.14788, -27.4097601],
      [30.14844, -27.4093001],
      [30.14864, -27.4091301],
      [30.14875, -27.4090001],
      [30.14926, -27.4083901],
      [30.15037, -27.4070801],
      [30.15133, -27.4059401],
      [30.15206, -27.4050701],
      [30.15264, -27.4043801],
      [30.1527199, -27.4042801],
      [30.1529, -27.4033401],
      [30.1529521, -27.4030506],
      [30.15299, -27.4028401],
      [30.1531067, -27.4022407],
      [30.15321, -27.4017101],
      [30.1533405, -27.4010093],
      [30.15348, -27.4002601],
      [30.1535967, -27.3996503],
      [30.15379, -27.3986401],
      [30.15406, -27.3972201],
      [30.1540999, -27.3969701],
      [30.15311, -27.3957501],
      [30.15181, -27.3941701],
      [30.1507047, -27.3928221],
      [30.15058, -27.3926701],
      [30.1502399, -27.3922501],
      [30.15145, -27.3916701],
      [30.15223, -27.3912901],
      [30.15353, -27.3906601],
      [30.1542234, -27.3903256],
      [30.15494, -27.3899801],
      [30.1557609, -27.3895746],
      [30.15656, -27.3891801],
      [30.1574225, -27.3887602],
      [30.15769, -27.3886301],
      [30.1579573, -27.3884953],
      [30.15884, -27.3880501],
      [30.1598789, -27.3875454],
      [30.16024, -27.3873701],
      [30.1603635, -27.3873122],
      [30.1607099, -27.3871501],
      [30.16091, -27.3871601],
      [30.161857, -27.387224],
      [30.16298, -27.3873001],
      [30.16522, -27.3874501],
      [30.16564, -27.3874801],
      [30.1657488, -27.3874909],
      [30.1658399, -27.3875001],
      [30.1669, -27.3867001],
      [30.16825, -27.3857001],
      [30.17016, -27.3842801],
      [30.17143, -27.3833301],
      [30.1726541, -27.3824141],
      [30.17286, -27.3822601],
      [30.17413, -27.3813201],
      [30.17549, -27.3803101],
      [30.1757025, -27.3801461],
      [30.17689, -27.3792301],
      [30.1779734, -27.378396],
      [30.17815, -27.3782601],
      [30.17956, -27.3771601],
      [30.18084, -27.3761701],
      [30.1818949, -27.3753504],
      [30.18214, -27.3751601],
      [30.18233, -27.3750124],
      [30.18317, -27.3743601],
      [30.18472, -27.3731601],
      [30.18624, -27.3719801],
      [30.18756, -27.3709501],
      [30.18898, -27.3698501],
      [30.1900699, -27.3688701],
      [30.1902, -27.3686401],
      [30.19081, -27.3676001],
      [30.19164, -27.3661901],
      [30.19239, -27.3649001],
      [30.19324, -27.3634601],
      [30.19416, -27.3618801],
      [30.19497, -27.3605001],
      [30.19655, -27.3577901],
      [30.1980799, -27.3551801],
      [30.1981243, -27.3551863],
      [30.198158, -27.355191],
      [30.1982726, -27.3552074],
      [30.19843, -27.3552301],
      [30.1988751, -27.3553805],
      [30.19911, -27.3554601],
      [30.1995524, -27.3556062],
      [30.20029, -27.3558501],
      [30.2016258, -27.3562931],
      [30.20237, -27.3565401],
      [30.20474, -27.3573301],
      [30.2052791, -27.3575121],
      [30.20625, -27.3578401],
      [30.2070618, -27.3581041],
      [30.20751, -27.3582501],
      [30.20883, -27.3587001],
      [30.21022, -27.3591601],
      [30.210639, -27.3592986],
      [30.21152, -27.3595901],
      [30.212246, -27.3598342],
      [30.21259, -27.3599501],
      [30.2130566, -27.3601033],
      [30.21402, -27.3604201],
      [30.21511, -27.3607901],
      [30.2166787, -27.3613086],
      [30.21753, -27.3615901],
      [30.2178507, -27.3616992],
      [30.21847, -27.3619101],
      [30.21984, -27.3623601],
      [30.2207276, -27.3626559],
      [30.22119, -27.3628101],
      [30.22247, -27.3632401],
      [30.2227486, -27.3633318],
      [30.22332, -27.3635201],
      [30.2241596, -27.3638021],
      [30.22457, -27.3639401],
      [30.2256189, -27.3642896],
      [30.22673, -27.3646601],
      [30.2268322, -27.3647009],
      [30.22693, -27.3647401],
      [30.2269992, -27.3647631],
      [30.22714, -27.3648101],
      [30.22735, -27.36489],
      [30.2274858, -27.3649376],
      [30.22755, -27.36496],
      [30.2276192, -27.3649831],
      [30.22776, -27.36503],
      [30.2283553, -27.3652465],
      [30.2286399, -27.3653501],
      [30.2289, -27.36596],
      [30.22936, -27.36716],
      [30.22983, -27.36835],
      [30.23044, -27.3699],
      [30.23104, -27.37145],
      [30.23165, -27.373],
      [30.23225, -27.37455],
      [30.23286, -27.3761],
      [30.2332672, -27.3771519],
      [30.23346, -27.37765],
      [30.2336564, -27.378149],
      [30.23407, -27.3792],
      [30.2346699, -27.3807401],
      [30.2355309, -27.380265],
      [30.23583, -27.3801],
      [30.23815, -27.3788],
      [30.2384353, -27.3786412],
      [30.2393, -27.37816],
      [30.24052, -27.37745],
      [30.24174, -27.37673],
      [30.2426847, -27.3761679],
      [30.24295, -27.3760101],
      [30.2432233, -27.3758487],
      [30.24417, -27.3752901],
      [30.24538, -27.3745701],
      [30.2465899, -27.3738601],
      [30.2467854, -27.3738173],
      [30.24691, -27.3737901],
      [30.24765, -27.3736201],
      [30.2479428, -27.3735568],
      [30.24839, -27.3734601],
      [30.24913, -27.3732901],
      [30.24987, -27.37311],
      [30.25058, -27.37293],
      [30.2510242, -27.3728111],
      [30.25129, -27.37274],
      [30.25199, -27.37255],
      [30.2527, -27.37237],
      [30.252974, -27.3722967],
      [30.25341, -27.37218],
      [30.25411, -27.37199],
      [30.25482, -27.37181],
      [30.25733, -27.37148],
      [30.2587674, -27.3712968],
      [30.25984, -27.37116],
      [30.2608965, -27.3710258],
      [30.26236, -27.37084],
      [30.2685375, -27.3700524],
      [30.27491, -27.36924],
      [30.2761926, -27.3690714],
      [30.27742, -27.36891],
      [30.279807, -27.368606],
      [30.2799299, -27.3685901],
      [30.2799772, -27.3669483],
      [30.28002, -27.36546],
      [30.28011, -27.36232],
      [30.28022, -27.35832],
      [30.28034, -27.35432],
      [30.28045, -27.35032],
      [30.28011, -27.34687],
      [30.27978, -27.34343],
      [30.27944, -27.33998],
      [30.27911, -27.33654],
      [30.2787299, -27.3326301],
      [30.2801799, -27.3291101],
      [30.2816299, -27.3282101],
      [30.28171, -27.32684],
      [30.28189, -27.3241001],
      [30.28197, -27.3227301],
      [30.28206, -27.3213501],
      [30.28214, -27.3199801],
      [30.28223, -27.3186101],
      [30.28231, -27.3172401],
      [30.2824, -27.3158701],
      [30.28248, -27.3145001],
      [30.2824899, -27.3144401],
      [30.28422, -27.3146901],
      [30.2848379, -27.314782],
      [30.28563, -27.3149001],
      [30.2866748, -27.3150629],
      [30.28749, -27.3151901],
      [30.28895, -27.3154101],
      [30.29102, -27.3157101],
      [30.2917795, -27.3158248],
      [30.29274, -27.3159701],
      [30.29448, -27.3162301],
      [30.2950247, -27.3163169],
      [30.29542, -27.31638],
      [30.2957576, -27.3164302],
      [30.29616, -27.31649],
      [30.2971713, -27.3166414],
      [30.29803, -27.31677],
      [30.29968, -27.31702],
      [30.30106, -27.31722],
      [30.30222, -27.317395],
      [30.30309, -27.31652],
      [30.30399, -27.31561],
      [30.30512, -27.3144701],
      [30.30699, -27.3126],
      [30.30865, -27.3109201],
      [30.30961, -27.3099601],
      [30.31105, -27.3085001],
      [30.31222, -27.3073301],
      [30.31338, -27.3061501],
      [30.3143, -27.3052301],
      [30.31575, -27.3037701],
      [30.31689, -27.3026201],
      [30.3175299, -27.3019801],
      [30.318085, -27.3018551],
      [30.3185121, -27.3017639],
      [30.31914, -27.3016301],
      [30.32019, -27.3014201],
      [30.32277, -27.3008801],
      [30.32363, -27.3006901],
      [30.3241462, -27.3005746],
      [30.32448, -27.3005001],
      [30.3248213, -27.3004246],
      [30.32534, -27.3003101],
      [30.32619, -27.3001201],
      [30.328375, -27.2996401],
      [30.32945, -27.2999901],
      [30.3298178, -27.3001092],
      [30.33053, -27.3003401],
      [30.3319032, -27.3007892],
      [30.33267, -27.3010401],
      [30.3330574, -27.3011655],
      [30.33375, -27.3013901],
      [30.33482, -27.3017501],
      [30.33696, -27.3024501],
      [30.339, -27.3031101],
      [30.3396884, -27.3033395],
      [30.34002, -27.3034501],
      [30.3401907, -27.3035022],
      [30.34051, -27.3036001],
      [30.3408291, -27.3036977],
      [30.3426, -27.3042401],
      [30.347595, -27.3057856],
      [30.3532, -27.3075201],
      [30.35585, -27.3083301],
      [30.36645, -27.3116101],
      [30.3667099, -27.3116901],
      [30.3667177, -27.3115821],
      [30.36688, -27.3093001],
      [30.36704, -27.3069201],
      [30.3672, -27.3045301],
      [30.36737, -27.3021401],
      [30.36753, -27.2997601],
      [30.36769, -27.2973701],
      [30.36786, -27.2949801],
      [30.36802, -27.2926001],
      [30.36818, -27.2902101],
      [30.36835, -27.2878201],
      [30.36836, -27.2876201],
      [30.36838, -27.2872801],
      [30.3683599, -27.2866101],
      [30.36833, -27.2854201],
      [30.36828, -27.2834701],
      [30.36825, -27.2822001],
      [30.3682, -27.2804701],
      [30.36816, -27.2789201],
      [30.36812, -27.2771601],
      [30.36809, -27.2762601],
      [30.36804, -27.2739401],
      [30.36799, -27.2722601],
      [30.36795, -27.2704401],
      [30.36793, -27.2697801],
      [30.36779, -27.2687601],
      [30.3676099, -27.2674301],
      [30.36948, -27.2678201],
      [30.3697659, -27.2678804],
      [30.37019, -27.2679701],
      [30.37124, -27.2682001],
      [30.3728056, -27.2685312],
      [30.37384, -27.2687501],
      [30.3745475, -27.2688987],
      [30.3756, -27.2691201],
      [30.3765749, -27.2693246],
      [30.37722, -27.2694601],
      [30.3785659, -27.269747],
      [30.38069, -27.2702001],
      [30.3826, -27.2706001],
      [30.3835655, -27.2708029],
      [30.38417, -27.2709301],
      [30.38593, -27.2713001],
      [30.38768, -27.2716801],
      [30.39124, -27.2724301],
      [30.39473, -27.2731701],
      [30.39753, -27.2737601],
      [30.3976199, -27.2737801],
      [30.3978, -27.2737501],
      [30.39852, -27.2736601],
      [30.3988313, -27.2736173],
      [30.40209, -27.2731701],
      [30.4029075, -27.2730553],
      [30.40373, -27.2729401],
      [30.40543, -27.2727101],
      [30.40895, -27.2722301],
      [30.4096835, -27.2721298],
      [30.41078, -27.2719801],
      [30.41261, -27.2717201],
      [30.4132494, -27.2716351],
      [30.41374, -27.2715701],
      [30.41597, -27.2712601],
      [30.4167714, -27.2711505],
      [30.4178, -27.2710101],
      [30.4188165, -27.2708738],
      [30.41959, -27.2707701],
      [30.4202333, -27.2706813],
      [30.42104, -27.2705701],
      [30.42305, -27.2702901],
      [30.4250221, -27.2700232],
      [30.4264499, -27.2698301],
      [30.42644, -27.2704601],
      [30.42642, -27.2719701],
      [30.42639, -27.2745001],
      [30.42637, -27.2766701],
      [30.42635, -27.2780301],
      [30.42635, -27.2783201],
      [30.42633, -27.2792401],
      [30.42632, -27.2806901],
      [30.42629, -27.2829701],
      [30.42627, -27.2845701],
      [30.42625, -27.2861201],
      [30.42626, -27.2869901],
      [30.42627, -27.2888001],
      [30.42629, -27.2906901],
      [30.4262997, -27.2918041],
      [30.42631, -27.2929801],
      [30.4263149, -27.2935351],
      [30.42632, -27.2941101],
      [30.42628, -27.2963301],
      [30.42626, -27.2978401],
      [30.42624, -27.2987601],
      [30.42621, -27.3008201],
      [30.42618, -27.3023201],
      [30.42615, -27.3044801],
      [30.42612, -27.3062301],
      [30.42609, -27.3082401],
      [30.42607, -27.3091401],
      [30.42606, -27.3100201],
      [30.42603, -27.3115201],
      [30.42601, -27.3130301],
      [30.42599, -27.3142001],
      [30.42598, -27.3145701],
      [30.4259799, -27.3149601],
      [30.42619, -27.3152701],
      [30.42671, -27.3160101],
      [30.42757, -27.3172401],
      [30.42804, -27.3179101],
      [30.42851, -27.3185901],
      [30.42904, -27.3193401],
      [30.42957, -27.3201001],
      [30.43043, -27.3213401],
      [30.43189, -27.3234201],
      [30.43265, -27.3245101],
      [30.43341, -27.3256101],
      [30.4334599, -27.3256801],
      [30.4334895, -27.3256859],
      [30.43351, -27.3256901],
      [30.4341128, -27.3257625],
      [30.43484, -27.3258501],
      [30.435461, -27.3259084],
      [30.43601, -27.3259601],
      [30.43718, -27.3260601],
      [30.43863, -27.3261901],
      [30.44014, -27.3263201],
      [30.44158, -27.3264401],
      [30.4419201, -27.3264717],
      [30.44233, -27.3265101],
      [30.44333, -27.3266001],
      [30.4438681, -27.326643],
      [30.44433, -27.3266801],
      [30.4451067, -27.3267484],
      [30.44592, -27.3268201],
      [30.44711, -27.3269201],
      [30.4478044, -27.3269811],
      [30.4483599, -27.3270301],
      [30.44827, -27.3277399],
      [30.4483105, -27.3276884],
      [30.4486399, -27.3272701],
      [30.4486799, -27.3272101],
      [30.4487099, -27.3271801],
      [30.4487399, -27.3271301],
      [30.4487899, -27.3270801],
      [30.4488299, -27.3270301],
      [30.4488499, -27.3270001],
      [30.4488799, -27.3269601],
      [30.4490199, -27.3268201],
      [30.4490399, -27.3267901],
      [30.4490899, -27.3267401],
      [30.44913, -27.326715],
      [30.4491699, -27.3266901],
      [30.4493499, -27.3265101],
      [30.4493699, -27.3264801],
      [30.4493999, -27.3264601],
      [30.4494799, -27.3263801],
      [30.4495399, -27.3263301],
      [30.4495447, -27.3263269],
      [30.4495699, -27.3263101],
      [30.4495999, -27.3262801],
      [30.4496866, -27.3262107],
      [30.4496999, -27.3262001],
      [30.4497799, -27.3261501],
      [30.4498599, -27.3260901],
      [30.4499422, -27.3260325],
      [30.4499599, -27.3260201],
      [30.4499734, -27.3260099],
      [30.4500399, -27.3259601],
      [30.4500836, -27.3259382],
      [30.4500999, -27.3259301],
      [30.4502499, -27.3258201],
      [30.4504299, -27.3257301],
      [30.4505245, -27.3256864],
      [30.4505599, -27.3256701],
      [30.4506999, -27.3256201],
      [30.4507312, -27.3256044],
      [30.4508199, -27.3255601],
      [30.4510599, -27.3254801],
      [30.451254, -27.3254458],
      [30.4513999, -27.3254201],
      [30.4514916, -27.3253918],
      [30.4516599, -27.3253401],
      [30.4517442, -27.3253206],
      [30.4517899, -27.3253101],
      [30.4518448, -27.3253022],
      [30.4519299, -27.3252901],
      [30.4521136, -27.3252614],
      [30.4521806, -27.3252508],
      [30.4522499, -27.3252401],
      [30.4524699, -27.3251901],
      [30.4525402, -27.3251744],
      [30.4526499, -27.3251501],
      [30.4528661, -27.325114],
      [30.4529499, -27.3251001],
      [30.4531999, -27.3250801],
      [30.4534399, -27.3250701],
      [30.453557, -27.3250669],
      [30.4536345, -27.3250649],
      [30.4538199, -27.3250601],
      [30.4539544, -27.3250652],
      [30.4540799, -27.3250701],
      [30.4543145, -27.3250787],
      [30.4543499, -27.3250801],
      [30.4548099, -27.3251001],
      [30.4550501, -27.325124],
      [30.4551099, -27.3251301],
      [30.4554299, -27.3251601],
      [30.4556055, -27.3251893],
      [30.4558499, -27.3252301],
      [30.4560899, -27.3252801],
      [30.4562305, -27.3253268],
      [30.4562999, -27.3253501],
      [30.456372, -27.3253762],
      [30.4565199, -27.3254301],
      [30.4567239, -27.3255247],
      [30.4567999, -27.3255601],
      [30.456849, -27.3255818],
      [30.4569799, -27.3256401],
      [30.4570829, -27.3257033],
      [30.4571099, -27.3257201],
      [30.4573099, -27.3258701],
      [30.4574499, -27.3260101],
      [30.4575699, -27.3261201],
      [30.4577699, -27.3263201],
      [30.4579099, -27.3264501],
      [30.4580499, -27.3265601],
      [30.4581837, -27.3266386],
      [30.4582199, -27.3266601],
      [30.458265, -27.3266739],
      [30.4583499, -27.3267001],
      [30.4584899, -27.3267101],
      [30.4587199, -27.3267001],
      [30.4587824, -27.3266911],
      [30.4588599, -27.3266801],
      [30.4589799, -27.3266601],
      [30.4591699, -27.3266101],
      [30.4593299, -27.3265401],
      [30.4595399, -27.3264401],
      [30.4595731, -27.3264229],
      [30.4597991, -27.3263067],
      [30.4598899, -27.3262601],
      [30.4599571, -27.3262216],
      [30.4601699, -27.3261001],
      [30.4604299, -27.3259501],
      [30.4607599, -27.3257501],
      [30.4609899, -27.3256101],
      [30.4611485, -27.3255194],
      [30.4611999, -27.3254901],
      [30.4612599, -27.32546],
      [30.4613496, -27.3254152],
      [30.4614199, -27.3253801],
      [30.4618199, -27.3252501],
      [30.4620799, -27.3252101],
      [30.4623399, -27.3252101],
      [30.4624636, -27.3252281],
      [30.462512, -27.3252352],
      [30.4627499, -27.3252701],
      [30.4629261, -27.3253287],
      [30.4630199, -27.3253601],
      [30.4635599, -27.3256001],
      [30.4636087, -27.3256268],
      [30.4636987, -27.3256763],
      [30.4637599, -27.3257101],
      [30.4639125, -27.3258063],
      [30.4639499, -27.3258301],
      [30.4640313, -27.3258808],
      [30.4643499, -27.3260801],
      [30.4644604, -27.3261389],
      [30.4644999, -27.3261601],
      [30.4645989, -27.326212],
      [30.4646899, -27.3262601],
      [30.4647502, -27.3262851],
      [30.4648099, -27.3263101],
      [30.4649499, -27.3263501],
      [30.4651599, -27.3264001],
      [30.465226, -27.3264088],
      [30.4653099, -27.3264201],
      [30.4654799, -27.3264101],
      [30.465591, -27.3264011],
      [30.4657299, -27.3263901],
      [30.4658299, -27.3263701],
      [30.4658699, -27.3263601],
      [30.4659399, -27.3263501],
      [30.4660599, -27.3262801],
      [30.4661328, -27.3262072],
      [30.4661699, -27.3261701],
      [30.4662299, -27.3260701],
      [30.4662599, -27.3260101],
      [30.46627, -27.32591],
      [30.4662799, -27.3258401],
      [30.4662699, -27.3257001],
      [30.4662599, -27.3255901],
      [30.4662299, -27.3254901],
      [30.4661799, -27.3253201],
      [30.4661499, -27.3252001],
      [30.4661299, -27.3250701],
      [30.4660999, -27.3248701],
      [30.4661099, -27.3247501],
      [30.4661399, -27.3246401],
      [30.4661899, -27.3245001],
      [30.4662299, -27.3244201],
      [30.4662699, -27.3243701],
      [30.4663299, -27.3243001],
      [30.4664502, -27.3242142],
      [30.4664699, -27.3242001],
      [30.4665009, -27.3241859],
      [30.4665799, -27.3241501],
      [30.4666999, -27.3241001],
      [30.4668799, -27.3240101],
      [30.46695, -27.3239909],
      [30.4669899, -27.3239801],
      [30.4670899, -27.3239501],
      [30.4672399, -27.3239001],
      [30.4672942, -27.3238855],
      [30.4673899, -27.3238601],
      [30.4675399, -27.3238001],
      [30.467664, -27.3237543],
      [30.4677299, -27.3237301],
      [30.4678499, -27.3236701],
      [30.4678843, -27.3236542],
      [30.4679799, -27.3236101],
      [30.4681199, -27.3235201],
      [30.4682081, -27.3234686],
      [30.4682399, -27.3234501],
      [30.4682595, -27.3234378],
      [30.4683199, -27.3234001],
      [30.4685399, -27.3232001],
      [30.4687699, -27.3229601],
      [30.4688499, -27.3228801],
      [30.4689499, -27.3227901],
      [30.4691399, -27.3226601],
      [30.4692899, -27.3225601],
      [30.4694599, -27.3224501],
      [30.4696699, -27.3223501],
      [30.4699399, -27.3222501],
      [30.4700043, -27.3222379],
      [30.4700999, -27.3222201],
      [30.4702699, -27.3221801],
      [30.4704999, -27.3221401],
      [30.4705753, -27.32213],
      [30.4706499, -27.3221201],
      [30.4707799, -27.3220901],
      [30.4708216, -27.3220761],
      [30.4708999, -27.3220501],
      [30.4710099, -27.3220101],
      [30.4711036, -27.321974],
      [30.4711399, -27.3219601],
      [30.4712084, -27.3219258],
      [30.4713199, -27.3218701],
      [30.4714199, -27.3218101],
      [30.4714356, -27.3218002],
      [30.4714999, -27.3217601],
      [30.4716599, -27.3216301],
      [30.4720499, -27.3212401],
      [30.4721699, -27.3211301],
      [30.4722999, -27.3210201],
      [30.4724843, -27.3208776],
      [30.4725199, -27.3208501],
      [30.4725938, -27.3207989],
      [30.4726499, -27.3207601],
      [30.4727226, -27.3207164],
      [30.4727999, -27.3206701],
      [30.4728474, -27.3206429],
      [30.4730099, -27.3205501],
      [30.4731899, -27.3204701],
      [30.473316, -27.320421],
      [30.4733699, -27.3204001],
      [30.4734206, -27.3203792],
      [30.4735399, -27.3203301],
      [30.4737399, -27.3202501],
      [30.4738324, -27.3202073],
      [30.4738699, -27.3201901],
      [30.4739899, -27.3201301],
      [30.4740279, -27.3201081],
      [30.4741799, -27.3200201],
      [30.4743999, -27.3198801],
      [30.4745525, -27.3197961],
      [30.4745999, -27.3197701],
      [30.4746362, -27.3197507],
      [30.4747499, -27.3196901],
      [30.4748799, -27.3196201],
      [30.4750499, -27.3195301],
      [30.4751699, -27.3194801],
      [30.4752387, -27.3194671],
      [30.4753299, -27.3194501],
      [30.4756499, -27.3194001],
      [30.4757754, -27.3193829],
      [30.4758699, -27.3193701],
      [30.4760599, -27.3193501],
      [30.4761677, -27.3193328],
      [30.4763099, -27.3193101],
      [30.4764399, -27.3193001],
      [30.4765999, -27.3192801],
      [30.4768899, -27.3192201],
      [30.4771199, -27.3191801],
      [30.4772421, -27.3191634],
      [30.4773399, -27.3191501],
      [30.477507, -27.3191405],
      [30.4776899, -27.3191301],
      [30.4778999, -27.3191301],
      [30.4780799, -27.3191401],
      [30.4781493, -27.3191446],
      [30.4782299, -27.3191501],
      [30.4783618, -27.3191399],
      [30.4784899, -27.3191301],
      [30.4785699, -27.3191301],
      [30.4787699, -27.3190801],
      [30.4788309, -27.3190699],
      [30.4788899, -27.3190601],
      [30.4789537, -27.3190453],
      [30.4790199, -27.3190301],
      [30.479113, -27.3190027],
      [30.4791899, -27.3189801],
      [30.4793199, -27.3189301],
      [30.4793512, -27.3189158],
      [30.4794299, -27.3188801],
      [30.4795373, -27.3188187],
      [30.4795699, -27.3188001],
      [30.479614, -27.3187687],
      [30.4797152, -27.3186963],
      [30.4798499, -27.3186001],
      [30.4799699, -27.3185101],
      [30.4801199, -27.3184101],
      [30.4802265, -27.3183491],
      [30.4802599, -27.3183301],
      [30.480293, -27.3183168],
      [30.4803599, -27.3182901],
      [30.4805899, -27.3180701],
      [30.4806999, -27.3179901],
      [30.4808458, -27.3178928],
      [30.4808799, -27.3178701],
      [30.4809249, -27.317845],
      [30.4810599, -27.3177701],
      [30.4811817, -27.3177127],
      [30.4812299, -27.3176901],
      [30.4812632, -27.3176734],
      [30.4813499, -27.3176301],
      [30.4814499, -27.3175701],
      [30.4816999, -27.3174101],
      [30.4818799, -27.3172801],
      [30.4819655, -27.317226],
      [30.4820699, -27.3171601],
      [30.4821271, -27.3171267],
      [30.4823099, -27.3170201],
      [30.4824999, -27.3169301],
      [30.4825847, -27.3169039],
      [30.4826299, -27.3168901],
      [30.4827499, -27.3168501],
      [30.4829799, -27.3168101],
      [30.4831399, -27.3168001],
      [30.4832999, -27.3168001],
      [30.4835199, -27.3168101],
      [30.4837799, -27.3168501],
      [30.4839022, -27.3168675],
      [30.4839899, -27.3168801],
      [30.4840619, -27.3168885],
      [30.4841599, -27.3169001],
      [30.4842447, -27.3169053],
      [30.4843199, -27.3169101],
      [30.4845799, -27.3169101],
      [30.4846911, -27.3168989],
      [30.4847799, -27.3168901],
      [30.484848, -27.3168711],
      [30.4849599, -27.3168401],
      [30.4852599, -27.3167401],
      [30.4853873, -27.3166931],
      [30.4854499, -27.3166701],
      [30.4855123, -27.316648],
      [30.4856199, -27.3166101],
      [30.4857208, -27.3165863],
      [30.4857899, -27.3165701],
      [30.4858436, -27.3165618],
      [30.4859199, -27.3165501],
      [30.4860999, -27.3165201],
      [30.4861999, -27.3164801],
      [30.4864199, -27.3164001],
      [30.4866499, -27.3163001],
      [30.486747, -27.3162478],
      [30.4867799, -27.3162301],
      [30.4869299, -27.3161401],
      [30.4869701, -27.3161168],
      [30.4871199, -27.3160301],
      [30.4875399, -27.3157701],
      [30.4877888, -27.3156309],
      [30.4878799, -27.3155801],
      [30.487982, -27.3155305],
      [30.4882299, -27.3154101],
      [30.4887199, -27.3151901],
      [30.4889799, -27.3150801],
      [30.4891661, -27.3149941],
      [30.4892399, -27.3149601],
      [30.4896699, -27.3147701],
      [30.4898764, -27.3146901],
      [30.4902899, -27.3145301],
      [30.4906025, -27.3144281],
      [30.4907799, -27.3143701],
      [30.4908969, -27.3143335],
      [30.4910999, -27.3142701],
      [30.4913899, -27.3141801],
      [30.4920599, -27.3139901],
      [30.4922138, -27.3139451],
      [30.4922999, -27.3139201],
      [30.4923753, -27.3138985],
      [30.4925099, -27.3138601],
      [30.4928499, -27.3137701],
      [30.4929877, -27.3137325],
      [30.4930699, -27.3137101],
      [30.4931557, -27.3136929],
      [30.4932699, -27.3136701],
      [30.4934799, -27.3136401],
      [30.4935999, -27.3136301],
      [30.4936575, -27.3136185],
      [30.4936999, -27.3136101],
      [30.4938499, -27.3135901],
      [30.493912, -27.3135784],
      [30.4940099, -27.3135601],
      [30.4942199, -27.3135201],
      [30.4943199, -27.3135101],
      [30.4944174, -27.3134929],
      [30.4944899, -27.3134801],
      [30.4946699, -27.3134401],
      [30.4948099, -27.3133901],
      [30.4948555, -27.3133725],
      [30.4949399, -27.3133401],
      [30.4950599, -27.3132801],
      [30.4952399, -27.3131601],
      [30.4953999, -27.3130301],
      [30.4956999, -27.3127901],
      [30.4958199, -27.3127101],
      [30.4959499, -27.3126501],
      [30.4961699, -27.3125601],
      [30.4962489, -27.3125354],
      [30.4963299, -27.3125101],
      [30.4963956, -27.3125013],
      [30.4964799, -27.3124901],
      [30.4965961, -27.3124726],
      [30.4966799, -27.3124601],
      [30.4967353, -27.3124515],
      [30.4968099, -27.3124401],
      [30.4968737, -27.3124347],
      [30.4969299, -27.3124301],
      [30.4970232, -27.3124207],
      [30.4971299, -27.3124101],
      [30.4972699, -27.3124101],
      [30.4974199, -27.3124001],
      [30.4976999, -27.3124001],
      [30.497804, -27.312409],
      [30.4979299, -27.3124201],
      [30.498061, -27.3124309],
      [30.4981699, -27.3124401],
      [30.4983214, -27.3124573],
      [30.4985199, -27.3124801],
      [30.4987599, -27.3125101],
      [30.4989799, -27.3125501],
      [30.499152, -27.3125666],
      [30.4992899, -27.3125801],
      [30.4993931, -27.3125935],
      [30.4995199, -27.3126101],
      [30.4997699, -27.3126401],
      [30.4999108, -27.3126502],
      [30.5000499, -27.3126601],
      [30.5005199, -27.3126701],
      [30.5006676, -27.3126748],
      [30.5008299, -27.3126801],
      [30.5009861, -27.3127023],
      [30.5011099, -27.3127201],
      [30.5014599, -27.3128101],
      [30.5015164, -27.3128308],
      [30.5016499, -27.3128801],
      [30.5018065, -27.3129545],
      [30.5018599, -27.3129801],
      [30.5022199, -27.3131201],
      [30.5024499, -27.3131901],
      [30.5030999, -27.3133701],
      [30.5033299, -27.3134301],
      [30.5034083, -27.3134486],
      [30.5035399, -27.3134801],
      [30.5036843, -27.3135089],
      [30.5037899, -27.3135301],
      [30.5038738, -27.3135412],
      [30.5039399, -27.3135501],
      [30.5039957, -27.3135586],
      [30.5040699, -27.3135701],
      [30.5041894, -27.3135752],
      [30.5042999, -27.3135801],
      [30.5043846, -27.3135747],
      [30.5044599, -27.3135701],
      [30.504541, -27.313561],
      [30.5046399, -27.3135501],
      [30.5048075, -27.3135211],
      [30.5049299, -27.3135001],
      [30.5050128, -27.3134834],
      [30.5051299, -27.3134601],
      [30.5052347, -27.3134548],
      [30.5053299, -27.3134501],
      [30.5055026, -27.3134438],
      [30.5056099, -27.3134401],
      [30.5056994, -27.3134512],
      [30.5057699, -27.3134601],
      [30.5059399, -27.3135101],
      [30.5059974, -27.3135291],
      [30.5061199, -27.3135701],
      [30.5063999, -27.3136601],
      [30.5065799, -27.3137101],
      [30.5067799, -27.3137501],
      [30.5071199, -27.3137901],
      [30.5072101, -27.31379],
      [30.5073499, -27.3137901],
      [30.5076099, -27.3137601],
      [30.5077683, -27.3137267],
      [30.5079899, -27.3136801],
      [30.5081563, -27.3136352],
      [30.5082499, -27.3136101],
      [30.5085299, -27.3135301],
      [30.5086949, -27.313485],
      [30.5089699, -27.3134101],
      [30.5092599, -27.3133401],
      [30.5095399, -27.3132801],
      [30.5097891, -27.3132461],
      [30.5099799, -27.3132201],
      [30.5101093, -27.3132108],
      [30.5102599, -27.3132001],
      [30.5105299, -27.3132101],
      [30.5106825, -27.3132347],
      [30.5108999, -27.3132701],
      [30.511059, -27.3133164],
      [30.5111399, -27.3133401],
      [30.5113599, -27.3134101],
      [30.5116599, -27.3135201],
      [30.5117125, -27.3135364],
      [30.5118199, -27.3135701],
      [30.5119203, -27.3135877],
      [30.5119899, -27.3136001],
      [30.5122899, -27.3136401],
      [30.5125199, -27.3136801],
      [30.5126977, -27.3137123],
      [30.5129599, -27.3137601],
      [30.5131342, -27.313789],
      [30.5132599, -27.3138101],
      [30.5134499, -27.3138301],
      [30.5136399, -27.3138401],
      [30.5139099, -27.3138601],
      [30.5140999, -27.3138601],
      [30.5142899, -27.3138701],
      [30.5144132, -27.3138791],
      [30.5145599, -27.3138901],
      [30.5146999, -27.3139201],
      [30.5147967, -27.3139458],
      [30.5148499, -27.3139601],
      [30.5150599, -27.3140301],
      [30.5151123, -27.3140421],
      [30.5151899, -27.3140601],
      [30.5152636, -27.3140653],
      [30.5153299, -27.3140701],
      [30.5155099, -27.3140901],
      [30.5160099, -27.3140901],
      [30.5160854, -27.3140846],
      [30.5161499, -27.3140801],
      [30.5162637, -27.3140632],
      [30.5164199, -27.3140401],
      [30.5165399, -27.3140201],
      [30.5166699, -27.3140001],
      [30.5168199, -27.3139901],
      [30.5169899, -27.3139901],
      [30.5170526, -27.3139989],
      [30.5171299, -27.3140101],
      [30.5172579, -27.3140668],
      [30.5173099, -27.3140901],
      [30.5173808, -27.3141254],
      [30.5175899, -27.3142301],
      [30.517714, -27.3142883],
      [30.5177599, -27.3143101],
      [30.5178899, -27.3143601],
      [30.5180299, -27.3143901],
      [30.5182299, -27.3144301],
      [30.5183499, -27.3144501],
      [30.5183997, -27.3144545],
      [30.5184599, -27.3144601],
      [30.5186399, -27.3144701],
      [30.5187499, -27.3144801],
      [30.5190899, -27.3144801],
      [30.5192199, -27.3144701],
      [30.5193699, -27.3144601],
      [30.5195699, -27.3144601],
      [30.5198299, -27.3144401],
      [30.5200499, -27.3144501],
      [30.5202399, -27.3144701],
      [30.5204199, -27.3144901],
      [30.5205699, -27.3145201],
      [30.5207599, -27.3145801],
      [30.5208049, -27.314596],
      [30.5208999, -27.3146301],
      [30.5209959, -27.3146711],
      [30.5210399, -27.3146901],
      [30.5212799, -27.3147901],
      [30.5214399, -27.3148601],
      [30.5215799, -27.3149201],
      [30.5216395, -27.3149438],
      [30.5217799, -27.3150001],
      [30.521879, -27.315033],
      [30.5219299, -27.3150501],
      [30.5221341, -27.3150908],
      [30.5223299, -27.3151301],
      [30.522432, -27.3151354],
      [30.5225199, -27.3151401],
      [30.5226033, -27.3151483],
      [30.5227199, -27.3151601],
      [30.5231871, -27.31516],
      [30.5233799, -27.3151601],
      [30.5234922, -27.3151502],
      [30.5236099, -27.3151401],
      [30.5236858, -27.3151292],
      [30.5237499, -27.3151201],
      [30.5238199, -27.3151153],
      [30.5238999, -27.3151101],
      [30.5241399, -27.3150801],
      [30.5243099, -27.3150601],
      [30.5244999, -27.3150501],
      [30.5246345, -27.3150448],
      [30.5247599, -27.3150401],
      [30.5249299, -27.3150401],
      [30.5250243, -27.3150452],
      [30.5251099, -27.3150501],
      [30.5252699, -27.3150701],
      [30.5256799, -27.3151401],
      [30.5257147, -27.3151516],
      [30.5257999, -27.3151801],
      [30.5259799, -27.3152501],
      [30.5260626, -27.3152951],
      [30.5260899, -27.3153101],
      [30.5261167, -27.3153234],
      [30.5261899, -27.3153601],
      [30.5263299, -27.3154401],
      [30.5264074, -27.3154752],
      [30.5264399, -27.3154901],
      [30.5265599, -27.3155501],
      [30.5267499, -27.3156301],
      [30.5268899, -27.3156901],
      [30.5270499, -27.3157501],
      [30.5271306, -27.315778],
      [30.5272799, -27.3158301],
      [30.5274299, -27.3158801],
      [30.5275348, -27.3159219],
      [30.5275799, -27.3159401],
      [30.5276464, -27.3159653],
      [30.5277899, -27.3160201],
      [30.5278828, -27.3160531],
      [30.5279299, -27.3160701],
      [30.528018, -27.3161063],
      [30.5280999, -27.3161401],
      [30.5282303, -27.3161931],
      [30.5283699, -27.3162501],
      [30.5284324, -27.316273],
      [30.5285599, -27.3163201],
      [30.5286906, -27.316375],
      [30.5287499, -27.3164001],
      [30.5289599, -27.3164801],
      [30.5290641, -27.3165169],
      [30.5292699, -27.3165901],
      [30.5294005, -27.3166381],
      [30.5294599, -27.3166601],
      [30.5296499, -27.3167401],
      [30.5299599, -27.3168701],
      [30.5301499, -27.3169501],
      [30.5302054, -27.3169746],
      [30.5303299, -27.3170301],
      [30.5305136, -27.3171181],
      [30.5305799, -27.3171501],
      [30.5307399, -27.3172201],
      [30.5309199, -27.3173201],
      [30.5309759, -27.3173549],
      [30.5311599, -27.3174701],
      [30.5313099, -27.3175601],
      [30.5314399, -27.3176501],
      [30.5316499, -27.3177801],
      [30.5317899, -27.3178901],
      [30.5319499, -27.3180001],
      [30.5321899, -27.3181701],
      [30.5325299, -27.3183901],
      [30.5327599, -27.3185201],
      [30.5328406, -27.3185648],
      [30.5331199, -27.3187201],
      [30.5334099, -27.3188901],
      [30.5335598, -27.3189799],
      [30.5336099, -27.3190101],
      [30.5338199, -27.3191401],
      [30.5340499, -27.3192701],
      [30.5341303, -27.3193149],
      [30.5343899, -27.3194601],
      [30.5346099, -27.3195501],
      [30.5347568, -27.3195947],
      [30.5348399, -27.3196201],
      [30.5349782, -27.3196611],
      [30.5352099, -27.3197301],
      [30.5354599, -27.3197901],
      [30.5356351, -27.3198262],
      [30.5357499, -27.3198501],
      [30.5359283, -27.3198896],
      [30.5361999, -27.3199501],
      [30.5363713, -27.3199928],
      [30.5364799, -27.3200201],
      [30.5367199, -27.3201001],
      [30.5370699, -27.3202701],
      [30.5371218, -27.3202996],
      [30.5372799, -27.3203901],
      [30.537456, -27.320494],
      [30.5374999, -27.3205201],
      [30.5377574, -27.3206439],
      [30.5380399, -27.3207801],
      [30.5382299, -27.3208601],
      [30.5385199, -27.3209601],
      [30.5387299, -27.3210201],
      [30.5389499, -27.3210801],
      [30.5392899, -27.3211701],
      [30.5394999, -27.3212201],
      [30.5396999, -27.3212701],
      [30.5399899, -27.3213501],
      [30.5401599, -27.3214001],
      [30.5402256, -27.3214207],
      [30.5403499, -27.3214601],
      [30.5404762, -27.3215065],
      [30.5405399, -27.3215301],
      [30.5406209, -27.3215624],
      [30.5407899, -27.3216301],
      [30.5408532, -27.321664],
      [30.5409199, -27.3217001],
      [30.5409602, -27.3217251],
      [30.5410799, -27.3218001],
      [30.5414299, -27.3220001],
      [30.5415399, -27.3220801],
      [30.5416699, -27.3221701],
      [30.5417399, -27.3222301],
      [30.5418099, -27.3222701],
      [30.5418319, -27.3222846],
      [30.5419299, -27.3223501],
      [30.5419986, -27.3224015],
      [30.5420099, -27.3224101],
      [30.5421099, -27.3224701],
      [30.5422899, -27.3225901],
      [30.5424299, -27.3227001],
      [30.5425051, -27.3227516],
      [30.5425899, -27.3228101],
      [30.5426271, -27.3228334],
      [30.5427799, -27.3229301],
      [30.5428999, -27.3230101],
      [30.5429999, -27.3230901],
      [30.5431599, -27.3232001],
      [30.5432599, -27.3232801],
      [30.5433699, -27.3233701],
      [30.5435499, -27.3235201],
      [30.5436699, -27.3236401],
      [30.5438099, -27.3237601],
      [30.5439499, -27.3238901],
      [30.5441399, -27.3240801],
      [30.5442699, -27.3242201],
      [30.5443899, -27.3243401],
      [30.5446099, -27.3245501],
      [30.5448799, -27.3248201],
      [30.5450099, -27.3249701],
      [30.5450899, -27.3250401],
      [30.5451599, -27.3251001],
      [30.5454099, -27.3253001],
      [30.5454999, -27.3253701],
      [30.5455464, -27.3253979],
      [30.5456999, -27.3254901],
      [30.5457929, -27.3255329],
      [30.5458299, -27.3255501],
      [30.5458576, -27.3255661],
      [30.5459499, -27.3256201],
      [30.5461399, -27.3257101],
      [30.5462171, -27.325745],
      [30.5462499, -27.3257601],
      [30.5463017, -27.3257759],
      [30.5463799, -27.3258001],
      [30.5465299, -27.3258601],
      [30.5465999, -27.3258901],
      [30.5466536, -27.3259019],
      [30.5466899, -27.3259101],
      [30.5467977, -27.3259194],
      [30.5469199, -27.3259301],
      [30.5470399, -27.3259401],
      [30.5471599, -27.3259401],
      [30.5473699, -27.3259301],
      [30.5474349, -27.3259214],
      [30.5475199, -27.3259101],
      [30.5476102, -27.3258987],
      [30.5476799, -27.3258901],
      [30.5478999, -27.3258501],
      [30.5479559, -27.325838],
      [30.5480399, -27.3258201],
      [30.5481799, -27.3257801],
      [30.5483699, -27.3257301],
      [30.5484799, -27.3256901],
      [30.548569, -27.3256558],
      [30.5486099, -27.3256401],
      [30.5486824, -27.3256137],
      [30.5488299, -27.3255601],
      [30.5491099, -27.3254801],
      [30.5492999, -27.3254401],
      [30.5493631, -27.3254285],
      [30.5494099, -27.3254201],
      [30.5495399, -27.3254101],
      [30.5496788, -27.325404],
      [30.5497699, -27.3254001],
      [30.54985, -27.3253953],
      [30.5499399, -27.3253901],
      [30.5501399, -27.3253901],
      [30.5502752, -27.3253948],
      [30.5504199, -27.3254001],
      [30.5505399, -27.3254101],
      [30.5506299, -27.3254201],
      [30.5508299, -27.3254301],
      [30.5510599, -27.3254501],
      [30.5512585, -27.325485],
      [30.5513999, -27.3255101],
      [30.5516099, -27.3255401],
      [30.5516999, -27.3255571],
      [30.5518199, -27.3255801],
      [30.5520189, -27.3256298],
      [30.5521399, -27.3256601],
      [30.5523098, -27.3257117],
      [30.5525999, -27.3258001],
      [30.5528175, -27.3258684],
      [30.5529499, -27.3259101],
      [30.5531999, -27.3259901],
      [30.5532798, -27.3260177],
      [30.5534299, -27.3260701],
      [30.5536578, -27.3261504],
      [30.5537699, -27.3261901],
      [30.5538454, -27.326214],
      [30.5539899, -27.3262601],
      [30.5541999, -27.3263401],
      [30.5544328, -27.32642],
      [30.5545199, -27.3264501],
      [30.5547299, -27.3265401],
      [30.5549499, -27.3266301],
      [30.5550336, -27.3266629],
      [30.5552299, -27.3267401],
      [30.555329, -27.3267846],
      [30.5554299, -27.3268301],
      [30.5555478, -27.3268761],
      [30.5556599, -27.3269201],
      [30.5558928, -27.3270291],
      [30.5559799, -27.3270701],
      [30.5561799, -27.3271601],
      [30.5563499, -27.3272401],
      [30.5565799, -27.3273501],
      [30.5567199, -27.3274101],
      [30.5568799, -27.3274601],
      [30.5569534, -27.3274793],
      [30.557074, -27.327511],
      [30.5573599, -27.3275701],
      [30.5574288, -27.3275815],
      [30.5574799, -27.3275901],
      [30.5575699, -27.3276001],
      [30.5576352, -27.3276087],
      [30.5577199, -27.3276201],
      [30.5578406, -27.32762],
      [30.5580699, -27.3276201],
      [30.5581608, -27.327607],
      [30.5582799, -27.3275901],
      [30.5584032, -27.3275592],
      [30.5584799, -27.3275401],
      [30.5586036, -27.3275063],
      [30.5588099, -27.3274501],
      [30.5590599, -27.3273801],
      [30.5597399, -27.3272001],
      [30.5599084, -27.3271563],
      [30.5600099, -27.3271301],
      [30.5601186, -27.3271059],
      [30.5602799, -27.3270701],
      [30.5606399, -27.3270101],
      [30.5610999, -27.3269701],
      [30.5613055, -27.3269595],
      [30.5614899, -27.3269501],
      [30.5617799, -27.3269501],
      [30.5620899, -27.3269601],
      [30.5623312, -27.3269712],
      [30.5625199, -27.3269801],
      [30.5627599, -27.3269801],
      [30.5629699, -27.3269701],
      [30.5631138, -27.3269452],
      [30.5632599, -27.3269201],
      [30.5633258, -27.3268981],
      [30.5634399, -27.3268601],
      [30.5636299, -27.3267901],
      [30.5638399, -27.3267201],
      [30.5638685, -27.3267058],
      [30.5638799, -27.3267001],
      [30.5641599, -27.3266001],
      [30.5642313, -27.3265773],
      [30.5643799, -27.3265301],
      [30.5645104, -27.3264909],
      [30.5645799, -27.3264701],
      [30.5647999, -27.3264201],
      [30.5648634, -27.3264081],
      [30.5649599, -27.3263901],
      [30.5650899, -27.3263701],
      [30.5652099, -27.3263501],
      [30.5653499, -27.3263501],
      [30.5654193, -27.3263447],
      [30.5654799, -27.3263401],
      [30.5655396, -27.3263454],
      [30.5655899, -27.3263501],
      [30.5656598, -27.3263446],
      [30.5657199, -27.3263401],
      [30.5658153, -27.32634],
      [30.5660299, -27.3263401],
      [30.5661341, -27.3263452],
      [30.5662299, -27.3263501],
      [30.5663499, -27.3263501],
      [30.5664093, -27.3263446],
      [30.5664599, -27.3263401],
      [30.5665188, -27.326331],
      [30.5665899, -27.3263201],
      [30.5666568, -27.3263105],
      [30.5667299, -27.3263001],
      [30.5668926, -27.3262593],
      [30.5670499, -27.3262201],
      [30.5671253, -27.3262084],
      [30.5671799, -27.3262001],
      [30.5672294, -27.3261886],
      [30.5673099, -27.3261701],
      [30.5674799, -27.3261401],
      [30.5675285, -27.326128],
      [30.5675599, -27.3261201],
      [30.5676116, -27.3261081],
      [30.5676899, -27.3260901],
      [30.5678099, -27.3260401],
      [30.5680299, -27.3259601],
      [30.5681364, -27.3259134],
      [30.5681899, -27.3258901],
      [30.5683199, -27.3258501],
      [30.5683315, -27.3258443],
      [30.5683599, -27.3258301],
      [30.5684799, -27.3257901],
      [30.5685599, -27.3257601],
      [30.5686699, -27.3257201],
      [30.5688061, -27.3256656],
      [30.5688699, -27.3256401],
      [30.5689225, -27.3256225],
      [30.5690199, -27.3255901],
      [30.5691499, -27.3255601],
      [30.5693399, -27.3255101],
      [30.5694399, -27.3254801],
      [30.5694977, -27.3254685],
      [30.5695399, -27.3254601],
      [30.5696699, -27.3254301],
      [30.5697799, -27.3254101],
      [30.5698319, -27.3254014],
      [30.5698999, -27.3253901],
      [30.5700299, -27.3253701],
      [30.5701199, -27.3253601],
      [30.5702899, -27.3253501],
      [30.5704699, -27.3253501],
      [30.5705799, -27.3253601],
      [30.5706599, -27.3253601],
      [30.5707499, -27.3253701],
      [30.5708599, -27.3253801],
      [30.5710299, -27.3253901],
      [30.5711099, -27.3253901],
      [30.5711503, -27.3253945],
      [30.5711999, -27.3254001],
      [30.5714299, -27.3254001],
      [30.5714698, -27.3253956],
      [30.5715199, -27.3253901],
      [30.5716199, -27.3253801],
      [30.5716899, -27.3253801],
      [30.5717999, -27.3253701],
      [30.5719299, -27.3253501],
      [30.5720899, -27.3253301],
      [30.5721743, -27.325318],
      [30.5722299, -27.3253101],
      [30.5723499, -27.3252801],
      [30.572409, -27.3252709],
      [30.5724799, -27.3252601],
      [30.572599, -27.3252438],
      [30.5726999, -27.3252301],
      [30.572762, -27.3252211],
      [30.5728399, -27.3252101],
      [30.5729245, -27.3251919],
      [30.5729799, -27.3251801],
      [30.5730734, -27.3251673],
      [30.5731999, -27.3251501],
      [30.5733399, -27.3251101],
      [30.5734699, -27.3250701],
      [30.5735799, -27.3250401],
      [30.5737899, -27.3249801],
      [30.5739499, -27.3249301],
      [30.5740799, -27.3248901],
      [30.5741148, -27.3248761],
      [30.5741299, -27.3248701],
      [30.5744099, -27.3247901],
      [30.5744772, -27.3247688],
      [30.5745999, -27.3247301],
      [30.5746868, -27.3247052],
      [30.5747399, -27.3246901],
      [30.5747558, -27.3246861],
      [30.5747799, -27.3246801],
      [30.5749506, -27.3246447],
      [30.5750699, -27.3246201],
      [30.5751385, -27.3246072],
      [30.5752299, -27.3245901],
      [30.5753799, -27.3245801],
      [30.5754997, -27.3245691],
      [30.5755999, -27.3245601],
      [30.57567, -27.3245553],
      [30.5757499, -27.3245501],
      [30.5759099, -27.3245401],
      [30.5761399, -27.3245301],
      [30.5767397, -27.32453],
      [30.5770799, -27.3245301],
      [30.5772278, -27.3245191],
      [30.5773499, -27.3245101],
      [30.577434, -27.3245007],
      [30.5775299, -27.3244901],
      [30.5776999, -27.3244601],
      [30.5778468, -27.3244233],
      [30.5779399, -27.3244001],
      [30.5779914, -27.3243853],
      [30.5780799, -27.3243601],
      [30.5782299, -27.3243001],
      [30.5783899, -27.3242301],
      [30.5786599, -27.3241001],
      [30.5788008, -27.3240185],
      [30.5788499, -27.3239901],
      [30.5790399, -27.3239001],
      [30.5792599, -27.3237801],
      [30.5793206, -27.3237461],
      [30.5795099, -27.3236401],
      [30.5795919, -27.3235971],
      [30.5797199, -27.3235301],
      [30.5798355, -27.3234723],
      [30.5798799, -27.3234501],
      [30.5800499, -27.3233801],
      [30.5803299, -27.3232801],
      [30.5805199, -27.3232301],
      [30.5807199, -27.3231901],
      [30.5808504, -27.3231807],
      [30.5809999, -27.3231701],
      [30.5811096, -27.3231648],
      [30.5812099, -27.3231601],
      [30.5813297, -27.3231652],
      [30.5814399, -27.3231701],
      [30.5817899, -27.3231801],
      [30.5818949, -27.3231848],
      [30.5820099, -27.3231901],
      [30.5822099, -27.3231901],
      [30.5824899, -27.3231601],
      [30.5825638, -27.3231471],
      [30.5826599, -27.3231301],
      [30.5827534, -27.3231125],
      [30.5828199, -27.3231001],
      [30.5829899, -27.3230601],
      [30.583089, -27.3230435],
      [30.5832299, -27.3230201],
      [30.5832891, -27.3230146],
      [30.5833399, -27.3230101],
      [30.5834121, -27.3229997],
      [30.5834799, -27.3229901],
      [30.5835599, -27.3229901],
      [30.5836599, -27.3229801],
      [30.5837207, -27.3229749],
      [30.5837799, -27.3229701],
      [30.5839099, -27.3229701],
      [30.5839999, -27.3229601],
      [30.5843414, -27.32296],
      [30.5844599, -27.3229601],
      [30.5845599, -27.3229701],
      [30.5846499, -27.3229701],
      [30.5847147, -27.3229754],
      [30.5847699, -27.3229801],
      [30.5848399, -27.3229901],
      [30.5848999, -27.3230001],
      [30.5849494, -27.3230045],
      [30.5850099, -27.3230101],
      [30.5850496, -27.3230158],
      [30.5850799, -27.3230201],
      [30.5851499, -27.3230201],
      [30.5852399, -27.3230301],
      [30.5853099, -27.3230401],
      [30.5853399, -27.3230401],
      [30.5853703, -27.3230443],
      [30.5854099, -27.3230501],
      [30.5855299, -27.3230601],
      [30.5855799, -27.3230601],
      [30.5856197, -27.3230657],
      [30.5856499, -27.3230701],
      [30.5857599, -27.3230801],
      [30.5858599, -27.3230801],
      [30.5859399, -27.3230901],
      [30.5865499, -27.3230901],
      [30.5866599, -27.3230801],
      [30.5870599, -27.3230801],
      [30.5870899, -27.3230701],
      [30.5871199, -27.3230701],
      [30.5874046, -27.3230151],
      [30.5876899, -27.3229601],
      [30.5877154, -27.3229549],
      [30.5877399, -27.3229501],
      [30.5919499, -27.3210001],
      [30.5920545, -27.3209495],
      [30.5960499, -27.3190201],
      [30.6048999, -27.3147601],
      [30.6074767, -27.3135155],
      [30.6079158, -27.3133035],
      [30.6087099, -27.3129201],
      [30.6104799, -27.3120901],
      [30.6109893, -27.3118503],
      [30.6120786, -27.3113377],
      [30.6126899, -27.3110501],
      [30.6152999, -27.3098001],
      [30.6170596, -27.3089613],
      [30.6217199, -27.3067401],
      [30.6219182, -27.3066446],
      [30.6219899, -27.3066101],
      [30.624605, -27.30534],
      [30.6249999, -27.3051501],
      [30.6410999, -27.2973601],
      [30.6417209, -27.2970592],
      [30.6433499, -27.2962701],
      [30.6567099, -27.2898101],
      [30.6595148, -27.2884542],
      [30.6606199, -27.2879201],
      [30.6607399, -27.2879101],
      [30.6629499, -27.2876901],
      [30.6638595, -27.2875945],
      [30.6647599, -27.2875001],
      [30.6705899, -27.2869201],
      [30.6707563, -27.2869039],
      [30.6708999, -27.2868901],
      [30.6712421, -27.2868545],
      [30.6716699, -27.2868101],
      [30.6740152, -27.2865748],
      [30.6864299, -27.2853301],
      [30.686902, -27.2852866],
      [30.6872999, -27.2852501],
      [30.6920299, -27.2847701],
      [30.696765, -27.2842956],
      [30.7025099, -27.2837201],
      [30.7036899, -27.2836001],
      [30.7067999, -27.2832901],
      [30.7068399, -27.2833501],
      [30.7070199, -27.2835701],
      [30.7071299, -27.2836901],
      [30.7073599, -27.2839301],
      [30.7076899, -27.2842301],
      [30.7078099, -27.2843001],
      [30.7080099, -27.2843801],
      [30.7081999, -27.2844101],
      [30.7087599, -27.2843901],
      [30.7092799, -27.2843901],
      [30.7097399, -27.2844201],
      [30.7098799, -27.2844501],
      [30.7100499, -27.2844401],
      [30.7107099, -27.2845501],
      [30.7111399, -27.2846401],
      [30.7112699, -27.2846701],
      [30.7114499, -27.2847401],
      [30.7115599, -27.2847901],
      [30.7116999, -27.2848801],
      [30.7119899, -27.2852301],
      [30.7125799, -27.2858101],
      [30.7128099, -27.2859701],
      [30.7130299, -27.2860601],
      [30.7131199, -27.2860701],
      [30.7133399, -27.2860501],
      [30.7139699, -27.2859301],
      [30.7141499, -27.2858801],
      [30.7143099, -27.2858101],
      [30.7146999, -27.2855501],
      [30.7149599, -27.2853001],
      [30.7152199, -27.2850901],
      [30.7154799, -27.2848401],
      [30.7157299, -27.2846301],
      [30.7160799, -27.2843901],
      [30.7162099, -27.2843301],
      [30.7163199, -27.2842401],
      [30.7167699, -27.2840101],
      [30.7170599, -27.2838801],
      [30.7174399, -27.2837901],
      [30.7175699, -27.2837801],
      [30.7177599, -27.2837901],
      [30.7182699, -27.2839001],
      [30.7185699, -27.2840401],
      [30.7186599, -27.2841101],
      [30.7187299, -27.2841901],
      [30.7187799, -27.2843001],
      [30.7188099, -27.2844701],
      [30.7188099, -27.2846401],
      [30.7187799, -27.2848201],
      [30.7187299, -27.2849901],
      [30.7185999, -27.2852101],
      [30.7184199, -27.2854001],
      [30.7180799, -27.2856301],
      [30.7179699, -27.2857401],
      [30.7178899, -27.2858501],
      [30.7178299, -27.2859701],
      [30.7177899, -27.2861001],
      [30.7177799, -27.2862401],
      [30.7177899, -27.2868301],
      [30.7178199, -27.2870201],
      [30.7178999, -27.2872401],
      [30.7181299, -27.2875301],
      [30.7182699, -27.2876801],
      [30.7183799, -27.2877701],
      [30.7185899, -27.2879101],
      [30.7192099, -27.2882201],
      [30.7195199, -27.2884001],
      [30.7198099, -27.2886101],
      [30.7199399, -27.2887301],
      [30.7201799, -27.2890101],
      [30.7203199, -27.2892001],
      [30.7203999, -27.2893701],
      [30.7204399, -27.2895201],
      [30.7204499, -27.2898001],
      [30.7204299, -27.2904001],
      [30.7204499, -27.2905101],
      [30.7205599, -27.2907601],
      [30.7206099, -27.2908301],
      [30.7206999, -27.2909301],
      [30.7209399, -27.2910901],
      [30.7210699, -27.2911301],
      [30.7213199, -27.2911401],
      [30.7214699, -27.2911201],
      [30.7217599, -27.2910301],
      [30.7219499, -27.2909401],
      [30.7231499, -27.2902401],
      [30.7240499, -27.2896401],
      [30.7241999, -27.2895601],
      [30.7243299, -27.2895101],
      [30.7246599, -27.2895001],
      [30.7247899, -27.2895401],
      [30.7249099, -27.2896001],
      [30.7249799, -27.2897101],
      [30.7249799, -27.2898401],
      [30.7249099, -27.2902001],
      [30.7248999, -27.2903901],
      [30.7249299, -27.2908001],
      [30.7250099, -27.2913501],
      [30.7250899, -27.2916801],
      [30.7252199, -27.2920301],
      [30.7254099, -27.2923901],
      [30.7255099, -27.2925301],
      [30.7259499, -27.2932601],
      [30.7260299, -27.2934401],
      [30.7260699, -27.2936101],
      [30.7260499, -27.2939101],
      [30.7260099, -27.2941201],
      [30.7259499, -27.2942401],
      [30.7258699, -27.2943701],
      [30.7257599, -27.2944901],
      [30.7254299, -27.2947801],
      [30.7252999, -27.2949201],
      [30.7251699, -27.2950801],
      [30.7250899, -27.2952101],
      [30.7250699, -27.2954801],
      [30.7251199, -27.2956501],
      [30.7251799, -27.2957901],
      [30.7253199, -27.2960201],
      [30.7255499, -27.2962601],
      [30.7259299, -27.2965701],
      [30.7261199, -27.2966701],
      [30.7264699, -27.2969401],
      [30.7273199, -27.2978101],
      [30.7274199, -27.2979701],
      [30.7275499, -27.2981301],
      [30.7278999, -27.2988201],
      [30.7279899, -27.2990701],
      [30.7282599, -27.2993401],
      [30.7286699, -27.2995101],
      [30.7291699, -27.2996001],
      [30.7292499, -27.2996001],
      [30.7294499, -27.2995801],
      [30.7296999, -27.2994201],
      [30.7297899, -27.2991501],
      [30.7298699, -27.2990001],
      [30.7302299, -27.2986001],
      [30.7303699, -27.2984101],
      [30.7307799, -27.2980001],
      [30.7318299, -27.2971201],
      [30.7321099, -27.2969201],
      [30.7323599, -27.2967001],
      [30.7327999, -27.2962501],
      [30.7329699, -27.2961001],
      [30.7331899, -27.2959801],
      [30.7334699, -27.2957901],
      [30.7336899, -27.2956301],
      [30.7339399, -27.2954101],
      [30.7341199, -27.2953001],
      [30.7344099, -27.2951601],
      [30.7347299, -27.2950601],
      [30.7353099, -27.2948301],
      [30.7354899, -27.2947401],
      [30.7359999, -27.2945601],
      [30.7363699, -27.2944801],
      [30.7367399, -27.2944401],
      [30.7371299, -27.2943701],
      [30.7373199, -27.2942901],
      [30.7374999, -27.2941801],
      [30.7376999, -27.2941401],
      [30.7379599, -27.2941401],
      [30.7383399, -27.2941701],
      [30.7385699, -27.2942101],
      [30.7389299, -27.2943201],
      [30.7394799, -27.2945601],
      [30.7395999, -27.2945901],
      [30.7397699, -27.2945901],
      [30.7400199, -27.2945601],
      [30.7403499, -27.2945601],
      [30.7405299, -27.2946201],
      [30.7406799, -27.2947901],
      [30.7407199, -27.2949501],
      [30.7406399, -27.2952101],
      [30.7406199, -27.2953301],
      [30.7406399, -27.2954901],
      [30.7407599, -27.2957201],
      [30.7408699, -27.2960301],
      [30.7408499, -27.2964501],
      [30.7408199, -27.2966301],
      [30.7408199, -27.2969201],
      [30.7408399, -27.2971001],
      [30.7409999, -27.2976101],
      [30.7412099, -27.2980001],
      [30.7413499, -27.2981601],
      [30.7417799, -27.2985301],
      [30.7418099, -27.2985701],
      [30.7422599, -27.2988401],
      [30.7423799, -27.2989401],
      [30.7424599, -27.2990601],
      [30.7425999, -27.2992201],
      [30.7428899, -27.2997001],
      [30.7430499, -27.2998801],
      [30.7432999, -27.3000301],
      [30.7435899, -27.3002301],
      [30.7437699, -27.3004101],
      [30.7438499, -27.3006201],
      [30.7438799, -27.3007601],
      [30.7438599, -27.3008801],
      [30.7438099, -27.3010001],
      [30.7435199, -27.3013801],
      [30.7433799, -27.3017501],
      [30.7431799, -27.3020401],
      [30.7430699, -27.3021501],
      [30.7428899, -27.3022401],
      [30.7424899, -27.3024801],
      [30.7421299, -27.3027601],
      [30.7420099, -27.3028901],
      [30.7419399, -27.3030201],
      [30.7418899, -27.3031801],
      [30.7418999, -27.3033901],
      [30.7420599, -27.3038801],
      [30.7422899, -27.3047001],
      [30.7423499, -27.3048601],
      [30.7425499, -27.3052501],
      [30.7426899, -27.3054501],
      [30.7429799, -27.3058301],
      [30.7431399, -27.3059901],
      [30.7432699, -27.3060701],
      [30.7435699, -27.3061301],
      [30.7441699, -27.3059901],
      [30.7443299, -27.3059001],
      [30.7445199, -27.3057501],
      [30.7446499, -27.3054501],
      [30.7447299, -27.3051601],
      [30.7448499, -27.3045501],
      [30.7449899, -27.3041201],
      [30.7452399, -27.3037301],
      [30.7454399, -27.3034701],
      [30.7455899, -27.3033401],
      [30.7456999, -27.3032001],
      [30.7459099, -27.3030401],
      [30.7461099, -27.3029201],
      [30.7470499, -27.3020701],
      [30.7476599, -27.3012901],
      [30.7478599, -27.3009901],
      [30.7481599, -27.3005901],
      [30.7487199, -27.2999601],
      [30.7490299, -27.2996401],
      [30.7495199, -27.2992501],
      [30.7499299, -27.2989801],
      [30.7501599, -27.2988501],
      [30.7503599, -27.2987901],
      [30.7505399, -27.2987601],
      [30.7507999, -27.2987501],
      [30.7510099, -27.2988001],
      [30.7511699, -27.2989201],
      [30.7512599, -27.2990601],
      [30.7513299, -27.2992601],
      [30.7514099, -27.2995801],
      [30.7515699, -27.3000101],
      [30.7517699, -27.3004701],
      [30.7519799, -27.3008701],
      [30.7520799, -27.3010101],
      [30.7521399, -27.3011601],
      [30.7521499, -27.3012501],
      [30.7522099, -27.3013501],
      [30.7523599, -27.3015301],
      [30.7525699, -27.3016901],
      [30.7528199, -27.3019201],
      [30.7535099, -27.3026001],
      [30.7538799, -27.3029401],
      [30.7541899, -27.3033201],
      [30.7543599, -27.3034801],
      [30.7545999, -27.3037401],
      [30.7549899, -27.3041001],
      [30.7551699, -27.3042401],
      [30.7555699, -27.3046001],
      [30.7557499, -27.3047101],
      [30.7559199, -27.3047801],
      [30.7563399, -27.3048601],
      [30.7568099, -27.3049101],
      [30.7569699, -27.3049101],
      [30.7571499, -27.3048801],
      [30.7574099, -27.3047501],
      [30.7575599, -27.3046501],
      [30.7577199, -27.3044801],
      [30.7579299, -27.3043401],
      [30.7580799, -27.3043301],
      [30.7581899, -27.3043401],
      [30.7583099, -27.3043801],
      [30.7584399, -27.3044501],
      [30.7585799, -27.3045601],
      [30.7587199, -27.3047401],
      [30.7590699, -27.3051101],
      [30.7592999, -27.3052501],
      [30.7601299, -27.3057001],
      [30.7604199, -27.3058701],
      [30.7605999, -27.3059901],
      [30.7607599, -27.3061201],
      [30.7610399, -27.3063801],
      [30.7613599, -27.3065401],
      [30.7621299, -27.3069801],
      [30.7625599, -27.3072501],
      [30.7627399, -27.3073901],
      [30.7628899, -27.3075901],
      [30.7630199, -27.3079201],
      [30.7630999, -27.3083701],
      [30.7631099, -27.3086601],
      [30.7630699, -27.3087701],
      [30.7629699, -27.3088601],
      [30.7627999, -27.3089101],
      [30.7625999, -27.3090201],
      [30.7624499, -27.3091401],
      [30.7623499, -27.3092501],
      [30.7622799, -27.3093901],
      [30.7622299, -27.3095801],
      [30.7621999, -27.3097901],
      [30.7620999, -27.3100001],
      [30.7617099, -27.3104101],
      [30.7614299, -27.3106401],
      [30.7612399, -27.3108301],
      [30.7610599, -27.3109801],
      [30.7607299, -27.3113401],
      [30.7603399, -27.3119001],
      [30.7598899, -27.3126101],
      [30.7598399, -27.3128001],
      [30.7598099, -27.3130001],
      [30.7598299, -27.3132101],
      [30.7599599, -27.3135801],
      [30.7600599, -27.3137801],
      [30.7601599, -27.3138801],
      [30.7602699, -27.3139301],
      [30.7604799, -27.3139901],
      [30.7607399, -27.3139701],
      [30.7609399, -27.3139101],
      [30.7611399, -27.3138901],
      [30.7614999, -27.3138901],
      [30.7620499, -27.3140001],
      [30.7625299, -27.3142701],
      [30.7628499, -27.3145201],
      [30.7630799, -27.3147501],
      [30.7634599, -27.3151701],
      [30.7637299, -27.3155401],
      [30.7638599, -27.3157701],
      [30.7647699, -27.3169801],
      [30.7655999, -27.3177601],
      [30.7659199, -27.3181701],
      [30.7659899, -27.3183501],
      [30.7659999, -27.3185801],
      [30.7659599, -27.3188201],
      [30.7659699, -27.3189701],
      [30.7660099, -27.3191101],
      [30.7660899, -27.3192101],
      [30.7662099, -27.3193001],
      [30.7663899, -27.3193601],
      [30.7666299, -27.3193901],
      [30.7668499, -27.3193601],
      [30.7669699, -27.3192601],
      [30.7671299, -27.3191601],
      [30.7673799, -27.3190401],
      [30.7678599, -27.3188701],
      [30.7682899, -27.3187901],
      [30.7685899, -27.3188001],
      [30.7687599, -27.3188301],
      [30.7689099, -27.3189101],
      [30.7690299, -27.3190201],
      [30.7691199, -27.3191701],
      [30.7691699, -27.3193201],
      [30.7692399, -27.3196101],
      [30.7692599, -27.3197601],
      [30.7692499, -27.3198901],
      [30.7691199, -27.3203401],
      [30.7690699, -27.3207101],
      [30.7690699, -27.3208601],
      [30.7690899, -27.3210201],
      [30.7691499, -27.3212601],
      [30.7692199, -27.3214201],
      [30.7692699, -27.3216201],
      [30.7693299, -27.3223901],
      [30.7693399, -27.3227101],
      [30.7693799, -27.3230001],
      [30.7693899, -27.3233001],
      [30.7696699, -27.3244701],
      [30.7697499, -27.3248801],
      [30.7698199, -27.3251201],
      [30.7699199, -27.3253601],
      [30.7700999, -27.3256401],
      [30.7702499, -27.3258401],
      [30.7705799, -27.3261601],
      [30.7707899, -27.3262801],
      [30.7711999, -27.3264401],
      [30.7715399, -27.3265301],
      [30.7717099, -27.3265401],
      [30.7719799, -27.3265301],
      [30.7722399, -27.3264501],
      [30.7727899, -27.3261001],
      [30.7729899, -27.3258401],
      [30.7730599, -27.3256201],
      [30.7731499, -27.3249701],
      [30.7732099, -27.3247501],
      [30.7733399, -27.3245701],
      [30.7735199, -27.3244201],
      [30.7739199, -27.3243201],
      [30.7741699, -27.3242801],
      [30.7743199, -27.3242801],
      [30.7747099, -27.3243501],
      [30.7750799, -27.3244601],
      [30.7752799, -27.3245001],
      [30.7754199, -27.3245001],
      [30.7757399, -27.3244901],
      [30.7759899, -27.3244301],
      [30.7761799, -27.3244101],
      [30.7768999, -27.3242701],
      [30.7774099, -27.3242001],
      [30.7781999, -27.3242201],
      [30.7784399, -27.3242401],
      [30.7790199, -27.3243301],
      [30.7798799, -27.3245801],
      [30.7800799, -27.3246201],
      [30.7806899, -27.3246301],
      [30.7808899, -27.3246301],
      [30.7811399, -27.3245901],
      [30.7813799, -27.3245301],
      [30.7816699, -27.3244101],
      [30.7818199, -27.3244001],
      [30.7825199, -27.3244901],
      [30.7830899, -27.3245301],
      [30.7832599, -27.3245601],
      [30.7834499, -27.3245501],
      [30.783888, -27.3244911],
      [30.7839599, -27.3244801],
      [30.7842499, -27.3244101],
      [30.7843999, -27.3243201],
      [30.7845499, -27.3241801],
      [30.7845899, -27.3240301],
      [30.7845899, -27.3238601],
      [30.7843599, -27.3233401],
      [30.7842999, -27.3231501],
      [30.7842799, -27.3229401],
      [30.7843299, -27.3227401],
      [30.7846599, -27.3221901],
      [30.7848699, -27.3217501],
      [30.7852899, -27.3208001],
      [30.7854899, -27.3203101],
      [30.7855399, -27.3201101],
      [30.7855799, -27.3197001],
      [30.7855799, -27.3195201],
      [30.7854999, -27.3191701],
      [30.7853799, -27.3190201],
      [30.7852199, -27.3189101],
      [30.7850199, -27.3188101],
      [30.7846199, -27.3187001],
      [30.7844199, -27.3186101],
      [30.7835299, -27.3182901],
      [30.7829899, -27.3181301],
      [30.7825099, -27.3180301],
      [30.7820299, -27.3178701],
      [30.7813399, -27.3175501],
      [30.7803799, -27.3169301],
      [30.7794499, -27.3161801],
      [30.7789299, -27.3156001],
      [30.7786899, -27.3152001],
      [30.7786199, -27.3150201],
      [30.7785699, -27.3148001],
      [30.7785899, -27.3145501],
      [30.7786299, -27.3144301],
      [30.7786999, -27.3143301],
      [30.7788199, -27.3142401],
      [30.7789799, -27.3141801],
      [30.7791199, -27.3141501],
      [30.7792999, -27.3141501],
      [30.7795199, -27.3141801],
      [30.7797599, -27.3142501],
      [30.7798899, -27.3143101],
      [30.7800199, -27.3143901],
      [30.7801999, -27.3145601],
      [30.7803599, -27.3146801],
      [30.7805299, -27.3147801],
      [30.7806899, -27.3148401],
      [30.7808399, -27.3148701],
      [30.7809799, -27.3148601],
      [30.7811599, -27.3148201],
      [30.7813199, -27.3147501],
      [30.7815399, -27.3147201],
      [30.7822199, -27.3148001],
      [30.7826499, -27.3148001],
      [30.7828299, -27.3147701],
      [30.7838299, -27.3144901],
      [30.7843999, -27.3143001],
      [30.7846399, -27.3142401],
      [30.7848399, -27.3141601],
      [30.7852999, -27.3140501],
      [30.7860699, -27.3139001],
      [30.7873099, -27.3135501],
      [30.7877299, -27.3133901],
      [30.7881399, -27.3131801],
      [30.7883199, -27.3130301],
      [30.7885299, -27.3128001],
      [30.7886299, -27.3127601],
      [30.7887599, -27.3127601],
      [30.7889299, -27.3128001],
      [30.7890099, -27.3128801],
      [30.7891099, -27.3130401],
      [30.7891799, -27.3132201],
      [30.7892199, -27.3134001],
      [30.7892999, -27.3135901],
      [30.7895399, -27.3139801],
      [30.7896999, -27.3143001],
      [30.7897999, -27.3144601],
      [30.7899099, -27.3147101],
      [30.7901099, -27.3150701],
      [30.7904899, -27.3156201],
      [30.7906199, -27.3157201],
      [30.7908699, -27.3160001],
      [30.7909199, -27.3161001],
      [30.7909799, -27.3163601],
      [30.7909799, -27.3165301],
      [30.7908599, -27.3172901],
      [30.7907999, -27.3178601],
      [30.7908099, -27.3180901],
      [30.7908599, -27.3182701],
      [30.7909899, -27.3184501],
      [30.7911399, -27.3185501],
      [30.7914082, -27.3186798],
      [30.7918299, -27.3188501],
      [30.7920699, -27.3189201],
      [30.7924499, -27.3191501],
      [30.7937499, -27.3198601],
      [30.7939599, -27.3200001],
      [30.7943099, -27.3201701],
      [30.7947099, -27.3204501],
      [30.7948799, -27.3205501],
      [30.7951599, -27.3208101],
      [30.7955599, -27.3210801],
      [30.7959299, -27.3214101],
      [30.7961599, -27.3215701],
      [30.7969499, -27.3223601],
      [30.7970099, -27.3224801],
      [30.7970399, -27.3227201],
      [30.7969299, -27.3230901],
      [30.7968499, -27.3232801],
      [30.7967099, -27.3234801],
      [30.7966199, -27.3236501],
      [30.7964299, -27.3241301],
      [30.7963199, -27.3244901],
      [30.7962799, -27.3246901],
      [30.7962799, -27.3250801],
      [30.7963199, -27.3255901],
      [30.7963499, -27.3257301],
      [30.7964099, -27.3258401],
      [30.7965099, -27.3259901],
      [30.7966199, -27.3261201],
      [30.7967799, -27.3262801],
      [30.7971499, -27.3265901],
      [30.7974199, -27.3267401],
      [30.7975999, -27.3267801],
      [30.7981699, -27.3268401],
      [30.7985099, -27.3269301],
      [30.7986299, -27.3269301],
      [30.7987799, -27.3268801],
      [30.7988999, -27.3267801],
      [30.7990199, -27.3266101],
      [30.7990999, -27.3264501],
      [30.7991799, -27.3261201],
      [30.7991699, -27.3257301],
      [30.7992299, -27.3255701],
      [30.7993199, -27.3254401],
      [30.7995999, -27.3251901],
      [30.8000999, -27.3248701],
      [30.8008599, -27.3247501],
      [30.8013899, -27.3246901],
      [30.8023099, -27.3247001],
      [30.8025499, -27.3246701],
      [30.8027999, -27.3245601],
      [30.8031099, -27.3243801],
      [30.8033199, -27.3242801],
      [30.8035199, -27.3242501],
      [30.8041499, -27.3242601],
      [30.8043099, -27.3243001],
      [30.8044699, -27.3244001],
      [30.8047699, -27.3247001],
      [30.8050299, -27.3250401],
      [30.8051499, -27.3252301],
      [30.8052399, -27.3254201],
      [30.8054899, -27.3261601],
      [30.8056399, -27.3265401],
      [30.8059199, -27.3269801],
      [30.8060199, -27.3271101],
      [30.8062299, -27.3273201],
      [30.8063499, -27.3273801],
      [30.8064499, -27.3274101],
      [30.8068199, -27.3274201],
      [30.8074399, -27.3275801],
      [30.8076399, -27.3276601],
      [30.8080499, -27.3277801],
      [30.8084699, -27.3280001],
      [30.8087099, -27.3281901],
      [30.8087899, -27.3282801],
      [30.8088199, -27.3283601],
      [30.8088199, -27.3284401],
      [30.8087699, -27.3285401],
      [30.8085499, -27.3287001],
      [30.8082499, -27.3288601],
      [30.8080799, -27.3289801],
      [30.8078099, -27.3290701],
      [30.8073899, -27.3291001],
      [30.8069499, -27.3291901],
      [30.8066199, -27.3293201],
      [30.8064199, -27.3294601],
      [30.8061399, -27.3297201],
      [30.8059699, -27.3298401],
      [30.8051799, -27.3302901],
      [30.8049299, -27.3303301],
      [30.8040599, -27.3303301],
      [30.8035499, -27.3303701],
      [30.8033399, -27.3304201],
      [30.8031399, -27.3305001],
      [30.8029999, -27.3305801],
      [30.8027699, -27.3307501],
      [30.8026499, -27.3308601],
      [30.8023899, -27.3314201],
      [30.8022599, -27.3318101],
      [30.8021799, -27.3321201],
      [30.8021699, -27.3326201],
      [30.8023399, -27.3331601],
      [30.8025899, -27.3336001],
      [30.8027099, -27.3337801],
      [30.8028399, -27.3339301],
      [30.8029699, -27.3340501],
      [30.8033699, -27.3343401],
      [30.8034599, -27.3343701],
      [30.8040299, -27.3343901],
      [30.8045799, -27.3345001],
      [30.8048199, -27.3345201],
      [30.8049399, -27.3345201],
      [30.8051399, -27.3344701],
      [30.8052899, -27.3344101],
      [30.8055499, -27.3341701],
      [30.8058199, -27.3338601],
      [30.8060399, -27.3337101],
      [30.8064599, -27.3334701],
      [30.8070899, -27.3330001],
      [30.8074199, -27.3327801],
      [30.8076099, -27.3326901],
      [30.8078499, -27.3326201],
      [30.8084099, -27.3325501],
      [30.8087499, -27.3324801],
      [30.8096899, -27.3322401],
      [30.8099799, -27.3321401],
      [30.8102999, -27.3320501],
      [30.8105599, -27.3320201],
      [30.8107799, -27.3320201],
      [30.8109399, -27.3320501],
      [30.8112299, -27.3322501],
      [30.8113799, -27.3323901],
      [30.8114799, -27.3325601],
      [30.8115099, -27.3327101],
      [30.8115099, -27.3328501],
      [30.8114899, -27.3329901],
      [30.8114199, -27.3331301],
      [30.8112999, -27.3332401],
      [30.8112299, -27.3333601],
      [30.8111799, -27.3334601],
      [30.8111399, -27.3336301],
      [30.8110999, -27.3343201],
      [30.8111099, -27.3347701],
      [30.8110799, -27.3350701],
      [30.8110299, -27.3352101],
      [30.8108099, -27.3353401],
      [30.8106999, -27.3353701],
      [30.8103399, -27.3355401],
      [30.8101999, -27.3356401],
      [30.8099499, -27.3359101],
      [30.8098499, -27.3360401],
      [30.8096399, -27.3365001],
      [30.8095299, -27.3367001],
      [30.8094099, -27.3368501],
      [30.8086699, -27.3374601],
      [30.8084699, -27.3376701],
      [30.8083299, -27.3378601],
      [30.8082199, -27.3380801],
      [30.8081599, -27.3382501],
      [30.8081299, -27.3384101],
      [30.8080999, -27.3386201],
      [30.8081599, -27.3387801],
      [30.8082499, -27.3389201],
      [30.8083999, -27.3390201],
      [30.8086299, -27.3391401],
      [30.8087499, -27.3391901],
      [30.8090299, -27.3392701],
      [30.8094499, -27.3393201],
      [30.8096699, -27.3393301],
      [30.8099799, -27.3393801],
      [30.8105499, -27.3395201],
      [30.8107899, -27.3396001],
      [30.8116399, -27.3397001],
      [30.8124699, -27.3397601],
      [30.8132299, -27.3396601],
      [30.8137699, -27.3396901],
      [30.8143499, -27.3398301],
      [30.8155399, -27.3400801],
      [30.8157499, -27.3400801],
      [30.8159099, -27.3401001],
      [30.8160799, -27.3400701],
      [30.8162899, -27.3399801],
      [30.8166299, -27.3398001],
      [30.8169199, -27.3396201],
      [30.8169699, -27.3395701],
      [30.8169699, -27.3394201],
      [30.8169199, -27.3391301],
      [30.8169699, -27.3388001],
      [30.8169999, -27.3386301],
      [30.8172499, -27.3379101],
      [30.8173599, -27.3377601],
      [30.8177999, -27.3372901],
      [30.8180299, -27.3371201],
      [30.8183799, -27.3369101],
      [30.8186099, -27.3367301],
      [30.8192599, -27.3363501],
      [30.8198999, -27.3361401],
      [30.8200799, -27.3361001],
      [30.8202699, -27.3361001],
      [30.8204799, -27.3361301],
      [30.8209499, -27.3362901],
      [30.8213399, -27.3364701],
      [30.8213999, -27.3365301],
      [30.8214399, -27.3366101],
      [30.8214799, -27.3367601],
      [30.8214999, -27.3375301],
      [30.8214699, -27.3378301],
      [30.8214399, -27.3379801],
      [30.8211399, -27.3384201],
      [30.8210699, -27.3386001],
      [30.8210399, -27.3389301],
      [30.8210899, -27.3392001],
      [30.8212799, -27.3394801],
      [30.8214499, -27.3395701],
      [30.8215799, -27.3395701],
      [30.8217899, -27.3395401],
      [30.8219899, -27.3394801],
      [30.8222399, -27.3394301],
      [30.8224699, -27.3394301],
      [30.8226699, -27.3394601],
      [30.8228699, -27.3395401],
      [30.8230299, -27.3396401],
      [30.8237199, -27.3401401],
      [30.8239099, -27.3402401],
      [30.8243199, -27.3404001],
      [30.8245699, -27.3405201],
      [30.8250399, -27.3406601],
      [30.8251899, -27.3406801],
      [30.8254699, -27.3408001],
      [30.8256199, -27.3409301],
      [30.8257299, -27.3410601],
      [30.8258099, -27.3412801],
      [30.8258199, -27.3414501],
      [30.8259099, -27.3415901],
      [30.8260999, -27.3417401],
      [30.8269099, -27.3421501],
      [30.8273499, -27.3424301],
      [30.8275299, -27.3425801],
      [30.8278899, -27.3429601],
      [30.8281699, -27.3432901],
      [30.8282899, -27.3434701],
      [30.8284999, -27.3438401],
      [30.8286099, -27.3440801],
      [30.8286699, -27.3442601],
      [30.8286899, -27.3444001],
      [30.8286799, -27.3445301],
      [30.8286499, -27.3446201],
      [30.8285799, -27.3447001],
      [30.8284399, -27.3447601],
      [30.8279399, -27.3448801],
      [30.8271999, -27.3451601],
      [30.8266599, -27.3452801],
      [30.8258699, -27.3454101],
      [30.8256699, -27.3454201],
      [30.8247299, -27.3454101],
      [30.8239399, -27.3453801],
      [30.8237699, -27.3454101],
      [30.8236199, -27.3454901],
      [30.8234599, -27.3456201],
      [30.8233399, -27.3458101],
      [30.8232399, -27.3461701],
      [30.8232099, -27.3466601],
      [30.8232099, -27.3470301],
      [30.8232699, -27.3478401],
      [30.8232799, -27.3481801],
      [30.8232899, -27.3489801],
      [30.8232499, -27.3493201],
      [30.8233099, -27.3498301],
      [30.8233899, -27.3502501],
      [30.8233899, -27.3503501],
      [30.8232999, -27.3505801],
      [30.8231099, -27.3508901],
      [30.8227499, -27.3512801],
      [30.8222899, -27.3519101],
      [30.8220899, -27.3523401],
      [30.8219499, -27.3527601],
      [30.8218999, -27.3530301],
      [30.8219199, -27.3534101],
      [30.8219499, -27.3535701],
      [30.8219899, -27.3537401],
      [30.8220799, -27.3539101],
      [30.8222299, -27.3541201],
      [30.8223399, -27.3541601],
      [30.8224499, -27.3541801],
      [30.8225899, -27.3541801],
      [30.8228099, -27.3541001],
      [30.8232499, -27.3539001],
      [30.8239099, -27.3535601],
      [30.8241199, -27.3534801],
      [30.8242699, -27.3534001],
      [30.8245299, -27.3531801],
      [30.8247199, -27.3530701],
      [30.8254699, -27.3527501],
      [30.8257799, -27.3526001],
      [30.8266399, -27.3520701],
      [30.8278499, -27.3512201],
      [30.8292799, -27.3503401],
      [30.8296799, -27.3501501],
      [30.8298899, -27.3500801],
      [30.8301899, -27.3500301],
      [30.8305199, -27.3500201],
      [30.8307299, -27.3500601],
      [30.8309399, -27.3501501],
      [30.8311899, -27.3503101],
      [30.8316099, -27.3504101],
      [30.8324699, -27.3504501],
      [30.8328099, -27.3504301],
      [30.8343899, -27.3504901],
      [30.8347099, -27.3504901],
      [30.8351599, -27.3505301],
      [30.8355699, -27.3504901],
      [30.8360099, -27.3503901],
      [30.8367999, -27.3501501],
      [30.8372499, -27.3500501],
      [30.8378299, -27.3500401],
      [30.8379899, -27.3500901],
      [30.8382599, -27.3502301],
      [30.8385799, -27.3505801],
      [30.8387299, -27.3507001],
      [30.8388599, -27.3507701],
      [30.8395099, -27.3512801],
      [30.8396999, -27.3514901],
      [30.8398999, -27.3516801],
      [30.8405699, -27.3522101],
      [30.8410499, -27.3526301],
      [30.8412199, -27.3528001],
      [30.8413599, -27.3528701],
      [30.8414999, -27.3529201],
      [30.8416999, -27.3529501],
      [30.8422899, -27.3528601],
      [30.8425099, -27.3528401],
      [30.8426799, -27.3528401],
      [30.8429199, -27.3528701],
      [30.8431599, -27.3528701],
      [30.8434099, -27.3528301],
      [30.8437099, -27.3527401],
      [30.8439999, -27.3526101],
      [30.8442199, -27.3524401],
      [30.8445899, -27.3520901],
      [30.8447299, -27.3519201],
      [30.8448199, -27.3517501],
      [30.8448699, -27.3515301],
      [30.8448199, -27.3507001],
      [30.8448399, -27.3502701],
      [30.8448199, -27.3499901],
      [30.8447799, -27.3497101],
      [30.8446899, -27.3487601],
      [30.8445999, -27.3481901],
      [30.8445399, -27.3476301],
      [30.8445299, -27.3468801],
      [30.8445699, -27.3466401],
      [30.8446799, -27.3463801],
      [30.8447899, -27.3461701],
      [30.8448799, -27.3460601],
      [30.8453399, -27.3458501],
      [30.8458499, -27.3456601],
      [30.8462199, -27.3454701],
      [30.8468399, -27.3450501],
      [30.8471599, -27.3448101],
      [30.8476899, -27.3445301],
      [30.8479199, -27.3444401],
      [30.8481499, -27.3443101],
      [30.8485999, -27.3440901],
      [30.8490799, -27.3438101],
      [30.8495099, -27.3434901],
      [30.8497599, -27.3433401],
      [30.8498999, -27.3432901],
      [30.8502499, -27.3432301],
      [30.8504699, -27.3432201],
      [30.8510399, -27.3431401],
      [30.8515399, -27.3431001],
      [30.8517799, -27.3431001],
      [30.8520099, -27.3431201],
      [30.8521799, -27.3432001],
      [30.8525699, -27.3435601],
      [30.8527399, -27.3437501],
      [30.8531499, -27.3440701],
      [30.8533899, -27.3442201],
      [30.8538699, -27.3444001],
      [30.8542699, -27.3444301],
      [30.8545399, -27.3444001],
      [30.8550999, -27.3443701],
      [30.8556999, -27.3443801],
      [30.8558899, -27.3443601],
      [30.8560499, -27.3443101],
      [30.8569499, -27.3438001],
      [30.8572099, -27.3436301],
      [30.8575899, -27.3433001],
      [30.8577799, -27.3429601],
      [30.8579199, -27.3425501],
      [30.8579599, -27.3423701],
      [30.8579599, -27.3422101],
      [30.8577599, -27.3418801],
      [30.8576199, -27.3417201],
      [30.8573799, -27.3412801],
      [30.8572299, -27.3410901],
      [30.8568999, -27.3401501],
      [30.8566099, -27.3394901],
      [30.8564699, -27.3390801],
      [30.8563899, -27.3389101],
      [30.8562199, -27.3383601],
      [30.8561199, -27.3381101],
      [30.8559599, -27.3378001],
      [30.8558999, -27.3376501],
      [30.8558599, -27.3374301],
      [30.8557999, -27.3372501],
      [30.8558899, -27.3370001],
      [30.8560399, -27.3369101],
      [30.8561399, -27.3368801],
      [30.8563199, -27.3367801],
      [30.8564299, -27.3367001],
      [30.8566999, -27.3365901],
      [30.8568299, -27.3365701],
      [30.8573499, -27.3366601],
      [30.8577699, -27.3367101],
      [30.8579399, -27.3367601],
      [30.8580899, -27.3368301],
      [30.8581999, -27.3369301],
      [30.8582099, -27.3370401],
      [30.8581199, -27.3371901],
      [30.8580499, -27.3372401],
      [30.8580099, -27.3373001],
      [30.8580099, -27.3373901],
      [30.8580699, -27.3375201],
      [30.8581999, -27.3376701],
      [30.8583399, -27.3378001],
      [30.8588299, -27.3381401],
      [30.8590699, -27.3382501],
      [30.8592599, -27.3383601],
      [30.8594499, -27.3385101],
      [30.8597099, -27.3388001],
      [30.8598699, -27.3389201],
      [30.8601599, -27.3390701],
      [30.8604499, -27.3391601],
      [30.8607499, -27.3391701],
      [30.8610299, -27.3391401],
      [30.8613099, -27.3390701],
      [30.8614899, -27.3389601],
      [30.8616399, -27.3387901],
      [30.8617399, -27.3386501],
      [30.8618399, -27.3384601],
      [30.8619099, -27.3381001],
      [30.8620999, -27.3377501],
      [30.8621199, -27.3375801],
      [30.8620799, -27.3374101],
      [30.8618299, -27.3371101],
      [30.8617299, -27.3369101],
      [30.8614899, -27.3362501],
      [30.8613699, -27.3358201],
      [30.8612999, -27.3354601],
      [30.8613099, -27.3352701],
      [30.8613699, -27.3350001],
      [30.8615899, -27.3344501],
      [30.8616599, -27.3342101],
      [30.8617699, -27.3339601],
      [30.8618699, -27.3337801],
      [30.8620899, -27.3335201],
      [30.8626099, -27.3332101],
      [30.8629099, -27.3330801],
      [30.8632499, -27.3329701],
      [30.8641599, -27.3324401],
      [30.8645299, -27.3321801],
      [30.8646499, -27.3320701],
      [30.8648199, -27.3317801],
      [30.8648399, -27.3316301],
      [30.8648199, -27.3313601],
      [30.8648799, -27.3307401],
      [30.8650899, -27.3299501],
      [30.8651299, -27.3296201],
      [30.8651299, -27.3279301],
      [30.8651099, -27.3277301],
      [30.8650399, -27.3273801],
      [30.8648899, -27.3268201],
      [30.8646899, -27.3264401],
      [30.8642599, -27.3257201],
      [30.8637999, -27.3250801],
      [30.8636599, -27.3247501],
      [30.8635899, -27.3244801],
      [30.8635582, -27.3242785],
      [30.8635299, -27.3241001],
      [30.8635299, -27.3237201],
      [30.8634799, -27.3233301],
      [30.8634999, -27.3229901],
      [30.8635399, -27.3227901],
      [30.8636199, -27.3225701],
      [30.8639399, -27.3219601],
      [30.8639599, -27.3217801],
      [30.8638799, -27.3210101],
      [30.8638199, -27.3206401],
      [30.8637499, -27.3204301],
      [30.8636799, -27.3200201],
      [30.8636599, -27.3198201],
      [30.8636699, -27.3196201],
      [30.8636799, -27.3194501],
      [30.8637799, -27.3189401],
      [30.8637899, -27.3187301],
      [30.8640399, -27.3176401],
      [30.8640699, -27.3174501],
      [30.8641299, -27.3167901],
      [30.8642799, -27.3156601],
      [30.8643899, -27.3152201],
      [30.8645599, -27.3147401],
      [30.8646999, -27.3142501],
      [30.8647699, -27.3140601],
      [30.8649499, -27.3137101],
      [30.8653599, -27.3131401],
      [30.8656699, -27.3128501],
      [30.8659099, -27.3126701],
      [30.8660499, -27.3126201],
      [30.8661399, -27.3126201],
      [30.8662399, -27.3126501],
      [30.8664499, -27.3127801],
      [30.8670099, -27.3128901],
      [30.8672999, -27.3129101],
      [30.8684999, -27.3129001],
      [30.8691199, -27.3129801],
      [30.8693299, -27.3130301],
      [30.8699699, -27.3132401],
      [30.8702099, -27.3133601],
      [30.8704899, -27.3135501],
      [30.8707899, -27.3136201],
      [30.8709899, -27.3136501],
      [30.8714999, -27.3138301],
      [30.8717699, -27.3139601],
      [30.8723399, -27.3143401],
      [30.8725799, -27.3144501],
      [30.8727099, -27.3144701],
      [30.8736399, -27.3144201],
      [30.8742799, -27.3143501],
      [30.8745399, -27.3143401],
      [30.8747999, -27.3143501],
      [30.8750299, -27.3143301],
      [30.8751999, -27.3143101],
      [30.8753899, -27.3142501],
      [30.8761599, -27.3141701],
      [30.8766399, -27.3140601],
      [30.8768799, -27.3140201],
      [30.8772399, -27.3139301],
      [30.8778399, -27.3137501],
      [30.8794897, -27.313191],
      [30.8796399, -27.3131401],
      [30.8807999, -27.3128101],
      [30.8810001, -27.3127465],
      [30.8818699, -27.3124701],
      [30.8820999, -27.3123701],
      [30.8822099, -27.3123001],
      [30.8823399, -27.3120101],
      [30.8823999, -27.3117101],
      [30.8828399, -27.3107401],
      [30.8830599, -27.3101801],
      [30.8831399, -27.3099201],
      [30.8834399, -27.3092401],
      [30.8835599, -27.3090601],
      [30.8836599, -27.3089501],
      [30.8837999, -27.3088401],
      [30.8839199, -27.3087901],
      [30.8840999, -27.3087501],
      [30.8842299, -27.3087601],
      [30.8844099, -27.3088201],
      [30.8845399, -27.3089201],
      [30.8846699, -27.3090501],
      [30.8849199, -27.3093901],
      [30.8852099, -27.3096001],
      [30.8853499, -27.3097301],
      [30.8859099, -27.3103801],
      [30.8861999, -27.3106101],
      [30.8863499, -27.3107101],
      [30.8865999, -27.3108101],
      [30.8867299, -27.3108201],
      [30.8869199, -27.3107901],
      [30.8872699, -27.3105801],
      [30.8876399, -27.3103901],
      [30.8882299, -27.3100301],
      [30.8887699, -27.3098401],
      [30.8892099, -27.3097701],
      [30.8899299, -27.3098001],
      [30.8904499, -27.3098401],
      [30.8908699, -27.3098401],
      [30.8910899, -27.3098201],
      [30.8913999, -27.3097201],
      [30.8916699, -27.3096001],
      [30.8925599, -27.3091901],
      [30.8927899, -27.3090601],
      [30.8931699, -27.3089101],
      [30.8933499, -27.3088701],
      [30.8935499, -27.3088501],
      [30.8936999, -27.3088801],
      [30.8939399, -27.3089701],
      [30.8941499, -27.3090101],
      [30.8944399, -27.3090401],
      [30.8958399, -27.3092601],
      [30.8967599, -27.3093801],
      [30.8968799, -27.3093901],
      [30.8970599, -27.3093801],
      [30.8974799, -27.3092801],
      [30.8976299, -27.3091901],
      [30.8979099, -27.3088601],
      [30.8981399, -27.3086501],
      [30.8985399, -27.3084501],
      [30.8987799, -27.3083901],
      [30.8993099, -27.3083301],
      [30.9004099, -27.3082401],
      [30.9014299, -27.3082201],
      [30.9021299, -27.3081401],
      [30.9023299, -27.3081001],
      [30.9025299, -27.3080201],
      [30.9028599, -27.3077801],
      [30.9030099, -27.3076201],
      [30.9032999, -27.3073601],
      [30.9034399, -27.3072201],
      [30.9036999, -27.3068801],
      [30.9038599, -27.3067001],
      [30.9043599, -27.3063201],
      [30.9047599, -27.3061201],
      [30.9054299, -27.3058801],
      [30.9057999, -27.3057201],
      [30.9060499, -27.3056401],
      [30.9062299, -27.3055601],
      [30.9064699, -27.3055201],
      [30.9069199, -27.3054801],
      [30.9072499, -27.3054801],
      [30.9076099, -27.3054501],
      [30.9084499, -27.3053401],
      [30.9091299, -27.3053101],
      [30.9094699, -27.3053501],
      [30.9097199, -27.3054401],
      [30.9098099, -27.3055001],
      [30.9098599, -27.3056301],
      [30.9098199, -27.3060801],
      [30.9098199, -27.3063501],
      [30.9098499, -27.3064801],
      [30.9100699, -27.3069701],
      [30.9101799, -27.3071501],
      [30.9104299, -27.3074801],
      [30.9108199, -27.3078401],
      [30.9111499, -27.3080701],
      [30.9113099, -27.3081301],
      [30.9114699, -27.3081501],
      [30.9116299, -27.3081501],
      [30.9118199, -27.3081001],
      [30.9119399, -27.3079601],
      [30.9120699, -27.3077301],
      [30.9128299, -27.3071201],
      [30.9132299, -27.3067401],
      [30.9136099, -27.3064101],
      [30.9138399, -27.3062601],
      [30.9142999, -27.3060401],
      [30.9147099, -27.3058701],
      [30.9152999, -27.3055201],
      [30.9154899, -27.3054401],
      [30.9156799, -27.3054001],
      [30.9160999, -27.3054101],
      [30.9168699, -27.3053101],
      [30.9173699, -27.3052101],
      [30.9182999, -27.3051101],
      [30.9192399, -27.3050901],
      [30.9204799, -27.3051201],
      [30.9217299, -27.3050501],
      [30.9221599, -27.3050501],
      [30.9228499, -27.3051301],
      [30.9230999, -27.3052101],
      [30.9233999, -27.3053601],
      [30.9236299, -27.3055901],
      [30.92367, -27.305647],
      [30.9237399, -27.3057501],
      [30.9238499, -27.3059601],
      [30.9238899, -27.3061201],
      [30.9238799, -27.3063101],
      [30.9238399, -27.3063801],
      [30.9237299, -27.3064801],
      [30.9236399, -27.3065301],
      [30.9234999, -27.3066601],
      [30.9233599, -27.3068801],
      [30.9233599, -27.3073501],
      [30.9236599, -27.3090701],
      [30.9236799, -27.3092501],
      [30.9237899, -27.3096701],
      [30.9241099, -27.3105101],
      [30.9243699, -27.3109901],
      [30.9244499, -27.3112101],
      [30.9244699, -27.3113101],
      [30.9244699, -27.3114401],
      [30.9244399, -27.3115901],
      [30.9242699, -27.3121901],
      [30.9241299, -27.3125701],
      [30.9239099, -27.3129501],
      [30.9235899, -27.3133701],
      [30.9233299, -27.3136601],
      [30.9230199, -27.3139401],
      [30.9228799, -27.3141401],
      [30.9228399, -27.3142301],
      [30.9227999, -27.3144201],
      [30.9227599, -27.3148401],
      [30.9226999, -27.3151601],
      [30.9226399, -27.3152501],
      [30.9225099, -27.3153701],
      [30.9223399, -27.3154901],
      [30.9219199, -27.3157401],
      [30.9216899, -27.3158601],
      [30.9215999, -27.3159501],
      [30.9215099, -27.3160701],
      [30.9213599, -27.3163601],
      [30.9213099, -27.3165101],
      [30.9212199, -27.3167001],
      [30.9210799, -27.3172201],
      [30.9210199, -27.3176101],
      [30.9209699, -27.3184601],
      [30.9209699, -27.3186601],
      [30.9211399, -27.3193701],
      [30.9211899, -27.3195001],
      [30.9212199, -27.3196701],
      [30.9213099, -27.3199801],
      [30.9213799, -27.3200901],
      [30.9214599, -27.3202001],
      [30.9215599, -27.3203001],
      [30.9221699, -27.3208701],
      [30.9223599, -27.3210101],
      [30.9228199, -27.3213001],
      [30.9229199, -27.3213301],
      [30.9230299, -27.3214101],
      [30.9231299, -27.3215101],
      [30.9231899, -27.3216001],
      [30.9232199, -27.3216801],
      [30.9232399, -27.3218101],
      [30.9232599, -27.3220701],
      [30.9232499, -27.3222801],
      [30.9232699, -27.3229801],
      [30.9234199, -27.3234801],
      [30.9237399, -27.3242001],
      [30.9239599, -27.3246201],
      [30.9240399, -27.3247501],
      [30.9242499, -27.3250101],
      [30.9243299, -27.3251501],
      [30.9243899, -27.3252901],
      [30.9244599, -27.3255301],
      [30.9244599, -27.3257501],
      [30.9244199, -27.3259201],
      [30.9243499, -27.3260901],
      [30.9242699, -27.3262301],
      [30.9241599, -27.3263701],
      [30.9238799, -27.3269601],
      [30.9237399, -27.3274701],
      [30.9236099, -27.3283001],
      [30.9234899, -27.3286101],
      [30.9232899, -27.3289901],
      [30.9232299, -27.3292001],
      [30.92323, -27.3292542],
      [30.9232299, -27.3295301],
      [30.9231999, -27.3299001],
      [30.9232099, -27.3301401],
      [30.9232799, -27.3304501],
      [30.9233399, -27.3306201],
      [30.9234899, -27.3309401],
      [30.9236799, -27.3312701],
      [30.9243699, -27.3321501],
      [30.9248499, -27.3327001],
      [30.9254399, -27.3333001],
      [30.9258699, -27.3336701],
      [30.9260699, -27.3338801],
      [30.9263099, -27.3340801],
      [30.9268599, -27.3344901],
      [30.9275199, -27.3350801],
      [30.9276299, -27.3352001],
      [30.9278099, -27.3353601],
      [30.9281299, -27.3357801],
      [30.9281899, -27.3359101],
      [30.9282899, -27.3362201],
      [30.9282899, -27.3364501],
      [30.9283199, -27.3366801],
      [30.9283699, -27.3368201],
      [30.9286299, -27.3372401],
      [30.9290999, -27.3379001],
      [30.9295299, -27.3383901],
      [30.9299699, -27.3388601],
      [30.9306299, -27.3395601],
      [30.9314199, -27.3403601],
      [30.9315299, -27.3404901],
      [30.9316699, -27.3406201],
      [30.9323099, -27.3411401],
      [30.9329699, -27.3417301],
      [30.9331899, -27.3419001],
      [30.9333699, -27.3420801],
      [30.9337699, -27.3423601],
      [30.9343199, -27.3427801],
      [30.9350099, -27.3433201],
      [30.9353199, -27.3436001],
      [30.9354799, -27.3437201],
      [30.9358999, -27.3440001],
      [30.9361099, -27.3441201],
      [30.9361399, -27.3441201],
      [30.9367099, -27.3443701],
      [30.9374999, -27.3446401],
      [30.9379399, -27.3448701],
      [30.9381899, -27.3450701],
      [30.9386199, -27.3454801],
      [30.9389799, -27.3459601],
      [30.9391599, -27.3462501],
      [30.9392299, -27.3464101],
      [30.9393299, -27.3465701],
      [30.9394199, -27.3467601],
      [30.9395199, -27.3471001],
      [30.9395899, -27.3475301],
      [30.9396199, -27.3478201],
      [30.9396499, -27.3481301],
      [30.9396699, -27.3488001],
      [30.9396699, -27.3493201],
      [30.9396299, -27.3495201],
      [30.9394799, -27.3499001],
      [30.9394099, -27.3501701],
      [30.9392199, -27.3506301],
      [30.9391499, -27.3507601],
      [30.9387899, -27.3510101],
      [30.9385399, -27.3512901],
      [30.9382699, -27.3516701],
      [30.9381099, -27.3520401],
      [30.9380599, -27.3522801],
      [30.9379299, -27.3527501],
      [30.9378499, -27.3529501],
      [30.9378199, -27.3531701],
      [30.9378099, -27.3533601],
      [30.9378499, -27.3538501],
      [30.9379099, -27.3541201],
      [30.9379499, -27.3544201],
      [30.9379999, -27.3545701],
      [30.9380299, -27.3547501],
      [30.9380699, -27.3554101],
      [30.9380699, -27.3557401],
      [30.9381399, -27.3562001],
      [30.9381899, -27.3567501],
      [30.9382799, -27.3570701],
      [30.9386299, -27.3575801],
      [30.9390399, -27.3580701],
      [30.9391699, -27.3581901],
      [30.9394199, -27.3583301],
      [30.9396299, -27.3584401],
      [30.9402799, -27.3587201],
      [30.9406399, -27.3589301],
      [30.9407699, -27.3590401],
      [30.9408799, -27.3591601],
      [30.9411099, -27.3595601],
      [30.9411299, -27.3596701],
      [30.9412999, -27.3600801],
      [30.9413299, -27.3602301],
      [30.9413599, -27.3605101],
      [30.9413199, -27.3608601],
      [30.9412399, -27.3610701],
      [30.9409799, -27.3615401],
      [30.9406999, -27.3622801],
      [30.9405899, -27.3626601],
      [30.9404699, -27.3634501],
      [30.9404499, -27.3639801],
      [30.9404599, -27.3649901],
      [30.9405499, -27.3657601],
      [30.9405999, -27.3659901],
      [30.9406199, -27.3661901],
      [30.9408199, -27.3668401],
      [30.9408399, -27.3669501],
      [30.9410099, -27.3672201],
      [30.9414099, -27.3676501],
      [30.9416799, -27.3678601],
      [30.9419999, -27.3680401],
      [30.9424399, -27.3681601],
      [30.9426799, -27.3682001],
      [30.9429699, -27.3682001],
      [30.9432013, -27.3681587],
      [30.9436999, -27.3680601],
      [30.9443499, -27.3678601],
      [30.9450699, -27.3675501],
      [30.9456199, -27.3672401],
      [30.9459499, -27.3671001],
      [30.9466399, -27.3667501],
      [30.9474599, -27.3663801],
      [30.9480299, -27.3660801],
      [30.9489699, -27.3653201],
      [30.9496499, -27.3645801],
      [30.9498599, -27.3643001],
      [30.9502999, -27.3637801],
      [30.9506399, -27.3632701],
      [30.9507899, -27.3629901],
      [30.9509199, -27.3628101],
      [30.9510999, -27.3624901],
      [30.9513299, -27.3622001],
      [30.9514899, -27.3620401],
      [30.9518599, -27.3617801],
      [30.9520199, -27.3616501],
      [30.9523299, -27.3614701],
      [30.9532799, -27.3606801],
      [30.9535599, -27.3603901],
      [30.9538199, -27.3602101],
      [30.9540499, -27.3600901],
      [30.9548499, -27.3598201],
      [30.9550099, -27.3597701],
      [30.9553799, -27.3597101],
      [30.9556099, -27.3597001],
      [30.9557899, -27.3597101],
      [30.9562599, -27.3597901],
      [30.9566899, -27.3599101],
      [30.9572499, -27.3601101],
      [30.9574299, -27.3602101],
      [30.9578099, -27.3603801],
      [30.9580799, -27.3605601],
      [30.9581799, -27.3606701],
      [30.9582899, -27.3608301],
      [30.9584799, -27.3612001],
      [30.9585799, -27.3613601],
      [30.9587299, -27.3617601],
      [30.9589899, -27.3623201],
      [30.9590399, -27.3625001],
      [30.9594899, -27.3635501],
      [30.9596999, -27.3638601],
      [30.9598999, -27.3640701],
      [30.9600299, -27.3641901],
      [30.9602399, -27.3643501],
      [30.9612699, -27.3649401],
      [30.9623399, -27.3656401],
      [30.9624899, -27.3657101],
      [30.9626499, -27.3657601],
      [30.9631099, -27.3657801],
      [30.9635699, -27.3656501],
      [30.9640499, -27.3655501],
      [30.9651499, -27.3653901],
      [30.9654099, -27.3653401],
      [30.9660399, -27.3651901],
      [30.9663799, -27.3650901],
      [30.9669799, -27.3648601],
      [30.9672299, -27.3647501],
      [30.9674199, -27.3646401],
      [30.9677199, -27.3645001],
      [30.9679399, -27.3643701],
      [30.9681399, -27.3642801],
      [30.9684299, -27.3641001],
      [30.9686499, -27.3640001],
      [30.9690499, -27.3637601],
      [30.9697299, -27.3634301],
      [30.9700299, -27.3633101],
      [30.9702599, -27.3631801],
      [30.9704499, -27.3630501],
      [30.9709899, -27.3626201],
      [30.9713299, -27.3623901],
      [30.9718199, -27.3621001],
      [30.9722099, -27.3618401],
      [30.9725599, -27.3615401],
      [30.9727299, -27.3613601],
      [30.9730599, -27.3610701],
      [30.9734999, -27.3607601],
      [30.9738599, -27.3604701],
      [30.9747399, -27.3598601],
      [30.9750299, -27.3596401],
      [30.9754199, -27.3593101],
      [30.9759299, -27.3590101],
      [30.9761499, -27.3588601],
      [30.9770699, -27.3581601],
      [30.9772099, -27.3580801],
      [30.9773699, -27.3580401],
      [30.9777699, -27.3580301],
      [30.9779299, -27.3580401],
      [30.9781499, -27.3581001],
      [30.9792799, -27.3586901],
      [30.9801599, -27.3590001],
      [30.9806899, -27.3591501],
      [30.9810399, -27.3591901],
      [30.9814899, -27.3592201],
      [30.9816599, -27.3592201],
      [30.9818699, -27.3591801],
      [30.9822399, -27.3590701],
      [30.9826099, -27.3589201],
      [30.9833299, -27.3585601],
      [30.9835999, -27.3583301],
      [30.9838899, -27.3580201],
      [30.9840399, -27.3579301],
      [30.9841399, -27.3578501],
      [30.9841999, -27.3577601],
      [30.9842199, -27.3577001],
      [30.9843099, -27.3575901],
      [30.9844499, -27.3575101],
      [30.9845499, -27.3574801],
      [30.9846999, -27.3574601],
      [30.9854499, -27.3574601],
      [30.9856299, -27.3574901],
      [30.9860199, -27.3575201],
      [30.9863099, -27.3575001],
      [30.9868499, -27.3574901],
      [30.9871399, -27.3575001],
      [30.9876899, -27.3574901],
      [30.9883099, -27.3574601],
      [30.9887299, -27.3574701],
      [30.9889299, -27.3574901],
      [30.9893399, -27.3575601],
      [30.9899599, -27.3576801],
      [30.9906799, -27.3577801],
      [30.9909499, -27.3578001],
      [30.9913699, -27.3578701],
      [30.9917999, -27.3578901],
      [30.9937399, -27.3580501],
      [30.9943899, -27.3580401],
      [30.9949299, -27.3580501],
      [30.9951899, -27.3580801],
      [30.9956799, -27.3581001],
      [30.9962299, -27.3581501],
      [30.9971699, -27.3583001],
      [30.9977199, -27.3584401],
      [30.9981199, -27.3585801],
      [30.9982199, -27.3586001],
      [30.9987299, -27.3586801],
      [30.9988899, -27.3586901],
      [30.9990999, -27.3587401],
      [30.9996199, -27.3588101],
      [31.0007899, -27.3588901],
      [31.0016899, -27.3589001],
      [31.0022499, -27.3588601],
      [31.0025499, -27.3587901],
      [31.0028099, -27.3586801],
      [31.0030299, -27.3585301],
      [31.0031799, -27.3583801],
      [31.0032899, -27.3582101],
      [31.0034099, -27.3578101],
      [31.0034399, -27.3571801],
      [31.0035199, -27.3567801],
      [31.0035599, -27.3562001],
      [31.0036099, -27.3558601],
      [31.0036699, -27.3556501],
      [31.0039299, -27.3550901],
      [31.0043199, -27.3547301],
      [31.0044499, -27.3545801],
      [31.0045499, -27.3544201],
      [31.0047899, -27.3541701],
      [31.0048899, -27.3540301],
      [31.0049699, -27.3538801],
      [31.0051099, -27.3537001],
      [31.0051599, -27.3532901],
      [31.0051099, -27.3529201],
      [31.0051199, -27.3527801],
      [31.0050899, -27.3521101],
      [31.0050999, -27.3519101],
      [31.0051299, -27.3517301],
      [31.0052099, -27.3515401],
      [31.0054499, -27.3511801],
      [31.0054799, -27.3510801],
      [31.0056599, -27.3509301],
      [31.0058499, -27.3507401],
      [31.0062499, -27.3501801],
      [31.0066699, -27.3497701],
      [31.0069999, -27.3495201],
      [31.0072799, -27.3493601],
      [31.0078399, -27.3489701],
      [31.0081299, -27.3488201],
      [31.0084299, -27.3487601],
      [31.0099699, -27.3487901],
      [31.0102599, -27.3488801],
      [31.0106199, -27.3490801],
      [31.0108999, -27.3494401],
      [31.0111199, -27.3497601],
      [31.0114699, -27.3501101],
      [31.0115899, -27.3503001],
      [31.0116899, -27.3504901],
      [31.0120599, -27.3513101],
      [31.0121199, -27.3515301],
      [31.0125299, -27.3524701],
      [31.0128499, -27.3530601],
      [31.0130499, -27.3536701],
      [31.0133199, -27.3540201],
      [31.0135499, -27.3543701],
      [31.0136299, -27.3545001],
      [31.0137899, -27.3548401],
      [31.0139099, -27.3550301],
      [31.0140599, -27.3551901],
      [31.0145099, -27.3555801],
      [31.0147499, -27.3557301],
      [31.0151199, -27.3560101],
      [31.0155099, -27.3563201],
      [31.0158199, -27.3566001],
      [31.0160099, -27.3567501],
      [31.0164399, -27.3569701],
      [31.0166699, -27.3571201],
      [31.0168599, -27.3572801],
      [31.0170099, -27.3574401],
      [31.0171899, -27.3576001],
      [31.0175299, -27.3580101],
      [31.0180399, -27.3588601],
      [31.0183199, -27.3592901],
      [31.0184799, -27.3595901],
      [31.0186099, -27.3597901],
      [31.0189299, -27.3601501],
      [31.0191099, -27.3603001],
      [31.0193399, -27.3604401],
      [31.0196699, -27.3605501],
      [31.0200599, -27.3606301],
      [31.0202899, -27.3606501],
      [31.0205499, -27.3606101],
      [31.0208699, -27.3604201],
      [31.0209999, -27.3602601],
      [31.0210799, -27.3601301],
      [31.0211299, -27.3599501],
      [31.0211499, -27.3597601],
      [31.0212099, -27.3595001],
      [31.0214299, -27.3589201],
      [31.0216399, -27.3585101],
      [31.0216999, -27.3583601],
      [31.0217799, -27.3580101],
      [31.0218699, -27.3577701],
      [31.0222399, -27.3569501],
      [31.0226099, -27.3560301],
      [31.0228699, -27.3555301],
      [31.0230799, -27.3549701],
      [31.0231299, -27.3547601],
      [31.0231899, -27.3546001],
      [31.0233999, -27.3541401],
      [31.0236699, -27.3531901],
      [31.0240399, -27.3523901],
      [31.0242199, -27.3520301],
      [31.0243299, -27.3518601],
      [31.0244899, -27.3517201],
      [31.0246299, -27.3516601],
      [31.0247799, -27.3516401],
      [31.0250499, -27.3516401],
      [31.0252999, -27.3516001],
      [31.0254699, -27.3515401],
      [31.0256099, -27.3515101],
      [31.0260799, -27.3512801],
      [31.0265899, -27.3509801],
      [31.0270099, -27.3507101],
      [31.0271899, -27.3506101],
      [31.0273499, -27.3504801],
      [31.0276699, -27.3502101],
      [31.0279699, -27.3499301],
      [31.0280999, -27.3497701],
      [31.0281999, -27.3496101],
      [31.0283899, -27.3493601],
      [31.0287599, -27.3489401],
      [31.0291299, -27.3483501],
      [31.0291999, -27.3481901],
      [31.0292399, -27.3480101],
      [31.0293399, -27.3477201],
      [31.0295499, -27.3474801],
      [31.0296699, -27.3472101],
      [31.0297899, -27.3470701],
      [31.0299299, -27.3469401],
      [31.0303499, -27.3466101],
      [31.0308999, -27.3463201],
      [31.0311799, -27.3462401],
      [31.0316899, -27.3462001],
      [31.0318699, -27.3462001],
      [31.0323299, -27.3461301],
      [31.0325599, -27.3460801],
      [31.0327199, -27.3460301],
      [31.0331099, -27.3458601],
      [31.0335299, -27.3457201],
      [31.0336599, -27.3457001],
      [31.0338499, -27.3456801],
      [31.0344799, -27.3457201],
      [31.0347499, -27.3457201],
      [31.0349499, -27.3458201],
      [31.0350999, -27.3460001],
      [31.0353299, -27.3464401],
      [31.0353899, -27.3465901],
      [31.0354799, -27.3469201],
      [31.0356299, -27.3471201],
      [31.0358199, -27.3475701],
      [31.0360099, -27.3479701],
      [31.0360999, -27.3485201],
      [31.0361599, -27.3486901],
      [31.0364599, -27.3491401],
      [31.0366499, -27.3495201],
      [31.0369599, -27.3500001],
      [31.0374799, -27.3506401],
      [31.0378899, -27.3513601],
      [31.0379999, -27.3514701],
      [31.0382299, -27.3516401],
      [31.0384499, -27.3517401],
      [31.0390199, -27.3522101],
      [31.0392699, -27.3523701],
      [31.0394999, -27.3525001],
      [31.0401499, -27.3528001],
      [31.0403699, -27.3528801],
      [31.0406299, -27.3529601],
      [31.0408799, -27.3530101],
      [31.0412399, -27.3531101],
      [31.0422999, -27.3533101],
      [31.0425099, -27.3533301],
      [31.0426599, -27.3533601],
      [31.0429699, -27.3533801],
      [31.0432399, -27.3533801],
      [31.0434499, -27.3533701],
      [31.0437299, -27.3533301],
      [31.0440399, -27.3532601],
      [31.0444699, -27.3531101],
      [31.0447299, -27.3530001],
      [31.0451699, -27.3527401],
      [31.0453399, -27.3526001],
      [31.0458599, -27.3522601],
      [31.0460399, -27.3520901],
      [31.0462299, -27.3518801],
      [31.0463799, -27.3516301],
      [31.0466299, -27.3511101],
      [31.0468999, -27.3501501],
      [31.0469899, -27.3498501],
      [31.0470999, -27.3495701],
      [31.0471699, -27.3493001],
      [31.0473099, -27.3486601],
      [31.0473399, -27.3484001],
      [31.0473899, -27.3481701],
      [31.0474799, -27.3479201],
      [31.0476799, -27.3475601],
      [31.0477799, -27.3473001],
      [31.0479399, -27.3466601],
      [31.0483599, -27.3453401],
      [31.0484399, -27.3451301],
      [31.0486799, -27.3447201],
      [31.0488399, -27.3445201],
      [31.0491499, -27.3442101],
      [31.0493599, -27.3440401],
      [31.0497999, -27.3437401],
      [31.0499599, -27.3436601],
      [31.0504999, -27.3433401],
      [31.0507599, -27.3432201],
      [31.0511699, -27.3431101],
      [31.0523299, -27.3426101],
      [31.0535899, -27.3421301],
      [31.0541399, -27.3418601],
      [31.0552199, -27.3414401],
      [31.0567599, -27.3407601],
      [31.0579199, -27.3402801],
      [31.0587299, -27.3399201],
      [31.0595899, -27.3396301],
      [31.0604499, -27.3394001],
      [31.0607999, -27.3393201],
      [31.0614999, -27.3391101],
      [31.0618399, -27.3390401],
      [31.0621299, -27.3389501],
      [31.0624299, -27.3388901],
      [31.0626499, -27.3388201],
      [31.0629299, -27.3387701],
      [31.0631999, -27.3387001],
      [31.0640299, -27.3385701],
      [31.0642799, -27.3384901],
      [31.0647199, -27.3383901],
      [31.0651899, -27.3383301],
      [31.0656499, -27.3383301],
      [31.0658799, -27.3383501],
      [31.0665799, -27.3385501],
      [31.0669199, -27.3386901],
      [31.0674299, -27.3388401],
      [31.0677699, -27.3389701],
      [31.0682499, -27.3392301],
      [31.0684999, -27.3393301],
      [31.0686999, -27.3394401],
      [31.0688899, -27.3395601],
      [31.0692199, -27.3398301],
      [31.0697799, -27.3403301],
      [31.0699299, -27.3405101],
      [31.0701499, -27.3407101],
      [31.0703999, -27.3409101],
      [31.0706199, -27.3410701],
      [31.0710199, -27.3412701],
      [31.0715199, -27.3414301],
      [31.0717599, -27.3414901],
      [31.0719799, -27.3415301],
      [31.0722899, -27.3415501],
      [31.0727999, -27.3416201],
      [31.0733799, -27.3418201],
      [31.0747199, -27.3423301],
      [31.0759299, -27.3428501],
      [31.0760999, -27.3429001],
      [31.0773399, -27.3431001],
      [31.0775999, -27.3431701],
      [31.0781999, -27.3431901],
      [31.0785399, -27.3431501],
      [31.0788299, -27.3430901],
      [31.0791199, -27.3429901],
      [31.0794299, -27.3428601],
      [31.0796099, -27.3427201],
      [31.0798999, -27.3423701],
      [31.0801499, -27.3419301],
      [31.0803399, -27.3415201],
      [31.0807399, -27.3409701],
      [31.0808999, -27.3407201],
      [31.0810599, -27.3404501],
      [31.0812299, -27.3401201],
      [31.0813899, -27.3398801],
      [31.0815799, -27.3396501],
      [31.0818499, -27.3393701],
      [31.0819799, -27.3391501],
      [31.0820699, -27.3383301],
      [31.0822599, -27.3377301],
      [31.0827799, -27.3371701],
      [31.0832199, -27.3365801],
      [31.0834099, -27.3362401],
      [31.0836899, -27.3358801],
      [31.0839599, -27.3355901],
      [31.0864499, -27.3348501],
      [31.0875299, -27.3344301],
      [31.0878099, -27.3343401],
      [31.0882199, -27.3341201],
      [31.0886499, -27.3338201],
      [31.0888399, -27.3337201],
      [31.0892899, -27.3335401],
      [31.0896899, -27.3334001],
      [31.0904099, -27.3331901],
      [31.0906699, -27.3330901],
      [31.0915699, -27.3328001],
      [31.0920399, -27.3327001],
      [31.0923899, -27.3326601],
      [31.0926099, -27.3326101],
      [31.0928799, -27.3325101],
      [31.0935199, -27.3321701],
      [31.0944099, -27.3317301],
      [31.0953199, -27.3313301],
      [31.0956799, -27.3311201],
      [31.0962899, -27.3308901],
      [31.0968299, -27.3307601],
      [31.0970199, -27.3306601],
      [31.0972399, -27.3305101],
      [31.0974099, -27.3303201],
      [31.0978099, -27.3299801],
      [31.0980299, -27.3298701],
      [31.0982999, -27.3298001],
      [31.0985799, -27.3297601],
      [31.0987799, -27.3297601],
      [31.0989699, -27.3297901],
      [31.0990999, -27.3298301],
      [31.0992299, -27.3299101],
      [31.0993699, -27.3300301],
      [31.0998299, -27.3305501],
      [31.0999999, -27.3307001],
      [31.1003399, -27.3311101],
      [31.1004899, -27.3313501],
      [31.1009099, -27.3317601],
      [31.1009999, -27.3319001],
      [31.1010399, -27.3320201],
      [31.1012999, -27.3325501],
      [31.1014499, -27.3329301],
      [31.1015599, -27.3331601],
      [31.1016699, -27.3335201],
      [31.1014999, -27.3347801],
      [31.1014399, -27.3350001],
      [31.1013599, -27.3351701],
      [31.10096, -27.33576],
      [31.1011899, -27.3359101],
      [31.1039399, -27.3377601],
      [31.1061847, -27.3392646],
      [31.1066999, -27.3396101],
      [31.1072078, -27.3399498],
      [31.1094499, -27.3414501],
      [31.1121999, -27.3433001],
      [31.1149599, -27.3451501],
      [31.1177099, -27.3469901],
      [31.1204699, -27.3488401],
      [31.1227142, -27.3503416],
      [31.1232199, -27.3506801],
      [31.1259699, -27.3525301],
      [31.1287299, -27.3543801],
      [31.1287598, -27.3544008],
      [31.1289299, -27.3545201],
      [31.1348661, -27.3585686],
      [31.140865, -27.36266],
      [31.1562, -27.3662001],
      [31.1658, -27.3685101],
      [31.16583, -27.3685143],
      [31.16587, -27.36852],
      [31.16848, -27.3650601],
      [31.17111, -27.3616001],
      [31.17373, -27.3581401],
      [31.173925, -27.357882],
      [31.1739422, -27.3578592],
      [31.17635, -27.3546701],
      [31.18159, -27.3477501],
      [31.18422, -27.3442901],
      [31.18684, -27.3408201],
      [31.1920692, -27.3339143],
      [31.1920717, -27.3339109],
      [31.1920799, -27.3339001],
      [31.1922699, -27.3340901],
      [31.19351, -27.3324501],
      [31.19476, -27.3308101],
      [31.19598, -27.3291901],
      [31.19722, -27.3275101],
      [31.19843, -27.3258501],
      [31.19965, -27.3241801],
      [31.20088, -27.3225101],
      [31.2021, -27.3208501],
      [31.20454, -27.3175101],
      [31.20457, -27.3174801],
      [31.20486, -27.3171801],
      [31.2048492, -27.3171746],
      [31.20482, -27.3171601],
      [31.2047699, -27.3171201],
      [31.20484, -27.3170501],
      [31.2245726, -27.2961738],
      [31.2303178, -27.2900957],
      [31.230464, -27.289941],
      [31.240064, -27.279785],
      [31.24039, -27.27944],
      [31.2405034, -27.2793171],
      [31.24051, -27.2793101],
      [31.2405723, -27.2792217],
      [31.24063, -27.2791401],
      [31.24152, -27.27821],
      [31.24402, -27.2757],
      [31.24657, -27.27312],
      [31.24897, -27.2707001],
      [31.2495, -27.2701201],
      [31.25, -27.2693501],
      [31.25047, -27.2688],
      [31.25216, -27.2668601],
      [31.25598, -27.2628],
      [31.25668, -27.26202],
      [31.2577701, -27.2608793],
      [31.25883, -27.25977],
      [31.2606666, -27.2577867],
      [31.26121, -27.2572001],
      [31.2617, -27.25668],
      [31.26445, -27.25375],
      [31.26617, -27.25183],
      [31.2691, -27.24875],
      [31.27195, -27.24574],
      [31.27225, -27.24536],
      [31.27433, -27.2431701],
      [31.27479, -27.24289],
      [31.26784, -27.24056],
      [31.2296573, -27.228141],
      [31.22286, -27.22593],
      [31.2164503, -27.2236373],
      [31.2101235, -27.2215197],
      [31.2022893, -27.2189342],
      [31.1932951, -27.216007],
      [31.15567, -27.20377],
      [31.15353, -27.20306],
      [31.15225, -27.20264],
      [31.15055, -27.20208],
      [31.12477, -27.17153],
      [31.11467, -27.15955],
      [31.10862, -27.15238],
      [31.095416, -27.136715],
      [31.08638, -27.126],
      [31.07512, -27.11275],
      [31.07117, -27.10803],
      [31.0687013, -27.1050872],
      [31.06789, -27.10412],
      [31.06133, -27.09629],
      [31.04846, -27.08706],
      [31.0377422, -27.0796442],
      [31.02176, -27.06778],
      [30.996932, -27.0471134],
      [30.98476, -27.03698],
      [30.984378, -27.036348],
      [30.96986, -27.01234],
      [30.96292, -27.00013],
      [30.958476, -26.992335],
      [30.958326, -26.992129],
      [30.95929, -26.99049],
      [30.95975, -26.98955],
      [30.96051, -26.98824],
      [30.96112, -26.98727],
      [30.96136, -26.98667],
      [30.96153, -26.98644],
      [30.96179, -26.98595],
      [30.96239, -26.98487],
      [30.96261, -26.98448],
      [30.96294, -26.98395],
      [30.96341, -26.98308],
      [30.96367, -26.98254],
      [30.96412, -26.9818],
      [30.96479, -26.98077],
      [30.96492, -26.98032],
      [30.96517, -26.9799],
      [30.96535, -26.97952],
      [30.96594, -26.97842],
      [30.96654, -26.97759],
      [30.96698, -26.9766],
      [30.9673428, -26.9757199],
      [30.9695477, -26.9715993],
      [30.9706947, -26.9695239],
      [30.9726943, -26.9658496],
      [30.9734881, -26.9643239],
      [30.9742241, -26.9615523],
      [30.9747399, -26.9595455],
      [30.9753034, -26.957322],
      [30.9760242, -26.9543971],
      [30.9768483, -26.951092],
      [30.97688, -26.94883],
      [30.97689, -26.9459933],
      [30.97688, -26.94543],
      [30.97687, -26.94461],
      [30.97689, -26.94358],
      [30.97689, -26.9404],
      [30.97692, -26.93947],
      [30.97694, -26.93901],
      [30.97686, -26.93694],
      [30.9768, -26.93574],
      [30.97684, -26.93471],
      [30.97682, -26.93326],
      [30.97678, -26.93258],
      [30.97681, -26.93104],
      [30.9768, -26.93047],
      [30.9768, -26.92892],
      [30.97683, -26.92852],
      [30.97687, -26.9273],
      [30.97689, -26.92634],
      [30.9768587, -26.924306],
      [30.97682, -26.92161],
      [30.97482, -26.91331],
      [30.97422, -26.91089],
      [30.97356, -26.90821],
      [30.97332, -26.90799],
      [30.97325, -26.90792],
      [30.97316, -26.90784],
      [30.97313, -26.90781],
      [30.97311, -26.90778],
      [30.97308, -26.90776],
      [30.97306, -26.90774],
      [30.9730003, -26.9077303],
      [30.9727, -26.9076],
      [30.97213, -26.90746],
      [30.9716, -26.90727],
      [30.97144, -26.90719],
      [30.97082, -26.9070301],
      [30.97003, -26.90672],
      [30.96964, -26.9065001],
      [30.96931, -26.90622],
      [30.9689, -26.906],
      [30.96867, -26.90589],
      [30.96831, -26.9056],
      [30.96807, -26.9054801],
      [30.96771, -26.90515],
      [30.96712, -26.9044],
      [30.96658, -26.90384],
      [30.96637, -26.90361],
      [30.96599, -26.90336],
      [30.96564, -26.9032],
      [30.96504, -26.90291],
      [30.96485, -26.90282],
      [30.96433, -26.90265],
      [30.96416, -26.90251],
      [30.96383, -26.90241],
      [30.96366, -26.90236],
      [30.96335, -26.90217],
      [30.96304, -26.90191],
      [30.96276, -26.9017],
      [30.96252, -26.90146],
      [30.96221, -26.90127],
      [30.9619, -26.90096],
      [30.96166, -26.90079],
      [30.96147, -26.90063],
      [30.96056, -26.89991],
      [30.9601, -26.8995],
      [30.95981, -26.89924],
      [30.95962, -26.89904],
      [30.9595, -26.8989],
      [30.95939, -26.89864],
      [30.95927, -26.89835],
      [30.95922, -26.89814],
      [30.95905, -26.89793],
      [30.95896, -26.89763],
      [30.95879, -26.8973],
      [30.95871, -26.8972],
      [30.95843, -26.89699],
      [30.95814, -26.89687],
      [30.95786, -26.8968],
      [30.95737, -26.89665],
      [30.95656, -26.89637],
      [30.95618, -26.8962],
      [30.95589, -26.89594],
      [30.9553, -26.89548],
      [30.95501, -26.89504],
      [30.95486, -26.89473],
      [30.95472, -26.89437],
      [30.95458, -26.89411],
      [30.95432, -26.89382],
      [30.95398, -26.89354],
      [30.95366, -26.89324],
      [30.95232, -26.89258],
      [30.95214, -26.89256],
      [30.95182, -26.89242],
      [30.95151, -26.8922],
      [30.95122, -26.89211],
      [30.95072, -26.8918501],
      [30.95049, -26.89166],
      [30.95022, -26.89149],
      [30.9492, -26.89073],
      [30.94881, -26.89051],
      [30.94865, -26.89049],
      [30.94846, -26.89037],
      [30.94824, -26.89021],
      [30.94793, -26.89009],
      [30.94767, -26.88999],
      [30.94711, -26.88968],
      [30.9469, -26.8895601],
      [30.94655, -26.88921],
      [30.94629, -26.88894],
      [30.94601, -26.8886801],
      [30.94584, -26.88859],
      [30.94552, -26.88859],
      [30.94418, -26.8886801],
      [30.94387, -26.88861],
      [30.94344, -26.88852],
      [30.94301, -26.8882101],
      [30.94275, -26.8879901],
      [30.94263, -26.8877301],
      [30.94255, -26.88737],
      [30.94255, -26.88709],
      [30.94251, -26.8869001],
      [30.9424, -26.88668],
      [30.94231, -26.8865201],
      [30.94168, -26.88595],
      [30.94146, -26.8857],
      [30.94111, -26.88539],
      [30.94088, -26.8852001],
      [30.94083, -26.88491],
      [30.94083, -26.8840801],
      [30.9408, -26.88396],
      [30.94074, -26.8839],
      [30.94003, -26.8836001],
      [30.9398, -26.88358],
      [30.93942, -26.88355],
      [30.93859, -26.8835501],
      [30.93783, -26.8834401],
      [30.93745, -26.88328],
      [30.9372, -26.8831301],
      [30.93698, -26.88294],
      [30.9368, -26.8827],
      [30.93654, -26.88222],
      [30.9363, -26.88196],
      [30.93604, -26.88176],
      [30.93573, -26.88166],
      [30.93526, -26.8815901],
      [30.93497, -26.88147],
      [30.93459, -26.8811901],
      [30.93438, -26.88093],
      [30.93394, -26.8803201],
      [30.93371, -26.88006],
      [30.93348, -26.87984],
      [30.93328, -26.8796001],
      [30.93314, -26.87941],
      [30.93307, -26.8792501],
      [30.93231, -26.87863],
      [30.93067, -26.8773101],
      [30.93065, -26.8772101],
      [30.93036, -26.87695],
      [30.93005, -26.87662],
      [30.92972, -26.8762601],
      [30.92885, -26.87552],
      [30.92858, -26.87536],
      [30.92833, -26.87514],
      [30.9281, -26.87491],
      [30.92788, -26.87474],
      [30.92767, -26.87448],
      [30.92752, -26.8744101],
      [30.92742, -26.87424],
      [30.92711, -26.87391],
      [30.92635, -26.87306],
      [30.92613, -26.8728501],
      [30.92606, -26.87263],
      [30.92594, -26.8724701],
      [30.9257, -26.87223],
      [30.92535, -26.87195],
      [30.92521, -26.8718201],
      [30.92488, -26.87161],
      [30.92435, -26.87121],
      [30.92371, -26.8707801],
      [30.92325, -26.8705],
      [30.92296, -26.8703501],
      [30.92277, -26.87013],
      [30.92258, -26.86996],
      [30.92222, -26.86971],
      [30.92202, -26.8694901],
      [30.92182, -26.86935],
      [30.92151, -26.86916],
      [30.92112, -26.8689],
      [30.91983, -26.868],
      [30.91921, -26.8675801],
      [30.91895, -26.86734],
      [30.91852, -26.8669301],
      [30.91823, -26.8666],
      [30.91797, -26.8662401],
      [30.91761, -26.8659601],
      [30.91703, -26.86558],
      [30.91671, -26.86546],
      [30.91548, -26.8647201],
      [30.915, -26.86434],
      [30.9141, -26.8636701],
      [30.91352, -26.86339],
      [30.91294, -26.86306],
      [30.91254, -26.86282],
      [30.91197, -26.86246],
      [30.9108, -26.86182],
      [30.91032, -26.8615401],
      [30.90986, -26.8612],
      [30.90955, -26.8609601],
      [30.90919, -26.86077],
      [30.90881, -26.86063],
      [30.90843, -26.86046],
      [30.90773, -26.86007],
      [30.90742, -26.8599301],
      [30.90723, -26.8595901],
      [30.90718, -26.8591901],
      [30.90718, -26.85893],
      [30.90725, -26.85851],
      [30.90725, -26.85803],
      [30.90729, -26.85749],
      [30.90732, -26.8568001],
      [30.90729, -26.8562501],
      [30.90717, -26.8557],
      [30.90707, -26.85523],
      [30.90695, -26.8549401],
      [30.90669, -26.8546101],
      [30.90631, -26.85442],
      [30.90582, -26.85423],
      [30.90547, -26.8540401],
      [30.90529, -26.85387],
      [30.90515, -26.8536801],
      [30.90498, -26.8531801],
      [30.90475, -26.8529001],
      [30.90446, -26.85273],
      [30.90406, -26.8525301],
      [30.90353, -26.8524],
      [30.903365, -26.85239],
      [30.90329, -26.85235],
      [30.90322, -26.85232],
      [30.90309, -26.8523],
      [30.90301, -26.85227],
      [30.90292, -26.85227],
      [30.90274, -26.8522301],
      [30.90268, -26.85216],
      [30.90261, -26.8521],
      [30.90249, -26.85205],
      [30.90237, -26.8520101],
      [30.90234, -26.85195],
      [30.90231, -26.85193],
      [30.90228, -26.85187],
      [30.90225, -26.8518001],
      [30.90196, -26.8491601],
      [30.89767, -26.8273201],
      [30.897611, -26.827047],
      [30.89753, -26.82667],
      [30.89422, -26.81133],
      [30.89297, -26.8053101],
      [30.89282, -26.80289],
      [30.89216, -26.7861101],
      [30.89193, -26.78515],
      [30.89191, -26.7850601],
      [30.89186, -26.7853201],
      [30.8915, -26.7857],
      [30.89091, -26.7862901],
      [30.89067, -26.7867901],
      [30.890428, -26.7870946],
      [30.89036, -26.78718],
      [30.89001, -26.78765],
      [30.8897, -26.7880101],
      [30.88951, -26.7884601],
      [30.88937, -26.78896],
      [30.88926, -26.7896],
      [30.88917, -26.79005],
      [30.88907, -26.79053],
      [30.88888, -26.7911301],
      [30.88886, -26.7917],
      [30.88894, -26.7922801],
      [30.88921, -26.79291],
      [30.88942, -26.7934301],
      [30.88949, -26.79379],
      [30.88955, -26.7942201],
      [30.88955, -26.7947401],
      [30.88942, -26.7952701],
      [30.88877, -26.7968801],
      [30.8887, -26.79717],
      [30.88863, -26.7974101],
      [30.88835, -26.79793],
      [30.88808, -26.79841],
      [30.88786, -26.79874],
      [30.88774, -26.7989501],
      [30.88771, -26.7991901],
      [30.88776, -26.79955],
      [30.8878, -26.7997901],
      [30.88795, -26.80002],
      [30.88821, -26.80058],
      [30.88842, -26.801],
      [30.88845, -26.80104],
      [30.88868, -26.8014301],
      [30.88879, -26.80179],
      [30.88879, -26.8020201],
      [30.88869, -26.80221],
      [30.88831, -26.80257],
      [30.888, -26.8030001],
      [30.8873, -26.8035727],
      [30.887285, -26.803585],
      [30.88667, -26.80377],
      [30.88607, -26.80406],
      [30.88532, -26.80432],
      [30.88382, -26.80491],
      [30.88329, -26.8050601],
      [30.88281, -26.8052901],
      [30.88236, -26.8056501],
      [30.88179, -26.80587],
      [30.88112, -26.80619],
      [30.88052, -26.8064801],
      [30.88045, -26.8065],
      [30.87995, -26.8066301],
      [30.87943, -26.80687],
      [30.87893, -26.80704],
      [30.8784, -26.8073],
      [30.87762, -26.80763],
      [30.87681, -26.80796],
      [30.87636, -26.8080101],
      [30.87588, -26.80825],
      [30.87545, -26.8084301],
      [30.87489, -26.8085901],
      [30.87338, -26.80893],
      [30.8726, -26.8090901],
      [30.87203, -26.8092801],
      [30.87108, -26.8098601],
      [30.87035, -26.81061],
      [30.8698, -26.8112],
      [30.86956, -26.81139],
      [30.86909, -26.81194],
      [30.86875, -26.81227],
      [30.86823, -26.8127901],
      [30.86731, -26.8138901],
      [30.86683, -26.81429],
      [30.86645, -26.81472],
      [30.86598, -26.8151501],
      [30.86571, -26.81555],
      [30.86538, -26.8159401],
      [30.86474, -26.8165301],
      [30.86422, -26.81686],
      [30.86367, -26.81732],
      [30.8632, -26.81765],
      [30.86275, -26.81793],
      [30.86225, -26.81829],
      [30.86172, -26.8186701],
      [30.86141, -26.8187901],
      [30.86083, -26.81891],
      [30.86017, -26.8190201],
      [30.85956, -26.81902],
      [30.85904, -26.8189901],
      [30.85817, -26.81873],
      [30.85722, -26.81837],
      [30.85684, -26.8182301],
      [30.85622, -26.8181401],
      [30.85551, -26.8179201],
      [30.85476, -26.8178],
      [30.85404, -26.8176801],
      [30.85318, -26.8176601],
      [30.85266, -26.81771],
      [30.85213, -26.81785],
      [30.85166, -26.8179201],
      [30.85107, -26.8181601],
      [30.84994, -26.8184701],
      [30.84909, -26.8186101],
      [30.84859, -26.81876],
      [30.84805, -26.8189701],
      [30.84744, -26.8193501],
      [30.84684, -26.8200401],
      [30.84673, -26.8203701],
      [30.84668, -26.82102],
      [30.84668, -26.82182],
      [30.84664, -26.8222301],
      [30.84645, -26.8227801],
      [30.84588, -26.8234301],
      [30.84504, -26.82417],
      [30.84437, -26.82479],
      [30.84401, -26.8250801],
      [30.8435, -26.82516],
      [30.84161, -26.8253301],
      [30.84079, -26.8253301],
      [30.84029, -26.82542],
      [30.83937, -26.8256101],
      [30.83892, -26.8257801],
      [30.83844, -26.8261101],
      [30.83794, -26.82621],
      [30.83742, -26.8262501],
      [30.83686, -26.8264001],
      [30.83643, -26.82665],
      [30.8361, -26.8269001],
      [30.83591, -26.82722],
      [30.83543, -26.82825],
      [30.83507, -26.8288],
      [30.83487, -26.82929],
      [30.83471, -26.82958],
      [30.83454, -26.8298901],
      [30.83388, -26.83068],
      [30.83322, -26.83158],
      [30.8331, -26.8317301],
      [30.83299, -26.83194],
      [30.83282, -26.83211],
      [30.8327, -26.83227],
      [30.83257, -26.83251],
      [30.83251, -26.8326301],
      [30.83234, -26.8328],
      [30.83223, -26.83287],
      [30.8319, -26.8332201],
      [30.83128, -26.83408],
      [30.83085, -26.8346],
      [30.83064, -26.8348901],
      [30.8305197, -26.8351266],
      [30.83016, -26.83544],
      [30.82992, -26.8357101],
      [30.82978, -26.83579],
      [30.8294, -26.8361301],
      [30.82848, -26.83709],
      [30.82838, -26.83721],
      [30.82821, -26.83734],
      [30.82802, -26.83752],
      [30.82795, -26.8375901],
      [30.8278678, -26.8377062],
      [30.82779, -26.83781],
      [30.82745, -26.83811],
      [30.82714, -26.8384],
      [30.82682, -26.83876],
      [30.82604, -26.83951],
      [30.82531, -26.8401501],
      [30.82483, -26.8404301],
      [30.82441, -26.84062],
      [30.82375, -26.84086],
      [30.82341, -26.84105],
      [30.8227283, -26.8415579],
      [30.8218249, -26.841836],
      [30.82135, -26.84196],
      [30.82084, -26.84216],
      [30.82039, -26.842347],
      [30.8200554, -26.8424217],
      [30.8192804, -26.8424973],
      [30.8186381, -26.8427278],
      [30.8180629, -26.8429065],
      [30.8173946, -26.8430973],
      [30.817, -26.8432022],
      [30.81674, -26.8433001],
      [30.8163115, -26.8434387],
      [30.8158761, -26.8435726],
      [30.8154639, -26.8437234],
      [30.814189, -26.8440934],
      [30.81363, -26.8442901],
      [30.8132093, -26.8444275],
      [30.81302, -26.8441001],
      [30.8126948, -26.84339],
      [30.8123468, -26.842619],
      [30.8119841, -26.8421408],
      [30.8117499, -26.8418008],
      [30.81165, -26.8415201],
      [30.8114405, -26.8409678],
      [30.8110666, -26.8402657],
      [30.8101736, -26.8385634],
      [30.8098815, -26.8380118],
      [30.80965, -26.8376765],
      [30.8093554, -26.8371395],
      [30.8086166, -26.835713],
      [30.8083276, -26.83521],
      [30.80807, -26.8346601],
      [30.80765, -26.83404],
      [30.8071, -26.8330601],
      [30.80672, -26.8321201],
      [30.80646, -26.83161],
      [30.80621, -26.83116],
      [30.80578, -26.8304101],
      [30.80527, -26.82931],
      [30.80502, -26.8287501],
      [30.80468, -26.8282],
      [30.80439, -26.82764],
      [30.804, -26.82692],
      [30.80319, -26.82534],
      [30.80302, -26.8250001],
      [30.80281, -26.82453],
      [30.80271, -26.82422],
      [30.80265, -26.8240201],
      [30.80252, -26.8216701],
      [30.80235, -26.8208201],
      [30.80222, -26.81961],
      [30.80209, -26.81835],
      [30.80178, -26.8154701],
      [30.80166, -26.81462],
      [30.80149, -26.8137901],
      [30.80149, -26.8131301],
      [30.80109, -26.80955],
      [30.80088, -26.80748],
      [30.80055, -26.80479],
      [30.80038, -26.80296],
      [30.80031, -26.8021901],
      [30.80005, -26.8006601],
      [30.8, -26.80002],
      [30.79992, -26.79916],
      [30.79988, -26.7981801],
      [30.79962, -26.7966901],
      [30.7996, -26.79631],
      [30.79958, -26.79588],
      [30.79925, -26.7929801],
      [30.79908, -26.792],
      [30.79891, -26.79042],
      [30.79882, -26.78957],
      [30.79866, -26.7886601],
      [30.7987, -26.7878201],
      [30.79841, -26.78542],
      [30.79834, -26.78486],
      [30.79824, -26.78414],
      [30.79797, -26.78162],
      [30.79784, -26.78051],
      [30.79767, -26.77881],
      [30.79759, -26.7783801],
      [30.79759, -26.7778301],
      [30.79745, -26.7773801],
      [30.79728, -26.77569],
      [30.79711, -26.7742901],
      [30.79706, -26.7730901],
      [30.79694, -26.7722],
      [30.79658, -26.76915],
      [30.79649, -26.76843],
      [30.79643, -26.76804],
      [30.79635, -26.76719],
      [30.79624, -26.76608],
      [30.79595, -26.76361],
      [30.79585, -26.76263],
      [30.79572, -26.76139],
      [30.79563, -26.76084],
      [30.79563, -26.7605],
      [30.79555, -26.75994],
      [30.79535, -26.75824],
      [30.79513, -26.7566401],
      [30.79507, -26.7554901],
      [30.79463, -26.7522901],
      [30.79448, -26.7507101],
      [30.79463, -26.7505001],
      [30.7943, -26.74728],
      [30.79422, -26.7458901],
      [30.79417, -26.74545],
      [30.79405, -26.74464],
      [30.79384, -26.74285],
      [30.79372, -26.74187],
      [30.79359, -26.7408801],
      [30.79346, -26.73922],
      [30.79313, -26.7363701],
      [30.793127, -26.735981],
      [30.79313, -26.73589],
      [30.79315, -26.7352201],
      [30.79305, -26.7345901],
      [30.79293, -26.7344201],
      [30.79278, -26.7321001],
      [30.79263, -26.7313],
      [30.79249, -26.73029],
      [30.79235, -26.7290401],
      [30.79239, -26.7284001],
      [30.79232, -26.72788],
      [30.79215, -26.7270601],
      [30.79203, -26.72599],
      [30.79188, -26.72446],
      [30.7918, -26.7240901],
      [30.79169, -26.72286],
      [30.79155, -26.72132],
      [30.79146, -26.72086],
      [30.79139, -26.7205],
      [30.79136, -26.71983],
      [30.79119, -26.71829],
      [30.79116, -26.71768],
      [30.79114, -26.71728],
      [30.79102, -26.7165201],
      [30.79089, -26.7150601],
      [30.79086, -26.71409],
      [30.7908, -26.7122901],
      [30.79084, -26.71009],
      [30.79086, -26.70925],
      [30.79089, -26.70744],
      [30.79092, -26.70691],
      [30.79096, -26.7062701],
      [30.79089, -26.7057501],
      [30.7909, -26.7035101],
      [30.79092, -26.70275],
      [30.79092, -26.70185],
      [30.79095, -26.70006],
      [30.79095, -26.6998],
      [30.79097, -26.69932],
      [30.79097, -26.6986],
      [30.79094, -26.6965901],
      [30.79098, -26.69617],
      [30.79101, -26.69558],
      [30.79101, -26.6951799],
      [30.79101, -26.69498],
      [30.79096, -26.69453],
      [30.79097, -26.69333],
      [30.79095, -26.6926901],
      [30.79098, -26.69042],
      [30.79101, -26.68952],
      [30.79103, -26.68885],
      [30.79104, -26.6878501],
      [30.79097, -26.6873301],
      [30.791, -26.68643],
      [30.79098, -26.6847101],
      [30.79101, -26.68393],
      [30.79101, -26.6821601],
      [30.79104, -26.68157],
      [30.79111, -26.6811001],
      [30.79107, -26.68065],
      [30.79104, -26.6804301],
      [30.79108, -26.67808],
      [30.79108, -26.67766],
      [30.7911, -26.67717],
      [30.79108, -26.67684],
      [30.79111, -26.6746],
      [30.79111, -26.67411],
      [30.79109, -26.67367],
      [30.79111, -26.67325],
      [30.7911, -26.67139],
      [30.79111, -26.67091],
      [30.79113, -26.67047],
      [30.79115, -26.66968],
      [30.79111, -26.6679201],
      [30.79117, -26.6672501],
      [30.79116, -26.66675],
      [30.79114, -26.6662],
      [30.79115, -26.66512],
      [30.79115, -26.66429],
      [30.79116, -26.66225],
      [30.79116, -26.66049],
      [30.79114, -26.6599201],
      [30.79117, -26.65883],
      [30.79125, -26.6569501],
      [30.79125, -26.6563],
      [30.79119, -26.65577],
      [30.79119, -26.65546],
      [30.79121, -26.65482],
      [30.79123, -26.65348],
      [30.79119, -26.6527901],
      [30.79121, -26.65237],
      [30.79121, -26.65177],
      [30.79128, -26.6501901],
      [30.79123, -26.64915],
      [30.79116, -26.64856],
      [30.79116, -26.6481501],
      [30.79125, -26.6473101],
      [30.7914, -26.6471701],
      [30.79144, -26.63953],
      [30.79152, -26.6262401],
      [30.79144, -26.6055001],
      [30.79169, -26.5882201],
      [30.79175, -26.57148],
      [30.7917956, -26.5696807],
      [30.79181, -26.5691101],
      [30.79392, -26.5522201],
      [30.7955, -26.5412101],
      [30.79737, -26.52662],
      [30.8002599, -26.50406],
      [30.80288, -26.4836601],
      [30.802902, -26.483491],
      [30.80506, -26.466671],
      [30.8162885, -26.4426592],
      [30.83101, -26.4111701],
      [30.83591, -26.4062101],
      [30.836849, -26.405235],
      [30.84092, -26.40101],
      [30.85022, -26.39139],
      [30.857558, -26.383792],
      [30.86756, -26.3654101],
      [30.87694, -26.3485601],
      [30.8883389, -26.3273672],
      [30.891699, -26.32112],
      [30.89186, -26.3208201],
      [30.89568, -26.3178101],
      [30.8999271, -26.314376],
      [30.9141539, -26.3020331],
      [30.9142154, -26.3019806],
      [30.9142649, -26.3019383],
      [30.918099, -26.298664],
      [30.92109, -26.2961101],
      [30.9263497, -26.2916286],
      [30.961438, -26.261732],
      [30.96836, -26.2497101],
      [30.98094, -26.22716],
      [30.98197, -26.2253101],
      [30.9863, -26.21766],
      [30.9891836, -26.2125713],
      [30.9892235, -26.2124976],
      [30.990536, -26.21018],
      [30.99263, -26.20639],
      [30.9951, -26.20194],
      [30.99757, -26.1975],
      [30.998633, -26.195585],
      [31.00004, -26.19305],
      [31.00279, -26.18812],
      [31.00553, -26.1831901],
      [31.00828, -26.1782601],
      [31.0110021, -26.173339],
      [31.0112691, -26.1728634],
      [31.01377, -26.1684101],
      [31.0181575, -26.1605157],
      [31.01925, -26.15855],
      [31.01999, -26.15724],
      [31.0205288, -26.1562932],
      [31.02073, -26.15594],
      [31.02146, -26.15464],
      [31.0222, -26.15334],
      [31.02293, -26.15203],
      [31.02367, -26.15073],
      [31.0244, -26.14943],
      [31.02514, -26.14813],
      [31.02588, -26.14682],
      [31.02661, -26.14552],
      [31.0313512, -26.1371417],
      [31.0324224, -26.1352487],
      [31.04169, -26.1188701],
      [31.0457599, -26.1117211],
      [31.050116, -26.104069],
      [31.0561139, -26.0935334],
      [31.0563716, -26.0930808],
      [31.0570828, -26.0918313],
      [31.06026, -26.08625],
      [31.07104, -26.0673101],
      [31.07252, -26.06402],
      [31.07401, -26.06073],
      [31.07549, -26.05744],
      [31.076535, -26.055134],
      [31.07847, -26.05086],
      [31.0790021, -26.049677],
      [31.07995, -26.04757],
      [31.08144, -26.04428],
      [31.08292, -26.04099],
      [31.0842248, -26.0381088],
      [31.08441, -26.0377],
      [31.0845327, -26.0374272],
      [31.0849637, -26.0364694],
      [31.0852033, -26.0359368],
      [31.0853273, -26.0357067],
      [31.0857853, -26.0346523],
      [31.0858638, -26.0344719],
      [31.085895, -26.0344],
      [31.0859088, -26.0343694],
      [31.089407, -26.026639],
      [31.08961, -26.0261901],
      [31.0896542, -26.0261563],
      [31.08999, -26.0259001],
      [31.09001, -26.0257001],
      [31.0900721, -26.0255963],
      [31.0902143, -26.0253601],
      [31.09059, -26.02472],
      [31.09131, -26.02351],
      [31.09163, -26.0229501],
      [31.0921, -26.0218601],
      [31.09254, -26.02118],
      [31.09284, -26.0207301],
      [31.09323, -26.01996],
      [31.09375, -26.0191001],
      [31.09404, -26.0184501],
      [31.09454, -26.01766],
      [31.09573, -26.01545],
      [31.09601, -26.0149801],
      [31.09616, -26.01462],
      [31.09703, -26.01306],
      [31.09718, -26.0126901],
      [31.09777, -26.01167],
      [31.09836, -26.0106],
      [31.09866, -26.01],
      [31.09945, -26.00855],
      [31.09985, -26.00785],
      [31.10044, -26.00674],
      [31.10072, -26.00622],
      [31.10128, -26.00514],
      [31.1019, -26.00406],
      [31.10227, -26.00342],
      [31.10258, -26.00285],
      [31.1029, -26.00214],
      [31.1031373, -26.0017733],
      [31.1032443, -26.0016289],
      [31.10323, -26.0016301],
      [31.1037272, -26.0003609],
      [31.10372, -26.0003501],
      [31.10409, -25.99969],
      [31.10456, -25.99875],
      [31.1046123, -25.99863],
      [31.10486, -25.99807],
      [31.1051595, -25.997492],
      [31.10572, -25.9964501],
      [31.106, -25.99587],
      [31.1061, -25.9954901],
      [31.10639, -25.99502],
      [31.10718, -25.9935601],
      [31.10747, -25.99296],
      [31.1077, -25.99251],
      [31.10802, -25.99182],
      [31.1080938, -25.9916649],
      [31.10874, -25.99038],
      [31.10932, -25.9892801],
      [31.10947, -25.9888501],
      [31.1097676, -25.988321],
      [31.11043, -25.98705],
      [31.11076, -25.9865201],
      [31.11091, -25.9860401],
      [31.11121, -25.98552],
      [31.1114412, -25.9850709],
      [31.1117363, -25.984526],
      [31.11206, -25.9839],
      [31.1120957, -25.9838461],
      [31.11212, -25.98379],
      [31.11246, -25.98315],
      [31.11275, -25.9825701],
      [31.11282, -25.98206],
      [31.11298, -25.98137],
      [31.11329, -25.97998],
      [31.11338, -25.97957],
      [31.11354, -25.97902],
      [31.11376, -25.97793],
      [31.11382, -25.9775901],
      [31.11416, -25.97638],
      [31.11433, -25.9756801],
      [31.11441, -25.97523],
      [31.11449, -25.97489],
      [31.1146, -25.9743],
      [31.11479, -25.97339],
      [31.11492, -25.9726601],
      [31.115, -25.97255],
      [31.11516, -25.9723101],
      [31.11525, -25.97176],
      [31.1152848, -25.9715393],
      [31.11534, -25.9712],
      [31.11538, -25.97081],
      [31.1154028, -25.9706977],
      [31.11564, -25.9694201],
      [31.11583, -25.96873],
      [31.11595, -25.96808],
      [31.11607, -25.96755],
      [31.11625, -25.96701],
      [31.1164014, -25.9661686],
      [31.11651, -25.96555],
      [31.1166, -25.96515],
      [31.11678, -25.9645801],
      [31.11679, -25.9640901],
      [31.11698, -25.9635801],
      [31.1173, -25.96196],
      [31.11734, -25.9616201],
      [31.11761, -25.9609801],
      [31.11766, -25.96057],
      [31.11785, -25.95985],
      [31.11806, -25.95871],
      [31.11831, -25.95759],
      [31.11841, -25.95702],
      [31.1186, -25.9564],
      [31.11877, -25.9555],
      [31.1189295, -25.9548798],
      [31.11904, -25.95445],
      [31.11921, -25.9534401],
      [31.1194, -25.95279],
      [31.11972, -25.95143],
      [31.11973, -25.95128],
      [31.1199, -25.9506],
      [31.12003, -25.95007],
      [31.12025, -25.9492],
      [31.12033, -25.9488401],
      [31.12054, -25.94785],
      [31.12073, -25.94686],
      [31.12081, -25.9462901],
      [31.12106, -25.9456301],
      [31.12123, -25.94458],
      [31.12134, -25.9439101],
      [31.12158, -25.94297],
      [31.12178, -25.9423501],
      [31.12208, -25.94094],
      [31.1220991, -25.9408231],
      [31.12216, -25.94045],
      [31.12223, -25.9400201],
      [31.1222855, -25.9398389],
      [31.12242, -25.9394],
      [31.1226, -25.9389001],
      [31.12305, -25.93681],
      [31.12317, -25.93626],
      [31.12324, -25.9357701],
      [31.1235, -25.9347],
      [31.12367, -25.93398],
      [31.12375, -25.93379],
      [31.12388, -25.9332401],
      [31.12405, -25.93227],
      [31.12421, -25.93174],
      [31.1244, -25.93069],
      [31.12452, -25.93018],
      [31.12466, -25.92966],
      [31.12473, -25.92924],
      [31.12484, -25.9287],
      [31.12497, -25.92817],
      [31.1250182, -25.9279628],
      [31.12517, -25.92731],
      [31.12538, -25.92649],
      [31.12549, -25.92609],
      [31.1255886, -25.9256729],
      [31.12562, -25.92554],
      [31.12565, -25.92511],
      [31.12565, -25.92499],
      [31.12589, -25.92415],
      [31.1262272, -25.9226597],
      [31.12651, -25.92141],
      [31.1265699, -25.92115],
      [31.1265999, -25.92115],
      [31.126659, -25.9211017],
      [31.1295275, -25.9187545],
      [31.1334611, -25.9155356],
      [31.1380016, -25.91182],
      [31.1422924, -25.9083086],
      [31.1423931, -25.9082262],
      [31.1486421, -25.9031121],
      [31.1523806, -25.9000525],
      [31.1531899, -25.89939],
      [31.1612712, -25.8928261],
      [31.1633702, -25.8911212],
      [31.1667902, -25.8883432],
      [31.1685108, -25.8869456],
      [31.1737448, -25.8826939],
      [31.1779631, -25.8792673],
      [31.1822454, -25.8757885],
      [31.1845699, -25.8739],
      [31.188333, -25.8708287],
      [31.1941157, -25.8661088],
      [31.1974709, -25.8633701],
      [31.2053033, -25.8569768],
      [31.2104199, -25.8528],
      [31.2123628, -25.8512241],
      [31.2365816, -25.8315774],
      [31.2399927, -25.8288099],
      [31.2412858, -25.8277609],
      [31.2472399, -25.82293],
      [31.2635699, -25.80963],
      [31.2647139, -25.8081712],
      [31.2749399, -25.79513],
      [31.2795852, -25.7892294],
      [31.3144591, -25.7449219],
      [31.3159399, -25.74304],
      [31.3335199, -25.7388],
      [31.3765807, -25.728376],
      [31.4162999, -25.71876],
      [31.4626149, -25.7474316],
      [31.4887635, -25.7635863],
      [31.492494, -25.765854],
      [31.4935387, -25.7664994],
      [31.5251699, -25.7860364],
      [31.539619, -25.794961],
      [31.539645, -25.794974],
      [31.5831123, -25.8224678],
      [31.5913587, -25.8276829],
      [31.594075, -25.829401],
      [31.603387, -25.835295],
      [31.60341, -25.83531],
      [31.6678537, -25.8754156],
      [31.676631, -25.880878],
      [31.689297, -25.88876],
      [31.6923165, -25.8906391],
      [31.6924705, -25.8907349],
      [31.720357, -25.908089],
      [31.72039, -25.90811],
      [31.7597769, -25.9325779],
      [31.75989, -25.93265],
      [31.7651235, -25.9358955],
      [31.792839, -25.953081],
      [31.86786, -25.9996],
      [31.8755083, -25.9962469],
      [31.8947295, -25.987919],
      [31.9015259, -25.9849743],
      [31.9020438, -25.98474],
      [31.911121, -25.980633],
      [31.938408, -25.968669],
      [31.9751904, -25.9526462],
      [31.9744587, -25.9508062],
      [31.9466114, -25.8807712],
      [31.9316879, -25.843737],
      [31.9305639, -25.840806],
      [31.93055, -25.84077],
      [31.9376399, -25.81865],
      [31.9446499, -25.79728],
      [31.9475179, -25.788596],
      [31.9505885, -25.7792972],
      [31.9570399, -25.75976],
      [31.9602799, -25.749614],
      [31.9625299, -25.74257],
      [31.9691579, -25.722327],
      [31.9763499, -25.70053],
      [31.97856, -25.69367],
      [31.996711, -25.6760068],
      [31.9971048, -25.6747144],
      [32.0058871, -25.6447443],
      [32.0056499, -25.62599],
      [32.0053626, -25.6049841],
      [32.0009099, -25.58532],
      [31.9956244, -25.5259086],
      [31.9799272, -25.5241903],
      [31.97738, -25.5098],
      [31.9773854, -25.5086066],
      [31.9773858, -25.5084875],
      [31.9776909, -25.5010765],
      [31.9777429, -25.4997412],
      [31.9780254, -25.4924906],
      [31.9778499, -25.4821791],
      [31.9774868, -25.473754],
      [31.9782742, -25.469554],
      [31.9790717, -25.4630516],
      [31.9793699, -25.46024],
      [31.9795047, -25.4570309],
      [31.9822319, -25.4517967],
      [31.9832283, -25.4498264],
      [31.9843999, -25.44781],
      [31.9855749, -25.4454297],
      [31.9867537, -25.442971],
      [31.9867928, -25.4424337],
      [31.9868057, -25.4422558],
      [31.987284, -25.4391114],
      [31.9879562, -25.4388295],
      [31.9881094, -25.4372873],
      [31.9883836, -25.4369387],
      [31.9893916, -25.4356524],
      [31.9898562, -25.4317646],
      [31.9900102, -25.4302845],
      [31.9940296, -25.4231312],
      [31.9997099, -25.41263],
      [32.0069899, -25.39986],
      [32.0087699, -25.39629],
      [32.0134999, -25.38811],
      [32.0146499, -25.38556],
      [32.0152799, -25.3825],
      [32.0159199, -25.37739],
      [32.0179599, -25.35441],
      [32.0245134, -25.2908324],
      [32.025597, -25.2801444],
      [32.0267343, -25.2692687],
      [32.0267867, -25.2687532],
      [32.0268111, -25.2684949],
      [32.028097, -25.2554544],
      [32.0288199, -25.24143],
      [32.0318082, -25.1830679],
      [32.033716, -25.1325394],
      [32.0306208, -25.070331],
      [32.0303687, -25.0657664],
      [32.0244102, -25.0083113],
      [32.0237757, -25.0030071],
      [32.0211579, -24.9786184],
      [32.0179822, -24.9486608],
      [32.0158364, -24.9288147],
      [32.0141191, -24.9112613],
      [32.0067383, -24.8061263],
      [32.005453, -24.7893237],
      [31.9978067, -24.6893822],
      [32.0090129, -24.4576487],
      [32.0089699, -24.4555392],
      [32.0085837, -24.4533124],
      [32.0057084, -24.4350283],
      [31.999829, -24.3979831],
      [31.9964226, -24.3764491],
      [31.9961463, -24.3746974],
      [31.9960176, -24.3736542],
      [31.9948885, -24.3665272],
      [31.9853461, -24.3052245],
      [31.9516729, -24.2515129],
      [31.9081175, -24.1818141],
      [31.9065539, -24.1681893],
      [31.9018386, -24.1288411],
      [31.8953699, -24.07471],
      [31.8867599, -24.00133],
      [31.8843925, -23.9840457],
      [31.85268, -23.9868501],
      [31.84793, -23.9861701],
      [31.84488, -23.9859301],
      [31.84014, -23.9867201],
      [31.83266, -23.9869001],
      [31.82891, -23.9859701],
      [31.82497, -23.9861601],
      [31.82298, -23.9882601],
      [31.82161, -23.9908501],
      [31.82238, -23.9929801],
      [31.82212, -23.9965101],
      [31.82036, -23.9983801],
      [31.81796, -23.9990801],
      [31.81254, -23.9993101],
      [31.80952, -23.9988401],
      [31.8047, -23.9971801],
      [31.80121, -23.9940901],
      [31.79847, -23.9933701],
      [31.79461, -23.9919301],
      [31.79161, -23.9883701],
      [31.78747, -23.9864901],
      [31.78269, -23.9820801],
      [31.78054, -23.9814101],
      [31.7764, -23.9812401],
      [31.76997, -23.9831901],
      [31.76748, -23.9846201],
      [31.76398, -23.9879101],
      [31.75906, -23.9916401],
      [31.75467, -23.9958001],
      [31.75177, -23.9976501],
      [31.74888, -24.0007201],
      [31.74656, -24.0034801],
      [31.74486, -24.0046401],
      [31.7417, -24.0062701],
      [31.73708, -24.0088201],
      [31.73491, -24.0113401],
      [31.7335, -24.0145201],
      [31.73357, -24.0183601],
      [31.73543, -24.0255501],
      [31.73598, -24.0289201],
      [31.73727, -24.0320601],
      [31.73764, -24.0390501],
      [31.7375339, -24.0425831],
      [31.7359117, -24.0464827],
      [31.7318605, -24.050392],
      [31.7270904, -24.0533077],
      [31.7187, -24.0568401],
      [31.70877, -24.0586901],
      [31.70191, -24.0599201],
      [31.69036, -24.0601001],
      [31.68372, -24.0595301],
      [31.67998, -24.0566501],
      [31.67872, -24.0550901],
      [31.67818, -24.0523901],
      [31.6774, -24.0499201],
      [31.67613, -24.0479101],
      [31.67534, -24.0452101],
      [31.67432, -24.0429701],
      [31.67379, -24.0407301],
      [31.67196, -24.0351101],
      [31.6714, -24.0310601],
      [31.6706, -24.0274601],
      [31.66957, -24.0249901],
      [31.66876, -24.0209501],
      [31.6657408, -24.0170234],
      [31.6627861, -24.015671],
      [31.6591791, -24.0149772],
      [31.6523469, -24.0147753],
      [31.6395131, -24.0169627],
      [31.6328183, -24.0182543],
      [31.62719, -24.0203868],
      [31.6215895, -24.0240577],
      [31.6147617, -24.0313581],
      [31.6121846, -24.0344055],
      [31.6106697, -24.0365729],
      [31.6099165, -24.0401807],
      [31.6097706, -24.0452208],
      [31.6095146, -24.0458267],
      [31.6083909, -24.0484873],
      [31.606288, -24.0514423],
      [31.6045457, -24.0542815],
      [31.6017304, -24.0563252],
      [31.598662, -24.0569757],
      [31.5947, -24.0563701],
      [31.58687, -24.0527801],
      [31.58028, -24.0471101],
      [31.57651, -24.0422001],
      [31.57372, -24.0372801],
      [31.57096, -24.0343901],
      [31.568677, -24.0336784],
      [31.56112, -24.0336301],
      [31.55206, -24.0355701],
      [31.54865, -24.0372001],
      [31.54624, -24.0397201],
      [31.54457, -24.0424501],
      [31.54387, -24.0449401],
      [31.54373, -24.0508101],
      [31.54256, -24.0539901],
      [31.53792, -24.0558601],
      [31.53155, -24.0568501],
      [31.52909, -24.0566701],
      [31.52094, -24.0543001],
      [31.51903, -24.0526101],
      [31.51344, -24.0469601],
      [31.5094818, -24.0435787],
      [31.505231, -24.0410841],
      [31.50029, -24.0394801],
      [31.49757, -24.0383901],
      [31.49336, -24.0368701],
      [31.48197, -24.0316201],
      [31.47114, -24.0302001],
      [31.4641381, -24.0297446],
      [31.46253, -24.0296401],
      [31.45956, -24.0283301],
      [31.45259, -24.0232401],
      [31.45035, -24.0212401],
      [31.44762, -24.0199201],
      [31.44094, -24.0209801],
      [31.44058, -24.0247601],
      [31.4407, -24.0317601],
      [31.44056, -24.0383001],
      [31.43866, -24.0421701],
      [31.43603, -24.0467201],
      [31.43386, -24.0494601],
      [31.4312, -24.0523501],
      [31.42805, -24.0545001],
      [31.41997, -24.0564201],
      [31.41583, -24.0585101],
      [31.40902, -24.0628901],
      [31.39902, -24.0675501],
      [31.39558, -24.0675901],
      [31.3926, -24.0658301],
      [31.39009, -24.0622501],
      [31.38778, -24.0566401],
      [31.38644, -24.0522001],
      [31.38352, -24.0512901],
      [31.37911, -24.0522501],
      [31.37355, -24.0575101],
      [31.3682, -24.0639001],
      [31.36512, -24.0684601],
      [31.36001, -24.0712401],
      [31.34946, -24.0727401],
      [31.34237, -24.0748601],
      [31.33652, -24.0776501],
      [31.33114, -24.0795301],
      [31.32672, -24.0800401],
      [31.32062, -24.0826001],
      [31.31767, -24.0828701],
      [31.31323, -24.0813501],
      [31.31001, -24.0798101],
      [31.30478, -24.0756001],
      [31.30156, -24.0738301],
      [31.29885, -24.0734201],
      [31.29639, -24.0732301],
      [31.29345, -24.0743901],
      [31.28764, -24.0796601],
      [31.28356, -24.0858101],
      [31.27508, -24.0938201],
      [31.2724, -24.0954301],
      [31.26411, -24.0998301],
      [31.25725, -24.1010501],
      [31.257019, -24.1009654],
      [31.2548084, -24.100154],
      [31.25428, -24.0999601],
      [31.25228, -24.0977301],
      [31.2497, -24.0896401],
      [31.24811, -24.0826601],
      [31.24783, -24.0801801],
      [31.24701, -24.0750001],
      [31.24524, -24.0714201],
      [31.24247, -24.0671701],
      [31.23847, -24.0629301],
      [31.2347, -24.0575701],
      [31.22834, -24.0515801],
      [31.22002, -24.0455701],
      [31.21606, -24.0438101],
      [31.2125669, -24.0427913],
      [31.2113305, -24.0424307],
      [31.21134, -24.0426901],
      [31.21129, -24.0426801],
      [31.21043, -24.0426301],
      [31.2089, -24.0421601],
      [31.20681, -24.0413301],
      [31.20603, -24.0410301],
      [31.20532, -24.0405201],
      [31.20395, -24.0397101],
      [31.20332, -24.0393401],
      [31.20288, -24.0390301],
      [31.20226, -24.0384401],
      [31.20148, -24.0378301],
      [31.20094, -24.0372701],
      [31.20055, -24.0367501],
      [31.20012, -24.0363501],
      [31.19908, -24.0351701],
      [31.19802, -24.0341201],
      [31.19767, -24.0336601],
      [31.19676, -24.0327101],
      [31.19527, -24.0317001],
      [31.19448, -24.0313101],
      [31.19425, -24.0311501],
      [31.19339, -24.0310401],
      [31.19187, -24.0310701],
      [31.19081, -24.0311301],
      [31.18977, -24.0314001],
      [31.18816, -24.0316901],
      [31.18705, -24.0320601],
      [31.18576, -24.0325201],
      [31.18391, -24.0330901],
      [31.18201, -24.0338101],
      [31.18107, -24.0341101],
      [31.18028, -24.0343301],
      [31.17905, -24.0347001],
      [31.17853, -24.0348701],
      [31.1781, -24.0349901],
      [31.17753, -24.0352101],
      [31.17705, -24.0354801],
      [31.1765, -24.0357801],
      [31.17611, -24.0360601],
      [31.17566, -24.0363801],
      [31.17513, -24.0368501],
      [31.17468, -24.0375101],
      [31.17432, -24.0379201],
      [31.17395, -24.0383101],
      [31.17368, -24.0386901],
      [31.17336, -24.0391301],
      [31.17308, -24.0398401],
      [31.17282, -24.0404401],
      [31.1727, -24.0408901],
      [31.17197, -24.0425501],
      [31.17173, -24.0430401],
      [31.17151, -24.0435001],
      [31.17131, -24.0441801],
      [31.17126, -24.0453801],
      [31.17123, -24.0461201],
      [31.17105, -24.0465201],
      [31.17104, -24.0481601],
      [31.17082, -24.0485901],
      [31.1707245, -24.0489337],
      [31.17067, -24.0491301],
      [31.17053, -24.0497701],
      [31.17063, -24.0510401],
      [31.17079, -24.0516601],
      [31.17076, -24.0522801],
      [31.17097, -24.0534201],
      [31.17098, -24.0538801],
      [31.17097, -24.0552201],
      [31.17095, -24.0561901],
      [31.17063, -24.0569701],
      [31.17041, -24.0574701],
      [31.17027, -24.0578701],
      [31.17008, -24.0583001],
      [31.16985, -24.0586301],
      [31.16948, -24.0588901],
      [31.1693741, -24.0589224],
      [31.16899, -24.0590401],
      [31.16822, -24.0590401],
      [31.1679557, -24.0590125],
      [31.16774, -24.0589901],
      [31.16709, -24.0590801],
      [31.16628, -24.0591501],
      [31.1651916, -24.0593067],
      [31.16503, -24.0593301],
      [31.16451, -24.0593201],
      [31.16428, -24.0593701],
      [31.16367, -24.0595901],
      [31.16263, -24.0600501],
      [31.1623306, -24.0602153],
      [31.16109, -24.0609001],
      [31.16053, -24.0612501],
      [31.1601318, -24.061513],
      [31.15947, -24.0619501],
      [31.15706, -24.0633801],
      [31.1562, -24.0638101],
      [31.15533, -24.0644301],
      [31.1552499, -24.0644668],
      [31.15459, -24.0647701],
      [31.15424, -24.0649401],
      [31.15359, -24.0653501],
      [31.15296, -24.0656801],
      [31.15267, -24.0659201],
      [31.1525468, -24.0660769],
      [31.15212, -24.0666201],
      [31.15173, -24.0669601],
      [31.15127, -24.0672401],
      [31.15083, -24.0676501],
      [31.15025, -24.0680101],
      [31.1499, -24.0681501],
      [31.1497665, -24.0682028],
      [31.14856, -24.0686801],
      [31.14826, -24.0689501],
      [31.1477982, -24.0692523],
      [31.14771, -24.0693101],
      [31.14708, -24.0696801],
      [31.14605, -24.0699901],
      [31.1458449, -24.0700439],
      [31.14506, -24.0702501],
      [31.14385, -24.0707101],
      [31.14247, -24.0711201],
      [31.1423628, -24.0711493],
      [31.14141, -24.0714101],
      [31.14047, -24.0717701],
      [31.13901, -24.0721301],
      [31.13783, -24.0723501],
      [31.13689, -24.0727801],
      [31.136, -24.0731501],
      [31.13475, -24.0735101],
      [31.13417, -24.0736401],
      [31.13378, -24.0737001],
      [31.13253, -24.0736601],
      [31.13117, -24.0735401],
      [31.13058, -24.0732601],
      [31.12934, -24.0729201],
      [31.1278, -24.0719101],
      [31.12712, -24.0713601],
      [31.12635, -24.0707301],
      [31.12561, -24.0701601],
      [31.12425, -24.0692001],
      [31.12357, -24.0688901],
      [31.12306, -24.0686601],
      [31.12214, -24.0684601],
      [31.12156, -24.0683401],
      [31.1214838, -24.0683294],
      [31.1207715, -24.0682307],
      [31.12055, -24.0682001],
      [31.11991, -24.0682101],
      [31.11944, -24.0682301],
      [31.1188, -24.0682401],
      [31.11825, -24.0683201],
      [31.11715, -24.0685001],
      [31.11632, -24.0686401],
      [31.11582, -24.0688001],
      [31.11495, -24.0689901],
      [31.11347, -24.0692401],
      [31.11249, -24.0694201],
      [31.1111529, -24.0696103],
      [31.10994, -24.0698001],
      [31.10901, -24.0698701],
      [31.10769, -24.0701201],
      [31.10636, -24.0702901],
      [31.10549, -24.0703001],
      [31.1045, -24.0704801],
      [31.10311, -24.0705201],
      [31.1028839, -24.0705361],
      [31.10187, -24.0706101],
      [31.10155, -24.0706401],
      [31.10094, -24.0707701],
      [31.10021, -24.0710201],
      [31.09954, -24.0713201],
      [31.09897, -24.0716401],
      [31.09826, -24.0721901],
      [31.09748, -24.0729301],
      [31.09683, -24.0735501],
      [31.09613, -24.0743001],
      [31.09559, -24.0748401],
      [31.09514, -24.0750801],
      [31.09491, -24.0752001],
      [31.09425, -24.0755201],
      [31.09381, -24.0756901],
      [31.09336, -24.0758001],
      [31.09274, -24.0759601],
      [31.09185, -24.0761101],
      [31.09145, -24.0761801],
      [31.09013, -24.0765101],
      [31.08879, -24.0768601],
      [31.08787, -24.0772001],
      [31.0876, -24.0772601],
      [31.08707, -24.0774201],
      [31.08646, -24.0776701],
      [31.08563, -24.0780101],
      [31.08511, -24.0782101],
      [31.0842, -24.0785101],
      [31.08372, -24.0786801],
      [31.08266, -24.0789901],
      [31.08175, -24.0792901],
      [31.08101, -24.0795401],
      [31.0806, -24.0796601],
      [31.08027, -24.0798001],
      [31.0794, -24.0801001],
      [31.07857, -24.0804301],
      [31.07769, -24.0807401],
      [31.077, -24.0809701],
      [31.07642, -24.0811901],
      [31.07554, -24.0815801],
      [31.07474, -24.0819501],
      [31.07406, -24.0822601],
      [31.07352, -24.0825601],
      [31.07309, -24.0827101],
      [31.07262, -24.0830501],
      [31.07214, -24.0833301],
      [31.07187, -24.0835301],
      [31.07163, -24.0837801],
      [31.07144, -24.0840501],
      [31.07111, -24.0844801],
      [31.07086, -24.0848201],
      [31.07056, -24.0852001],
      [31.07035, -24.0855001],
      [31.07011, -24.0858701],
      [31.06976, -24.0862001],
      [31.06938, -24.0865901],
      [31.0692, -24.0867601],
      [31.06897, -24.0871301],
      [31.06878, -24.0874701],
      [31.06857, -24.0877501],
      [31.06823, -24.0880401],
      [31.06787, -24.0884301],
      [31.06729, -24.0891701],
      [31.0669, -24.0896301],
      [31.06652, -24.0899601],
      [31.06608, -24.0902601],
      [31.06566, -24.0906101],
      [31.0651, -24.0909501],
      [31.06477, -24.0911401],
      [31.06444, -24.0912601],
      [31.06374, -24.0914201],
      [31.0634786, -24.0915081],
      [31.06501, -24.0917001],
      [31.06622, -24.0918601],
      [31.0749, -24.0930101],
      [31.08103, -24.0938301],
      [31.08599, -24.0945201],
      [31.09971, -24.0928401],
      [31.1145477, -24.0910984],
      [31.12057, -24.0902601],
      [31.11885, -24.0998101],
      [31.11787, -24.1048401],
      [31.1151, -24.1192101],
      [31.09615, -24.1173601],
      [31.09841, -24.1230501],
      [31.10727, -24.1457301],
      [31.10277, -24.1491701],
      [31.07935, -24.1664901],
      [31.0519, -24.1859501],
      [31.04994, -24.1873201],
      [31.0518188, -24.2062409],
      [31.05208, -24.2088709],
      [31.05437, -24.2319301],
      [31.0544509, -24.2323621],
      [31.055, -24.2352901],
      [31.0555538, -24.2402745],
      [31.0555976, -24.2405845],
      [31.0577278, -24.2554426],
      [31.05865, -24.2609201],
      [31.0604055, -24.271595],
      [31.0604292, -24.2717394],
      [31.05719, -24.3105501],
      [31.05712, -24.3113701],
      [31.05682, -24.3131801],
      [31.05677, -24.3134301],
      [31.05616, -24.3203101],
      [31.05602, -24.3218901],
      [31.05719, -24.3219901],
      [31.0574, -24.3220001],
      [31.07352, -24.3225401],
      [31.1021853, -24.3239305],
      [31.13932, -24.3200901],
      [31.15252, -24.3186701],
      [31.16176, -24.3158901],
      [31.16585, -24.3146101],
      [31.2002678, -24.305238],
      [31.2068, -24.3150401],
      [31.21955, -24.3331901],
      [31.22889, -24.3468801],
      [31.24203, -24.3654301],
      [31.19895, -24.3707601],
      [31.16382, -24.3750901],
      [31.15997, -24.3755701],
      [31.1601, -24.3862601],
      [31.1600801, -24.3897609],
      [31.16007, -24.3913301],
      [31.16005, -24.3959001],
      [31.1600387, -24.4025813],
      [31.1601, -24.4145881],
      [31.16004, -24.4166201],
      [31.16004, -24.4234601],
      [31.15991, -24.4262601],
      [31.15991, -24.4299901],
      [31.15995, -24.4360001],
      [31.15995, -24.4374101],
      [31.2035527, -24.4263809],
      [31.2200832, -24.450228],
      [31.2202128, -24.4504314],
      [31.22647, -24.4602501],
      [31.2538643, -24.498926],
      [31.25277, -24.5008001],
      [31.25271, -24.5009101],
      [31.2263483, -24.5556597],
      [31.22618, -24.5560101],
      [31.2249719, -24.5560921],
      [31.2059499, -24.5574191],
      [31.2059199, -24.5574241],
      [31.1850399, -24.5591961],
      [31.1795759, -24.5596581],
      [31.16809, -24.5606301],
      [31.1680849, -24.5606651],
      [31.1680499, -24.5606661],
      [31.1592, -24.5614601],
      [31.15015, -24.5622901],
      [31.14476, -24.5629201],
      [31.13883, -24.5633601],
      [31.13511, -24.5637601],
      [31.1339123, -24.5638915],
      [31.13119, -24.5641901],
      [31.12857, -24.5644501],
      [31.1274499, -24.5645081],
      [31.12566, -24.5646001],
      [31.11854, -24.5654001],
      [31.11382, -24.5658101],
      [31.11238, -24.5659201],
      [31.11163, -24.5660401],
      [31.11108, -24.5661201],
      [31.10434, -24.5666401],
      [31.1003339, -24.5668261],
      [31.09938, -24.5668701],
      [31.09221, -24.5675901],
      [31.08621, -24.5681401],
      [31.07342, -24.5690301],
      [31.0690898, -24.5692891],
      [31.0677519, -24.5693691],
      [31.06757, -24.5693801],
      [31.0602, -24.5697801],
      [31.05374, -24.5702801],
      [31.0534, -24.5703201],
      [31.0390519, -24.5720101],
      [31.03897, -24.5720201],
      [31.0386954, -24.5720529],
      [31.0302609, -24.5730601],
      [31.0288338, -24.5732306],
      [31.0091229, -24.5755861],
      [31.00398, -24.5762001],
      [31.0036, -24.5762501],
      [31.0004265, -24.5766688],
      [30.99981, -24.5767501],
      [30.9883979, -24.5782461],
      [30.98181, -24.5791101],
      [30.97732, -24.5797101],
      [30.95932, -24.5820701],
      [30.9592719, -24.5814821],
      [30.95882, -24.5759901],
      [30.95832, -24.5699001],
      [30.95732, -24.5577401],
      [30.95682, -24.5516501],
      [30.95632, -24.5455701],
      [30.95588, -24.5402601],
      [30.95582, -24.5394901],
      [30.95532, -24.5334001],
      [30.95482, -24.5273201],
      [30.95433, -24.5212801],
      [30.9543, -24.5212801],
      [30.952, -24.5214901],
      [30.95091, -24.5215901],
      [30.95027, -24.5216501],
      [30.94622, -24.5220201],
      [30.9423299, -24.5223701],
      [30.94219, -24.5223801],
      [30.94181, -24.5224201],
      [30.94124, -24.5224701],
      [30.94113, -24.5224801],
      [30.93813, -24.5227501],
      [30.93671, -24.5228801],
      [30.93409, -24.5231201],
      [30.91789, -24.5246001],
      [30.91386, -24.5249701],
      [30.91381, -24.5249701],
      [30.91335, -24.5250301],
      [30.91286, -24.5251301],
      [30.9109, -24.5254501],
      [30.9104, -24.5255301],
      [30.90893, -24.5257701],
      [30.90525, -24.5269901],
      [30.90342, -24.5276001],
      [30.90157, -24.5281901],
      [30.89974, -24.5288201],
      [30.89862, -24.5292101],
      [30.89715, -24.5297101],
      [30.89569, -24.5302201],
      [30.89433, -24.5306901],
      [30.89131, -24.5317301],
      [30.88972, -24.5322801],
      [30.88814, -24.5328301],
      [30.88777, -24.5329501],
      [30.88694, -24.5332401],
      [30.8861, -24.5335301],
      [30.88444, -24.5341101],
      [30.8836, -24.5343901],
      [30.88277, -24.5346801],
      [30.88193, -24.5349701],
      [30.88027, -24.5355501],
      [30.87943, -24.5358301],
      [30.87789, -24.5363701],
      [30.87712, -24.5366301],
      [30.87634, -24.5369001],
      [30.87557, -24.5371701],
      [30.8748, -24.5374301],
      [30.87403, -24.5377001],
      [30.87325, -24.5379701],
      [30.87248, -24.5382401],
      [30.87171, -24.5385001],
      [30.86756, -24.5362101],
      [30.8291226, -24.5149744],
      [30.82897, -24.5148901],
      [30.82661, -24.5135801],
      [30.82066, -24.5104501],
      [30.80236, -24.5008101],
      [30.79928, -24.4988901],
      [30.78534, -24.4857801],
      [30.78136, -24.4818801],
      [30.78127, -24.4817801],
      [30.7757069, -24.4764371],
      [30.77215, -24.4729801],
      [30.75898, -24.4602201],
      [30.7586999, -24.46059],
      [30.7301799, -24.4985],
      [30.7307099, -24.5108],
      [30.7316616, -24.533058],
      [30.7317489, -24.5369667],
      [30.7322799, -24.54752],
      [30.7322814, -24.5475488],
      [30.7323099, -24.5480891],
      [30.7322599, -24.54833],
      [30.7312799, -24.57397],
      [30.7306399, -24.59653],
      [30.7304969, -24.6020531],
      [30.7303999, -24.60584],
      [30.7303199, -24.60873],
      [30.7265099, -24.6058371],
      [30.7218399, -24.60229],
      [30.7015499, -24.58641],
      [30.6792399, -24.62367],
      [30.6807899, -24.62637],
      [30.6943099, -24.64551],
      [30.6980799, -24.65094],
      [30.7096609, -24.6673641],
      [30.7149599, -24.68657],
      [30.7200999, -24.7052381],
      [30.7161199, -24.7083],
      [30.6855299, -24.7324],
      [30.6785699, -24.73581],
      [30.6366099, -24.73408],
      [30.6346399, -24.75089],
      [30.6337199, -24.7585],
      [30.6497999, -24.76702],
      [30.6642199, -24.77461],
      [30.6639899, -24.77568],
      [30.6561999, -24.81169],
      [30.6358899, -24.85066],
      [30.6348799, -24.85277],
      [30.6308899, -24.85066],
      [30.6186599, -24.84424],
      [30.6135599, -24.85821],
      [30.6128899, -24.86008],
      [30.6109399, -24.86538],
      [30.6104799, -24.86668],
      [30.6099199, -24.86821],
      [30.6093999, -24.86961],
      [30.6083649, -24.8724131],
      [30.6033499, -24.87514],
      [30.5997899, -24.87713],
      [30.5914399, -24.88157],
      [30.5818899, -24.88663],
      [30.5817299, -24.8867],
      [30.5816399, -24.8867],
      [30.5815799, -24.88671],
      [30.5814999, -24.88673],
      [30.5814399, -24.88675],
      [30.5813599, -24.88678],
      [30.5813099, -24.8868],
      [30.5811999, -24.88684],
      [30.5811299, -24.88687],
      [30.5810699, -24.88691],
      [30.5809999, -24.88693],
      [30.5809199, -24.88697],
      [30.5808299, -24.887],
      [30.5807499, -24.88704],
      [30.5806599, -24.88708],
      [30.5805899, -24.88711],
      [30.5805299, -24.88714],
      [30.5804699, -24.88716],
      [30.5803899, -24.88718],
      [30.5803199, -24.88719],
      [30.5802699, -24.88721],
      [30.5802299, -24.88723],
      [30.5802199, -24.88727],
      [30.5801599, -24.88728],
      [30.5800699, -24.88731],
      [30.5800199, -24.88733],
      [30.5799699, -24.88737],
      [30.5799899, -24.88759],
      [30.5800203, -24.8883662],
      [30.5804999, -24.90066],
      [30.5811699, -24.91691],
      [30.5763399, -24.9115],
      [30.5666299, -24.90066],
      [30.5645199, -24.8983],
      [30.5628799, -24.89646],
      [30.5498099, -24.8999],
      [30.5451399, -24.90112],
      [30.5443499, -24.90143],
      [30.5435999, -24.90169],
      [30.5320699, -24.90484],
      [30.5220599, -24.90757],
      [30.5140699, -24.90979],
      [30.5068399, -24.91185],
      [30.5066399, -24.91192],
      [30.5064599, -24.91196],
      [30.5011849, -24.9134141],
      [30.4968799, -24.9146],
      [30.4963099, -24.91472],
      [30.4962999, -24.91482],
      [30.4958499, -24.92112],
      [30.4956899, -24.92433],
      [30.4956899, -24.92451],
      [30.4961699, -24.92487],
      [30.4959899, -24.92825],
      [30.4952599, -24.93627],
      [30.4948099, -24.94461],
      [30.4942199, -24.95327],
      [30.4887699, -24.94834],
      [30.4866599, -24.94609],
      [30.4853199, -24.94498],
      [30.4841999, -24.94366],
      [30.4838999, -24.94337],
      [30.4723599, -24.93242],
      [30.4667599, -24.92691],
      [30.4661299, -24.92632],
      [30.4650199, -24.92509],
      [30.4596999, -24.91983],
      [30.4536899, -24.91412],
      [30.4515399, -24.912],
      [30.4468999, -24.89552],
      [30.4440799, -24.88626],
      [30.4407199, -24.87431],
      [30.4379799, -24.86434],
      [30.4250699, -24.85486],
      [30.3897699, -24.84945],
      [30.3897399, -24.84944],
      [30.3897699, -24.84952],
      [30.3898199, -24.84962],
      [30.3900299, -24.84995],
      [30.3901399, -24.85012],
      [30.3901999, -24.85033],
      [30.3902899, -24.85053],
      [30.3903899, -24.85082],
      [30.3905099, -24.85103],
      [30.3905999, -24.85116],
      [30.3906999, -24.8514],
      [30.3908199, -24.85213],
      [30.3907999, -24.85245],
      [30.3907599, -24.8526],
      [30.3906999, -24.8527],
      [30.3906399, -24.85279],
      [30.3905599, -24.85295],
      [30.3904699, -24.85321],
      [30.3904199, -24.85342],
      [30.3903999, -24.85362],
      [30.3903299, -24.85399],
      [30.3902699, -24.8543],
      [30.3901999, -24.85467],
      [30.3901699, -24.85492],
      [30.3901499, -24.85513],
      [30.3901599, -24.85525],
      [30.3901799, -24.85547],
      [30.3902799, -24.85581],
      [30.3903399, -24.85598],
      [30.3903599, -24.85613],
      [30.3903399, -24.85642],
      [30.3902899, -24.85682],
      [30.3902599, -24.85701],
      [30.3901699, -24.85743],
      [30.3900899, -24.85766],
      [30.3900499, -24.85777],
      [30.3899199, -24.8582201],
      [30.3899034, -24.8583006],
      [30.3898499, -24.8585601],
      [30.3897999, -24.8588201],
      [30.3897299, -24.8592001],
      [30.3896799, -24.8594901],
      [30.3896399, -24.8598501],
      [30.3896399, -24.8600201],
      [30.3896699, -24.8601601],
      [30.3897099, -24.8603201],
      [30.3897799, -24.8604901],
      [30.3899599, -24.8607801],
      [30.3900799, -24.8610601],
      [30.3902099, -24.8612001],
      [30.3905099, -24.8615101],
      [30.3907799, -24.8617701],
      [30.3909299, -24.8619501],
      [30.3910699, -24.86208],
      [30.3912099, -24.86216],
      [30.3913399, -24.86222],
      [30.3914599, -24.86226],
      [30.3916299, -24.8623],
      [30.3918999, -24.8623],
      [30.3920399, -24.8622701],
      [30.3921499, -24.86222],
      [30.3922599, -24.86212],
      [30.3923799, -24.86201],
      [30.3924699, -24.86189],
      [30.3926899, -24.86166],
      [30.3927899, -24.86154],
      [30.3929999, -24.86139],
      [30.3933199, -24.86114],
      [30.3935199, -24.861],
      [30.3937099, -24.8609001],
      [30.3939899, -24.8607601],
      [30.3943899, -24.8606401],
      [30.3945999, -24.8606001],
      [30.3947299, -24.8606001],
      [30.3950799, -24.8606501],
      [30.3956699, -24.8607201],
      [30.3958499, -24.8608101],
      [30.3959899, -24.8609801],
      [30.3960999, -24.8611601],
      [30.3961999, -24.8613601],
      [30.3963099, -24.8615301],
      [30.3963899, -24.8617101],
      [30.3964199, -24.8618801],
      [30.3964299, -24.8621001],
      [30.3964199, -24.8623601],
      [30.3963799, -24.8625101],
      [30.3963599, -24.8626401],
      [30.3963299, -24.8628101],
      [30.3963099, -24.8630101],
      [30.3963399, -24.8631601],
      [30.3963699, -24.8633701],
      [30.3964099, -24.8636201],
      [30.3963999, -24.8638001],
      [30.3963799, -24.8639201],
      [30.3963999, -24.8641601],
      [30.3964299, -24.8643601],
      [30.3965399, -24.8647301],
      [30.3965999, -24.8649901],
      [30.3966899, -24.8651501],
      [30.3967899, -24.8653101],
      [30.3968599, -24.8654401],
      [30.3969399, -24.8655001],
      [30.3970499, -24.8658001],
      [30.3970999, -24.8659601],
      [30.3971899, -24.8661101],
      [30.3973399, -24.86631],
      [30.3974899, -24.8665001],
      [30.3975999, -24.8666801],
      [30.3977299, -24.8668301],
      [30.3979099, -24.8670201],
      [30.3980599, -24.8672001],
      [30.3982099, -24.86744],
      [30.3984699, -24.86782],
      [30.3985499, -24.86796],
      [30.3985899, -24.86814],
      [30.3986199, -24.86827],
      [30.3986099, -24.8685001],
      [30.3985699, -24.8688],
      [30.3985199, -24.86901],
      [30.3984499, -24.86917],
      [30.3983399, -24.86933],
      [30.3982399, -24.86948],
      [30.3981299, -24.86961],
      [30.3978999, -24.86985],
      [30.3977499, -24.86999],
      [30.3975899, -24.87011],
      [30.3974699, -24.87021],
      [30.3971499, -24.87047],
      [30.3968199, -24.8708],
      [30.3966899, -24.87097],
      [30.3965999, -24.87108],
      [30.3964899, -24.8712],
      [30.3964599, -24.87123],
      [30.3961899, -24.87086],
      [30.3736399, -24.85922],
      [30.3660899, -24.85544],
      [30.3541699, -24.84928],
      [30.3538399, -24.85708],
      [30.3535099, -24.86505],
      [30.3533799, -24.86624],
      [30.3534699, -24.87296],
      [30.3532299, -24.8781],
      [30.3528799, -24.88345],
      [30.3203599, -24.87578],
      [30.3192899, -24.87556],
      [30.3163599, -24.87483],
      [30.3108999, -24.87292],
      [30.3104799, -24.87308],
      [30.3102899, -24.87317],
      [30.3098099, -24.87332],
      [30.3095199, -24.87349],
      [30.3092399, -24.87364],
      [30.3089099, -24.8738201],
      [30.3087399, -24.8741501],
      [30.3085599, -24.8743801],
      [30.3085299, -24.8745101],
      [30.3085099, -24.8748001],
      [30.3085699, -24.8751101],
      [30.3085599, -24.8753601],
      [30.3086099, -24.8756601],
      [30.3087299, -24.8759401],
      [30.3088099, -24.8760501],
      [30.3088899, -24.8762701],
      [30.3090999, -24.8766501],
      [30.3092899, -24.87689],
      [30.3093999, -24.87702],
      [30.3097099, -24.87742],
      [30.3097699, -24.87759],
      [30.3099099, -24.87779],
      [30.3099699, -24.87804],
      [30.3099799, -24.87823],
      [30.3100799, -24.87845],
      [30.3100999, -24.87868],
      [30.3101199, -24.87904],
      [30.3101099, -24.87921],
      [30.3100499, -24.87948],
      [30.3100099, -24.87973],
      [30.3099299, -24.88003],
      [30.3099299, -24.88025],
      [30.3100299, -24.88063],
      [30.3102899, -24.88081],
      [30.3104599, -24.88087],
      [30.3106799, -24.88106],
      [30.3109399, -24.88118],
      [30.3113299, -24.88125],
      [30.3115899, -24.88136],
      [30.3118099, -24.88146],
      [30.3121799, -24.8817],
      [30.3122899, -24.88199],
      [30.3124299, -24.88224],
      [30.3123799, -24.88248],
      [30.3122099, -24.88269],
      [30.3120999, -24.88301],
      [30.3120199, -24.88338],
      [30.3118399, -24.88359],
      [30.3117399, -24.88376],
      [30.3111399, -24.88351],
      [30.3088499, -24.88273],
      [30.3080299, -24.88505],
      [30.3062599, -24.88426],
      [30.3067899, -24.88147],
      [30.2972899, -24.86774],
      [30.2852099, -24.86649],
      [30.2815269, -24.8659811],
      [30.2464199, -24.86233],
      [30.2274899, -24.86001],
      [30.2232899, -24.85957],
      [30.2172299, -24.8589],
      [30.1984899, -24.85678],
      [30.1919799, -24.85547],
      [30.1883599, -24.87253],
      [30.1871899, -24.87898],
      [30.1850199, -24.8896],
      [30.1784699, -24.92206],
      [30.1779799, -24.92609],
      [30.1778899, -24.92665],
      [30.1775699, -24.9282],
      [30.1764599, -24.93682],
      [30.1749427, -24.948073],
      [30.1748999, -24.94839],
      [30.1730299, -24.96095],
      [30.1717299, -24.9698001],
      [30.1715399, -24.97226],
      [30.1720699, -24.98917],
      [30.1794599, -24.98964],
      [30.1791699, -24.99703],
      [30.1791999, -24.99911],
      [30.1829299, -25.00562],
      [30.1925799, -25.02245],
      [30.1971599, -25.03088],
      [30.1986599, -25.03636],
      [30.1751799, -25.03143],
      [30.1593399, -25.02803],
      [30.1485099, -25.03235],
      [30.1485699, -25.0339],
      [30.1484299, -25.05141],
      [30.1485799, -25.08995],
      [30.1444299, -25.09121],
      [30.1444299, -25.0983],
      [30.1444399, -25.10173],
      [30.1444599, -25.10517],
      [30.1443799, -25.10841],
      [30.1443899, -25.12379],
      [30.1211499, -25.12086],
      [30.0908499, -25.1255],
      [30.0902399, -25.10811],
      [30.0768209, -25.0979321],
      [30.0580699, -25.08371],
      [30.0566999, -25.0827],
      [30.0561299, -25.08231],
      [30.0298699, -25.06413],
      [30.0298399, -25.08457],
      [30.0005199, -25.08898],
      [29.9789499, -25.09212],
      [29.9950799, -25.12361],
      [29.9977499, -25.12913],
      [29.9992899, -25.13226],
      [30.0003299, -25.13429],
      [30.0003699, -25.13437],
      [30.0024599, -25.13853],
      [30.0054099, -25.14438],
      [30.0055499, -25.14712],
      [30.0058799, -25.15366],
      [30.0062299, -25.16062],
      [30.0065399, -25.16666],
      [30.0070199, -25.176],
      [30.0072499, -25.18067],
      [30.0074899, -25.18533],
      [30.0077099, -25.18961],
      [30.0079199, -25.19389],
      [30.0080799, -25.19686],
      [30.0080899, -25.19722],
      [30.0082899, -25.20099],
      [30.0083099, -25.20135],
      [30.0083399, -25.20209],
      [30.0083799, -25.20282],
      [30.0084199, -25.20356],
      [30.0084599, -25.20429],
      [30.0084899, -25.20503],
      [30.0085299, -25.20577],
      [30.0085699, -25.2065],
      [30.0086099, -25.20724],
      [30.0086399, -25.20798],
      [30.0086599, -25.20862],
      [30.0086699, -25.20927],
      [30.0087199, -25.21059],
      [30.0087999, -25.2123],
      [30.0088299, -25.21302],
      [30.0097399, -25.22949],
      [30.0098299, -25.2311751],
      [30.0098399, -25.23128],
      [30.0109899, -25.23118],
      [30.0128999, -25.23096],
      [30.0121499, -25.23471],
      [30.0118299, -25.23632],
      [30.0101999, -25.24447],
      [30.0091099, -25.24953],
      [30.0073599, -25.25606],
      [30.0066999, -25.25848],
      [30.0059199, -25.26106],
      [30.0051099, -25.26375],
      [30.0035899, -25.26924],
      [30.0006699, -25.27948],
      [30.0008099, -25.28097],
      [30.0009899, -25.28279],
      [30.0012199, -25.28528],
      [30.0016799, -25.29031],
      [30.0017899, -25.29148],
      [30.0025899, -25.30043],
      [30.0028499, -25.30332],
      [30.0029999, -25.30495],
      [30.0030469, -25.3054671],
      [30.0036699, -25.3123],
      [30.0042999, -25.31916],
      [30.0045499, -25.32179],
      [30.0046299, -25.32274],
      [30.0056699, -25.33415],
      [30.0056799, -25.33426],
      [30.0057299, -25.33486],
      [30.0057899, -25.33546],
      [30.0058399, -25.33607],
      [30.0059599, -25.33729],
      [30.0060099, -25.33789],
      [30.0060599, -25.3385],
      [30.0061199, -25.33911],
      [30.0061799, -25.33971],
      [30.0062349, -25.3403301],
      [30.0062099, -25.34034],
      [30.0031899, -25.33994],
      [30.0016699, -25.33973],
      [30.0001599, -25.33953],
      [29.9986399, -25.33933],
      [29.9971299, -25.33913],
      [29.9956099, -25.33893],
      [29.9940099, -25.33871],
      [29.9927399, -25.33854],
      [29.9914599, -25.33837],
      [29.9905899, -25.3382501],
      [29.9903999, -25.3382301],
      [29.9870399, -25.3377701],
      [29.9839699, -25.3373501],
      [29.9814999, -25.3370101],
      [29.9805599, -25.3368901],
      [29.9792999, -25.3367201],
      [29.9779399, -25.3365301],
      [29.9766799, -25.3363601],
      [29.9743299, -25.3360401],
      [29.9650999, -25.3347801],
      [29.9599399, -25.3340801],
      [29.9585099, -25.3338801],
      [29.9576099, -25.3337601],
      [29.9451399, -25.3320601],
      [29.9375699, -25.3310201],
      [29.9375571, -25.331022],
      [29.9199299, -25.3337101],
      [29.9159599, -25.3343201],
      [29.9136999, -25.3346601],
      [29.9087199, -25.3354201],
      [29.8981199, -25.3370301],
      [29.8957499, -25.3373901],
      [29.8924699, -25.3378901],
      [29.8879199, -25.3385801],
      [29.8879099, -25.3412001],
      [29.8878799, -25.3476101],
      [29.8878699, -25.3481701],
      [29.8878599, -25.3502501],
      [29.8878599, -25.3511101],
      [29.8878499, -25.3524701],
      [29.8878299, -25.3569001],
      [29.8878099, -25.3609501],
      [29.8877999, -25.3643401],
      [29.8871899, -25.3646201],
      [29.8870799, -25.3646801],
      [29.8827899, -25.3666701],
      [29.8792199, -25.3683401],
      [29.8698499, -25.3726901],
      [29.8640499, -25.3753901],
      [29.8605499, -25.3770001],
      [29.8589199, -25.3777501],
      [29.8535899, -25.3802001],
      [29.8523799, -25.3807701],
      [29.8414099, -25.3858101],
      [29.8402999, -25.3863201],
      [29.8402799, -25.3860501],
      [29.8402599, -25.3858001],
      [29.8402199, -25.3855901],
      [29.8401999, -25.3853601],
      [29.8401699, -25.3850501],
      [29.8401599, -25.3849201],
      [29.8401499, -25.3847701],
      [29.8400899, -25.3846101],
      [29.8399699, -25.3844301],
      [29.8398299, -25.3842301],
      [29.8397099, -25.3841101],
      [29.8396099, -25.3840001],
      [29.8394799, -25.3839001],
      [29.8392799, -25.3837501],
      [29.8390699, -25.3836101],
      [29.8388299, -25.3834301],
      [29.8386699, -25.3833001],
      [29.8384699, -25.3831501],
      [29.8381899, -25.3829901],
      [29.8379699, -25.3828601],
      [29.8377599, -25.3826301],
      [29.8375899, -25.3824101],
      [29.8374799, -25.3822001],
      [29.8373799, -25.3819501],
      [29.8372599, -25.3817801],
      [29.8371499, -25.3814201],
      [29.8370699, -25.3812101],
      [29.8369999, -25.3809501],
      [29.8369699, -25.3807501],
      [29.8369299, -25.3804201],
      [29.8369399, -25.3797501],
      [29.8369299, -25.3792901],
      [29.8369599, -25.3789901],
      [29.8369899, -25.3787701],
      [29.8370199, -25.3786101],
      [29.8370899, -25.3784001],
      [29.8371999, -25.3780501],
      [29.8372999, -25.3776701],
      [29.8373499, -25.3775001],
      [29.8373699, -25.3773501],
      [29.8373699, -25.3772601],
      [29.8373099, -25.3770101],
      [29.8372499, -25.3768201],
      [29.8370899, -25.3765701],
      [29.8369499, -25.3763901],
      [29.8367899, -25.3762601],
      [29.8366399, -25.3761201],
      [29.8363999, -25.37593],
      [29.8361599, -25.3757001],
      [29.8358499, -25.3754301],
      [29.8356399, -25.37525],
      [29.8354899, -25.37506],
      [29.8353299, -25.37484],
      [29.8351899, -25.3746501],
      [29.8350599, -25.3744501],
      [29.8349299, -25.3742401],
      [29.8347799, -25.3740301],
      [29.8346599, -25.3738001],
      [29.8344899, -25.37353],
      [29.8343599, -25.37333],
      [29.8342899, -25.37318],
      [29.8342099, -25.373],
      [29.8340899, -25.37275],
      [29.8339699, -25.37245],
      [29.8338999, -25.37231],
      [29.8338099, -25.37216],
      [29.8337099, -25.37201],
      [29.8336199, -25.37186],
      [29.8335699, -25.37171],
      [29.8334499, -25.37147],
      [29.8333399, -25.37121],
      [29.8332299, -25.37103],
      [29.8331199, -25.37086],
      [29.8330099, -25.37067],
      [29.8328999, -25.37043],
      [29.8327999, -25.37023],
      [29.8326599, -25.36997],
      [29.8325799, -25.36979],
      [29.8325799, -25.36959],
      [29.8325599, -25.36931],
      [29.8325599, -25.36903],
      [29.8325799, -25.36864],
      [29.8325599, -25.36827],
      [29.8325099, -25.36797],
      [29.8324799, -25.36773],
      [29.8324699, -25.36744],
      [29.8324599, -25.36725],
      [29.8324399, -25.36706],
      [29.8323899, -25.36683],
      [29.8323399, -25.36661],
      [29.8322599, -25.3664201],
      [29.8321599, -25.3662001],
      [29.8321099, -25.3660101],
      [29.8320899, -25.3658001],
      [29.8320499, -25.3656101],
      [29.8319999, -25.3654801],
      [29.8318899, -25.3653701],
      [29.8316799, -25.3652201],
      [29.8315499, -25.3651301],
      [29.8313199, -25.3650201],
      [29.8310699, -25.3649401],
      [29.8308199, -25.3648401],
      [29.8306099, -25.3647801],
      [29.8303899, -25.3647301],
      [29.8298499, -25.3647301],
      [29.8295599, -25.3647801],
      [29.8290999, -25.3648701],
      [29.8286799, -25.3649201],
      [29.8282799, -25.3649901],
      [29.8279199, -25.3650401],
      [29.8276399, -25.3650501],
      [29.8274099, -25.3650301],
      [29.8272799, -25.3649901],
      [29.8271899, -25.3649201],
      [29.8270599, -25.3647901],
      [29.8269199, -25.3646901],
      [29.8267999, -25.3645901],
      [29.8266899, -25.3644601],
      [29.8265999, -25.3642701],
      [29.8265399, -25.3641401],
      [29.8264599, -25.3639101],
      [29.8263699, -25.3636201],
      [29.8262899, -25.3633701],
      [29.8262399, -25.3632101],
      [29.8261999, -25.3630501],
      [29.8261599, -25.3628501],
      [29.8261099, -25.3626301],
      [29.8260799, -25.3624801],
      [29.8260399, -25.3623201],
      [29.8259599, -25.3622201],
      [29.8258399, -25.3621101],
      [29.8257199, -25.3620101],
      [29.8255899, -25.3619101],
      [29.8253899, -25.3617901],
      [29.8252799, -25.3617201],
      [29.8251699, -25.3616801],
      [29.8249799, -25.3616501],
      [29.8245999, -25.3616701],
      [29.8244499, -25.3616801],
      [29.8243499, -25.3617201],
      [29.8242799, -25.3617701],
      [29.8242099, -25.3618301],
      [29.8240999, -25.3619201],
      [29.8239999, -25.3620301],
      [29.8238499, -25.3621401],
      [29.8237099, -25.3622001],
      [29.8235699, -25.3622901],
      [29.8234499, -25.3623501],
      [29.8233199, -25.3623701],
      [29.8231799, -25.3623701],
      [29.8230399, -25.3623501],
      [29.8229399, -25.3623101],
      [29.8228699, -25.3622401],
      [29.8227799, -25.3621301],
      [29.8226999, -25.3619701],
      [29.8226799, -25.3618701],
      [29.8226699, -25.3617801],
      [29.8226799, -25.3616201],
      [29.8226999, -25.3615201],
      [29.8227099, -25.3613101],
      [29.8226999, -25.3611201],
      [29.8226399, -25.3610201],
      [29.8225499, -25.3609101],
      [29.8224299, -25.3608001],
      [29.8223699, -25.3607601],
      [29.8222299, -25.3607301],
      [29.8220699, -25.3607201],
      [29.8219499, -25.3607001],
      [29.8217799, -25.3606701],
      [29.8216499, -25.3606201],
      [29.8214999, -25.3605501],
      [29.8213999, -25.3604901],
      [29.8213199, -25.3604301],
      [29.8212199, -25.3603001],
      [29.8211499, -25.3601601],
      [29.8210799, -25.3600101],
      [29.8209699, -25.3597601],
      [29.8208999, -25.3596501],
      [29.8208499, -25.3595601],
      [29.8208099, -25.3595301],
      [29.8207099, -25.3594701],
      [29.8206099, -25.3593801],
      [29.8205199, -25.3592601],
      [29.8204699, -25.3591301],
      [29.8204299, -25.3590201],
      [29.8203699, -25.3589401],
      [29.8202899, -25.3588701],
      [29.8201999, -25.3588601],
      [29.8200199, -25.3588701],
      [29.8199299, -25.3589001],
      [29.8198399, -25.3589601],
      [29.8197799, -25.3590601],
      [29.8197599, -25.3591501],
      [29.8197599, -25.3592401],
      [29.8198299, -25.3594001],
      [29.8199699, -25.3595701],
      [29.8201699, -25.3598401],
      [29.8202699, -25.3600301],
      [29.8203099, -25.3602401],
      [29.8203199, -25.3604001],
      [29.8202799, -25.3605001],
      [29.8202199, -25.3605501],
      [29.8200699, -25.3607201],
      [29.8198199, -25.3608301],
      [29.8189799, -25.3612001],
      [29.8170799, -25.3620201],
      [29.8121399, -25.3620201],
      [29.8115499, -25.3620301],
      [29.8108799, -25.3620301],
      [29.8051099, -25.3620401],
      [29.8024899, -25.3620401],
      [29.8003399, -25.3620501],
      [29.7993489, -25.3620516],
      [29.7934599, -25.3620601],
      [29.7931899, -25.3620601],
      [29.7770359, -25.3898471],
      [29.7702399, -25.40153],
      [29.7558599, -25.39511],
      [29.7485099, -25.39217],
      [29.7458199, -25.39113],
      [29.7449699, -25.39081],
      [29.7276499, -25.38416],
      [29.7123499, -25.38075],
      [29.7069999, -25.37956],
      [29.7013099, -25.37829],
      [29.6963199, -25.37717],
      [29.6919799, -25.3762],
      [29.6738599, -25.37216],
      [29.6518499, -25.38242],
      [29.6418999, -25.38706],
      [29.6336099, -25.39092],
      [29.6329299, -25.39123],
      [29.6254699, -25.39471],
      [29.6198599, -25.39732],
      [29.6196699, -25.39741],
      [29.6148999, -25.39963],
      [29.6127899, -25.40061],
      [29.5992099, -25.39774],
      [29.5968799, -25.39725],
      [29.5968399, -25.39724],
      [29.5869999, -25.39516],
      [29.5798399, -25.39621],
      [29.5571899, -25.39973],
      [29.5453899, -25.40154],
      [29.5226299, -25.40504],
      [29.5197299, -25.41859],
      [29.5188785, -25.4228376],
      [29.5119799, -25.4211601],
      [29.5095499, -25.4205901],
      [29.4862499, -25.4150701],
      [29.4820749, -25.4140901],
      [29.4717099, -25.4116701],
      [29.4599299, -25.4089201],
      [29.4527799, -25.4072501],
      [29.4529599, -25.4065201],
      [29.4399399, -25.4084001],
      [29.4288799, -25.4099901],
      [29.4142399, -25.4120901],
      [29.4071799, -25.4131101],
      [29.4000099, -25.4141401],
      [29.3999599, -25.4141401],
      [29.3999199, -25.4141901],
      [29.3992999, -25.4146301],
      [29.3989499, -25.4148301],
      [29.3903099, -25.4130601],
      [29.3797399, -25.4107801],
      [29.3694399, -25.4085801],
      [29.3630626, -25.407263],
      [29.3627099, -25.4071901],
      [29.3624599, -25.4071101],
      [29.3622699, -25.40707],
      [29.3551199, -25.40559],
      [29.3528499, -25.40512],
      [29.3499599, -25.40464],
      [29.3497399, -25.4037],
      [29.3480299, -25.39682],
      [29.3466299, -25.39116],
      [29.3433899, -25.37807],
      [29.3430599, -25.37674],
      [29.3430099, -25.37652],
      [29.3424299, -25.37419],
      [29.3421299, -25.37307],
      [29.3398299, -25.3738],
      [29.3396399, -25.37387],
      [29.3396099, -25.37388],
      [29.3296499, -25.37716],
      [29.3214399, -25.37987],
      [29.3113999, -25.37909],
      [29.2644339, -25.3754631],
      [29.2530999, -25.38354],
      [29.2488699, -25.3923],
      [29.2431776, -25.4033234],
      [29.2430399, -25.40359],
      [29.2425099, -25.40347],
      [29.2375399, -25.40233],
      [29.2073389, -25.4145721],
      [29.1956999, -25.37028],
      [29.1312699, -25.39024],
      [29.1420199, -25.38583],
      [29.1493299, -25.37542],
      [29.1560099, -25.36596],
      [29.1641199, -25.35448],
      [29.1745773, -25.3186498],
      [29.1746219, -25.3184971],
      [29.1746299, -25.31847],
      [29.1746102, -25.3184398],
      [29.1745199, -25.3183],
      [29.1705999, -25.31245],
      [29.1669599, -25.30336],
      [29.1541311, -25.3059103],
      [29.1536799, -25.306],
      [29.1465799, -25.30746],
      [29.1438511, -25.3080198],
      [29.1420799, -25.3083831],
      [29.1394599, -25.30892],
      [29.1328899, -25.31031],
      [29.1255399, -25.31177],
      [29.1183699, -25.31324],
      [29.1180999, -25.31332],
      [29.1177099, -25.31345],
      [29.1112699, -25.31571],
      [29.1042799, -25.3182],
      [29.0971299, -25.32074],
      [29.0958899, -25.32118],
      [29.0958609, -25.3210351],
      [29.0928596, -25.3043513],
      [29.092859, -25.3043479],
      [29.0901699, -25.2894],
      [29.0894399, -25.2897851],
      [29.0854399, -25.29233],
      [29.0843999, -25.29288],
      [29.0843099, -25.29258],
      [29.0842599, -25.29239],
      [29.0841799, -25.29213],
      [29.0841099, -25.29189],
      [29.0839699, -25.29137],
      [29.0838899, -25.29109],
      [29.0838099, -25.29082],
      [29.0836999, -25.29045],
      [29.0835799, -25.29003],
      [29.0835099, -25.2898],
      [29.0834099, -25.28942],
      [29.0833499, -25.28923],
      [29.0831299, -25.28846],
      [29.0829799, -25.28796],
      [29.0828999, -25.28767],
      [29.0827299, -25.28709],
      [29.0774299, -25.28516],
      [29.0763899, -25.28478],
      [29.0760699, -25.28461],
      [29.0759799, -25.28467],
      [29.0758499, -25.28474],
      [29.0756599, -25.28488],
      [29.0754999, -25.28499],
      [29.0753699, -25.2851],
      [29.0751799, -25.28521],
      [29.0747499, -25.28541],
      [29.0745099, -25.28553],
      [29.0742299, -25.2857],
      [29.0740099, -25.28585],
      [29.0737299, -25.28605],
      [29.0734899, -25.28624],
      [29.0732499, -25.28644],
      [29.0730499, -25.28662],
      [29.0727499, -25.28687],
      [29.0725199, -25.28646],
      [29.0723699, -25.28639],
      [29.0721199, -25.28629],
      [29.0631184, -25.2823901],
      [29.063074, -25.2823709],
      [29.0630557, -25.2823629],
      [29.0626799, -25.2822001],
      [29.0601079, -25.2810101],
      [29.0564799, -25.2793301],
      [29.0503699, -25.28018],
      [29.0502899, -25.28019],
      [29.0384449, -25.2764601],
      [29.0348599, -25.26456],
      [29.0355299, -25.2642],
      [29.0361899, -25.26384],
      [29.0368499, -25.26349],
      [29.0374599, -25.26316],
      [29.0380599, -25.26283],
      [29.0386499, -25.26251],
      [29.0400099, -25.26177],
      [29.0406799, -25.2614],
      [29.0413599, -25.26103],
      [29.0403799, -25.25999],
      [29.0393899, -25.25896],
      [29.0383999, -25.25792],
      [29.0374199, -25.25688],
      [29.0364299, -25.25585],
      [29.0354499, -25.25481],
      [29.0334699, -25.25273],
      [29.0318399, -25.2508901],
      [29.0322599, -25.24933],
      [29.0325929, -25.2480751],
      [29.0326272, -25.2479455],
      [29.0327799, -25.24737],
      [29.0334699, -25.24483],
      [29.0351299, -25.23865],
      [29.0366499, -25.23297],
      [29.0381099, -25.22755],
      [29.0386789, -25.2254231],
      [29.0392871, -25.2231499],
      [29.0393299, -25.22299],
      [29.0399279, -25.2207861],
      [29.0399999, -25.22052],
      [29.0413299, -25.21557],
      [29.0425599, -25.21089],
      [29.0436499, -25.20669],
      [29.0448889, -25.2022441],
      [29.0448999, -25.2022],
      [29.0448999, -25.20216],
      [29.0446899, -25.19647],
      [29.0444599, -25.19078],
      [29.0442699, -25.18509],
      [29.0442299, -25.18399],
      [29.0442299, -25.18395],
      [29.0439999, -25.17811],
      [29.0439239, -25.1761781],
      [29.0438712, -25.1748435],
      [29.0438702, -25.1748191],
      [29.0437699, -25.17228],
      [29.0436099, -25.16829],
      [29.0434499, -25.16431],
      [29.0433499, -25.162],
      [29.0432399, -25.15918],
      [29.0430099, -25.15313],
      [29.0427699, -25.14682],
      [29.0425161, -25.1406506],
      [29.0425099, -25.1405],
      [29.0537212, -25.1423895],
      [29.0604899, -25.14353],
      [29.0605399, -25.14354],
      [29.0705699, -25.14523],
      [29.0733099, -25.1456881],
      [29.0746326, -25.145909],
      [29.0845159, -25.1475591],
      [29.0859599, -25.1478],
      [29.0898399, -25.14845],
      [29.0868699, -25.13654],
      [29.0993739, -25.1294351],
      [29.0994519, -25.1293901],
      [29.0996599, -25.12927],
      [29.0997391, -25.1292258],
      [29.0998598, -25.1291582],
      [29.0998779, -25.129148],
      [29.1017499, -25.1281],
      [29.1020399, -25.12793],
      [29.1107499, -25.12302],
      [29.1198199, -25.1179],
      [29.1274878, -25.1135737],
      [29.1281499, -25.1132],
      [29.1284299, -25.11304],
      [29.1284146, -25.1130316],
      [29.1184999, -25.10752],
      [29.1154599, -25.1058301],
      [29.1134399, -25.1047001],
      [29.1116799, -25.1037201],
      [29.1108403, -25.1032537],
      [29.1062599, -25.1007101],
      [29.1057599, -25.1004301],
      [29.1016099, -25.1027201],
      [29.0978999, -25.1002501],
      [29.0942499, -25.1032101],
      [29.092876, -25.1018275],
      [29.0928203, -25.1017714],
      [29.0926699, -25.1016201],
      [29.0912499, -25.1002001],
      [29.0882899, -25.1036201],
      [29.0874699, -25.1021701],
      [29.0863899, -25.1002401],
      [29.0849499, -25.0977101],
      [29.0872999, -25.0951201],
      [29.0902999, -25.0917901],
      [29.0880399, -25.0904601],
      [29.0856799, -25.0887801],
      [29.0855799, -25.0882601],
      [29.0855709, -25.0882141],
      [29.0834999, -25.0850701],
      [29.0802099, -25.0800401],
      [29.0769799, -25.0751101],
      [29.0768199, -25.0748701],
      [29.0738199, -25.0702801],
      [29.0707799, -25.0656301],
      [29.0706639, -25.0654661],
      [29.0659099, -25.0644901],
      [29.0611899, -25.0635301],
      [29.0564999, -25.0625701],
      [29.0517799, -25.0616101],
      [29.0476949, -25.0607841],
      [29.0472624, -25.0606969],
      [29.047168, -25.0606779],
      [29.0470799, -25.0606601],
      [29.0423599, -25.0597001],
      [29.0376699, -25.0587401],
      [29.0329599, -25.0577801],
      [29.0282499, -25.0568201],
      [29.0235499, -25.0558701],
      [29.0189968, -25.0549383],
      [29.0188099, -25.0549001],
      [29.0187849, -25.0549091],
      [29.0153499, -25.0561701],
      [29.0134199, -25.0568701],
      [29.0133949, -25.0568801],
      [29.0110099, -25.0578201],
      [29.0102799, -25.0581101],
      [29.0066399, -25.0595301],
      [29.0022199, -25.0612701],
      [29.0009699, -25.0617601],
      [28.9995799, -25.0621401],
      [28.9982399, -25.0626901],
      [28.9936999, -25.0643201],
      [28.9898299, -25.0658801],
      [28.9894599, -25.0660101],
      [28.9849599, -25.0676701],
      [28.9808099, -25.0691901],
      [28.9763599, -25.0708301],
      [28.9754299, -25.0687001],
      [28.9717099, -25.0701801],
      [28.9709299, -25.0685301],
      [28.9699699, -25.0665201],
      [28.9690999, -25.0646701],
      [28.9682799, -25.0629401],
      [28.9680799, -25.0625301],
      [28.9671799, -25.0606301],
      [28.9668299, -25.0598901],
      [28.9663399, -25.0599901],
      [28.9662399, -25.0600101],
      [28.9657399, -25.0588901],
      [28.9649299, -25.0571201],
      [28.9639599, -25.0553001],
      [28.9632299, -25.0534401],
      [28.9623799, -25.0516201],
      [28.9617099, -25.0499001],
      [28.9605999, -25.0479201],
      [28.9597399, -25.0462001],
      [28.9587899, -25.0441401],
      [28.9579599, -25.0425601],
      [28.9568799, -25.0408101],
      [28.9567999, -25.0405101],
      [28.9566799, -25.0400801],
      [28.9564299, -25.0391801],
      [28.9564099, -25.0390801],
      [28.9562999, -25.0386701],
      [28.9555299, -25.0369801],
      [28.9547499, -25.0351601],
      [28.9537699, -25.0333101],
      [28.9528899, -25.0313601],
      [28.9520399, -25.0295501],
      [28.9510699, -25.0277301],
      [28.9501899, -25.0257501],
      [28.9494299, -25.0241601],
      [28.9485299, -25.0223501],
      [28.9483599, -25.0217501],
      [28.9476099, -25.0205301],
      [28.9469199, -25.0186701],
      [28.9466559, -25.0180691],
      [28.9462809, -25.0172145],
      [28.9461999, -25.0170301],
      [28.9348599, -25.0006601],
      [28.9348899, -25.0003301],
      [28.9349199, -25.0000101],
      [28.9325499, -25.0007101],
      [28.9140099, -25.0059401],
      [28.9138599, -25.0059801],
      [28.9102999, -25.0070901],
      [28.9052599, -24.9959501],
      [28.9093699, -24.9954901],
      [28.9032199, -24.9823601],
      [28.9032194, -24.9823588],
      [28.8917399, -24.9557571],
      [28.8916199, -24.9554801],
      [28.8916599, -24.9554601],
      [28.8937749, -24.9545431],
      [28.8946845, -24.9541489],
      [28.8966199, -24.9533101],
      [28.9065199, -24.9489901],
      [28.9114699, -24.9468401],
      [28.9164299, -24.9446751],
      [28.9214999, -24.9424701],
      [28.9265699, -24.9402601],
      [28.9316299, -24.9380501],
      [28.9366999, -24.9358501],
      [28.9417359, -24.9336511],
      [28.9417599, -24.9336401],
      [28.9369799, -24.9228501],
      [28.9279695, -24.9080029],
      [28.9276819, -24.9075291],
      [28.9265899, -24.9057301],
      [28.9240699, -24.9015301],
      [28.9141999, -24.9054001],
      [28.9034199, -24.9096801],
      [28.8984199, -24.9116401],
      [28.8826599, -24.9178601],
      [28.8488299, -24.9322101],
      [28.8463899, -24.9332601],
      [28.8457992, -24.9321326],
      [28.8457569, -24.9320521],
      [28.8375299, -24.9163401],
      [28.8373899, -24.9160101],
      [28.8198499, -24.9151001],
      [28.8107779, -24.9145801],
      [28.7849499, -24.9128801],
      [28.7665699, -24.9117801],
      [28.7593799, -24.9113501],
      [28.7529699, -24.9172901],
      [28.7328499, -24.9359401],
      [28.7194599, -24.9483601],
      [28.7137799, -24.9536201],
      [28.7027599, -24.9575901],
      [28.6972899, -24.9595601],
      [28.6883899, -24.9627701],
      [28.6802699, -24.9653501],
      [28.6698399, -24.9686701],
      [28.6686699, -24.9690401],
      [28.6588499, -24.9721701],
      [28.6505599, -24.9762101],
      [28.6494599, -24.9767501],
      [28.6459289, -24.9784711],
      [28.6395499, -24.9815801],
      [28.6390369, -24.9818311],
      [28.6337999, -24.9843901],
      [28.6274099, -24.9887701],
      [28.6207499, -24.9933401],
      [28.6100799, -25.0006701],
      [28.6091899, -25.0012701],
      [28.6058899, -25.0035301],
      [28.6058199, -25.0036401],
      [28.6057199, -25.0034401],
      [28.6055299, -25.0037501],
      [28.6055399, -25.0038001],
      [28.6082609, -25.0092321],
      [28.6178499, -25.0283701],
      [28.6190699, -25.0308001],
      [28.6287099, -25.0482601],
      [28.6289289, -25.0486851],
      [28.6307599, -25.0522301],
      [28.6342899, -25.0582401],
      [28.6094899, -25.0599001],
      [28.6094789, -25.0599441],
      [28.6068999, -25.0703901],
      [28.6068729, -25.0703941],
      [28.5968999, -25.0718401],
      [28.5853999, -25.0735201],
      [28.5656324, -25.0763903],
      [28.5582509, -25.0774621],
      [28.5579899, -25.0775001],
      [28.5514239, -25.0784011],
      [28.5299999, -25.0813401],
      [28.5147799, -25.0834301],
      [28.5084799, -25.0843301],
      [28.5083059, -25.0843571],
      [28.5051199, -25.0848201],
      [28.5045819, -25.0848991],
      [28.4969799, -25.0859901],
      [28.4871399, -25.0874001],
      [28.4737399, -25.0893201],
      [28.4737699, -25.0893701],
      [28.4922199, -25.1256201],
      [28.4952399, -25.1317801],
      [28.4879199, -25.1324001],
      [28.4859699, -25.1325701],
      [28.4670699, -25.1341501],
      [28.4654319, -25.1342891],
      [28.4544199, -25.1352201],
      [28.4468799, -25.1358501],
      [28.4465999, -25.1358701],
      [28.4429699, -25.1289901],
      [28.4361899, -25.1318801],
      [28.4347399, -25.1325301],
      [28.4322147, -25.1336598],
      [28.4320799, -25.1337201],
      [28.4319699, -25.1337701],
      [28.4314299, -25.1339941],
      [28.4305699, -25.1343501],
      [28.4304499, -25.1344101],
      [28.4264599, -25.1361801],
      [28.4263399, -25.1362301],
      [28.4183799, -25.1398001],
      [28.4181499, -25.1399101],
      [28.4165299, -25.1406801],
      [28.4130899, -25.1422201],
      [28.4118199, -25.1427801],
      [28.4102499, -25.1433701],
      [28.4099999, -25.1434901],
      [28.4065499, -25.1451101],
      [28.4023199, -25.1469701],
      [28.4008229, -25.1476361],
      [28.4005199, -25.1477701],
      [28.3980199, -25.1487401],
      [28.3978399, -25.1488101],
      [28.393449, -25.1503733],
      [28.3884299, -25.1521601],
      [28.3792599, -25.1553001],
      [28.3793899, -25.1553901],
      [28.3793399, -25.1554001],
      [28.3865599, -25.1604101],
      [28.3919099, -25.1641501],
      [28.3974499, -25.1759501],
      [28.3996799, -25.1806941],
      [28.4019199, -25.1854701],
      [28.4078499, -25.1980801],
      [28.4109899, -25.2047701],
      [28.4110059, -25.2048011],
      [28.4110199, -25.2048301],
      [28.4065999, -25.2063501],
      [28.4061899, -25.2064701],
      [28.4061199, -25.2065001],
      [28.4060909, -25.2065101],
      [28.4060599, -25.2065201],
      [28.4000399, -25.2086501],
      [28.3955399, -25.2102501],
      [28.3891399, -25.2126201],
      [28.3871179, -25.2133141],
      [28.3868799, -25.2133901],
      [28.4076979, -25.2101401],
      [28.4076899, -25.2101101],
      [28.4076599, -25.2100301],
      [28.4080899, -25.2099601],
      [28.4081299, -25.2100801],
      [28.4085099, -25.2100201],
      [28.4299099, -25.2066201],
      [28.4299399, -25.2066201],
      [28.4299699, -25.2066201],
      [28.4514299, -25.2033301],
      [28.4517299, -25.2032801],
      [28.4615099, -25.2015001],
      [28.4615999, -25.2014801],
      [28.4755454, -25.1938787],
      [28.4976499, -25.1818301],
      [28.4977199, -25.1818101],
      [28.4982199, -25.1816001],
      [28.5025999, -25.1800401],
      [28.5053499, -25.1790701],
      [28.5074499, -25.1783201],
      [28.5098299, -25.1774801],
      [28.5120899, -25.1766801],
      [28.5143799, -25.1758701],
      [28.5172299, -25.1750201],
      [28.5172599, -25.1750101],
      [28.5217099, -25.1732701],
      [28.5221699, -25.1731101],
      [28.5320599, -25.1697901],
      [28.5368299, -25.1525501],
      [28.5365899, -25.1524801],
      [28.5365999, -25.1524501],
      [28.5366099, -25.1524201],
      [28.5385299, -25.1521101],
      [28.5615899, -25.1482801],
      [28.5699499, -25.1469001],
      [28.5721799, -25.1465301],
      [28.5722489, -25.1465191],
      [28.5744899, -25.1461501],
      [28.5770899, -25.1457101],
      [28.5796899, -25.1452801],
      [28.5823099, -25.1448501],
      [28.5849299, -25.1444101],
      [28.5871599, -25.1440401],
      [28.5877399, -25.1439501],
      [28.5905899, -25.1434701],
      [28.5935299, -25.1429901],
      [28.5959899, -25.1425801],
      [28.5961099, -25.1425801],
      [28.5967199, -25.1384701],
      [28.5968199, -25.1384401],
      [28.5968963, -25.1384198],
      [28.5970759, -25.1383721],
      [28.6359599, -25.1281301],
      [28.6360599, -25.1281001],
      [28.6359499, -25.1270401],
      [28.6358399, -25.1263101],
      [28.6358199, -25.1262301],
      [28.6357299, -25.1259101],
      [28.6356999, -25.1255801],
      [28.6356899, -25.1255301],
      [28.6356899, -25.1255001],
      [28.6355999, -25.1245801],
      [28.6355899, -25.1245101],
      [28.6354999, -25.1236701],
      [28.6354999, -25.1235901],
      [28.6353999, -25.1226601],
      [28.6353899, -25.1225801],
      [28.6352999, -25.1216901],
      [28.6352899, -25.1216201],
      [28.6351899, -25.1206301],
      [28.6351799, -25.1205601],
      [28.6350999, -25.1197101],
      [28.6350899, -25.1196401],
      [28.6349599, -25.1183301],
      [28.6372199, -25.1178301],
      [28.6371599, -25.1177001],
      [28.6431199, -25.1154401],
      [28.6489099, -25.1129201],
      [28.6500499, -25.1257501],
      [28.6515579, -25.1427601],
      [28.65157, -25.1429001],
      [28.6598, -25.1407801],
      [28.66831, -25.138525],
      [28.67495, -25.1349801],
      [28.67994, -25.1322301],
      [28.6857, -25.1292701],
      [28.6867379, -25.1287088],
      [28.68914, -25.1274101],
      [28.69223, -25.1256601],
      [28.69403, -25.1246501],
      [28.70016, -25.1212401],
      [28.7006384, -25.1209909],
      [28.71011, -25.1160601],
      [28.7329799, -25.1117601],
      [28.7393899, -25.1105701],
      [28.744589, -25.109612],
      [28.7450499, -25.1108301],
      [28.7496999, -25.1234101],
      [28.7568599, -25.1431201],
      [28.7577399, -25.1456401],
      [28.7583299, -25.1472801],
      [28.7591599, -25.1497201],
      [28.7591299, -25.1497101],
      [28.7589899, -25.1495801],
      [28.7587199, -25.1495501],
      [28.7585499, -25.1495601],
      [28.7584599, -25.1495301],
      [28.7581999, -25.1497501],
      [28.7580899, -25.1500601],
      [28.7577299, -25.1499701],
      [28.7574199, -25.1498601],
      [28.7578899, -25.1506401],
      [28.758617, -25.151953],
      [28.7587199, -25.1521401],
      [28.7642213, -25.1619651],
      [28.7718899, -25.1756601],
      [28.7764999, -25.1837201],
      [28.7754099, -25.1837701],
      [28.777652, -25.1946656],
      [28.7788299, -25.2003901],
      [28.7839199, -25.2254801],
      [28.7845599, -25.2286601],
      [28.7790999, -25.2308201],
      [28.7746999, -25.2280501],
      [28.7709199, -25.2256301],
      [28.7674199, -25.2233701],
      [28.7638499, -25.2210901],
      [28.7609299, -25.2256201],
      [28.7579899, -25.2301001],
      [28.7525907, -25.2384097],
      [28.7509399, -25.2409501],
      [28.7505899, -25.2415001],
      [28.7502499, -25.2420101],
      [28.7497199, -25.2428101],
      [28.7446399, -25.2510601],
      [28.7443499, -25.2514501],
      [28.7357999, -25.2639201],
      [28.7356345, -25.2641779],
      [28.7324299, -25.2691701],
      [28.7395899, -25.2885301],
      [28.7329399, -25.2827001],
      [28.7229299, -25.2858801],
      [28.7179499, -25.2872301],
      [28.6956299, -25.2944601],
      [28.6883499, -25.2979301],
      [28.6792099, -25.3030001],
      [28.6688999, -25.3107601],
      [28.6576899, -25.3172901],
      [28.6412599, -25.3276401],
      [28.6331799, -25.3314901],
      [28.6225799, -25.3336501],
      [28.6231999, -25.3359401],
      [28.6260599, -25.3463101],
      [28.6287999, -25.3563601],
      [28.6290799, -25.3574201],
      [28.6339799, -25.3755301],
      [28.6340599, -25.3760301],
      [28.638905, -25.39385],
      [28.6389399, -25.3939801],
      [28.6283199, -25.4035601],
      [28.6271099, -25.4046401],
      [28.6197899, -25.4113901],
      [28.6202099, -25.4124501],
      [28.6204799, -25.4138601],
      [28.6240599, -25.4404101],
      [28.625085, -25.44596],
      [28.6251299, -25.4465001],
      [28.6252599, -25.4476301],
      [28.6258099, -25.4490801],
      [28.6261899, -25.4504001],
      [28.6276495, -25.4542221],
      [28.6279999, -25.4551401],
      [28.6281299, -25.4554701],
      [28.62874, -25.457244],
      [28.6291199, -25.4583501],
      [28.6294699, -25.4593701],
      [28.6294099, -25.4598501],
      [28.6291499, -25.4599601],
      [28.6285299, -25.4602501],
      [28.6278399, -25.4604201],
      [28.6241099, -25.4619101],
      [28.6225999, -25.4625301],
      [28.6208499, -25.4632201],
      [28.6193299, -25.4644901],
      [28.6188499, -25.4649501],
      [28.6153999, -25.4678601],
      [28.6209899, -25.4706601],
      [28.630644, -25.48614],
      [28.6320599, -25.4884101],
      [28.6336799, -25.5151401],
      [28.6339999, -25.5198901],
      [28.6260899, -25.5229101],
      [28.6257499, -25.5230501],
      [28.6260299, -25.5255901],
      [28.6263499, -25.5283001],
      [28.6266699, -25.5311501],
      [28.6282599, -25.5364501],
      [28.6289699, -25.5388201],
      [28.6301399, -25.5427301],
      [28.6302199, -25.5431201],
      [28.6324599, -25.5505901],
      [28.6348399, -25.5585501],
      [28.6349999, -25.5591601],
      [28.6356399, -25.5607701],
      [28.6374699, -25.5654201],
      [28.6375799, -25.5657301],
      [28.6400299, -25.5719301],
      [28.6414399, -25.5756601],
      [28.6419499, -25.5768601],
      [28.6423799, -25.5779901],
      [28.6430399, -25.5797101],
      [28.6438799, -25.5818801],
      [28.6446899, -25.5838101],
      [28.6454499, -25.5857801],
      [28.647255, -25.58563],
      [28.642512, -25.589865],
      [28.6458199, -25.5977001],
      [28.6459899, -25.5981001],
      [28.6471999, -25.6006101],
      [28.6497499, -25.6059101],
      [28.6515999, -25.6098301],
      [28.6533699, -25.6135201],
      [28.6544499, -25.6157201],
      [28.6564499, -25.6200101],
      [28.6590899, -25.6255801],
      [28.6612599, -25.6312801],
      [28.6635799, -25.6360801],
      [28.6679799, -25.6453801],
      [28.6683599, -25.6460601],
      [28.6720499, -25.6537701],
      [28.674695, -25.65885],
      [28.6727019, -25.6650318],
      [28.6837799, -25.6753801],
      [28.6992599, -25.6801201],
      [28.6999199, -25.6802001],
      [28.7088, -25.6828201],
      [28.71486, -25.6663001],
      [28.7192278, -25.6533862],
      [28.7192606, -25.6532891],
      [28.72206, -25.6441801],
      [28.72387, -25.6317701],
      [28.73818, -25.6338701],
      [28.76631, -25.6469801],
      [28.7652099, -25.6507901],
      [28.7623336, -25.6634025],
      [28.7590833, -25.6776547],
      [28.759, -25.6780201],
      [28.7565999, -25.6840201],
      [28.7529288, -25.6937025],
      [28.7528499, -25.6939106],
      [28.7541699, -25.6943101],
      [28.75743, -25.6953301],
      [28.75734, -25.69624],
      [28.75727, -25.69693],
      [28.75699, -25.6995401],
      [28.75692, -25.7009801],
      [28.75694, -25.70134],
      [28.75697, -25.7017001],
      [28.75706, -25.70216],
      [28.75713, -25.70254],
      [28.75721, -25.70295],
      [28.75734, -25.7036601],
      [28.75733, -25.70377],
      [28.75729, -25.7042201],
      [28.75722, -25.7058801],
      [28.7593, -25.7052601],
      [28.76349, -25.70403],
      [28.76494, -25.7036001],
      [28.7653, -25.7006401],
      [28.7680899, -25.7009201],
      [28.7692599, -25.6987801],
      [28.7751399, -25.7006201],
      [28.7793199, -25.7019401],
      [28.7889799, -25.7022901],
      [28.7927299, -25.7024301],
      [28.7934099, -25.7018801],
      [28.8082399, -25.6890301],
      [28.81003, -25.6899901],
      [28.8193, -25.6950901],
      [28.82435, -25.6928401],
      [28.83312, -25.6893101],
      [28.83344, -25.68916],
      [28.84038, -25.6860101],
      [28.8453, -25.6835501],
      [28.84695, -25.6824201],
      [28.8229199, -25.6589201],
      [28.8131299, -25.6592001],
      [28.8100299, -25.6591201],
      [28.8105799, -25.6516501],
      [28.81148, -25.64324],
      [28.8114999, -25.6430301],
      [28.8137599, -25.6426001],
      [28.8182799, -25.6413401],
      [28.8360099, -25.6373701],
      [28.8354599, -25.6456101],
      [28.8415699, -25.6544601],
      [28.8456999, -25.6523101],
      [28.8609999, -25.6560701],
      [28.8692999, -25.6581201],
      [28.87148, -25.643352],
      [28.8719499, -25.6416301],
      [28.87178, -25.6414601],
      [28.87154, -25.6414301],
      [28.871, -25.6410501],
      [28.87035, -25.6407101],
      [28.8696499, -25.6403701],
      [28.8694199, -25.6401201],
      [28.8690599, -25.6399801],
      [28.8628999, -25.6355501],
      [28.8583799, -25.6348101],
      [28.8581537, -25.6332581],
      [28.8580399, -25.6324801],
      [28.8541999, -25.6162001],
      [28.8536599, -25.6141801],
      [28.8524399, -25.6084401],
      [28.8500899, -25.5969201],
      [28.84957, -25.59471],
      [28.84905, -25.59256],
      [28.84624, -25.5806601],
      [28.84311, -25.5664401],
      [28.83925, -25.56726],
      [28.83081, -25.5690401],
      [28.82846, -25.5693501],
      [28.80854, -25.5732501],
      [28.80766, -25.5714301],
      [28.80555, -25.5656201],
      [28.8054, -25.5650101],
      [28.80484, -25.5633801],
      [28.8036, -25.5599101],
      [28.80108, -25.5530801],
      [28.80001, -25.5502201],
      [28.79988, -25.5497001],
      [28.797054, -25.542045],
      [28.80145, -25.5385201],
      [28.81106, -25.5311401],
      [28.8133699, -25.5292301],
      [28.81586, -25.5273401],
      [28.82186, -25.5224401],
      [28.8249, -25.5202201],
      [28.83036, -25.5164701],
      [28.84545, -25.5060701],
      [28.85084, -25.5025001],
      [28.85178, -25.5018101],
      [28.85664, -25.5071901],
      [28.86418, -25.5175901],
      [28.86756, -25.5218701],
      [28.86988, -25.5247501],
      [28.87408, -25.5270601],
      [28.87136, -25.5336601],
      [28.858224, -25.569065],
      [28.91009, -25.5244601],
      [28.9106, -25.5278201],
      [28.91516, -25.5580001],
      [28.92517, -25.5715],
      [28.92524, -25.5716001],
      [28.92995, -25.5778201],
      [28.93226, -25.5808801],
      [28.93821, -25.5891501],
      [28.94654, -25.5998001],
      [28.95047, -25.5982301],
      [28.96466, -25.5922901],
      [28.97543, -25.5879301],
      [28.97971, -25.5861201],
      [28.99931, -25.5779501],
      [29.00078, -25.5772001],
      [29.00447, -25.57559],
      [29.00776, -25.5741601],
      [29.00762, -25.57393],
      [29.00068, -25.5626201],
      [28.99635, -25.5564801],
      [28.986931, -25.540199],
      [28.98815, -25.5395301],
      [28.99324, -25.5425201],
      [29.00057, -25.5398401],
      [29.00672, -25.5376001],
      [29.0083, -25.5358],
      [29.01058, -25.5332001],
      [29.01902, -25.5277901],
      [29.01464, -25.51767],
      [29.013227, -25.514386],
      [29.01294, -25.5137301],
      [29.01373, -25.5131801],
      [29.01503, -25.51361],
      [29.01578, -25.51387],
      [29.01648, -25.5141],
      [29.01725, -25.5143501],
      [29.01829, -25.5146801],
      [29.01898, -25.51489],
      [29.02004, -25.5152101],
      [29.0212, -25.51549],
      [29.02193, -25.51566],
      [29.02299, -25.5159101],
      [29.0236, -25.51633],
      [29.02444, -25.51689],
      [29.02523, -25.51743],
      [29.0259, -25.51788],
      [29.0268, -25.5184901],
      [29.02816, -25.51904],
      [29.02892, -25.51936],
      [29.02966, -25.51965],
      [29.0304, -25.51996],
      [29.03142, -25.52038],
      [29.03227, -25.5207201],
      [29.03315, -25.52085],
      [29.03393, -25.52096],
      [29.03468, -25.52107],
      [29.03596, -25.5212601],
      [29.0367, -25.5211201],
      [29.03815, -25.5212601],
      [29.03965, -25.52116],
      [29.04049, -25.5211],
      [29.04132, -25.52104],
      [29.04221, -25.5209801],
      [29.04742, -25.5169501],
      [29.04815, -25.5175301],
      [29.04831, -25.5182201],
      [29.04862, -25.5188501],
      [29.04849, -25.5195501],
      [29.04819, -25.5202201],
      [29.04887, -25.52056],
      [29.0496, -25.5209401],
      [29.05052, -25.5217501],
      [29.05123, -25.5220601],
      [29.05265, -25.5229201],
      [29.05295, -25.5236701],
      [29.05354, -25.52407],
      [29.05416, -25.5244901],
      [29.05482, -25.5248001],
      [29.05553, -25.5252201],
      [29.05609, -25.5256601],
      [29.05643, -25.5263201],
      [29.05749, -25.5263001],
      [29.05817, -25.5266601],
      [29.05874, -25.5272301],
      [29.06508, -25.5186101],
      [29.0738, -25.5064701],
      [29.07437, -25.50568],
      [29.07873, -25.4995901],
      [29.07736, -25.4962301],
      [29.08001, -25.4946301],
      [29.09137, -25.5305901],
      [29.09842, -25.5377301],
      [29.08689, -25.5486201],
      [29.08295, -25.5495401],
      [29.06841, -25.5522801],
      [29.05902, -25.5554201],
      [29.05788, -25.55579],
      [29.03429, -25.5633901],
      [29.042, -25.5732601],
      [29.04562, -25.5808001],
      [29.04475, -25.58654],
      [29.04435, -25.58916],
      [29.04288, -25.5987601],
      [29.04, -25.6175501],
      [29.0642, -25.6206601],
      [29.06614, -25.6304801],
      [29.05655, -25.6326001],
      [29.06462, -25.6424201],
      [29.02965, -25.6537501],
      [29.00884, -25.6604],
      [29.00829, -25.6605701],
      [28.98874, -25.6668201],
      [28.96883, -25.6733101],
      [28.96525, -25.6841001],
      [28.96044, -25.6985201],
      [28.95576, -25.7129801],
      [28.9526803, -25.7224727],
      [28.9526054, -25.7227038],
      [28.95078, -25.72833],
      [28.95455, -25.7301501],
      [28.95903, -25.7322301],
      [28.9704756, -25.7374345],
      [28.97453, -25.739278],
      [28.97506, -25.739519],
      [28.9751085, -25.7395411],
      [28.97603, -25.7399601],
      [28.98063, -25.7435701],
      [28.97901, -25.7459401],
      [28.97694, -25.7489101],
      [28.97629, -25.7498101],
      [28.97596, -25.75016],
      [28.97586, -25.7502701],
      [28.97553, -25.7507301],
      [28.97271, -25.7538901],
      [28.9726, -25.75406],
      [28.9711, -25.7561501],
      [28.96978, -25.75795],
      [28.96968, -25.75807],
      [28.96751, -25.7610001],
      [28.96647, -25.76243],
      [28.9653238, -25.7640016],
      [28.96515, -25.7642401],
      [28.9646, -25.7650401],
      [28.96321, -25.7669001],
      [28.96139, -25.7694],
      [28.9613, -25.76953],
      [28.95934, -25.7721901],
      [28.95877, -25.7730101],
      [28.957587, -25.774646],
      [28.95722, -25.7755601],
      [28.95703, -25.7759201],
      [28.95591, -25.77884],
      [28.95421, -25.7830301],
      [28.95264, -25.7869601],
      [28.95125, -25.7905401],
      [28.94996, -25.7937901],
      [28.94973, -25.7942801],
      [28.9486, -25.7970501],
      [28.94724, -25.80058],
      [28.94704, -25.8011101],
      [28.94549, -25.8049401],
      [28.94289, -25.81145],
      [28.94116, -25.8157201],
      [28.94006, -25.8184701],
      [28.93817, -25.823285],
      [28.93843, -25.82335],
      [28.94144, -25.82397],
      [28.94334, -25.8243701],
      [28.94403, -25.8255501],
      [28.9474, -25.83176],
      [28.94897, -25.83464],
      [28.94941, -25.83546],
      [28.94972, -25.83603],
      [28.950449, -25.837353],
      [28.95028, -25.83804],
      [28.94973, -25.8403301],
      [28.94729, -25.8505801],
      [28.94315, -25.8677001],
      [28.94288, -25.8690201],
      [28.94207, -25.8723201],
      [28.94158, -25.8756501],
      [28.94124, -25.8766101],
      [28.94107, -25.8772901],
      [28.94091, -25.87793],
      [28.93818, -25.8886401],
      [28.91292, -25.8800501],
      [28.8868, -25.8714301],
      [28.88389, -25.8783501],
      [28.88411, -25.8784501],
      [28.88896, -25.8803301],
      [28.887169, -25.888383],
      [28.88457, -25.90116],
      [28.88204, -25.9133601],
      [28.88045, -25.9207801],
      [28.87954, -25.92505],
      [28.87951, -25.925241],
      [28.88108, -25.9470101],
      [28.88254, -25.9697801],
      [28.88329, -25.9714101],
      [28.88524, -25.9713701],
      [28.88505, -25.9744001],
      [28.86964, -26.0028301],
      [28.86735, -26.0070501],
      [28.86725, -26.00681],
      [28.86549, -26.00278],
      [28.86484, -26.0012701],
      [28.84327, -26.00367],
      [28.84232, -26.0037701],
      [28.83293, -26.0048101],
      [28.82236, -26.0039301],
      [28.79889, -26.0044601],
      [28.79591, -26.00453],
      [28.79454, -26.00456],
      [28.79386, -26.0045701],
      [28.78269, -26.0096501],
      [28.77961, -26.01105],
      [28.77507, -26.01311],
      [28.77386, -26.0136601],
      [28.77323, -26.01197],
      [28.77221, -26.0092601],
      [28.76241, -25.9830601],
      [28.758172, -25.983696],
      [28.75788, -25.9837401],
      [28.75754, -25.9905801],
      [28.7485, -25.99063],
      [28.74531, -25.99063],
      [28.73467, -25.9906201],
      [28.71084, -25.9905901],
      [28.68903, -25.9848401],
      [28.68138, -25.9825501],
      [28.67685, -25.98135],
      [28.67648, -25.9812601],
      [28.67539, -25.98092],
      [28.67263, -25.9800801],
      [28.66966, -25.9792101],
      [28.65266, -25.9742501],
      [28.64829, -25.9737601],
      [28.63439, -25.9713801],
      [28.6326, -25.9710201],
      [28.63226, -25.9707801],
      [28.63208, -25.97092],
      [28.631979, -25.970997],
      [28.5993, -25.9960901],
      [28.59095, -26.0024801],
      [28.586749, -26.016025],
      [28.58621, -26.01901],
      [28.58507, -26.0254101],
      [28.58371, -26.0329901],
      [28.57894, -26.0595901],
      [28.56482, -26.0554701],
      [28.55912, -26.0538001],
      [28.5541, -26.0523301],
      [28.5507, -26.0513401],
      [28.53863, -26.0478101],
      [28.53155, -26.06021],
      [28.5314743, -26.060342],
      [28.53077, -26.0615701],
      [28.52894, -26.0611901],
      [28.515765, -26.058525],
      [28.50617, -26.0625101],
      [28.503055, -26.0638],
      [28.50458, -26.0659001],
      [28.50537, -26.0669701],
      [28.50616, -26.0680501],
      [28.50778, -26.0702701],
      [28.51582, -26.0812501],
      [28.51331, -26.0826701],
      [28.50119, -26.0895701],
      [28.50127, -26.0897801],
      [28.50518, -26.0992201],
      [28.49695, -26.1038701],
      [28.4969087, -26.10401],
      [28.49439, -26.1125701],
      [28.49068, -26.1254401],
      [28.49053, -26.1262201],
      [28.4905, -26.126392],
      [28.49612, -26.1297001],
      [28.49629, -26.1298101],
      [28.50232, -26.1333301],
      [28.50253, -26.1334501],
      [28.50853, -26.136975],
      [28.51356, -26.1399301],
      [28.51469, -26.1405901],
      [28.52134, -26.1444901],
      [28.52159, -26.1459501],
      [28.52239, -26.1507001],
      [28.52242, -26.1508801],
      [28.52282, -26.1532201],
      [28.52324, -26.1557301],
      [28.52357, -26.1576301],
      [28.52367, -26.1582301],
      [28.52394, -26.1598601],
      [28.52475, -26.1646101],
      [28.5248, -26.1649001],
      [28.52615, -26.1728301],
      [28.52645, -26.1746501],
      [28.5271499, -26.17874],
      [28.52944, -26.1766601],
      [28.53199, -26.1743401],
      [28.53248, -26.1738901],
      [28.5339771, -26.1725251],
      [28.53429, -26.1722401],
      [28.53411, -26.1748001],
      [28.53403, -26.1759501],
      [28.53391, -26.1776901],
      [28.53388, -26.1780301],
      [28.53382, -26.1789401],
      [28.53375, -26.1798401],
      [28.53368, -26.1809001],
      [28.53361, -26.1818101],
      [28.5336, -26.1820101],
      [28.53355, -26.1827201],
      [28.53348, -26.1836301],
      [28.53342, -26.1845201],
      [28.53336, -26.1853501],
      [28.53321, -26.1873901],
      [28.53319, -26.1876901],
      [28.53313, -26.1885301],
      [28.53308, -26.1892101],
      [28.53304, -26.1898701],
      [28.53289, -26.1918801],
      [28.53286, -26.1923601],
      [28.53285, -26.1925401],
      [28.5328, -26.1932101],
      [28.53276, -26.1937301],
      [28.5327, -26.1945401],
      [28.53266, -26.1950901],
      [28.53261, -26.1958501],
      [28.53259, -26.1960801],
      [28.53259, -26.1961201],
      [28.53252, -26.1971301],
      [28.5325, -26.1973001],
      [28.5325, -26.1974301],
      [28.53247, -26.1977501],
      [28.53247, -26.1978001],
      [28.53231, -26.1999701],
      [28.53223, -26.2011301],
      [28.53207, -26.2033901],
      [28.532058, -26.203554],
      [28.53203, -26.2039501],
      [28.53172, -26.2083701],
      [28.53145, -26.2122301],
      [28.53121, -26.2156801],
      [28.53119, -26.2160301],
      [28.53086, -26.2206801],
      [28.53058, -26.2247801],
      [28.53054, -26.2253101],
      [28.53151, -26.2255301],
      [28.53248, -26.2257601],
      [28.53346, -26.2259901],
      [28.53443, -26.2262101],
      [28.5354, -26.2264401],
      [28.53637, -26.2266601],
      [28.53831, -26.2271201],
      [28.53928, -26.2273401],
      [28.54025, -26.2275701],
      [28.54039, -26.227605],
      [28.55135, -26.2301601],
      [28.55174, -26.2302501],
      [28.56418, -26.2331501],
      [28.57701, -26.2361401],
      [28.58197, -26.2372901],
      [28.59173, -26.2399801],
      [28.59192, -26.2400301],
      [28.60088, -26.2424901],
      [28.6069, -26.2441501],
      [28.60713, -26.2442101],
      [28.62229, -26.2483801],
      [28.62269, -26.2523501],
      [28.62274, -26.2528101],
      [28.62356, -26.2609901],
      [28.62416, -26.2670401],
      [28.62436, -26.2691201],
      [28.62501, -26.2754701],
      [28.6256, -26.2815901],
      [28.62603, -26.2856601],
      [28.62619, -26.2858001],
      [28.62687, -26.2921501],
      [28.6269, -26.2924401],
      [28.63983, -26.2978801],
      [28.65055, -26.3023701],
      [28.65644, -26.3048401],
      [28.66252, -26.3073901],
      [28.672797, -26.311688],
      [28.6728, -26.3118201],
      [28.672728, -26.320913],
      [28.67487, -26.3220901],
      [28.67521, -26.3222701],
      [28.69072, -26.3307001],
      [28.69592, -26.3335301],
      [28.70863, -26.3404301],
      [28.71012, -26.3412401],
      [28.7253599, -26.3325301],
      [28.7260099, -26.3321601],
      [28.73936, -26.3245301],
      [28.74137, -26.3240001],
      [28.75362, -26.3207201],
      [28.77397, -26.3176701],
      [28.7789, -26.3169301],
      [28.7822, -26.3156301],
      [28.7922, -26.3116801],
      [28.79555, -26.3103501],
      [28.80508, -26.3065901],
      [28.81358, -26.3327501],
      [28.81775, -26.3455801],
      [28.8178, -26.3457201],
      [28.82747, -26.3433901],
      [28.8384399, -26.34075],
      [28.84209, -26.3488201],
      [28.84451, -26.3541801],
      [28.8448199, -26.3548501],
      [28.84749, -26.3607701],
      [28.85033, -26.3670401],
      [28.85237, -26.3729101],
      [28.85322, -26.3753401],
      [28.85525, -26.3811901],
      [28.85539, -26.3815901],
      [28.8568199, -26.3857201],
      [28.8581299, -26.3894801],
      [28.8599699, -26.3947801],
      [28.861204, -26.398322],
      [28.8612899, -26.3985701],
      [28.8456499, -26.4035101],
      [28.83215, -26.4077601],
      [28.8055, -26.4221701],
      [28.79906, -26.4211501],
      [28.8, -26.4240201],
      [28.78993, -26.4264501],
      [28.7849, -26.4360501],
      [28.78381, -26.4381301],
      [28.78473, -26.4434201],
      [28.78649, -26.4491701],
      [28.78053, -26.4504701],
      [28.7803, -26.4505201],
      [28.776, -26.4567801],
      [28.77135, -26.4635501],
      [28.76969, -26.4659601],
      [28.76592, -26.4714501],
      [28.76546, -26.4822801],
      [28.76509, -26.4908301],
      [28.76499, -26.4929801],
      [28.76431, -26.5087401],
      [28.76426, -26.5099601],
      [28.76391, -26.5180101],
      [28.74908, -26.5170401],
      [28.73504, -26.5161201],
      [28.72328, -26.5153501],
      [28.70811, -26.5143501],
      [28.70252, -26.5139901],
      [28.6902, -26.5131801],
      [28.68895, -26.5130901],
      [28.677, -26.5099101],
      [28.6618, -26.5058601],
      [28.66162, -26.5059301],
      [28.66109, -26.5061101],
      [28.6569699, -26.5074901],
      [28.65344, -26.5086801],
      [28.65341, -26.5086701],
      [28.6530799, -26.5084701],
      [28.65278, -26.5083101],
      [28.65245, -26.5082501],
      [28.6520599, -26.5082101],
      [28.6516999, -26.5082101],
      [28.65145, -26.5081101],
      [28.6509599, -26.5079801],
      [28.65055, -26.5079201],
      [28.65022, -26.5079501],
      [28.65012, -26.5080301],
      [28.65002, -26.5081301],
      [28.6499899, -26.5083001],
      [28.65002, -26.5085801],
      [28.6500199, -26.5087201],
      [28.64998, -26.5088801],
      [28.6498499, -26.5091401],
      [28.6498099, -26.5094301],
      [28.6499099, -26.5095401],
      [28.65006, -26.5096701],
      [28.65025, -26.5097401],
      [28.65056, -26.5097801],
      [28.6506999, -26.5099501],
      [28.6507899, -26.5101901],
      [28.6507699, -26.5104201],
      [28.6506399, -26.5105801],
      [28.6504799, -26.5107801],
      [28.6501499, -26.5110301],
      [28.6498899, -26.5110901],
      [28.64933, -26.5110601],
      [28.64896, -26.5109101],
      [28.64855, -26.5106701],
      [28.64789, -26.5103201],
      [28.64711, -26.5100101],
      [28.64658, -26.5097601],
      [28.646514, -26.50972],
      [28.64613, -26.5094901],
      [28.64569, -26.5091701],
      [28.64544, -26.5089001],
      [28.64516, -26.5087401],
      [28.64491, -26.5086001],
      [28.64463, -26.5084901],
      [28.64437, -26.5083201],
      [28.64408, -26.5080401],
      [28.64382, -26.5079301],
      [28.64355, -26.5078601],
      [28.64303, -26.5077701],
      [28.6420099, -26.5076101],
      [28.64162, -26.5075701],
      [28.6414899, -26.5078301],
      [28.6368599, -26.5167101],
      [28.6351099, -26.5191701],
      [28.6311899, -26.5246401],
      [28.63152, -26.5257301],
      [28.63354, -26.5323101],
      [28.63495, -26.5368701],
      [28.63551, -26.5387001],
      [28.63815, -26.5473101],
      [28.63796, -26.5472801],
      [28.63256, -26.5463901],
      [28.6265, -26.5454001],
      [28.62128, -26.54454],
      [28.61852, -26.54409],
      [28.6161, -26.5436901],
      [28.61551, -26.54359],
      [28.60745, -26.5422701],
      [28.6053, -26.5419101],
      [28.59585, -26.5403601],
      [28.59351, -26.5399801],
      [28.58491, -26.53856],
      [28.58531, -26.53436],
      [28.58533, -26.53413],
      [28.58583, -26.52877],
      [28.58635, -26.52328],
      [28.58665, -26.52003],
      [28.58237, -26.51874],
      [28.58003, -26.51803],
      [28.57716, -26.5268301],
      [28.57437, -26.5262001],
      [28.56953, -26.5251201],
      [28.56899, -26.525],
      [28.57249, -26.51852],
      [28.57378, -26.51614],
      [28.57272, -26.51582],
      [28.57008, -26.51502],
      [28.5667, -26.5140001],
      [28.56414, -26.5132301],
      [28.55858, -26.5115501],
      [28.55375, -26.5100901],
      [28.55162, -26.5094401],
      [28.54785, -26.5083001],
      [28.54367, -26.5070401],
      [28.54058, -26.5036201],
      [28.54145, -26.50335],
      [28.54182, -26.50098],
      [28.53923, -26.50138],
      [28.53751, -26.50327],
      [28.53399, -26.50133],
      [28.53319, -26.50089],
      [28.52766, -26.50221],
      [28.52735, -26.50456],
      [28.52727, -26.50522],
      [28.52658, -26.51043],
      [28.52641, -26.51176],
      [28.52594, -26.51535],
      [28.52521, -26.52095],
      [28.52504, -26.52224],
      [28.52423, -26.52835],
      [28.524215, -26.5285],
      [28.52456, -26.5334],
      [28.52474, -26.53601],
      [28.52522, -26.54278],
      [28.5257, -26.54971],
      [28.52574, -26.5502801],
      [28.5262, -26.5533501],
      [28.52652, -26.5554701],
      [28.52665, -26.55806],
      [28.52601, -26.5625],
      [28.52644, -26.5628],
      [28.52662, -26.56293],
      [28.52848, -26.56486],
      [28.53016, -26.57057],
      [28.53079, -26.57232],
      [28.53298, -26.5779],
      [28.53047, -26.5838],
      [28.53014, -26.58456],
      [28.52907, -26.58707],
      [28.52784, -26.59064],
      [28.52198, -26.59023],
      [28.50593, -26.58968],
      [28.50544, -26.58966],
      [28.50559, -26.58984],
      [28.50577, -26.59005],
      [28.50618, -26.59084],
      [28.5064, -26.59116],
      [28.50679, -26.59187],
      [28.50728, -26.59213],
      [28.50784, -26.59228],
      [28.50825, -26.59239],
      [28.5083695, -26.5925462],
      [28.50838, -26.59256],
      [28.50857, -26.59289],
      [28.50876, -26.59348],
      [28.50891, -26.59384],
      [28.50898, -26.59432],
      [28.50896, -26.59442],
      [28.50872, -26.59487],
      [28.50855, -26.59502],
      [28.50811, -26.5953],
      [28.5078, -26.59545],
      [28.5076014, -26.5955301],
      [28.50723, -26.59568],
      [28.50672, -26.59603],
      [28.50647, -26.59618],
      [28.50636, -26.5963],
      [28.50628, -26.59648],
      [28.50628, -26.59664],
      [28.50644, -26.59719],
      [28.50649, -26.5974],
      [28.50653, -26.59781],
      [28.5065398, -26.597897],
      [28.50661, -26.59852],
      [28.50664, -26.59887],
      [28.50672, -26.59928],
      [28.50685, -26.60003],
      [28.50687, -26.60024],
      [28.5069, -26.6006],
      [28.50696, -26.60105],
      [28.50706, -26.60138],
      [28.50719, -26.60175],
      [28.50742, -26.6023],
      [28.50762, -26.60295],
      [28.50771, -26.60341],
      [28.50771, -26.60364],
      [28.50759, -26.60384],
      [28.50744, -26.60395],
      [28.50722, -26.60404],
      [28.50664, -26.6041],
      [28.50628, -26.60412],
      [28.50598, -26.60417],
      [28.50569, -26.6042],
      [28.50534, -26.60431],
      [28.5047, -26.60434],
      [28.50428, -26.60428],
      [28.50351, -26.60431],
      [28.50325, -26.60429],
      [28.50268, -26.6040601],
      [28.50203, -26.60394],
      [28.50146, -26.60384],
      [28.50042, -26.60373],
      [28.49981, -26.60372],
      [28.49923, -26.60381],
      [28.49875, -26.60391],
      [28.49835, -26.60403],
      [28.49818, -26.60418],
      [28.49795, -26.60439],
      [28.49765, -26.60465],
      [28.49739, -26.60487],
      [28.49679, -26.60517],
      [28.49621, -26.60545],
      [28.49589, -26.60568],
      [28.49553, -26.60603],
      [28.49449, -26.60697],
      [28.49421, -26.6072],
      [28.49389, -26.60751],
      [28.49357, -26.60785],
      [28.49311, -26.60844],
      [28.49277, -26.60887],
      [28.49208, -26.60962],
      [28.49176, -26.60997],
      [28.49134, -26.61037],
      [28.49111, -26.61053],
      [28.49087, -26.6106],
      [28.49077, -26.6106],
      [28.49062, -26.61054],
      [28.49042, -26.61043],
      [28.48996, -26.61005],
      [28.48947, -26.60957],
      [28.48906, -26.60922],
      [28.4887, -26.60899],
      [28.48834, -26.60877],
      [28.48797, -26.60861],
      [28.48774, -26.60856],
      [28.48752, -26.60857],
      [28.48734, -26.60862],
      [28.48702, -26.60883],
      [28.48664, -26.60909],
      [28.48626, -26.60936],
      [28.48601, -26.60961],
      [28.48587, -26.6098],
      [28.48567, -26.61016],
      [28.48556, -26.61043],
      [28.48549, -26.61071],
      [28.48546, -26.61113],
      [28.48547, -26.61128],
      [28.48557, -26.61165],
      [28.4857, -26.61195],
      [28.48578, -26.61221],
      [28.48581, -26.61241],
      [28.48582, -26.61269],
      [28.48578, -26.61289],
      [28.48565, -26.61315],
      [28.48554, -26.61338],
      [28.48519, -26.61407],
      [28.48511, -26.6142],
      [28.48466, -26.6149],
      [28.4842, -26.6157],
      [28.48413, -26.61581],
      [28.4839, -26.61637],
      [28.48355, -26.61732],
      [28.48347, -26.61758],
      [28.48334, -26.61804],
      [28.48325, -26.61838],
      [28.48307, -26.61867],
      [28.48286, -26.61883],
      [28.48265, -26.61889],
      [28.48251, -26.61891],
      [28.48229, -26.61881],
      [28.48218, -26.61867],
      [28.48215, -26.61859],
      [28.48211, -26.61843],
      [28.48211, -26.61785],
      [28.48205, -26.61749],
      [28.48195, -26.61733],
      [28.48184, -26.61725],
      [28.4816, -26.61711],
      [28.48131, -26.61702],
      [28.48095, -26.61699],
      [28.4807, -26.61697],
      [28.48037, -26.61702],
      [28.48014, -26.61717],
      [28.47981, -26.61752],
      [28.48003, -26.61782],
      [28.48162, -26.62053],
      [28.49028, -26.63533],
      [28.45082, -26.63854],
      [28.44788, -26.63878],
      [28.4431, -26.63917],
      [28.44383, -26.65443],
      [28.42219, -26.65473],
      [28.42202, -26.65473],
      [28.41499, -26.65622],
      [28.4001, -26.655045],
      [28.39799, -26.66275],
      [28.39481, -26.67432],
      [28.38301, -26.71734],
      [28.38296, -26.71753],
      [28.38356, -26.71749],
      [28.39397, -26.71675],
      [28.39656, -26.72579],
      [28.40075, -26.74043],
      [28.40251, -26.74657],
      [28.40384, -26.75119],
      [28.40685, -26.76171],
      [28.40141, -26.76275],
      [28.3967, -26.76365],
      [28.39, -26.76493],
      [28.384483, -26.765985],
      [28.37828, -26.76717],
      [28.35947, -26.77076],
      [28.35649, -26.77133],
      [28.34837, -26.77288],
      [28.3482, -26.77291],
      [28.34911, -26.77787],
      [28.34259, -26.77909],
      [28.34345, -26.78546],
      [28.33938, -26.78559],
      [28.32238, -26.7923],
      [28.31941, -26.79267],
      [28.32096, -26.80607],
      [28.32132, -26.80925],
      [28.3215, -26.81077],
      [28.32161, -26.81173],
      [28.31833, -26.8118],
      [28.31929, -26.81942],
      [28.32257, -26.82022],
      [28.32374, -26.83019],
      [28.32501, -26.84107],
      [28.32399, -26.8437],
      [28.32257, -26.84713],
      [28.32102, -26.85098],
      [28.31957, -26.85445],
      [28.31845, -26.85736],
      [28.31814, -26.85789],
      [28.31677, -26.86142],
      [28.31527, -26.86526],
      [28.31363, -26.86925],
      [28.31213, -26.87292],
      [28.31059, -26.8767],
      [28.30961, -26.87928],
      [28.30955, -26.87943],
      [28.30921, -26.87939],
      [28.30779, -26.87919],
      [28.30608, -26.87907],
      [28.30402, -26.87883],
      [28.29904, -26.87842],
      [28.29807, -26.87833],
      [28.29781, -26.8783],
      [28.29366, -26.87795],
      [28.28939, -26.8776],
      [28.28494, -26.8772],
      [28.28373, -26.87709],
      [28.28352, -26.87707],
      [28.28353, -26.87691],
      [28.28391, -26.87079],
      [28.28411, -26.86763],
      [28.28431, -26.86438],
      [28.27776, -26.86495],
      [28.27062, -26.86571],
      [28.26735, -26.86606],
      [28.26333, -26.86646],
      [28.26285, -26.86968],
      [28.26232, -26.87339],
      [28.26191, -26.87524],
      [28.26135, -26.87519],
      [28.25984, -26.87507],
      [28.25548, -26.8747],
      [28.2435, -26.87369],
      [28.243465, -26.873693],
      [28.24505, -26.87703],
      [28.24584, -26.87867],
      [28.24597, -26.87894],
      [28.24841, -26.88406],
      [28.24696, -26.88431],
      [28.24428, -26.88478],
    ],
  ],
};
